{
  "fieldLabels": {
    "supplier": "Supplier",
    "customer": "Customer",
    "items": "Items",
    "vatSummary": "VAT Summary",
    "bankingDetails": "Banking Details",
    "address": "Address",
    "documentType": "Document Type",
    "documentNumber": "Document Number",
    "issueDate": "Issue Date",
    "dueDate": "Due Date",
    "taxDate": "Tax Date",
    "currencyCode": "Currency",
    "name": "Name",
    "companyId": "Company ID",
    "taxId": "Tax ID",
    "vatId": "VAT ID",
    "email": "Email",
    "phone": "Phone",
    "streetName": "Street",
    "buildingNumber": "Building Number",
    "city": "City",
    "postalCode": "Postal Code",
    "countryCode": "Country",
    "description": "Description",
    "quantity": "Quantity",
    "unit": "Unit",
    "unitPrice": "Unit Price",
    "totalAmount": "Total Amount",
    "vatRate": "VAT Rate",
    "totalAmountNoVat": "Total (excl. VAT)",
    "totalVatAmount": "Total VAT",
    "accountingTotalVatAmount": "Accounting Total VAT",
    "paidAmount": "Paid Amount",
    "paymentMethod": "Payment Method",
    "paymentNote": "Payment Note",
    "orderReference": "Order Reference",
    "receiptDatetime": "Receipt Date/Time",
    "terminalId": "Terminal ID",
    "cashierId": "Cashier ID",
    "bankAccount": "Bank Account",
    "bankCode": "Bank Code",
    "iban": "IBAN",
    "swift": "SWIFT/BIC",
    "varSymb": "Variable Symbol",
    "specSymb": "Specific Symbol",
    "netAmount": "Net Amount",
    "vatAmount": "VAT Amount",
    "accountingAmount": "Accounting Amount",
    "accountingAmountNoVat": "Accounting Amount (excl. VAT)",
    "isVatPayer": "VAT Payer",
    "deliveryAddress": "Delivery Address",
    "code": "Code",
    "discountPercent": "Discount (%)",
    "isUnitPriceInclVat": "Unit Price Incl. VAT"
  },
  "general": {
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "view": "View",
    "download": "Download",
    "search": "Search",
    "filter": "Filter",
    "home": "Home",
    "back": "Back"
  },
  "UploadInput": {
    "defaultTitle": "Upload files",
    "uploading": "Uploading...",
    "acceptedTypes": "Accepted types",
    "maxSize": "Max size",
    "maxFiles": "Max files",
    "errors": {
      "maxFiles": "Maximum",
      "fileTooBig": "exceeds maximum size of",
      "invalidType": "is not a supported file type"
    }
  },
  "error": {
    "boundary": {
      "title": "Something went wrong",
      "message": "An unexpected error occurred. Please try refreshing the page.",
      "details": "Error details",
      "reload": "Reload Page",
      "goHome": "Go to Home"
    },
    "notFound": {
      "title": "Page Not Found",
      "message": "The page you are looking for does not exist or has been moved.",
      "goHome": "Go to Home",
      "goDashboard": "Go to Dashboard"
    }
  },
  "errors": {
    "lineNumber": "Line {{number}}"
  },
  "enums": {
    "boolean": {
      "true": "Yes",
      "false": "No"
    },
    "jobType": {
      "IMPLEMENTATION": "Implementation",
      "OVERHEAD": "Overhead",
      "SUPPORT": "Support"
    },
    "glPostingKind": {
      "ANY": "Any document",
      "ISSUED_INVOICE": "Issued invoice",
      "RECEIVED_INVOICE": "Received invoice",
      "CASH_RECEIPT": "Cash receipt",
      "CASH_EXPENSE": "Cash expense",
      "BANK_RECEIPT": "Bank receipt",
      "BANK_EXPENSE": "Bank expense",
      "PAYABLE": "Other payable",
      "RECEIVABLE": "Other receivable",
      "INTERNAL": "Internal document"
    },
    "vatCodeDirection": {
      "RECEIVED": "Received documents",
      "ISSUED": "Issued documents"
    },
    "vatPostingDirection": {
      "INCOME": "Income",
      "EXPENSE": "Expense"
    },
    "jobStatus": {
      "PLANNED": "Planned",
      "ACTIVE": "Active",
      "SUSPENDED": "Suspended",
      "CLOSED": "Closed"
    },
    "documentAttachmentRole": {
      "SOURCE_DOCUMENT": "Source document",
      "EMAIL_BODY": "Source email",
      "EMAIL_ATTACHMENT": "Email attachment",
      "ISDOC": "ISDOC",
      "ATTACHMENT": "Attachment",
      "SYNC_ATTACHMENT": "File from an integration"
    },
    "priority": {
      "all": "All Priorities",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "documentType": {
      "UNKNOWN": "Unknown",
      "INVOICE": "Invoice",
      "RECEIPT": "Receipt",
      "PROFORMA": "Proforma Invoice",
      "ADVANCE": "Advance Invoice",
      "CREDIT_NOTE": "Credit Note",
      "DEBIT_NOTE": "Debit Note",
      "CONTRACT": "Contract",
      "OTHER": "Other"
    },
    "processingStatus": {
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "EXTRACTED": "Extracted",
      "COMPLETED": "Completed",
      "FAILED": "Failed",
      "QUOTA_EXCEEDED": "Quota Exceeded",
      "UNSUPPORTED_DOCUMENT": "Unsupported Type",
      "PASSWORD_PROTECTED": "Password Protected"
    },
    "validationStatus": {
      "UNPROCESSED": "Unprocessed",
      "PENDING": "Processing",
      "SUCCESS": "Validated",
      "WARNING": "Warning",
      "ERROR": "Validation error",
      "WAITING_FOR_CREDITS": "Waiting for credits"
    },
    "creditOperation": {
      "DOCUMENT_SCAN": "Document extraction",
      "DOCUMENT_ISDOC": "ISDOC document import",
      "VALIDATION": "Document validation",
      "APPROVAL": "Approval",
      "APPROVAL_PREVIEW": "AI approval preview",
      "ATTACHMENT_CLASSIFICATION": "E-mail attachment classification",
      "MATCH_CONFIRMATION": "AI invoice match confirmation",
      "MORNING_BRIEFING": "Morning briefing",
      "CHAT": "AI chat message"
    },
    "invoiceStatus": {
      "all": "All statuses",
      "DRAFT": "Draft",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "SUBMITTED": "Submitted for approval",
      "FOR_APPROVAL": "For approval"
    },
    "approvalStatus": {
      "UNPROCESSED": "To process",
      "PENDING": "For approval",
      "FOR_REVIEW": "For approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected"
    },
    "requisitionApprovalStatus": {
      "APPROVED": "Approved",
      "FOR_REVIEW": "For approval",
      "REJECTED": "Rejected"
    },
    "changeSource": {
      "USER": "User",
      "EXTRACTION": "Extraction",
      "VALIDATION": "Validation",
      "AI_APPROVAL": "AI approval",
      "APPROVAL_SKIPPED": "Approval skipped",
      "AUTOFILL": "Autofill",
      "SYNC": "Sync",
      "MATCHING": "Matching",
      "AI_MATCHING": "AI matching",
      "COVERAGE": "Order coverage",
      "RENEWAL": "Automatic renewal"
    },
    "paymentStatus": {
      "PAID": "Paid",
      "PARTIALLY_PAID": "Partially Paid",
      "UNPAID": "Unpaid"
    },
    "invoicePostingStatus": {
      "NOT_POSTED": "Not Posted",
      "POSTED": "Posted",
      "CANCELLED": "Cancelled"
    },
    "invoiceType": {
      "UNKNOWN": "Unknown",
      "INVOICE": "Invoice",
      "CREDIT_NOTE": "Credit Note",
      "DEBIT_NOTE": "Debit Note",
      "PROFORMA": "Proforma Invoice",
      "ADVANCE": "Advance Tax Document",
      "RECEIPT": "Receipt",
      "OTHER": "Other Document Type"
    },
    "invoiceDocumentType": {
      "INVOICE": "Invoice",
      "CREDIT_NOTE": "Credit Note",
      "DEBIT_NOTE": "Debit Note",
      "PROFORMA": "Proforma Invoice"
    },
    "isdocDocumentType": {
      "INVOICE": "Invoice",
      "CREDIT_NOTE": "Credit Note",
      "DEBIT_NOTE": "Debit Note",
      "PROFORMA": "Proforma Invoice",
      "ADVANCE_PAYMENT": "Advance Payment Invoice (with VAT)",
      "CREDIT_NOTE_FOR_ADVANCE": "Credit Note for Advance Payment",
      "SIMPLIFIED_TAX_DOCUMENT": "Simplified Tax Document"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Bank Transfer",
      "CASH": "Cash",
      "CARD": "Card",
      "CHECK": "Check",
      "DIRECT_DEBIT": "Direct Debit",
      "CLEARING": "Clearing",
      "OTHER": "Other"
    },
    "invoicePurpose": {
      "GOODS": "Goods",
      "SERVICES": "Services",
      "FREIGHT": "Freight/Shipping",
      "SUMMARY": "Summary/Consolidated",
      "PARTIAL": "Partial/Progress",
      "FINAL": "Final",
      "SETTLEMENT": "Settlement",
      "MIXED": "Mixed (Goods & Services)"
    },
    "vatMode": {
      "STANDARD": "Standard VAT",
      "REVERSE_CHARGE": "Reverse Charge",
      "EXEMPT_DOMESTIC": "Exempt — Domestic",
      "EXEMPT_EU_SUPPLY": "Exempt — EU Supply",
      "EXEMPT_EXPORT": "Exempt — Export",
      "EXEMPT_OTHER": "VAT exempt"
    },
    "vatPayerType": {
      "PAYER": "VAT payer",
      "NON_PAYER": "Not a VAT payer",
      "IDENTIFIED_PERSON": "Identified person"
    },
    "invoiceDirection": {
      "ISSUED": "Issued/Outgoing",
      "RECEIVED": "Received/Incoming",
      "INTERNAL": "Internal/Intercompany"
    },
    "currencyCode": {
      "CZK": "CZK",
      "EUR": "€",
      "USD": "$"
    },
    "userRole": {
      "ADMIN": "Administrator",
      "SECURITY_ADMIN": "Security Administrator",
      "ACCOUNTANT": "Accountant",
      "APPROVER": "Approver",
      "RULES_MANAGER": "Rules Manager",
      "CODE_LISTS_MANAGER": "Code Lists Manager",
      "SYSTEM_BILLING_ADMIN": "System Billing Administrator",
      "SYSTEM_SUPPORT_ADMIN": "System Support Administrator",
      "MEMBER": "Member"
    },
    "userRoleDescription": {
      "MEMBER": "Views documents, companies and code lists, creates invoices, requisitions and purchase orders, and receives goods. Approves nothing and changes no settings.",
      "ADMIN": "Manages the whole account: users, settings, plan, code lists, approvers and integrations.",
      "ACCOUNTANT": "Edits, approves, matches and exports invoices, manages companies, reprocesses and deletes documents, prepares payment runs and records payments.",
      "APPROVER": "Approves invoices, requisitions and purchase orders, approves and releases payment runs, and confirms that payments were paid.",
      "RULES_MANAGER": "Manages the rules for checking and approving documents.",
      "CODE_LISTS_MANAGER": "Manages cost centers, jobs, the organizational structure and the product catalog.",
      "SECURITY_ADMIN": "Manages users, API keys, webhooks, integrations and account settings.",
      "SYSTEM_BILLING_ADMIN": "Manages billing across accounts in the platform administration.",
      "SYSTEM_SUPPORT_ADMIN": "Platform support: impersonation and the bridge plugin catalogue."
    },
    "masterAccountRole": {
      "MASTER_ADMIN": "Office Administrator",
      "MASTER_HEAD_ACCOUNTANT": "Head accountant",
      "MASTER_ACCOUNTANT": "Office Accountant"
    },
    "masterAccountRoleDescription": {
      "MASTER_ADMIN": "Manages clients, the office's people and their assignments, the plan and the office's details. Administrator at every client.",
      "MASTER_HEAD_ACCOUNTANT": "Works as an accountant at every client of the office and distributes the clients among the accountants.",
      "MASTER_ACCOUNTANT": "Sees the office board. Works as an accountant at the assigned clients; does not manage the client's code lists."
    },
    "accountStatus": {
      "ACTIVE": "Active",
      "DEACTIVATED": "Deactivated",
      "PENDING": "Invitation Sent"
    },
    "syncDirection": {
      "IN": "Inbound (external → Tappeer)",
      "OUT": "Outbound (Tappeer → external)"
    },
    "attachmentTransferStatus": {
      "PENDING": "Queued",
      "RUNNING": "Transferring",
      "DONE": "Transferred",
      "FAILED": "Failed",
      "REFUSED": "Refused"
    },
    "integrationActivityType": {
      "BRIDGE_REGISTERED": "Bridge registered",
      "BRIDGE_ENROLLMENT_CODE_REGENERATED": "Enrollment code reissued",
      "BRIDGE_ENROLLED": "Bridge enrolled",
      "BRIDGE_ENROLLMENT_REJECTED": "Enrollment refused",
      "BRIDGE_AUTH_REJECTED": "Connection refused",
      "BRIDGE_CONNECTED": "Bridge connected",
      "BRIDGE_DISCONNECTED": "Bridge disconnected",
      "BRIDGE_WENT_OFFLINE": "Bridge went offline",
      "BRIDGE_CAME_ONLINE": "Bridge came back online",
      "BRIDGE_REVOKED": "Bridge revoked",
      "BRIDGE_DELETED": "Bridge deleted",
      "MASTER_ACCOUNT_BRIDGE_ACCESS_ENDED": "Office bridge access ended",
      "BRIDGE_TRANSFERRED_TO_MASTER_ACCOUNT": "Bridge handed to the office",
      "BRIDGE_CLOCK_SKEW_WARNING": "Clock out of sync",
      "BRIDGE_AGENT_ERROR": "Agent error",
      "BRIDGE_PLUGIN_REGISTERED": "Target system added",
      "BRIDGE_PLUGIN_REMOVED": "Target system removed",
      "BRIDGE_PLUGIN_VERSION_CHANGED": "Target system updated",
      "PLUGIN_INSTANCE_CREATED": "Integration created",
      "PLUGIN_INSTANCE_UPDATED": "Integration updated",
      "PLUGIN_INSTANCE_DELETED": "Integration deleted",
      "PLUGIN_INSTANCE_ENABLED": "Integration enabled",
      "PLUGIN_INSTANCE_DISABLED": "Integration disabled",
      "PLUGIN_LINK_UNLINKED": "Record unlinked",
      "PLUGIN_LINK_RELINKED": "Record relinked",
      "PLUGIN_LINK_PROMOTED": "Duplicate company record became primary",
      "PLUGIN_LINK_PRIMARY_SET": "Duplicate company record set as primary",
      "PLUGIN_LINK_CONFIRMED": "Match confirmed",
      "SYNC_RUN_STARTED": "Sync started",
      "SYNC_RUN_COMPLETED": "Sync completed",
      "SYNC_RUN_FAILED": "Sync failed",
      "SYNC_RECORDS_SKIPPED": "Records skipped",
      "SYNC_RECORDS_DEACTIVATED": "Records missing at the source deactivated",
      "SYNC_ATTACHMENT_TRANSFER_RETRIED": "Attachment transfer retried",
      "SYNC_ATTACHMENTS_REPUSHED": "Attachments re-pushed",
      "SYNC_OUTBOUND_EVENT_DEAD": "Outbound change not delivered",
      "SYNC_OUTBOUND_FULL_FALLBACK": "Bulk changes sent as a full sync",
      "INTEGRATION_CREATED_FROM_TEMPLATE": "Created from the office’s template",
      "INTEGRATION_TEMPLATE_APPLIED": "Template applied to clients",
      "SYNC_RECORDS_MISSING": "Records missing at the source",
      "SYNC_MISSING_HELD": "Retirement held for confirmation",
      "SYNC_MISSING_HOLD_DECIDED": "Held batch decided",
      "SYNC_MISSING_APPLY_FAILED": "Retirement failed"
    },
    "integrationActivitySeverity": {
      "INFO": "Info",
      "WARN": "Warning",
      "ERROR": "Error"
    },
    "integrationActivityCategory": {
      "BRIDGE": "Bridge",
      "PLUGIN": "Plugin",
      "SYNC": "Sync"
    },
    "syncRunStatus": {
      "RUNNING": "Running",
      "COMPLETED": "Completed",
      "FAILED": "Failed",
      "LOST": "Lost"
    },
    "bridgeRunPriority": {
      "PUSH": "Sending changes",
      "BULK": "Sync"
    },
    "entityLinkStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNLINKED": "Unlinked"
    },
    "entityLinkMatchedBy": {
      "LINK": "Existing link",
      "CODE": "Code",
      "COMPANY_ID": "Company ID",
      "VAT_ID": "VAT ID",
      "EMAIL": "E-mail",
      "INVOICE_NUMBER": "Invoice number",
      "MARKER": "Marker",
      "CREATED": "Created by a sync",
      "MANUAL": "Manually"
    },
    "syncMissingReason": {
      "absent": "A full sync did not return it",
      "tombstone": "The source reported it deleted"
    },
    "missingHoldReason": {
      "batch": "50 or more records went missing within a day.",
      "share": "10% or more of the active records went missing within a day.",
      "small-stream": "A large part of a small set of records went missing.",
      "empty-export": "The source returned no records at all.",
      "legacy-mark": "These records were marked missing before this version of Tappeer."
    },
    "syncMissingAction": {
      "deactivate": "Deactivated",
      "delete": "Removed",
      "info": "Only marked"
    },
    "deletionMode": {
      "deactivate": "Deactivate",
      "delete": "Remove",
      "info": "Only mark"
    },
    "integrationEntityType": {
      "party": "Parties",
      "partyDescription": "Suppliers and customers — the companies Tappeer keeps invoices for.",
      "cost-center": "Cost centers",
      "cost-centerDescription": "The cost centers Tappeer assigns invoices and requisitions to.",
      "product": "Products",
      "productDescription": "The products and services catalogue synced from the ERP.",
      "requisition": "Requisitions",
      "requisitionDescription": "Approved purchase requisitions with their lines — sent to the ERP only, never read back.",
      "purchase-order": "Purchase orders",
      "purchase-orderDescription": "Purchase orders sent to the ERP or received from it, with their lines.",
      "goods-receipt": "Goods receipts",
      "goods-receiptDescription": "Goods receipts against purchase orders — what actually arrived, and how much.",
      "invoice": "Invoices",
      "invoiceDescription": "Received and issued invoices — the documents Tappeer approves and pays.",
      "job": "Jobs",
      "jobDescription": "Jobs from the ERP — the second cost dimension next to cost centers, which Tappeer assigns documents to.",
      "org-unit": "Org units",
      "org-unitDescription": "Units imported from the directory (LDAP / Active Directory) — the company's organizational structure.",
      "org-unit-member": "Org unit members",
      "org-unit-memberDescription": "Assignments of users to units — who belongs to which unit.",
      "gl-posting": "Posting templates",
      "gl-postingDescription": "Posting templates (předkontace) the accounting system owns — synced into Tappeer only, never sent back.",
      "vat-code": "VAT classification",
      "vat-codeDescription": "VAT classification codes (členění DPH) the accounting system owns — synced into Tappeer only, never sent back.",
      "vat-posting": "VAT posting rules",
      "vat-postingDescription": "VAT posting rules (zaúčtování DPH) the accounting system owns — synced into Tappeer only, never sent back.",
      "bank-document": "Bank, cash and internal documents",
      "bank-documentDescription": "Documents the accounting system owns, with the invoices they pay — synced into Tappeer only, never sent back."
    },
    "connectorHealth": {
      "never": "Never ran",
      "running": "Running",
      "ok": "Last run succeeded",
      "warnings": "Last run had problems",
      "failed": "Last run failed"
    },
    "pluginConfigStatus": {
      "UP_TO_DATE": "Up to date",
      "OUTDATED": "Outdated",
      "NEEDS_REVIEW": "Needs review"
    },
    "pluginTransport": {
      "DIRECT": "Direct",
      "BRIDGED": "Through a bridge"
    },
    "requisitionStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Submitted",
      "FOR_APPROVAL": "For approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "ORDERED": "Ordered",
      "CLOSED": "Closed",
      "CANCELLED": "Cancelled"
    },
    "requisitionDisplayStatus": {
      "DRAFT": "Draft",
      "FOR_APPROVAL": "For approval",
      "TO_ORDER": "To order",
      "AWAITING_DELIVERY": "Awaiting delivery",
      "AWAITING_INVOICE": "Awaiting invoice",
      "AWAITING_DELIVERY_AND_INVOICE": "Awaiting delivery and invoice",
      "AWAITING_COMPLETION": "Awaiting completion",
      "REJECTED": "Rejected",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "purchaseOrderStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Submitted",
      "FOR_APPROVAL": "For approval",
      "PRE_APPROVED": "Pre-approved",
      "APPROVED": "Approved",
      "DISPATCHED": "Sent to supplier",
      "REJECTED": "Rejected",
      "CLOSED": "Closed",
      "CANCELLED": "Cancelled"
    },
    "invoiceDisplayStatus": {
      "FOR_EDIT": "For editing",
      "FOR_APPROVAL": "For approval",
      "REJECTED": "Rejected",
      "TO_POST": "To post",
      "TO_PAY": "To pay",
      "TO_POST_AND_PAY": "To post and pay",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "purchaseOrderDisplayStatus": {
      "DRAFT": "Draft",
      "FOR_APPROVAL": "For approval",
      "TO_SEND": "To send",
      "AWAITING_DELIVERY": "Awaiting delivery",
      "AWAITING_INVOICE": "Awaiting invoice",
      "AWAITING_DELIVERY_AND_INVOICE": "Awaiting delivery and invoice",
      "AWAITING_COMPLETION": "Awaiting completion",
      "REJECTED": "Rejected",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "deliveryStatus": {
      "NOT_DELIVERED": "Not delivered",
      "PARTIALLY_DELIVERED": "Partially delivered",
      "DELIVERED": "Delivered"
    },
    "invoicedStatus": {
      "NOT_INVOICED": "Not invoiced",
      "PARTIALLY_INVOICED": "Partially invoiced",
      "INVOICED": "Invoiced"
    },
    "procurementRelationship": {
      "RAISED_FOR_ME": "Raised for me",
      "RAISED_BY_ME": "Raised by me",
      "HANDED_TO_ME": "Handed to me",
      "ASKED_TO_DECIDE": "Asked to decide",
      "BUYING_IT": "Buying it",
      "RECEIVED_BY_ME": "Received by me"
    },
    "documentHistoryEventType": {
      "CREATED": "Created",
      "UPDATED": "Updated",
      "STATUS_CHANGED": "Status changed",
      "APPROVAL_STATUS_CHANGED": "Approval changed",
      "ARCHIVED": "Archived",
      "UNARCHIVED": "Unarchived",
      "DOCUMENT_LINKED": "Document linked",
      "DOCUMENT_UNLINKED": "Document unlinked",
      "ATTACHMENT_ADDED": "Attachment added",
      "ATTACHMENT_REMOVED": "Attachment removed",
      "TERM_ADDED": "Term added",
      "TERM_CHANGED": "Term changed",
      "TERM_REMOVED": "Term removed"
    },
    "goodsReceiptStatus": {
      "DRAFT": "Draft",
      "RECEIVED": "Received",
      "PARTIALLY_RECEIVED": "Partially received",
      "INSPECTED": "Inspected",
      "REJECTED": "Refused",
      "CANCELLED": "Cancelled"
    },
    "incotermsCode": {
      "EXW": "EXW – Ex Works",
      "FCA": "FCA – Free Carrier",
      "CPT": "CPT – Carriage Paid To",
      "CIP": "CIP – Carriage and Insurance Paid To",
      "DAP": "DAP – Delivered at Place",
      "DPU": "DPU – Delivered at Place Unloaded",
      "DDP": "DDP – Delivered Duty Paid",
      "FAS": "FAS – Free Alongside Ship",
      "FOB": "FOB – Free on Board",
      "CFR": "CFR – Cost and Freight",
      "CIF": "CIF – Cost, Insurance and Freight"
    },
    "productType": {
      "PRODUCT": "Goods",
      "SERVICE": "Service"
    },
    "procurementDocumentType": {
      "REQUISITION": "Requisition",
      "PURCHASE_ORDER": "Purchase order",
      "GOODS_RECEIPT": "Delivery note",
      "INVOICE": "Invoice"
    },
    "contractStatus": {
      "DRAFT": "Draft",
      "ACTIVE": "Active",
      "TERMINATED": "Terminated"
    },
    "contractDisplayStatus": {
      "DRAFT": "Draft",
      "IN_FORCE": "In force",
      "TERMINATING": "Notice given",
      "ENDED": "Ended",
      "NOT_YET_IN_FORCE": "Not yet in force"
    },
    "contractDirection": {
      "SUPPLIER": "Supplier",
      "CUSTOMER": "Customer"
    },
    "contractType": {
      "PURCHASE": "Purchase agreement",
      "WORK": "Contract for work",
      "SERVICES": "Service agreement",
      "FRAMEWORK": "Framework agreement",
      "LEASE": "Lease agreement",
      "LICENSE": "Licence agreement",
      "SERVICE_MAINTENANCE": "Maintenance agreement",
      "COOPERATION": "Cooperation agreement",
      "NDA": "Non-disclosure agreement (NDA)",
      "EMPLOYMENT": "Employment contract",
      "OTHER": "Other"
    },
    "contractTermOrigin": {
      "INITIAL": "Initial",
      "MANUAL": "Renewal (manual)",
      "AUTOMATIC": "Automatic renewal"
    },
    "contractTermPeriod": {
      "PAST": "Past",
      "CURRENT": "Current",
      "FUTURE": "Future"
    },
    "contractLinkSource": {
      "MANUAL": "Manual",
      "ORDER": "From the order",
      "SUGGESTED": "Suggested"
    },
    "contractNotCountedReason": {
      "NOT_YET_COUNTING": "Not counted yet",
      "OTHER_CURRENCY": "Other currency",
      "OUT_OF_TERM": "Outside the term"
    },
    "matchType": {
      "AUTO": "Automatic",
      "MANUAL": "Manual",
      "AI": "AI proposal"
    },
    "matchPairingRung": {
      "CODE": "item code",
      "EAN": "EAN",
      "DESCRIPTION": "description",
      "ELIMINATION": "elimination"
    },
    "matchFindingType": {
      "UNRESOLVABLE_REFERENCE": "Order cannot be found",
      "AMBIGUOUS_ORDER": "Ambiguous order",
      "SUPPLIER_MISMATCH": "Different supplier",
      "UNKNOWN_LINE": "Unknown line",
      "AMBIGUOUS_PAIRING": "Ambiguous pairing",
      "WEAK_PAIRING": "Paired by resemblance"
    },
    "matchFindingAnswer": {
      "ACCEPTED": "Accepted",
      "REJECTED": "Rejected",
      "PAIRED": "Paired",
      "LEAVE_OPEN": "Left open"
    },
    "matchReviewOutcome": {
      "APPLIED": "Recorded",
      "LEFT_OPEN": "Left for a decision",
      "BELOW_THRESHOLD": "Low confidence",
      "SKIPPED": "Skipped"
    },
    "matchFindingResolution": {
      "OPEN": "Open",
      "ACCEPTED": "Accepted",
      "REJECTED": "Rejected",
      "RESOLVED": "Resolved"
    },
    "matchFindingSubjectType": {
      "INVOICE_LINE": "Invoice line",
      "MATCH_LINK": "Pairing"
    },
    "approverFallbackStrategy": {
      "MANUAL_APPROVER_SELECTION": "Manual approver selection",
      "ANYONE_WITH_PERMISSION": "Anybody who may approve",
      "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The requester’s superior",
      "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The superior by the unit on the document",
      "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Head of the chosen unit",
      "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Anybody in the chosen unit",
      "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Anybody holding the chosen role",
      "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "A specific user",
      "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "The approver suggested on the document"
    },
    "assignableEntityType": {
      "REQUISITION": "Requisition",
      "PURCHASE_ORDER": "Purchase order",
      "INVOICE": "Invoice"
    },
    "numberSeriesDocumentType": {
      "REQUISITION": "Requisition",
      "PURCHASE_ORDER": "Purchase order",
      "GOODS_RECEIPT": "Goods receipt",
      "CONTRACT": "Contract",
      "PAYMENT_RUN": "Payment run",
      "EXTRACTED_DOCUMENT": "Extracted document"
    },
    "masterAccountMemberClassification": {
      "EMPLOYEE": "Company employee",
      "MASTER_ACCOUNT_MEMBER": "Office member"
    },
    "bankAccountVerificationState": {
      "UNVERIFIED": "Unverified",
      "PENDING": "Waiting for the second signature",
      "VERIFIED": "Verified",
      "REJECTED": "Rejected",
      "REVOKED": "Revoked"
    },
    "bankAccountSource": {
      "MANUAL": "Entered by hand",
      "ERP": "From the ERP",
      "INVOICE": "From an invoice"
    },
    "bankAccountScheme": {
      "IBAN": "IBAN",
      "CZ": "Czech account",
      "SK": "Slovak account",
      "GB_SORT_CODE": "UK account (sort code)",
      "US_ABA": "US account (ABA)",
      "OTHER": "Account in another country"
    },
    "partyBankAccountEventType": {
      "CREATED": "Account added",
      "FIRST_SIGNED": "First signature",
      "SYSTEM_CHECKED": "First signature by the system",
      "VERIFIED": "Second signature, account verified",
      "REJECTED": "Account rejected",
      "REVOKED": "Verification revoked",
      "DEACTIVATED": "Account deactivated"
    },
    "bankMovementSource": {
      "STATEMENT": "Bank statement",
      "ERP": "ERP"
    },
    "bankMovementChannel": {
      "BANK": "Bank",
      "CASH": "Cash desk",
      "INTERNAL": "Internal document"
    },
    "bankMovementDirection": {
      "INCOMING": "Incoming",
      "OUTGOING": "Outgoing"
    },
    "bankMovementResolution": {
      "UNMATCHED": "Unmatched",
      "PROPOSED": "Proposed",
      "MATCHED": "Matched",
      "NOT_APPLICABLE": "Not applicable",
      "DISMISSED": "Dismissed"
    },
    "bankStatementFormat": {
      "CAMT_053": "CAMT.053",
      "MT940": "MT940",
      "ABO_GPC": "ABO (GPC)"
    },
    "creditorReferenceType": {
      "RF": "RF reference",
      "CZ_SK_SYMBOLS": "Symbols (VS, KS, SS)",
      "FREE": "Free text"
    },
    "paymentInstructionStatus": {
      "PLANNED": "Planned",
      "RELEASED": "Released",
      "SENT": "In the bank file",
      "CONFIRMED": "Confirmed",
      "RETURNED": "Returned by the bank",
      "FAILED": "Failed",
      "CANCELLED": "Cancelled"
    },
    "paymentConfirmationSource": {
      "STATEMENT": "Bank statement",
      "ERP": "ERP",
      "HUMAN": "By hand"
    },
    "paymentRunStatus": {
      "DRAFT": "Draft",
      "PROPOSED": "Awaiting approval",
      "APPROVED": "Approved",
      "RELEASED": "Released",
      "EXPORTED": "Exported",
      "CONFIRMED": "Confirmed",
      "CANCELLED": "Cancelled"
    },
    "payableClause": {
      "NOT_APPROVED": "not approved",
      "RESERVED": "held by a released run",
      "NOTHING_OUTSTANDING": "nothing left to pay",
      "NO_VERIFIED_ACCOUNT": "the supplier has no verified account",
      "AMBIGUOUS_ACCOUNT": "more than one verified account fits",
      "OVER_BILLED": "the order is over-billed",
      "ERP_REPORTS_PAID": "the ERP reports it paid",
      "ARCHIVED": "archived",
      "CANCELLED": "cancelled"
    },
    "paymentExportFormat": {
      "SEPA_PAIN_001": "SEPA (pain.001)",
      "ABO": "ABO (KPC)"
    },
    "bankStatementImportStatus": {
      "PENDING": "Waiting",
      "PROCESSING": "Reading",
      "DONE": "Read",
      "FAILED": "Not read"
    },
    "bankMovementProposalKind": {
      "IDENTITY": "Identifier match",
      "REFERENCE": "Reference match",
      "RESEMBLANCE": "Resemblance",
      "RETURN": "Return",
      "MANUAL": "Manual match",
      "SUM": "Sum of payments"
    },
    "bankMovementProposalStatus": {
      "OPEN": "Open",
      "ACCEPTED": "Accepted",
      "REJECTED": "Rejected",
      "SUPERSEDED": "Superseded"
    },
    "bankMovementProposalReason": {
      "AMOUNT_DIFFERS": "The amount differs from the payment's.",
      "COUNTERPARTY_DIFFERS": "The money went to another account than the payment's.",
      "COUNTERPARTY_MISSING": "The statement doesn't name the counterparty's account.",
      "REFERENCE_AMBIGUOUS": "More than one payment has the same reference.",
      "PAYMENT_NOT_SENT": "The payment hasn't been in a bank file yet.",
      "PAYMENT_NOT_LIVE": "The payment no longer stands: it is cancelled, failed or returned.",
      "CURRENCY_DIFFERS": "The currency differs from the payment's.",
      "UPLOADED_BY_RUN_AUTHOR": "The statement was uploaded by someone who prepared the payment's run, so we don't match it ourselves.",
      "DUPLICATE": "Another movement already confirmed this payment; it may be a double debit.",
      "PREVIOUSLY_REVOKED": "This match was revoked before."
    },
    "paymentDifferenceKind": {
      "FEE": "Bank fee",
      "FX_DIFFERENCE": "FX difference",
      "PARTIAL": "Partial payment",
      "RETURNED": "Returned by the bank"
    }
  },
  "features": {
    "attachments": {
      "title": "Attachments",
      "empty": "No attachments",
      "add": "Add attachment",
      "download": "Download {{fileName}}",
      "preview": "Open preview",
      "previewClose": "Close",
      "previewDownload": "Download",
      "remove": "Remove attachment",
      "removeTitle": "Remove attachment",
      "removeMessage": "The attachment {{fileName}} will be removed from the document for good.",
      "cancel": "Cancel",
      "confirmUpload": "Upload ({{count}})",
      "staged": "Files to upload ({{count}})",
      "removeStaged": "Remove {{fileName}} from the list",
      "addTitle": "Add attachments",
      "addDescription": "The selected files are attached to the document and stay available for download.",
      "uploadTitle": "Drop files here",
      "uploadDescription": "Or pick them from the computer",
      "errors": {
        "refused": "The file cannot be attached — its content does not match the extension.",
        "documentLocked": "The document can no longer be edited; its attachments stay as they are.",
        "tooLarge": "The file is too large.",
        "uploadFailed": "Attaching the file failed.",
        "tooManyFiles_one": "Only {{count}} file can be attached at once.",
        "tooManyFiles_other": "At most {{count}} files can be attached at once.",
        "limitReached": "The document already carries the maximum number of attachments.",
        "busy": "The file cannot be processed right now. Try again in a moment.",
        "tooSlow": "The connection is too slow for this file. Try again on a faster connection.",
        "filesFailed": "These files could not be attached: {{files}}.",
        "removeFailed": "Removing the attachment failed."
      }
    },
    "aiChat": {
      "title": "Tappeer AI",
      "connectingMessage": "Thinking…",
      "unread": "New message from the assistant",
      "online": "Online",
      "collapsePanel": "Collapse the chat",
      "expandPanel": "Expand the chat",
      "openChat": "Open Tappeer AI",
      "launcherHint": "Ask Tappeer about invoices, approvals or expenses.",
      "inputPlaceholder": "Ask me anything…",
      "typingMessage": "Tappeer is typing",
      "userLabel": "You",
      "inputActions": {
        "quickActions": "Quick actions",
        "help": "Help"
      },
      "quickActions": {
        "title": "Quick actions",
        "subtitle": "Pick one to send it right away. Some need a detail from you.",
        "needsInput": "fill in",
        "needsInputHint": "Add a detail, then send",
        "topics": {
          "daily": "Your day",
          "invoices": "Invoices",
          "reporting": "Reports",
          "partners": "Partners"
        },
        "myWork": "What's waiting for my approval?",
        "myRequests": "How are my requests and orders doing?",
        "invoiceLookup": "Find invoices from a supplier",
        "duePayments": "What do we need to pay this week?",
        "overdue": "Which invoices are overdue?",
        "spend": "How much did we spend this month?",
        "report": "Show me a chart of spending by supplier this year",
        "matching": "Which invoices have open matching findings?",
        "gettingStarted": "How do I set up Tappeer?",
        "invoiceIssues": "Which invoices have validation errors?",
        "purchaseOrders": "Show me our open purchase orders",
        "partnerVerify": "Check this partner's company ID and VAT status",
        "mailbox": "What is our invoice email address?",
        "plan": "What plan are we on and how much quota is left?",
        "syncStatus": "Are our integrations syncing correctly?",
        "notifications": "What happened while I was away?",
        "partnerLookup": "Show me the details of a partner"
      },
      "help": {
        "title": "How to use Tappeer AI",
        "intro": "Tappeer AI is an assistant that can see your invoices, orders and partners. Ask in plain language — English or Czech. It only answers from your account's data, and only what you have permission to see.",
        "capabilitiesTitle": "What it can do",
        "capabilities": {
          "invoices": "Invoices — find an invoice and show its line items, history and validation problems.",
          "approvals": "Approvals — approve, reject or revert an invoice (always after you confirm).",
          "payments": "Payments — what's overdue, what's due in a period, and how to pay an invoice.",
          "spend": "Reports & charts — spending totals, averages and supplier rankings over a period, rendered as graphs.",
          "matching": "Matching — how invoice lines pair with order lines and which findings are open.",
          "orders": "Orders and requests — what was ordered, what arrived, and where your request stands.",
          "partners": "Partners — search, details, company ID / VAT checks, and adding new partners.",
          "account": "Account — plan, extraction usage, settings, users and the invoice email address.",
          "gettingStarted": "Getting started — walks you through setup and points you to the right page.",
          "validation": "Validation — which invoices have errors or warnings, and what exactly is wrong.",
          "notifications": "Your day — what is waiting for your decision and what changed while you were away.",
          "banking": "Bank details — verify a partner's account against the public register before paying."
        },
        "tipsTitle": "Tips for better answers",
        "tips": {
          "beSpecific": "Be specific — name the invoice number, the supplier or the period.",
          "followUp": "Ask follow-ups. It remembers the earlier messages in the conversation.",
          "confirm": "Anything that changes data arrives as a proposal — it only runs once you confirm.",
          "reset": "Start a fresh conversation with the reset button in the chat header."
        },
        "limitsTitle": "Good to know",
        "limits": {
          "permissions": "It only sees your account's data, and only what your role allows.",
          "accuracy": "It can get things wrong — double-check important numbers against the invoice."
        },
        "close": "Close",
        "admin": {
          "title": "For administrators",
          "mailbox": "Invoice mailbox — the address suppliers send invoices to.",
          "plan": "Plan & quota — your subscription, extraction limits and how much is left.",
          "usage": "Usage — how many documents were extracted, and by whom.",
          "settings": "Setup check — which parts of the configuration are missing or failing.",
          "sync": "Integrations — sync status, recent activity, and retrying failed runs.",
          "users": "Users — who has access, and inviting new people to the account."
        }
      },
      "emptyState": {
        "title": "Let's get started",
        "subtitle": "Ask me anything about your invoices, approvals, or spending — or pick one of the ideas below.",
        "suggestionOverdue": "Which invoices are overdue?",
        "suggestionApprovals": "What's waiting for my approval?",
        "suggestionMyRequests": "How are my requests and orders doing?",
        "suggestionSpend": "Summarize this month's spending"
      },
      "openInvoice": "Open invoice",
      "invoiceCard": {
        "due": "due",
        "errorCount_one": "{{count}} error",
        "errorCount_other": "{{count}} errors",
        "warningCount_one": "{{count}} warning",
        "warningCount_other": "{{count}} warnings",
        "overdueDays_one": "{{count}} day overdue",
        "overdueDays_other": "{{count}} days overdue"
      },
      "invoiceCollection": {
        "title_one": "{{count}} invoice",
        "title_other": "{{count}} invoices",
        "showAll_one": "Show {{count}} invoice",
        "showAll_other": "Show all {{count}}",
        "partialNotice": "Showing {{shown}} of {{total}}. The totals cover everything found.",
        "currencyCount_one": "{{count}} invoice in {{currency}}",
        "currencyCount_other": "{{count}} invoices in {{currency}}",
        "number": "Number",
        "supplier": "Supplier",
        "amount": "Amount",
        "status": "Status",
        "dueDate": "Due date",
        "issues": "Issues"
      },
      "issueCollection": {
        "title": "Validation issues",
        "titleFor": "Issues on {{number}}",
        "showAll_one": "Show {{count}} issue",
        "showAll_other": "Show all {{count}}",
        "partialNotice": "Showing {{shown}} of {{total}}.",
        "severity": "Severity",
        "field": "Field",
        "problem": "Problem",
        "error": "Error",
        "warning": "Warning"
      },
      "resetConfirm": {
        "title": "Start over?",
        "message": "I'll wipe the whole conversation and we start fresh. No undo on this one.",
        "confirm": "Delete conversation"
      },
      "settings": {
        "open": "Chat settings",
        "title": "Chat settings",
        "greetingLabel": "Greet me after signing in",
        "greetingHint": "Tappeer opens the chat once a day and reports what needs your attention.",
        "saveFailed": "Saving didn't work out. Try again.",
        "displayMode": {
          "label": "Where the chat lives",
          "hint": "Pick a floating bubble, a docked side column, or hide the chat entirely.",
          "bubble": "Bubble",
          "docked": "Side panel",
          "hidden": "Hidden"
        }
      },
      "invoiceDetail": {
        "noNumber": "No number",
        "supplier": "Supplier",
        "supplierVatId": "VAT ID",
        "customer": "Customer",
        "invoiceDate": "Invoice date",
        "dueDate": "Due date",
        "taxDate": "Tax date",
        "documentType": "Document type",
        "internalNumber": "Internal number",
        "description": "Description",
        "totalNoVat": "Total excl. VAT",
        "totalVat": "VAT",
        "total": "Total",
        "paymentStatus": "Payment status",
        "paidAmount": "Paid amount",
        "paidDate": "Paid date",
        "paymentMethod": "Payment method",
        "lines": "Line items",
        "history": "Change history",
        "expand": "Show line items & history",
        "collapse": "Hide details"
      },
      "aggregateSummary": {
        "metric": {
          "total": "Total amount",
          "average": "Average invoice amount",
          "count": "Invoice count",
          "min": "Smallest invoice",
          "max": "Largest invoice",
          "median": "Median invoice amount"
        },
        "groupBy": {
          "supplier": "Supplier",
          "month": "Month",
          "quarter": "Quarter",
          "year": "Year",
          "week": "Week",
          "day": "Day",
          "weekday": "Weekday",
          "dayOfMonth": "Day of month",
          "status": "Status",
          "currency": "Currency",
          "paymentMethod": "Payment method"
        },
        "overall": "Overall",
        "noData": "No invoices found for the selected period",
        "invoiceCount": "Invoices",
        "truncated": "Showing top results only"
      },
      "chartLabels": {
        "text": {
          "unknown": "Not specified",
          "unknownSupplier": "Unknown supplier",
          "unknownPeriod": "Unknown period",
          "invoices": "Invoices"
        },
        "invoiceStatus": {
          "draft": "Draft",
          "submitted": "Submitted",
          "forApproval": "For approval",
          "approved": "Approved",
          "rejected": "Rejected",
          "completed": "Completed",
          "archived": "Archived"
        },
        "weekday": {
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday",
          "saturday": "Saturday",
          "sunday": "Sunday"
        },
        "paymentMethod": {
          "BANK_TRANSFER": "Bank transfer",
          "CASH": "Cash",
          "CARD": "Card",
          "CHECK": "Check",
          "DIRECT_DEBIT": "Direct debit",
          "CLEARING": "Clearing",
          "OTHER": "Other"
        }
      },
      "chartExport": {
        "button": "Export",
        "labelHeader": "Label",
        "modal": {
          "title": "Export chart",
          "subtitle": "Choose a format to download the chart",
          "exporting": "Exporting…",
          "error": "Export failed. Please try again.",
          "cancel": "Cancel"
        },
        "formats": {
          "pdf": {
            "title": "PDF",
            "description": "Chart image as seen on screen — for sharing and printing"
          },
          "xlsx": {
            "title": "Excel",
            "description": "Underlying data table — for further analysis"
          }
        }
      },
      "activities": {
        "invoiceSearch": {
          "running": "Looking for invoices…",
          "done": "Invoice search done",
          "failed": "Search didn't work out"
        },
        "invoiceValidationErrors": {
          "running": "Looking for invoices with errors…",
          "done": "Error check done",
          "failed": "Search didn't work out"
        },
        "invoiceAggregate": {
          "running": "Building the report…",
          "done": "Report ready",
          "failed": "That didn't work out"
        },
        "invoicesByStatus": {
          "running": "Counting invoices by status…",
          "done": "Status breakdown done",
          "failed": "That didn't work out"
        },
        "duePaymentsOutlook": {
          "running": "Building the payment outlook…",
          "done": "Payment outlook done",
          "failed": "That didn't work out"
        },
        "invoiceBlockers": {
          "running": "Checking what blocks the invoice…",
          "done": "Blocker check done",
          "failed": "That didn't work out"
        },
        "invoiceDetail": {
          "running": "Opening the invoice…",
          "done": "Invoice lookup done",
          "failed": "Couldn't open it"
        },
        "accountPlan": {
          "running": "Checking your subscription…",
          "done": "Subscription check done",
          "failed": "That didn't work out"
        },
        "settingsCheck": {
          "running": "Checking the settings…",
          "done": "Settings check done",
          "failed": "Check didn't work out"
        },
        "extractionUsage": {
          "running": "Checking extraction usage…",
          "done": "Usage check done",
          "failed": "That didn't work out"
        },
        "inviteUser": {
          "running": "Preparing a proposal…",
          "done": "Invite proposal ready",
          "failed": "Proposal didn't work out"
        },
        "addPartners": {
          "running": "Looking up companies in the register…",
          "done": "Company lookup done",
          "failed": "Lookup didn't work out"
        },
        "approveInvoice": {
          "running": "Preparing a proposal…",
          "done": "Approval proposal ready",
          "failed": "Proposal didn't work out"
        },
        "moveInvoiceStatus": {
          "running": "Preparing a proposal…",
          "done": "Status change proposal ready",
          "failed": "Proposal didn't work out"
        },
        "revertInvoice": {
          "running": "Preparing a proposal…",
          "done": "Revert proposal ready",
          "failed": "Proposal didn't work out"
        },
        "rejectInvoice": {
          "running": "Preparing a proposal…",
          "done": "Rejection proposal ready",
          "failed": "Proposal didn't work out"
        },
        "partnerSearch": {
          "running": "Looking for partners…",
          "done": "Partner search done",
          "failed": "Search didn't work out"
        },
        "partnerDetail": {
          "running": "Opening the partner…",
          "done": "Partner lookup done",
          "failed": "Couldn't open it"
        },
        "partnerVerify": {
          "running": "Verifying the company…",
          "done": "Company verification done",
          "failed": "Verification didn't work out"
        },
        "userDirectory": {
          "running": "Loading the team…",
          "done": "Team lookup done",
          "failed": "Couldn't load it"
        },
        "mailboxAddress": {
          "running": "Looking up the invoice email…",
          "done": "Email check done",
          "failed": "That didn't work out"
        },
        "matchFindings": {
          "running": "Loading matching findings…",
          "done": "Findings lookup done",
          "failed": "Couldn't load them"
        },
        "matchSummary": {
          "running": "Checking the match…",
          "done": "Match check done",
          "failed": "Check didn't work out"
        },
        "answerFinding": {
          "running": "Preparing a proposal…",
          "done": "Answer proposal ready",
          "failed": "Proposal didn't work out"
        },
        "purchaseOrderSearch": {
          "running": "Looking for orders…",
          "done": "Order search done",
          "failed": "Search didn't work out"
        },
        "purchaseOrderDetail": {
          "running": "Opening the order…",
          "done": "Order lookup done",
          "failed": "Couldn't open it"
        },
        "requisitionSearch": {
          "running": "Looking for requisitions…",
          "done": "Requisition search done",
          "failed": "Search didn't work out"
        },
        "requisitionDetail": {
          "running": "Opening the requisition…",
          "done": "Requisition lookup done",
          "failed": "Couldn't open it"
        },
        "duePayments": {
          "running": "Checking due payments…",
          "done": "Due payment check done",
          "failed": "That didn't work out"
        },
        "paymentDetails": {
          "running": "Loading payment details…",
          "done": "Payment details lookup done",
          "failed": "Couldn't load them"
        },
        "myApprovalQueue": {
          "running": "Checking what's waiting for you…",
          "done": "Approval queue checked",
          "failed": "That didn't work out"
        },
        "myNotifications": {
          "running": "Checking what's going on…",
          "done": "Activity checked",
          "failed": "That didn't work out"
        },
        "syncStatus": {
          "running": "Checking the sync…",
          "done": "Sync check done",
          "failed": "Check didn't work out"
        },
        "syncActivity": {
          "running": "Loading sync history…",
          "done": "Sync history lookup done",
          "failed": "Couldn't load it"
        },
        "bridgeStatus": {
          "running": "Checking the Bridge…",
          "done": "Bridge check done",
          "failed": "Couldn’t check it"
        },
        "openInApp": {
          "running": "Grabbing the link…",
          "done": "Link ready",
          "failed": "That didn't work out"
        },
        "bankAccountCheck": {
          "running": "Checking the bank account…",
          "done": "Account check done",
          "failed": "Check didn't work out"
        },
        "partnersVerify": {
          "running": "Checking the register…",
          "done": "Companies checked",
          "failed": "Couldn't check them"
        },
        "invoicesBlockers": {
          "running": "Looking at what is blocking them…",
          "done": "Blockers reviewed",
          "failed": "Couldn't review them"
        },
        "maintainInvoices": {
          "running": "Preparing a proposal…",
          "done": "Housekeeping proposal ready",
          "failed": "Proposal didn't work out"
        },
        "moveInvoicesStatus": {
          "running": "Preparing a proposal…",
          "done": "Status change proposal ready",
          "failed": "Proposal didn't work out"
        },
        "inviteUsers": {
          "running": "Preparing a proposal…",
          "done": "Invitation proposal ready",
          "failed": "Proposal didn't work out"
        },
        "maintainPartners": {
          "running": "Preparing a proposal…",
          "done": "Partner update proposal ready",
          "failed": "Proposal didn't work out"
        },
        "moveRequisitionsStatus": {
          "running": "Preparing a proposal…",
          "done": "Request status proposal ready",
          "failed": "Proposal didn't work out"
        },
        "movePurchaseOrdersStatus": {
          "running": "Preparing a proposal…",
          "done": "Order status proposal ready",
          "failed": "Proposal didn't work out"
        },
        "submitRequisitions": {
          "running": "Preparing a proposal…",
          "done": "Request submission ready",
          "failed": "Proposal didn't work out"
        },
        "submitPurchaseOrders": {
          "running": "Preparing a proposal…",
          "done": "Order submission ready",
          "failed": "Proposal didn't work out"
        },
        "retrySyncs": {
          "running": "Preparing a proposal…",
          "done": "Sync retry proposal ready",
          "failed": "Proposal didn't work out"
        },
        "cancelRequisitions": {
          "running": "Preparing cancellation…",
          "done": "Cancellation prepared",
          "failed": "Couldn't prepare the cancellation"
        },
        "completeRequisitions": {
          "running": "Preparing completion…",
          "done": "Completion prepared",
          "failed": "Couldn't prepare completion"
        },
        "archiveRequisitions": {
          "running": "Preparing archiving…",
          "done": "Archiving prepared",
          "failed": "Couldn't prepare archiving"
        },
        "unarchiveRequisitions": {
          "running": "Preparing unarchiving…",
          "done": "Unarchiving prepared",
          "failed": "Couldn't prepare unarchiving"
        },
        "returnRequisitionsToDraft": {
          "running": "Preparing return to draft…",
          "done": "Return prepared",
          "failed": "Couldn't prepare the return"
        },
        "acceptRequisitionWarnings": {
          "running": "Preparing to accept warnings…",
          "done": "Acceptance prepared",
          "failed": "Couldn't prepare acceptance"
        },
        "deleteRequisitions": {
          "running": "Preparing deletion…",
          "done": "Deletion prepared",
          "failed": "Couldn't prepare deletion"
        },
        "draftRequisition": {
          "running": "Preparing the request…",
          "done": "Request prepared",
          "failed": "Couldn't prepare the request"
        },
        "requisitionValidation": {
          "running": "Checking the request…",
          "done": "Request checked",
          "failed": "Couldn't check the request"
        },
        "requisitionTracking": {
          "running": "Tracking the request…",
          "done": "Request tracked",
          "failed": "Couldn't track the request"
        },
        "draftPurchaseOrder": {
          "running": "Preparing the order…",
          "done": "Order prepared",
          "failed": "Couldn't prepare the order"
        },
        "orderFromRequisition": {
          "running": "Preparing an order from the request…",
          "done": "Order prepared",
          "failed": "Couldn't prepare the order"
        },
        "purchaseOrderValidation": {
          "running": "Checking the order…",
          "done": "Order checked",
          "failed": "Couldn't check the order"
        },
        "purchaseOrderDispatchPreview": {
          "running": "Preparing the e-mail…",
          "done": "E-mail prepared",
          "failed": "Couldn't prepare the e-mail"
        },
        "dispatchPurchaseOrder": {
          "running": "Preparing to send the order…",
          "done": "Sending prepared",
          "failed": "Couldn't prepare sending"
        },
        "outstandingOrders": {
          "running": "Looking for open orders…",
          "done": "Open orders found",
          "failed": "Couldn't load open orders"
        },
        "costCenterSearch": {
          "running": "Looking for cost centres…",
          "done": "Cost centre search done",
          "failed": "Couldn't search cost centres"
        },
        "jobSearch": {
          "running": "Looking for jobs…",
          "done": "Job search done",
          "failed": "Couldn't search jobs"
        },
        "orgUnitSearch": {
          "running": "Looking for org units…",
          "done": "Org unit search done",
          "failed": "Couldn't search org units"
        },
        "cancelPurchaseOrders": {
          "running": "Preparing cancellation…",
          "done": "Cancellation prepared",
          "failed": "Couldn't prepare the cancellation"
        },
        "completePurchaseOrders": {
          "running": "Preparing completion…",
          "done": "Completion prepared",
          "failed": "Couldn't prepare completion"
        },
        "archivePurchaseOrders": {
          "running": "Preparing archiving…",
          "done": "Archiving prepared",
          "failed": "Couldn't prepare archiving"
        },
        "unarchivePurchaseOrders": {
          "running": "Preparing unarchiving…",
          "done": "Unarchiving prepared",
          "failed": "Couldn't prepare unarchiving"
        },
        "returnPurchaseOrdersToDraft": {
          "running": "Preparing return to draft…",
          "done": "Return prepared",
          "failed": "Couldn't prepare the return"
        },
        "acceptPurchaseOrderWarnings": {
          "running": "Preparing to accept warnings…",
          "done": "Acceptance prepared",
          "failed": "Couldn't prepare acceptance"
        },
        "deletePurchaseOrders": {
          "running": "Preparing deletion…",
          "done": "Deletion prepared",
          "failed": "Couldn't prepare deletion"
        },
        "goodsReceiptSearch": {
          "running": "Looking for deliveries…",
          "done": "Delivery search done",
          "failed": "Couldn't search deliveries"
        },
        "goodsReceiptDetail": {
          "running": "Opening the delivery…",
          "done": "Delivery loaded",
          "failed": "Couldn't load the delivery"
        },
        "receiveFromPurchaseOrder": {
          "running": "Preparing the delivery…",
          "done": "Delivery ready to confirm",
          "failed": "Couldn't prepare the delivery"
        },
        "draftGoodsReceipt": {
          "running": "Preparing the goods receipt…",
          "done": "Goods receipt ready to confirm",
          "failed": "Couldn't prepare the goods receipt"
        },
        "confirmGoodsReceipts": {
          "running": "Preparing confirmation…",
          "done": "Confirmation ready",
          "failed": "Couldn't prepare confirmation"
        },
        "cancelGoodsReceipts": {
          "running": "Preparing cancellation…",
          "done": "Cancellation ready",
          "failed": "Couldn't prepare cancellation"
        },
        "confirmDeliveryWithoutReceipt": {
          "running": "Preparing delivery confirmation…",
          "done": "Delivery confirmation ready",
          "failed": "Couldn't prepare delivery confirmation"
        },
        "archiveGoodsReceipts": {
          "running": "Preparing archiving…",
          "done": "Archiving ready",
          "failed": "Couldn't prepare archiving"
        },
        "unarchiveGoodsReceipts": {
          "running": "Preparing restore from archive…",
          "done": "Restore ready",
          "failed": "Couldn't prepare restore"
        },
        "deleteGoodsReceipts": {
          "running": "Preparing deletion…",
          "done": "Deletion ready",
          "failed": "Couldn't prepare deletion"
        },
        "documentSearch": {
          "running": "Looking for documents…",
          "done": "Document search done",
          "failed": "Couldn't search documents"
        },
        "reprocessDocuments": {
          "running": "Preparing extraction…",
          "done": "Extraction ready to confirm",
          "failed": "Couldn't prepare extraction"
        },
        "deleteDocuments": {
          "running": "Preparing deletion…",
          "done": "Deletion ready",
          "failed": "Couldn't prepare deletion"
        },
        "quarantinedEmails": {
          "running": "Checking quarantine…",
          "done": "Quarantine loaded",
          "failed": "Couldn't load quarantine"
        },
        "releaseQuarantinedEmails": {
          "running": "Preparing release…",
          "done": "Release ready",
          "failed": "Couldn't prepare release"
        },
        "discardQuarantinedEmails": {
          "running": "Preparing discard…",
          "done": "Discard ready",
          "failed": "Couldn't prepare discard"
        },
        "trustedSenders": {
          "running": "Loading trusted senders…",
          "done": "Trusted senders loaded",
          "failed": "Couldn't load trusted senders"
        },
        "trustSenders": {
          "running": "Preparing trusted senders…",
          "done": "Trusted senders ready to confirm",
          "failed": "Couldn't prepare trusted senders"
        },
        "untrustSenders": {
          "running": "Preparing removal…",
          "done": "Removal ready",
          "failed": "Couldn't prepare removal"
        },
        "manageMailbox": {
          "running": "Preparing mailbox change…",
          "done": "Mailbox change ready",
          "failed": "Couldn't prepare mailbox change"
        },
        "invoiceRelationships": {
          "running": "Loading linked documents…",
          "done": "Linked documents loaded",
          "failed": "Couldn't load linked documents"
        },
        "linkInvoices": {
          "running": "Preparing the link…",
          "done": "Link ready to confirm",
          "failed": "Couldn't prepare the link"
        },
        "unlinkInvoices": {
          "running": "Preparing unlinking…",
          "done": "Unlinking ready",
          "failed": "Couldn't prepare unlinking"
        },
        "invoiceAttachments": {
          "running": "Loading attachments…",
          "done": "Attachments loaded",
          "failed": "Couldn't load attachments"
        },
        "removeInvoiceAttachments": {
          "running": "Preparing removal…",
          "done": "Removal ready",
          "failed": "Couldn't prepare removal"
        },
        "exchangeRates": {
          "running": "Looking up exchange rates…",
          "done": "Exchange rates found",
          "failed": "Couldn't load exchange rates"
        },
        "editInvoice": {
          "running": "Preparing the invoice change…",
          "done": "Invoice change ready to confirm",
          "failed": "Couldn't prepare the invoice change"
        },
        "codeInvoices": {
          "running": "Preparing cost coding…",
          "done": "Cost coding ready to confirm",
          "failed": "Couldn't prepare cost coding"
        },
        "invoiceValidation": {
          "running": "Checking the invoice…",
          "done": "Invoice checked",
          "failed": "Couldn't check the invoice"
        },
        "acceptInvoiceWarnings": {
          "running": "Preparing warning acceptance…",
          "done": "Acceptance ready",
          "failed": "Couldn't prepare acceptance"
        },
        "approveInvoicesAcceptingWarnings": {
          "running": "Preparing approval…",
          "done": "Approval ready to confirm",
          "failed": "Couldn't prepare approval"
        },
        "submitInvoices": {
          "running": "Preparing submission…",
          "done": "Submission ready",
          "failed": "Couldn't prepare submission"
        },
        "returnInvoicesToDraft": {
          "running": "Preparing return for editing…",
          "done": "Return ready",
          "failed": "Couldn't prepare return"
        },
        "cancelInvoices": {
          "running": "Preparing cancellation…",
          "done": "Cancellation ready",
          "failed": "Couldn't prepare cancellation"
        },
        "deleteInvoices": {
          "running": "Preparing deletion…",
          "done": "Deletion ready",
          "failed": "Couldn't prepare deletion"
        },
        "completeInvoices": {
          "running": "Preparing completion…",
          "done": "Completion ready",
          "failed": "Couldn't prepare completion"
        },
        "invoiceCompletionBlockers": {
          "running": "Checking what is missing…",
          "done": "Completion check done",
          "failed": "Couldn't check completion"
        },
        "isdocExport": {
          "running": "Checking the ISDOC export…",
          "done": "ISDOC export checked",
          "failed": "Couldn't check the ISDOC export"
        },
        "matchCandidates": {
          "running": "Looking for order lines…",
          "done": "Order lines found",
          "failed": "Couldn't load order lines"
        },
        "pairInvoiceLines": {
          "running": "Preparing the pairing…",
          "done": "Pairing ready to confirm",
          "failed": "Couldn't prepare the pairing"
        },
        "unmatchInvoiceLines": {
          "running": "Preparing unpairing…",
          "done": "Unpairing ready",
          "failed": "Couldn't prepare unpairing"
        },
        "rejectMatchLinks": {
          "running": "Preparing rejection…",
          "done": "Rejection ready",
          "failed": "Couldn't prepare rejection"
        },
        "rematchInvoices": {
          "running": "Preparing re-matching…",
          "done": "Re-matching ready",
          "failed": "Couldn't prepare re-matching"
        },
        "approvalStatus": {
          "running": "Checking the approval…",
          "done": "Approval status loaded",
          "failed": "Couldn't load the approval"
        },
        "setApprovers": {
          "running": "Preparing approver change…",
          "done": "Approver change ready to confirm",
          "failed": "Couldn't prepare approver change"
        },
        "approverChain": {
          "running": "Loading approver rules…",
          "done": "Approver rules loaded",
          "failed": "Couldn't load approver rules"
        },
        "explainApproval": {
          "running": "Looking up the decision…",
          "done": "Decision found",
          "failed": "Couldn't load the decision"
        },
        "previewApproval": {
          "running": "Trying the approval automation…",
          "done": "Dry run done",
          "failed": "Couldn't run the dry run"
        },
        "pendingApprovals": {
          "running": "Looking for waiting approvals…",
          "done": "Waiting approvals found",
          "failed": "Couldn't load waiting approvals"
        },
        "moveInvoicesToExport": {
          "running": "Preparing the export move…",
          "done": "Export move ready to confirm",
          "failed": "Couldn't prepare the export move"
        },
        "paymentQr": {
          "running": "Checking the payment QR…",
          "done": "Payment QR checked",
          "failed": "Couldn't check the payment QR"
        },
        "inboxNotifications": {
          "running": "Opening your inbox…",
          "done": "Inbox loaded",
          "failed": "Couldn't load your inbox"
        },
        "markNotificationsRead": {
          "running": "Preparing to mark read…",
          "done": "Ready to confirm",
          "failed": "Couldn't prepare marking read"
        },
        "procurementFlow": {
          "running": "Tracing the purchase…",
          "done": "Purchase traced",
          "failed": "Couldn't trace the purchase"
        },
        "documentThreads": {
          "running": "Looking for questions…",
          "done": "Questions found",
          "failed": "Couldn't load questions"
        },
        "threadMessages": {
          "running": "Opening the conversation…",
          "done": "Conversation loaded",
          "failed": "Couldn't load the conversation"
        },
        "replyToThread": {
          "running": "Preparing the reply…",
          "done": "Reply ready to confirm",
          "failed": "Couldn't prepare the reply"
        },
        "draftCostCenter": {
          "running": "Preparing the cost centre…",
          "done": "Cost centre prepared",
          "failed": "Could not prepare the cost centre"
        },
        "deactivateCostCenters": {
          "running": "Checking cost centres…",
          "done": "Cost centres checked",
          "failed": "Could not check the cost centres"
        },
        "draftJob": {
          "running": "Preparing the job…",
          "done": "Job prepared",
          "failed": "Could not prepare the job"
        },
        "activateJobs": {
          "running": "Checking jobs…",
          "done": "Jobs checked",
          "failed": "Could not check the jobs"
        },
        "suspendJobs": {
          "running": "Checking jobs…",
          "done": "Jobs checked",
          "failed": "Could not check the jobs"
        },
        "closeJobs": {
          "running": "Checking jobs…",
          "done": "Jobs checked",
          "failed": "Could not check the jobs"
        },
        "deleteJobs": {
          "running": "Checking jobs…",
          "done": "Jobs checked",
          "failed": "Could not check the jobs"
        },
        "productSearch": {
          "running": "Searching the catalogue…",
          "done": "Catalogue searched",
          "failed": "Could not search the catalogue"
        },
        "draftProduct": {
          "running": "Preparing the product…",
          "done": "Product prepared",
          "failed": "Could not prepare the product"
        },
        "deactivateProducts": {
          "running": "Checking products…",
          "done": "Products checked",
          "failed": "Could not check the products"
        },
        "deleteProducts": {
          "running": "Checking products…",
          "done": "Products checked",
          "failed": "Could not check the products"
        },
        "draftOrgUnit": {
          "running": "Preparing the org unit…",
          "done": "Org unit prepared",
          "failed": "Could not prepare the org unit"
        },
        "deactivateOrgUnits": {
          "running": "Checking org units…",
          "done": "Org units checked",
          "failed": "Could not check the org units"
        },
        "changeOrgUnitMembers": {
          "running": "Preparing member changes…",
          "done": "Member changes prepared",
          "failed": "Could not prepare member changes"
        },
        "setOrgUnitManager": {
          "running": "Preparing the manager change…",
          "done": "Manager change prepared",
          "failed": "Could not prepare the manager change"
        },
        "deletePartners": {
          "running": "Checking partners…",
          "done": "Partners checked",
          "failed": "Could not check the partners"
        },
        "numberSeries": {
          "running": "Reading number series…",
          "done": "Number series read",
          "failed": "Could not read the number series"
        },
        "changeNumberSeries": {
          "running": "Preparing the numbering change…",
          "done": "Numbering change prepared",
          "failed": "Could not prepare the numbering change"
        },
        "approvalPolicy": {
          "running": "Reading the approval policy…",
          "done": "Approval policy read",
          "failed": "Could not read the approval policy"
        },
        "changeApprovalPolicy": {
          "running": "Preparing the policy change…",
          "done": "Policy change prepared",
          "failed": "Could not prepare the policy change"
        },
        "resetApprovalPolicy": {
          "running": "Preparing the policy reset…",
          "done": "Policy reset prepared",
          "failed": "Could not prepare the policy reset"
        },
        "automationHelp": {
          "running": "Loading automation help…",
          "done": "Automation help loaded",
          "failed": "Could not load automation help"
        },
        "automationRules": {
          "running": "Reading completion rules…",
          "done": "Completion rules read",
          "failed": "Could not read completion rules"
        },
        "changeAutomationRules": {
          "running": "Preparing the rules change…",
          "done": "Rules change prepared",
          "failed": "Could not prepare the rules change"
        },
        "validationPolicy": {
          "running": "Reading the validation policy…",
          "done": "Validation policy read",
          "failed": "Could not read the validation policy"
        },
        "changeValidationPolicy": {
          "running": "Preparing the validation change…",
          "done": "Validation change prepared",
          "failed": "Could not prepare the validation change"
        },
        "resetValidationPolicy": {
          "running": "Preparing the validation reset…",
          "done": "Validation reset prepared",
          "failed": "Could not prepare the validation reset"
        },
        "previewValidation": {
          "running": "Trying the validation…",
          "done": "Validation tried",
          "failed": "Could not try the validation"
        },
        "invoiceAutomationSwitches": {
          "running": "Reading invoice automation…",
          "done": "Invoice automation read",
          "failed": "Could not read invoice automation"
        },
        "changeInvoiceAutomationSwitches": {
          "running": "Preparing the automation change…",
          "done": "Automation change prepared",
          "failed": "Could not prepare the automation change"
        },
        "documentOutput": {
          "running": "Reading document settings…",
          "done": "Document settings read",
          "failed": "Could not read document settings"
        },
        "changeDocumentOutput": {
          "running": "Preparing the document change…",
          "done": "Document change prepared",
          "failed": "Could not prepare the document change"
        },
        "deleteEmailTemplates": {
          "running": "Checking e-mail templates…",
          "done": "E-mail templates checked",
          "failed": "Could not check e-mail templates"
        },
        "analysisRuns": {
          "running": "Reading validation runs…",
          "done": "Validation runs read",
          "failed": "Could not read validation runs"
        },
        "rerunAnalysis": {
          "running": "Checking invoices…",
          "done": "Invoices checked",
          "failed": "Could not check the invoices"
        },
        "procurementOverview": {
          "running": "Reading your procurement overview…",
          "done": "Procurement overview read",
          "failed": "Could not read the procurement overview"
        },
        "spendByCoding": {
          "running": "Breaking spend down…",
          "done": "Spend broken down",
          "failed": "Could not break the spend down"
        },
        "supplierPerformance": {
          "running": "Checking supplier deliveries…",
          "done": "Supplier deliveries checked",
          "failed": "Could not check supplier deliveries"
        },
        "cycleTime": {
          "running": "Measuring purchase times…",
          "done": "Purchase times measured",
          "failed": "Could not measure purchase times"
        },
        "anomalies": {
          "running": "Looking for risky invoices…",
          "done": "Risky invoices checked",
          "failed": "Could not check risky invoices"
        },
        "pendingMatches": {
          "running": "Reading unmatched records…",
          "done": "Unmatched records read",
          "failed": "Could not read unmatched records"
        },
        "confirmMatches": {
          "running": "Preparing the matches…",
          "done": "Matches prepared",
          "failed": "Could not prepare the matches"
        },
        "rejectMatches": {
          "running": "Checking unmatched records…",
          "done": "Unmatched records checked",
          "failed": "Could not check unmatched records"
        },
        "resendSyncChanges": {
          "running": "Preparing the re-send…",
          "done": "Re-send prepared",
          "failed": "Could not prepare the re-send"
        },
        "retryStuckSyncEvents": {
          "running": "Preparing the retry…",
          "done": "Retry prepared",
          "failed": "Could not prepare the retry"
        },
        "repushAttachments": {
          "running": "Preparing the attachments…",
          "done": "Attachments prepared",
          "failed": "Could not prepare the attachments"
        },
        "creditBalance": {
          "running": "Reading AI credits…",
          "done": "AI credits read",
          "failed": "Could not read AI credits"
        },
        "creditPacks": {
          "running": "Reading credit packs…",
          "done": "Credit packs read",
          "failed": "Could not read credit packs"
        },
        "buyCreditPack": {
          "running": "Preparing the checkout…",
          "done": "Checkout prepared",
          "failed": "Could not prepare the checkout"
        },
        "helpSearch": {
          "running": "Searching the help…",
          "done": "Help searched",
          "failed": "Could not search the help"
        },
        "undoLast": {
          "running": "Preparing the undo…",
          "done": "Undo prepared",
          "failed": "Could not prepare the undo"
        },
        "automationReadiness": {
          "running": "Checking the automation set-up…",
          "done": "Automation set-up checked",
          "failed": "Could not check the automation set-up"
        },
        "automationDryRun": {
          "running": "Trying the policy on documents…",
          "done": "Policy tried",
          "failed": "Could not try the policy"
        },
        "integrationPlugins": {
          "running": "Looking up the systems…",
          "done": "Systems found",
          "failed": "Lookup didn't work out"
        },
        "integrationSetup": {
          "running": "Checking the integrations…",
          "done": "Integrations checked",
          "failed": "Check didn't work out"
        },
        "proposeConnectorSetup": {
          "running": "Preparing a proposal…",
          "done": "Integration proposal ready",
          "failed": "Proposal didn't work out"
        },
        "connectionReadiness": {
          "running": "Checking the connection…",
          "done": "Connection checked",
          "failed": "Check didn't work out"
        },
        "integrationConnectors": {
          "running": "Looking up the syncs…",
          "done": "Syncs found",
          "failed": "Lookup didn't work out"
        },
        "proposeConnectorEnabled": {
          "running": "Preparing the switch…",
          "done": "Switch ready to confirm",
          "failed": "Proposal didn't work out"
        },
        "proposeConnectorSchedules": {
          "running": "Preparing the schedule…",
          "done": "Schedule change ready to confirm",
          "failed": "Proposal didn't work out"
        },
        "proposeConnectorSettings": {
          "running": "Preparing the settings…",
          "done": "Settings change ready to confirm",
          "failed": "Proposal didn't work out"
        },
        "proposeConnectorDelete": {
          "running": "Preparing the deletion…",
          "done": "Deletion ready to confirm",
          "failed": "Proposal didn't work out"
        },
        "proposeConnectionDelete": {
          "running": "Preparing the deletion…",
          "done": "Deletion ready to confirm",
          "failed": "Proposal didn't work out"
        }
      },
      "proposals": {
        "invite-user": {
          "title": "Invite user",
          "description": "Confirm and I'll send the invite.",
          "orgUnit": "Position in the org structure: {{label}}",
          "orgUnitAsHead": "Position in the org structure: {{label}}, as head"
        },
        "approve-invoice": {
          "title": "Approve invoice",
          "description": "Confirm and I'll approve it."
        },
        "reject-invoice": {
          "title": "Reject invoice",
          "description": "Confirm and I'll reject it and send it back for review."
        },
        "revert-invoice": {
          "title": "Revert invoice",
          "description": "Confirm and I'll move it back to its previous state."
        },
        "move-invoice-status": {
          "title": "Move invoice status",
          "description": "Confirm and I'll move it to the selected state."
        },
        "add-partners": {
          "title": "Add partners",
          "description": "Confirm and I'll add these companies as customer and supplier.",
          "countDescription_one": "Confirm and I'll add {{count}} company as customer and supplier.",
          "countDescription_other": "Confirm and I'll add {{count}} companies as customers and suppliers."
        },
        "confirm": "Confirm",
        "cancel": "Cancel",
        "resolution": {
          "confirmed": "Confirmed.",
          "cancelled": "Cancelled — nothing was changed.",
          "expired": "This card has expired. Just ask me again."
        },
        "total": "Total",
        "toast": {
          "confirmed": "Done — the action went through.",
          "failed": "That didn't go through. Ask me again and I'll retry.",
          "cancelFailed": "Could not cancel that."
        },
        "maintain-invoices": {
          "title": "Invoice housekeeping",
          "description": "Confirm and I'll run it.",
          "revalidate": {
            "title": "Re-run validation",
            "countDescription_one": "Confirm and I'll re-check {{count}} invoice.",
            "countDescription_other": "Confirm and I'll re-check {{count}} invoices."
          },
          "archive": {
            "title": "Archive invoices",
            "countDescription_one": "Confirm and I'll archive {{count}} invoice.",
            "countDescription_other": "Confirm and I'll archive {{count}} invoices."
          },
          "unarchive": {
            "title": "Restore invoices",
            "countDescription_one": "Confirm and I'll restore {{count}} invoice from the archive.",
            "countDescription_other": "Confirm and I'll restore {{count}} invoices from the archive."
          }
        },
        "move-invoices-status": {
          "title": "Move invoices to {{status}}",
          "description": "Confirm and I'll move these invoices.",
          "countDescription_one": "Confirm and I'll move {{count}} invoice to {{status}}.",
          "countDescription_other": "Confirm and I'll move {{count}} invoices to {{status}}."
        },
        "invite-users": {
          "title": "Invite people",
          "description": "Confirm and I'll send the invitations.",
          "countDescription_one": "Confirm and I'll invite {{count}} person as a member.",
          "countDescription_other": "Confirm and I'll invite {{count}} people as members.",
          "orgUnit": "Position in the org structure: {{label}}"
        },
        "maintain-partners": {
          "title": "Update partners",
          "description": "Confirm and I'll apply the change.",
          "archive": {
            "title": "Archive partners",
            "countDescription_one": "Confirm and I'll archive {{count}} partner.",
            "countDescription_other": "Confirm and I'll archive {{count}} partners."
          },
          "unarchive": {
            "title": "Restore partners",
            "countDescription_one": "Confirm and I'll restore {{count}} partner.",
            "countDescription_other": "Confirm and I'll restore {{count}} partners."
          },
          "markSupplier": {
            "title": "Mark as suppliers",
            "countDescription_one": "Confirm and I'll mark {{count}} partner as a supplier.",
            "countDescription_other": "Confirm and I'll mark {{count}} partners as suppliers."
          },
          "markCustomer": {
            "title": "Mark as customers",
            "countDescription_one": "Confirm and I'll mark {{count}} partner as a customer.",
            "countDescription_other": "Confirm and I'll mark {{count}} partners as customers."
          }
        },
        "move-procurement": {
          "requisitions": {
            "title": "Move requests to {{status}}",
            "description": "Confirm and I'll move these requests.",
            "countDescription_one": "Confirm and I'll move {{count}} request to {{status}}.",
            "countDescription_other": "Confirm and I'll move {{count}} requests to {{status}}."
          },
          "purchaseOrders": {
            "title": "Move orders to {{status}}",
            "description": "Confirm and I'll move these orders.",
            "countDescription_one": "Confirm and I'll move {{count}} order to {{status}}.",
            "countDescription_other": "Confirm and I'll move {{count}} orders to {{status}}."
          }
        },
        "submit-procurement": {
          "requisitions": {
            "title": "Submit requests for approval",
            "description": "Confirm and I'll submit these requests for approval.",
            "countDescription_one": "Confirm and I'll submit {{count}} request for approval.",
            "countDescription_other": "Confirm and I'll submit {{count}} requests for approval."
          },
          "purchaseOrders": {
            "title": "Submit orders for approval",
            "description": "Confirm and I'll submit these orders for approval.",
            "countDescription_one": "Confirm and I'll submit {{count}} order for approval.",
            "countDescription_other": "Confirm and I'll submit {{count}} orders for approval."
          }
        },
        "retry-syncs": {
          "title": "Re-run failed syncs",
          "description": "Confirm and I'll start a new sync run.",
          "countDescription_one": "Confirm and I'll start a new sync run for {{count}} connector.",
          "countDescription_other": "Confirm and I'll start a new sync run for {{count}} connectors."
        },
        "chat": {
          "empty": "(empty)",
          "countDescription_one": "Confirm and I'll do this for {{count}} record.",
          "countDescription_other": "Confirm and I'll do this for {{count}} records.",
          "note": "Note: {{note}}",
          "titles": {
            "cancel-requisitions": "Cancel requests",
            "complete-requisitions": "Complete requests",
            "archive-requisitions": "Archive requests",
            "unarchive-requisitions": "Unarchive requests",
            "return-requisitions-to-draft": "Return requests for editing",
            "accept-requisition-warnings": "Accept warnings on requests",
            "delete-requisitions": "Delete draft requests",
            "cancel-purchase-orders": "Cancel orders",
            "complete-purchase-orders": "Complete orders",
            "archive-purchase-orders": "Archive orders",
            "unarchive-purchase-orders": "Unarchive orders",
            "return-purchase-orders-to-draft": "Return orders for editing",
            "accept-purchase-order-warnings": "Accept warnings on orders",
            "delete-purchase-orders": "Delete draft orders",
            "draft-requisition": "Save the request",
            "draft-purchase-order": "Save the order",
            "order-from-requisition": "Create an order from the request",
            "dispatch-purchase-order": "Send the order to the supplier",
            "confirm-goods-receipts": "Confirm goods receipts",
            "cancel-goods-receipts": "Cancel goods receipts",
            "confirm-delivery-without-receipt": "Confirm delivery without a note",
            "archive-goods-receipts": "Archive goods receipts",
            "unarchive-goods-receipts": "Restore goods receipts from archive",
            "delete-goods-receipts": "Delete goods receipts",
            "receive-from-purchase-order": "Receive delivery against order",
            "draft-goods-receipt": "Goods receipt",
            "reprocess-documents": "Run extraction again",
            "delete-documents": "Delete documents",
            "release-quarantined-emails": "Release e-mails from quarantine",
            "discard-quarantined-emails": "Discard quarantined e-mails",
            "untrust-senders": "Stop trusting senders",
            "trust-senders": "Trust senders",
            "manage-mailbox": "Invoice mailbox",
            "unlink-invoices": "Unlink invoices",
            "link-invoices": "Link invoices",
            "remove-invoice-attachments": "Remove attachments",
            "edit-invoice": "Edit invoice",
            "code-invoices": "Code invoices",
            "accept-invoice-warnings": "Accept invoice warnings",
            "approve-invoices-accepting-warnings": "Approve invoices",
            "submit-invoices": "Submit invoices for approval",
            "return-invoices-to-draft": "Return invoices for editing",
            "cancel-invoices": "Cancel invoices",
            "delete-invoices": "Delete invoices",
            "complete-invoices": "Complete invoices",
            "unmatch-invoice-lines": "Unpair invoice lines",
            "reject-match-links": "Reject proposed pairings",
            "rematch-invoices": "Run matching again",
            "pair-invoice-lines": "Pair invoice lines",
            "set-approvers": "Change approvers",
            "move-invoices-to-export": "Move invoices to export",
            "mark-notifications-read": "Mark notifications read",
            "reply-to-thread": "Reply to the question",
            "deactivate-cost-centers": "Deactivate cost centres",
            "draft-cost-center": "Cost centre",
            "activate-jobs": "Activate jobs",
            "suspend-jobs": "Suspend jobs",
            "close-jobs": "Close jobs",
            "delete-jobs": "Delete jobs",
            "draft-job": "Job",
            "draft-product": "Catalogue product",
            "deactivate-products": "Deactivate products",
            "delete-products": "Delete products",
            "draft-org-unit": "Org unit",
            "deactivate-org-units": "Deactivate org units",
            "change-org-unit-members": "Org unit members",
            "set-org-unit-manager": "Org unit manager",
            "delete-partners": "Delete partners",
            "change-number-series": "Number series",
            "change-approval-policy": "Approval policy",
            "reset-approval-policy": "Restore the approval policy",
            "change-automation-rules": "Completion rules",
            "change-validation-policy": "Validation policy",
            "reset-validation-policy": "Restore the validation policy",
            "change-invoice-automation-switches": "Invoice automation",
            "change-document-output": "Document output",
            "delete-email-templates": "Delete e-mail templates",
            "rerun-analysis": "Run the AI validation again",
            "confirm-matches": "Confirm sync matches",
            "reject-matches": "Reject sync matches",
            "resend-sync-changes": "Re-send changes",
            "retry-stuck-sync-events": "Retry stuck changes",
            "repush-attachments": "Re-send attachments",
            "buy-credit-pack": "Buy a credit pack",
            "setup-connector": "Set up an integration",
            "switch-connector": "Switch a sync on or off",
            "change-connector-schedules": "Change a sync's schedule",
            "change-connector-settings": "Change a sync's settings",
            "delete-connector": "Delete a sync",
            "delete-connection": "Delete a connection"
          },
          "targets": {
            "approvalPolicy": {
              "REQUISITION": "Request approval policy",
              "PURCHASE_ORDER": "Purchase order approval policy",
              "INVOICE": "Invoice approval policy"
            },
            "completionRules": {
              "REQUISITION": "Request completion rules",
              "PURCHASE_ORDER": "Purchase order completion rules",
              "INVOICE": "Invoice completion rules"
            },
            "validationPolicy": "Invoice validation policy",
            "invoiceAutomation": "Invoice automation",
            "numberSeries": {
              "REQUISITION": "Request numbering {{year}}",
              "PURCHASE_ORDER": "Purchase order numbering {{year}}",
              "GOODS_RECEIPT": "Goods receipt numbering {{year}}",
              "EXTRACTED_DOCUMENT": "Document numbering {{year}}"
            },
            "documentOutput": {
              "PURCHASE_ORDER": "Purchase order PDF"
            },
            "trustedSenders": "Trusted senders",
            "invoiceMailbox": "Invoice mailbox",
            "invoices_one": "{{count}} invoice",
            "invoices_other": "{{count}} invoices",
            "syncMatches_one": "{{count}} sync match",
            "syncMatches_other": "{{count}} sync matches",
            "creditPackCheckout": "Credit pack checkout",
            "inbox": "Inbox",
            "question": "Question",
            "newRequisition": "New request",
            "newPurchaseOrder": "New purchase order",
            "newGoodsReceipt": "New goods receipt",
            "newCostCenter": "New cost centre {{code}}",
            "newJob": "New job {{code}}",
            "newProduct": "New product {{code}}",
            "newOrgUnit": "New org unit {{code}}",
            "connectorSetup": "Integration with {{system}}",
            "connector": "{{name}} ({{system}})",
            "connection": "Connection {{name}} ({{system}})"
          },
          "fields": {
            "title": "Title",
            "name": "Name",
            "code": "Code",
            "description": "Description",
            "note": "Note",
            "notes": "Notes",
            "internalNote": "Internal note",
            "justification": "Justification",
            "neededBy": "Needed by",
            "currencyCode": "Currency",
            "currency": "Currency",
            "supplier": "Supplier",
            "supplierName": "Supplier",
            "suggestedSupplier": "Suggested supplier",
            "expectedDeliveryDate": "Expected delivery",
            "paymentTermsDays": "Payment terms (days)",
            "invoiceNumber": "Invoice number",
            "invoiceDate": "Invoice date",
            "taxDate": "Tax date",
            "dueDate": "Due date",
            "variableSymbol": "Variable symbol",
            "orderReference": "Order reference",
            "userNote": "Note",
            "status": "Status",
            "dispatched": "Sent to supplier",
            "isActive": "Active",
            "isEnabled": "Enabled",
            "lines": "Lines",
            "line": "Line",
            "carrier": "Carrier",
            "deliveryNoteNumber": "Delivery note number",
            "receivedAt": "Received",
            "prefix": "Prefix",
            "pattern": "Pattern",
            "padding": "Digits",
            "email": "E-mail",
            "member": "Member",
            "manager": "Manager",
            "approvers": "Approvers",
            "prompt": "Instructions",
            "terms": "Terms",
            "footerNote": "Footer note",
            "costCenterId": "Cost centre",
            "jobId": "Job",
            "orgUnitId": "Org unit",
            "costCenter": "Cost centre",
            "job": "Job",
            "orgUnit": "Org unit",
            "relationType": "Relationship",
            "reply": "Reply",
            "unread": "Unread",
            "trustedSender": "Trusted sender",
            "mailbox": "Mailbox",
            "attachment": "Attachment",
            "attachments": "Attachments",
            "pack": "Credit pack",
            "unit": "Unit",
            "unitPrice": "Unit price",
            "quantity": "Quantity",
            "ean": "EAN",
            "vatRate": "VAT rate",
            "subject": "Subject",
            "isSelfApprovalForbidden": "No self-approval",
            "isManualApproverSelectionAllowed": "Manual approver choice",
            "fallbackRole": "Fallback role",
            "fallbackStrategy": "Fallback strategy",
            "approvalMode": "Approval mode",
            "system": "System",
            "connection": "Connection",
            "bridge": "Tappeer Bridge",
            "connectorName": "Sync name",
            "entityType": "Data synced",
            "syncDirections": "Direction",
            "enabled": "Switched on",
            "schedule": "Schedule entry"
          },
          "secretForm": {
            "hint": "Enter these here. They are sent only when you confirm and never appear in the chat.",
            "show": "Show value",
            "hide": "Hide value"
          },
          "values": {
            "approvalMode": {
              "AI_AND_USER": "AI + user",
              "USER_ONLY": "User approves",
              "SKIPPED": "Skipped"
            },
            "yes": "Yes",
            "no": "No",
            "syncMode": {
              "full": "All records",
              "modified-since": "Records changed since the last run",
              "read-back": "Read back what the target system owns",
              "event": "Each change"
            },
            "schedule": {
              "cron": "{{mode}}, on schedule {{expr}}",
              "cronInZone": "{{mode}}, on schedule {{expr}} ({{timezone}})",
              "interval_one": "{{mode}}, every minute",
              "interval_other": "{{mode}}, every {{count}} minutes",
              "event": "{{mode}}, as it happens"
            }
          }
        },
        "rows": {
          "showAll_one": "Show all {{count}} row",
          "showAll_other": "Show all {{count}} rows",
          "showLess": "Show fewer"
        }
      },
      "home": {
        "guideTitle": "What Tappeer AI can do",
        "fullGuide": "Read the full guide",
        "waitingOnMe": {
          "title": "Waiting for you",
          "empty": "Nothing is waiting for you.",
          "showAll": "Show all ({{count}})",
          "error": "Couldn't load what's waiting for you.",
          "retry": "Try again"
        }
      },
      "nudges": {
        "dismiss": "No thanks",
        "snooze": "Later",
        "answered": {
          "started": "Let’s go — answer my questions below.",
          "snoozed": "I’ll ask again in a few days.",
          "dismissed": "Understood, I won’t offer this again."
        },
        "answeredAlert": {
          "started": "Let’s look into it.",
          "snoozed": "I’ll remind you tomorrow if it still isn’t fixed.",
          "dismissed": "Understood, I’ll speak up again only when something new breaks."
        },
        "integration-trouble": {
          "title": "The sync with your accounting system has a problem",
          "description": "Some data isn’t getting through. I’ll find out what’s wrong and help you fix it.",
          "start": "Look into it with me",
          "startPrompt": "What’s wrong with the sync and how do I fix it?"
        },
        "approval-automation-setup": {
          "title": "Let routine approvals happen on their own",
          "description": "You approve many documents by hand. In a few questions I’ll help you set rules for what may be approved automatically and who decides the rest — and we’ll try them on your real documents before saving.",
          "start": "Set it up with me",
          "startPrompt": "Help me set up automatic approval."
        },
        "validation-automation-setup": {
          "title": "Tailor the AI check of invoices",
          "description": "The AI can watch incoming invoices for what matters to your company. I’ll help you write what to check and try it on a few invoices first.",
          "start": "Set it up with me",
          "startPrompt": "Help me tailor the AI invoice validation."
        }
      }
    },
    "policies": {
      "tabs": {
        "terms": "Terms of Service",
        "privacy": "Privacy Policy",
        "subprocessors": "Subprocessors"
      }
    },
    "auth": {
      "signIn": {
        "title": "Sign In",
        "subtitle": "Sign in to your account",
        "submit": "Sign In",
        "error": "Invalid email or password",
        "forgotPassword": "Forgot password?",
        "or": "or",
        "microsoft": "Sign in with Microsoft",
        "google": "Sign in with Google",
        "noAccount": "Don't have an account?",
        "signUpLink": "Sign up"
      },
      "signUp": {
        "title": "Register Organization",
        "subtitle": "Create a new account to get started",
        "submit": "Create Account",
        "tosConsentPrefix": "I agree to the ",
        "tosConsentLink": "Terms of Service",
        "consentSeparator": " and ",
        "privacyConsentLink": "Privacy Policy",
        "error": "Failed to create account",
        "emailAlreadyRegistered": "Email is already registered",
        "passwordMismatch": "Passwords do not match",
        "passwordRequirements": "Password must be at least 8 characters and contain an uppercase letter, a lowercase letter, and a number",
        "or": "or",
        "microsoft": "Sign up with Microsoft",
        "google": "Sign up with Google",
        "haveAccount": "Already have an account?",
        "signInLink": "Sign in"
      },
      "consentGateModal": {
        "stepIndicator": "{{current}} / {{total}}"
      },
      "policiesConsentModal": {
        "title": "One last step",
        "description": "Your account has been created. To continue, please review and accept our Terms of Service and Privacy Policy.",
        "continue": "Continue",
        "logout": "Log out"
      },
      "accountPendingDeletion": {
        "title": "This account is scheduled for deletion",
        "description": "This account and all its data will be permanently deleted on {{date}}. Reactivate it to keep using Tappeer, or log out.",
        "reactivate": "Reactivate account",
        "switchHint": "Or continue in another of your organizations:",
        "switchTo": "Switch to {{name}}",
        "logout": "Log out",
        "reactivateError": "The account could not be restored. Please try again."
      },
      "crossAccountLink": {
        "title": "This record is in another organization",
        "message": "You opened a link to a record that belongs to {{name}}. Switch to that organization to open it.",
        "confirm": "Switch to {{name}}"
      },
      "switchAccount": {
        "title": "Switch organization?",
        "message": "You are working in {{from}}. Switching takes you to {{to}} — from then on every document, invoice and setting you see belongs to that organization.",
        "warning": "The app will reload and open the homepage of {{to}}. Unsaved changes will be lost.",
        "confirm": "Switch to {{to}}",
        "switched": "You are now working in {{name}}"
      },
      "accountSelection": {
        "title": "Where would you like to continue?",
        "description": "You belong to more than one organization. Pick the one you want to work in.",
        "masterAccountsGroup": "Offices",
        "organizationsGroup": "Organizations"
      },
      "masterAccountBar": {
        "label": "Office bar",
        "masterAccount": "Back to the {{name}} board",
        "switchClient": "Switch client",
        "moreMatches": "Showing {{shown}} of {{total}} – refine your search",
        "backToMasterAccountBoard": "Back to the board"
      },
      "gdprConsentModal": {
        "title": "News and commercial communications",
        "checkboxPrefix": "I agree to receiving news and commercial communications about Tappeer to my e-mail. I can withdraw this consent at any time in my account settings or via the link in the footer of every e-mail. More in the ",
        "checkboxLink": "Privacy Policy",
        "checkboxSuffix": ".",
        "accept": "I agree",
        "refuse": "Decline"
      },
      "acceptInvitation": {
        "title": "Complete Registration",
        "subtitle": "You have been invited to an organization. Please fill in your details.",
        "submit": "Complete Registration",
        "fields": {
          "firstName": "First Name",
          "lastName": "Last Name",
          "password": "Password",
          "confirmPassword": "Confirm Password"
        },
        "placeholders": {
          "firstName": "Enter your first name",
          "lastName": "Enter your last name",
          "password": "Enter password",
          "confirmPassword": "Enter password again"
        },
        "hints": {
          "passwordRequirements": "At least 8 characters, uppercase letter, lowercase letter, and a number"
        },
        "status": {
          "accepting": "Completing..."
        },
        "errors": {
          "firstNameRequired": "First name is required",
          "lastNameRequired": "Last name is required",
          "passwordRequired": "Password is required",
          "passwordTooWeak": "Password must contain an uppercase letter, a lowercase letter, and a number",
          "passwordMismatch": "Passwords do not match",
          "acceptError": "Failed to complete registration",
          "invalidToken": "Invalid or expired invitation link",
          "alreadyAccepted": "This invitation has already been used"
        },
        "alreadyHaveAccount": "Already have an account?",
        "signInLink": "Sign in"
      },
      "errors": {
        "invalidCredentials": "Invalid email or password",
        "emailAlreadyExists": "This email is already registered",
        "emailNotFound": "No account found with this email",
        "invalidEmail": "Invalid email format",
        "passwordRequired": "Password is required",
        "passwordTooShort": "Password must be at least 8 characters",
        "passwordTooWeak": "Password must contain uppercase, lowercase, and number",
        "accountNameRequired": "Organization name is required",
        "accountNameTaken": "This organization name is already taken",
        "firstNameRequired": "First name is required",
        "lastNameRequired": "Last name is required",
        "networkError": "Connection error. Please check your connection and try again.",
        "unknownError": "An unexpected error occurred. Please try again.",
        "sessionExpired": "Your session has expired. Please sign in again.",
        "invalidToken": "Invalid or expired token",
        "verificationFailed": "Verification failed. Please try again.",
        "rateLimitExceeded": "Too many failed login attempts. Please try again in {{minutes}} minutes.",
        "accountDeactivated": "Your organization has been deactivated. Please contact support.",
        "noActiveMembership": "Your account does not belong to any organization. Ask an administrator for an invitation.",
        "captchaFailed": "We couldn't verify that you're not a robot. Please complete the verification and try again.",
        "captchaRequired": "Too many failed attempts. Please verify that you're not a robot below and try again.",
        "captchaUnavailable": "The verification couldn't be loaded. Please refresh the page and try again.",
        "signupRateLimited": "Too many attempts. Please try again later.",
        "disposableEmail": "Temporary email addresses are not allowed. Please use your regular email.",
        "magicLinkSendFailed": "We couldn't send the email right now. Please try again in a moment."
      },
      "forgotPassword": {
        "title": "Forgot Password",
        "description": "Enter your email and we'll send you a link to reset your password.",
        "submit": "Send Reset Link",
        "success": "If an account with this email exists, we've sent you instructions to reset your password.",
        "error": "Failed to send password reset email",
        "backToSignIn": "Back to Sign In"
      },
      "verifyEmail": {
        "title": "Email Verification",
        "verifying": "Verifying your email...",
        "noToken": "No verification token provided",
        "signIn": "Sign In",
        "backToSignIn": "Back to Sign In",
        "success": "Email verified successfully. You can now sign in to your account.",
        "alreadyVerified": "Email is already verified. You can sign in to your account.",
        "invalidToken": "Invalid or expired verification token",
        "networkError": "Unable to connect to the server. Please check your internet connection and try again."
      },
      "emailVerificationPending": {
        "title": "Verify Your Email",
        "message": "Your account has been created. Please check your email and click the verification link.",
        "emailSentTo": "We sent an email to",
        "spamTip": "Check your spam or promotions folder if you don't see it.",
        "expirationInfo": "The verification link is valid for 24 hours.",
        "backToSignIn": "Back to Sign In"
      },
      "passwordless": {
        "title": "Let's go!",
        "hint": "Sign in or create your account — all you need is your email.",
        "footer": "No card, no password, no phone. Try Tappeer freely, on your own, at your pace.",
        "promoHighlight": "10 documents per month free – forever.",
        "emailLabel": "Your email",
        "continue": "Continue",
        "consentNotice": "By continuing, you agree to the <tos>Terms of Service</tos> and <privacy>Privacy Policy</privacy>.",
        "microsoft": "Continue with Microsoft",
        "google": "Continue with Google",
        "usePassword": "Sign in with password",
        "checkEmail": "Check your email",
        "checkEmailMessage": "We sent you a sign-in link. Click the link in the email to continue.",
        "linkExpiry": "The link expires in 15 minutes.",
        "backToSignIn": "Back to sign in",
        "verifying": "Signing you in...",
        "verifyingMessage": "Please wait while we verify your link.",
        "verified": "You're signed in!",
        "verifiedMessage": "Redirecting you now...",
        "verifyFailed": "Sign-in failed",
        "verifyFailedMessage": "This link is invalid or has expired. Please request a new one.",
        "noToken": "No verification token provided.",
        "linkAlreadyUsed": "This link has already been used."
      },
      "magicLinkSent": {
        "title": "Check your inbox",
        "message": "We sent you a link. Click it and you're in. If you don't see it, check your spam folder.",
        "resend": "Send again",
        "resendTimer": "Send again ({{seconds}}s)",
        "changeEmail": "Use a different email"
      },
      "signOut": {
        "title": "Sign Out",
        "signingOut": "Signing you out...",
        "success": "You have been signed out successfully",
        "error": "Failed to sign out",
        "signInAgain": "Sign In Again",
        "backToHome": "Back to Home"
      },
      "oauth": {
        "processing": "Completing sign in...",
        "error": "Authentication failed. Please try again.",
        "cancelled": "Sign-in was cancelled.",
        "emailNotVerified": "Your identity provider did not verify the email address of this account. Sign in another way, or ask your IT administrator to verify the email domain.",
        "missingParams": "Invalid OAuth callback. Missing required parameters.",
        "backToSignIn": "Back to Sign In"
      },
      "fields": {
        "email": "Email",
        "emailPlaceholder": "Enter your email",
        "password": "Password",
        "passwordPlaceholder": "Enter your password",
        "confirmPassword": "Confirm Password",
        "confirmPasswordPlaceholder": "Confirm your password",
        "accountName": "Organization Name",
        "accountNamePlaceholder": "Enter your organization name",
        "firstName": "First Name",
        "firstNamePlaceholder": "Enter your first name",
        "lastName": "Last Name",
        "lastNamePlaceholder": "Enter your last name",
        "showPassword": "Show password",
        "hidePassword": "Hide password"
      }
    },
    "emailUnsubscribe": {
      "confirm": {
        "title": {
          "creditUsage": "Unsubscribe from credit usage alerts?",
          "creditRenewal": "Unsubscribe from credit renewal alerts?",
          "marketing": "Unsubscribe from tips and news?"
        },
        "body": "Once you unsubscribe, these e-mails stop coming. You can turn them back on in your profile any time.",
        "action": "Unsubscribe"
      },
      "done": {
        "title": "Done",
        "message": {
          "creditUsage": "You won't get credit usage alerts any more.",
          "creditRenewal": "You won't get credit renewal alerts any more.",
          "marketing": "You won't get tips and news any more."
        }
      },
      "invalid": {
        "title": "This link doesn't work",
        "message": "The link is invalid or incomplete. You can manage your e-mails in your profile."
      },
      "failed": "Unsubscribing didn't work just now. Try again in a moment."
    },
    "dashboard": {
      "title": "Dashboard",
      "subtitle": "Overview of your projects and activities",
      "widgets": {
        "totalProjects": "Total Projects",
        "completed": "Completed",
        "pending": "Pending"
      },
      "table": {
        "headers": {
          "id": "ID",
          "name": "Name",
          "status": "Status",
          "date": "Date"
        }
      }
    },
    "masterAccountBoardShell": {
      "menu": {
        "clients": "Clients",
        "queue": "Document queue",
        "settings": "Office settings",
        "queueWithCount": "Document queue ({{count}})",
        "queueBadgeOverflow": "99+",
        "queueToDo_one": "{{count}} document to do",
        "queueToDo_other": "{{count}} documents to do"
      },
      "settingsLayout": {
        "title": "Office settings",
        "groups": {
          "office": "Office",
          "clientIntegrations": "Client integrations",
          "subscription": "Subscription"
        },
        "sections": {
          "office": {
            "label": "Office profile",
            "description": "Your office's name, address and contact details.",
            "keywords": "office name company id vat tax address language phone e-mail registry details"
          },
          "people": {
            "label": "People",
            "description": "Who works in the office, what they may do and which clients they look after.",
            "keywords": "invite invitation roles admin accountant team access permissions assignments clients"
          },
          "integrationTemplates": {
            "label": "Integration templates",
            "description": "Ready-made connector settings you apply to your clients.",
            "keywords": "template connector integration copy apply client settings"
          },
          "bridges": {
            "label": "Bridges",
            "description": "The office's bridges that sync your clients' accounting software.",
            "keywords": "bridge agent installation accounting software pohoda money sync register"
          },
          "billing": {
            "label": "Plan & billing",
            "description": "The office's plan, payments and invoices from Tappeer.",
            "keywords": "plan subscription payment card invoice stripe credits pack"
          },
          "credits": {
            "label": "Credit statement",
            "description": "Where credits came from and what they were spent on.",
            "keywords": "credits statement movements usage history transactions balance"
          },
          "manage": {
            "label": "Office management",
            "description": "Closing the office and its own accounting.",
            "keywords": "close delete end deletion office my office accounting"
          }
        }
      },
      "people": {
        "noAccess": {
          "title": "You cannot manage the office's people here",
          "description": "The office's people are managed by an office administrator. Client assignments can also be changed by a head accountant."
        },
        "members": {
          "title": "Office people",
          "name": "Name",
          "email": "E-mail",
          "roles": "Office roles",
          "empty": "The office has no people yet.",
          "error": "The office's people could not be loaded.",
          "invite": {
            "button": "Invite to the office",
            "success": "An invitation was sent to {{email}}.",
            "errors": {
              "rolesRequired": "Choose at least one office role.",
              "alreadyMember": "This person is already a member of the office.",
              "alreadyInvited": "An invitation to the office has already been sent to this e-mail. You will find it under pending invitations, where you can resend or cancel it.",
              "failed": "The invitation could not be sent. Please try again."
            },
            "emailNotSent": "The invitation was created, but its e-mail could not be sent — please resend it."
          },
          "actions": {
            "label": "Actions",
            "editRoles": "Change roles",
            "remove": "Remove from the office",
            "removeSelf": "You cannot remove yourself from the office"
          },
          "editRoles": {
            "title": "Office roles",
            "description": "Choose the roles {{name}} has in the office.",
            "submit": "Save",
            "cancel": "Cancel",
            "success": "The roles were changed.",
            "error": "The roles could not be changed. Please try again.",
            "headAccountantRemoved": "Without the Head accountant role, they lose access to every client until you assign them again."
          },
          "remove": {
            "title": "Remove from the office?",
            "message": "{{name}} will no longer be a member of the office.",
            "warning": "They lose access to the board and to every client the office gave them, and their client assignments are revoked.",
            "confirm": "Remove",
            "cancel": "Cancel",
            "success": "{{name}} is no longer in the office.",
            "error": "The person could not be removed from the office. Please try again."
          },
          "errors": {
            "directClientMember": "This person is a direct member of one of the office’s clients. Remove them from that client first, then they can join the office.",
            "masterAccountNotActive": "The office is not active, so its people cannot be changed now.",
            "invitationNoLongerValid": "The invitation is no longer valid, so it cannot be resent. Cancel it and invite the person again.",
            "rateLimited": "The office has sent too many invitations in a short time. Please try again later.",
            "temporarilyUnavailable": "The service is temporarily unavailable and nothing was changed. Please try again in a moment."
          },
          "invitations": {
            "title": "Pending invitations",
            "email": "E-mail",
            "roles": "Offered role",
            "expiresAt": "Valid until",
            "error": "The pending invitations could not be loaded.",
            "actions": {
              "label": "Actions",
              "resend": "Resend",
              "cancel": "Cancel"
            },
            "resend": {
              "success": "The invitation was sent to {{email}} again.",
              "error": "The invitation could not be resent. Please try again."
            },
            "cancel": {
              "title": "Cancel the invitation?",
              "message": "The invitation for {{email}} will no longer be valid.",
              "confirm": "Cancel invitation",
              "keep": "Keep",
              "success": "The invitation for {{email}} was cancelled.",
              "error": "The invitation could not be cancelled. Please try again."
            }
          }
        },
        "clientAccountants": {
          "title": "Accountants assigned to clients",
          "description": "On the board, an accountant sees only the clients they are assigned to.",
          "headAccountants": "Head accountants work at every client without an assignment: {{names}}.",
          "loading": "Loading assignments…",
          "error": "The assignments could not be loaded. Try reloading the page.",
          "incomplete": "This office has more clients, accountants or assignments than can be shown reliably here.",
          "noClients": "The office has no clients yet.",
          "noAccountants": "The office has no accountant yet. Invite one with the Accountant role.",
          "noMatch": "No client matches.",
          "search": "Search clients",
          "filter": {
            "label": "Show",
            "all": "All",
            "unassigned": "No accountant"
          },
          "bulk": {
            "assign": "Assign accountants ({{count}})",
            "clear": "Clear selection",
            "selected": "{{count}} selected",
            "selectedWithHidden_one": "{{selected}} selected ({{count}} hidden)",
            "selectedWithHidden_other": "{{selected}} selected ({{count}} hidden)",
            "tooMany": "You can edit at most {{max}} clients at once – select fewer."
          },
          "table": {
            "selectAll": "Select all shown clients",
            "selectClient": "Select client {{client}}",
            "client": "Client",
            "accountants": "Accountants",
            "actions": "Actions",
            "unassigned": "No accountant",
            "inactive": "(inactive)",
            "assign": "Assign accountants",
            "edit": "Edit",
            "assignLabel": "Assign accountants to {{client}}",
            "editLabel": "Edit the accountants of {{client}}"
          },
          "modal": {
            "titleSingle": "Accountants – {{client}}",
            "titleBulk_one": "Accountants for {{count}} client",
            "titleBulk_other": "Accountants for {{count}} clients",
            "descriptionSingle": "The checked accountants see the client on the board.",
            "descriptionBulk": "A checked accountant is assigned to every selected client, an unchecked one is removed from all of them. A partly checked one stays as it is.",
            "accountants": "Office accountants",
            "inactive": "(inactive)",
            "noAccountants": "The office has no active accountant.",
            "submit": "Save",
            "cancel": "Cancel",
            "overCap": "At most {{max}} assignments can be changed at once – select fewer clients or accountants.",
            "success": "Saved – assignments added: {{assigned}}, removed: {{revoked}}.",
            "error": "The assignments could not be saved. Please try again.",
            "errors": {
              "subscriptionLocked": "The office is locked, so accountants cannot be assigned right now. You can still remove them.",
              "notAnAccountant": "One of the selected accountants is no longer active in the office. The list has been reloaded.",
              "notAClient": "One of the selected clients no longer belongs to the office. The list has been reloaded.",
              "masterAccountNotActive": "The office is not active, so accountants cannot be assigned right now."
            }
          }
        }
      },
      "billing": {
        "noAccess": {
          "title": "You cannot manage the office's plan here",
          "description": "The office's plan and billing are managed by an office administrator."
        },
        "pool": {
          "title": "Pool usage by client",
          "description": "Extractions in the current period ({{period}}).",
          "client": "Client",
          "extractions": "Extractions",
          "total": "Total",
          "empty": "The office has no clients yet.",
          "error": "The pool usage could not be loaded."
        },
        "creditPool": {
          "title": "Credit usage by client",
          "description": "Credits each client used in a calendar month (UTC).",
          "client": "Client",
          "credits": "Credits",
          "total": "Total",
          "csvTotal": "Total credits",
          "formerClients": "Former and unavailable clients",
          "empty": "The master account used no credits in this month.",
          "error": "The credit usage could not be loaded.",
          "export": "Export CSV",
          "toggle": "Breakdown by operation: {{client}}",
          "incomplete": "Some clients could not be loaded, so the export is unavailable. Try reloading the page."
        }
      },
      "settings": {
        "noAccess": {
          "title": "You cannot change the office's settings here",
          "description": "The office's details are managed by an office administrator."
        },
        "identity": {
          "mirrorNote": "The office's details are copied to “My office accounting” automatically.",
          "name": "Office name",
          "companyId": "Company ID",
          "taxId": "Tax ID",
          "vatId": "VAT ID",
          "isVatPayer": "VAT payer",
          "street": "Street",
          "buildingNumber": "Building number",
          "city": "City",
          "postalCode": "Postal code",
          "country": "Country",
          "phone": "Phone",
          "email": "E-mail",
          "loading": "Loading the office's details…",
          "loadError": "The office's details could not be loaded.",
          "saveSuccess": "Changes saved",
          "saveError": "Changes could not be saved",
          "nameRequired": "Enter the office's name.",
          "locale": "Language",
          "localeOptions": {
            "CS": "Čeština",
            "EN": "English"
          },
          "registry": {
            "CZ": {
              "label": "Load details by IČO or DIČ",
              "placeholder": "Enter IČO or DIČ"
            },
            "SK": {
              "label": "Load details by IČO",
              "placeholder": "Enter IČO"
            }
          }
        },
        "deletion": {
          "title": "Close the office",
          "hint": "The office and “My office accounting” are permanently deleted after a 30-day grace period.",
          "button": "Close the office",
          "confirmTitle": "Close the office?",
          "confirmMessage": "The office is scheduled for deletion, and “My office accounting” with it. Only an office that meets both conditions can be closed:",
          "conditions": {
            "noClients": "it has no other clients (disconnect or transfer them first),",
            "ownBooksEmpty": "“My office accounting” is empty – no documents, no people of its own and no open invitations."
          },
          "confirmWarning": "After 30 days the office and “My office accounting” are permanently deleted. Until then you can cancel the deletion. The office’s subscription ends with the paid period.",
          "confirmButton": "Close the office",
          "cancelConfirmButton": "Keep the office",
          "requestError": "The office could not be scheduled for deletion. Please try again later.",
          "pendingTitle": "The office is scheduled for deletion",
          "pendingHint": "The office and “My office accounting” will be permanently deleted on {{date}}.",
          "cancelButton": "Cancel the deletion",
          "cancelError": "The office’s deletion could not be cancelled. Please try again."
        }
      },
      "manage": {
        "noAccess": {
          "title": "You cannot manage the office here",
          "description": "Only an office administrator can close the office."
        }
      },
      "insideClient": {
        "title": "You are inside a client of {{name}}",
        "description": "This page belongs to the office board, so it cannot be opened from a client. Switch back to reach it.",
        "action": "Back to the board"
      },
      "ownOrganization": {
        "title": "This page belongs to the office board",
        "description": "You are working in {{name}}; the board belongs to the office, so switch into it.",
        "action": "Go to office {{name}}"
      },
      "home": {
        "noAccess": {
          "title": "Nothing on the board is open to you",
          "description": "Your roles in the office open no part of the board. Ask the office's admin for access."
        }
      },
      "errors": {
        "ownBooksCannotLeave": "“My office accounting” always stays with the office – it cannot be disconnected or transferred.",
        "ownBooksNotEmpty": "“My office accounting” still holds documents or people of its own. Remove them first, then you can revoke the office.",
        "ownBooksFollowsMasterAccount": "“My office accounting” is deleted and restored only together with the office. Manage the deletion from the office board.",
        "lastMasterAdmin": "The office must keep at least one active office administrator.",
        "masterAccountPendingDeletion": "The office is scheduled for deletion, so it cannot take on or create clients now.",
        "masterAccountHasClients": "The office still has clients. Disconnect or transfer them first, then you can close the office."
      },
      "pendingDeletion": {
        "title": "This office is scheduled for deletion",
        "description": "The office {{name}} and “My office accounting” will be permanently deleted on {{date}}. Until then only cancelling the deletion and Plan & billing are available.",
        "banner": "The office {{name}} is scheduled for deletion on {{date}}.",
        "askAdmin": "An office administrator can cancel the deletion.",
        "cancel": "Cancel the office’s deletion",
        "billing": "Plan & billing",
        "switchHint": "Or continue elsewhere:",
        "switchTo": "Switch to {{name}}",
        "logout": "Log out",
        "cancelError": "The office’s deletion could not be cancelled. Please try again."
      }
    },
    "masterAccountBoard": {
      "title": "Clients",
      "period": {
        "label": "Period"
      },
      "accountant": {
        "label": "Accountant",
        "all": "All accountants",
        "unassigned": "No accountant assigned"
      },
      "summary": {
        "waitingForReview": "Waiting for review",
        "probableError": "Validation errors",
        "validationWarning": "Warnings",
        "waitingForClient": "Waiting for the client",
        "readyForExport": "Ready for export",
        "noActivity": "Clients with no activity",
        "extractions": "Extractions from the pool",
        "scope": "Totals across the clients in this view: {{clients}}"
      },
      "status": {
        "REQUIRES_ACTION": "Requires action",
        "WAITING_FOR_CLIENT": "Waiting for the client",
        "NO_ACTIVITY": "No activity",
        "OK": "All clear"
      },
      "counts": {
        "needsHuman": "Needs a person",
        "clientReplied": "Client replied",
        "waitingForClient": "Waiting for the client",
        "probableError": "Validation error",
        "validationWarning": "Warning",
        "waitingForReview": "Waiting for review",
        "readyForExport": "Ready for export"
      },
      "table": {
        "client": "Client",
        "status": "Status",
        "waiting": "What is waiting",
        "oldest": "Oldest waiting document",
        "lastDocument": "Last document",
        "extractions": "Extractions",
        "accountants": "Assigned accountants",
        "enter": "Open the client"
      },
      "row": {
        "unassigned": "No accountant assigned",
        "noDocuments": "No document yet",
        "noDocumentsHint": "Open the client's settings and send them the address for receiving documents.",
        "enter": "Open",
        "enterClient": "Open client {{name}}",
        "detail": "Details",
        "detailClient": "Details of client {{name}}"
      },
      "empty": {
        "title": "The office has no clients yet",
        "description": "Create your first client and the list fills up with their documents.",
        "action": "Create a client"
      },
      "filtered": {
        "title": "No client matches the filter",
        "action": "Clear the filter"
      },
      "error": "The client list could not be loaded.",
      "newClient": "New client",
      "ownBooks": {
        "title": "Your office",
        "hint": "The office's own books – not counted in the client totals or filters."
      },
      "detail": {
        "title": "Client",
        "back": "Back to clients",
        "enter": "Enter the client",
        "error": "The client could not be loaded.",
        "notFound": {
          "title": "Client not found",
          "description": "This client is not in the office, or you have no access to it."
        },
        "summary": {
          "title": "Overview for the period",
          "nothingWaiting": "Nothing is waiting"
        },
        "membership": {
          "title": "Client of the office",
          "joinedAt": "Joined",
          "origin": "Origin",
          "disconnect": "Disconnect the client",
          "delete": "Delete the client",
          "loading": "Loading the client details…",
          "error": "The client's details could not be loaded.",
          "missing": "The client is no longer among the office's clients.",
          "noDetach": "The client has no user of its own and the office did not found it, so it can be neither disconnected nor deleted. Please contact support.",
          "pendingDeletion": "The client is scheduled for deletion."
        },
        "assignments": {
          "title": "Assigned accountants",
          "description": "An assigned accountant sees the client on the board and can enter it.",
          "loading": "Loading assignments…",
          "error": "The assignments could not be loaded. They are hidden rather than shown incomplete.",
          "incomplete": "This office has more clients, accountants or assignments than can be shown reliably here.",
          "noAccountants": "The office has no accountant yet. Invite one on the People page.",
          "none": "No accountant is assigned to the client, so no accountant will see it.",
          "readOnly": "Changing assignments needs the user management permission.",
          "feedback": {
            "assignSuccess": "Accountant assigned to the client",
            "assignError": "Failed to assign the accountant",
            "revokeSuccess": "Assignment revoked",
            "revokeError": "Failed to revoke the assignment"
          }
        }
      }
    },
    "masterAccountQueue": {
      "title": "Document queue",
      "action": {
        "restart": "From the oldest",
        "nextPage": "More documents",
        "takeOver": "Take over",
        "handOver": "Hand over…",
        "release": "Release"
      },
      "table": {
        "document": "Document",
        "client": "Client",
        "state": "State",
        "arrived": "Arrived",
        "waiting": "Waiting",
        "handler": "Handler",
        "approvedAt": "Approved",
        "approvedBy": "Approved by",
        "actions": "Actions",
        "selectAll": "Select all documents on this page",
        "selectRow": "Select document {{document}}"
      },
      "row": {
        "unnamed": "No number or supplier",
        "me": "Me",
        "handledBy": "Handled by {{name}}",
        "unhandled": "Not taken over",
        "newForMe": "New for me",
        "approvedByAi": "Approved by AI",
        "preview": "Preview document {{document}}",
        "openInClient": "Open in client",
        "openInClientLabel": "Open the document in client {{client}}",
        "menu": "More actions for document {{document}}"
      },
      "state": {
        "NEEDS_HUMAN": "Needs a person",
        "CLIENT_REPLIED": "Client replied",
        "WAITING_FOR_CLIENT": "Waiting for the client",
        "PROBABLE_ERROR": "Validation error",
        "VALIDATION_WARNING": "Warning",
        "WAITING_FOR_REVIEW": "Waiting for review",
        "READY_FOR_EXPORT": "Ready for export",
        "NONE": "No state"
      },
      "empty": {
        "TO_DO": {
          "title": "Nothing is waiting",
          "description": "No document of your clients needs your attention right now."
        },
        "WAITING_FOR_CLIENT": {
          "title": "Nothing is waiting for clients",
          "description": "No document is waiting for a client’s answer."
        },
        "DONE": {
          "title": "Nothing was approved in this month",
          "description": "Pick another month or change the filters."
        }
      },
      "end": {
        "title": "The queue does not continue past this point",
        "action": "Back to the oldest"
      },
      "error": "The queue could not be loaded.",
      "preview": {
        "close": "Close the preview",
        "untitled": "Document without a number or supplier",
        "approvedByAi": "Approved by AI",
        "field": {
          "supplier": "Supplier",
          "number": "Document number",
          "issueDate": "Issue date",
          "dueDate": "Due date",
          "total": "Total",
          "variableSymbol": "Variable symbol"
        },
        "handler": {
          "mine": "You handle it",
          "other": "Handled by {{name}}",
          "none": "Not taken over",
          "otherNotice": "{{name}} handles this document – you can carry on, you will not become its handler."
        },
        "action": {
          "approve": "Approve",
          "approveWithWarnings": "Approve with warnings",
          "returnToDraft": "Return to drafts",
          "askClient": "Ask the client",
          "editInClient": "Edit in the client"
        },
        "approveWarnings": {
          "title": "Approve with warnings",
          "message": "Approving the document accepts these warnings.",
          "cancel": "Cancel"
        },
        "ask": {
          "title": "Ask the client",
          "hintNewThread": "The client gets a question about this document.",
          "hintOpenThread": "This document already has an open question – your message is added to it and waits for the client’s reply."
        },
        "toast": {
          "approved": "The document is approved",
          "returned": "The document is back in drafts",
          "messageAdded": "The message was added to the open question"
        },
        "error": {
          "noAccess": "You no longer have access to this client.",
          "changed": "The document changed in the meantime. Showing its current state.",
          "action": "The action failed. Please try again.",
          "load": "The document could not be loaded.",
          "loadThreads": "The questions about the document could not be loaded."
        }
      },
      "tabs": {
        "TO_DO": "To do",
        "WAITING_FOR_CLIENT": "Waiting for client",
        "DONE": "Done"
      },
      "filters": {
        "handler": {
          "label": "Handler",
          "MINE_AND_UNHANDLED": "Mine + not taken over",
          "MINE": "Mine",
          "UNHANDLED": "Not taken over",
          "ALL": "Everyone",
          "person": "{{name}} ({{count}})"
        },
        "client": {
          "label": "Client",
          "all": "All clients"
        }
      },
      "bulk": {
        "clear": "Clear selection",
        "oneClientOnly": "Only documents of one client can be handed over.",
        "selected_one": "{{count}} document selected",
        "selected_other": "{{count}} documents selected"
      },
      "confirmTakeOver": {
        "title": "Take over colleagues’ documents?",
        "confirm": "Take over",
        "cancel": "Cancel",
        "message_one": "{{count}} of the selected documents is handled by a colleague. Once taken over, you handle it.",
        "message_other": "{{count}} of the selected documents are handled by colleagues. Once taken over, you handle them."
      },
      "handOver": {
        "title": "Hand over documents",
        "label": "To",
        "placeholder": "Choose a colleague",
        "loading": "Loading colleagues…",
        "me": "{{name}} (me)",
        "submit": "Hand over",
        "cancel": "Cancel",
        "error": "The colleagues could not be loaded.",
        "empty": "Nobody else can handle documents of this client.",
        "description_one": "{{count}} document of client {{client}}",
        "description_other": "{{count}} documents of client {{client}}"
      },
      "outcome": {
        "ALREADY_MINE": "{{count}} already yours",
        "HANDLED_BY_OTHER": "{{count}} handled by a colleague",
        "HANDLED_BY_OTHER_named": "{{count}} handled by {{name}}",
        "CONFLICT": "{{count}} changed hands meanwhile",
        "NOT_ALLOWED": "{{count}} not allowed or no longer accessible",
        "failedClient": "The change failed for client {{client}}.",
        "dismiss": "Dismiss",
        "TAKEN_one": "{{count}} taken over",
        "TAKEN_other": "{{count}} taken over",
        "HANDED_OVER_one": "{{count}} handed over",
        "HANDED_OVER_other": "{{count}} handed over",
        "RELEASED_one": "{{count}} released",
        "RELEASED_other": "{{count}} released",
        "NOT_FOUND_one": "{{count}} no longer exists",
        "NOT_FOUND_other": "{{count}} no longer exist"
      }
    },
    "inbox": {
      "title": "Notifications",
      "menu": {
        "labelWithUnread": "Notifications ({{count}})",
        "unread_one": "{{count}} unread",
        "unread_other": "{{count}} unread",
        "badgeOverflow": "99+"
      },
      "actions": {
        "markAllRead": "Mark all as read",
        "loadMore": "Load more"
      },
      "row": {
        "unread": "Unread"
      },
      "titles": {
        "documentThreadQuestion": {
          "full": "{{actor}} asked about the document {{name}}",
          "withoutActor": "A question about the document {{name}}",
          "withoutName": "{{actor}} asked about a document",
          "bare": "A question about a document"
        },
        "unknown": "New notification"
      },
      "empty": {
        "title": "No notifications",
        "description": "When someone asks you about a document, you will find it here."
      },
      "error": "Notifications could not be loaded.",
      "feedback": {
        "markAllError": "The notifications could not be marked as read."
      }
    },
    "integrations": {
      "description": "Connect external systems and manage data sync integrations.",
      "empty": "No integrations configured yet.",
      "loading": "Loading integrations...",
      "loadError": "Failed to load integrations",
      "opensInNewTab": "{{label}} (opens in a new tab)",
      "actions": {
        "sync": "Sync now",
        "edit": "Configure",
        "delete": "Delete"
      },
      "modals": {
        "delete": {
          "title": "Delete integration",
          "message": "Are you sure you want to delete the integration “{{name}}”? This cannot be undone.",
          "confirm": "Delete"
        },
        "register": {
          "title": "Add integration",
          "description": "Pick a plugin and what it syncs. The integration is created disabled — configure it on the next screen.",
          "titleForEntity": "Add integration for {{entity}}",
          "descriptionForEntity": "Pick a plugin that syncs {{entity}}. The integration is created disabled — configure it on the next screen.",
          "submit": "Register and configure"
        }
      },
      "fields": {
        "plugin": "Plugin",
        "name": "Name",
        "entityType": "Entity type",
        "secretSet": "A secret value is set",
        "clearSecret": "Clear secret value",
        "discovered": {
          "found": "Found on the bridge in {{source}}",
          "differs": "The bridge reports a different value ({{source}})",
          "use": "Use this"
        },
        "syncDirections": "Sync direction",
        "syncDirectionsHint": "One integration can sync in, out, or both ways.",
        "inbound": {
          "off": "Off",
          "readBack": "Read-back only",
          "full": "Full sync"
        },
        "noDirections": "This plugin implements no sync direction, or it could not be loaded — check the API log.",
        "default": "Default: {{value}}.",
        "on": "On",
        "off": "Off"
      },
      "placeholders": {
        "name": "e.g. Production ERP sync",
        "selectPlugin": "Select a plugin",
        "selectEntityType": "Select an entity type",
        "selectValue": "Select a value",
        "json": "Enter a JSON value"
      },
      "success": {
        "created": "Integration created.",
        "updated": "Integration updated.",
        "deleted": "Integration deleted.",
        "enabled": "Integration enabled.",
        "disabled": "Integration disabled.",
        "syncStarted": "Synchronization started.",
        "migrated": "Configuration migrated."
      },
      "errors": {
        "nameRequired": "Name is required",
        "entityTypeRequired": "Entity type is required",
        "directionRequired": "Sync direction is required",
        "pluginRequired": "Plugin is required",
        "configInvalid": "Configuration is invalid",
        "fieldRequired": "This field is required",
        "invalidValue": "Enter a valid value",
        "invalidUrl": "Enter a valid URL",
        "invalidJson": "Enter valid JSON",
        "invalidNumber": "Enter a valid number",
        "tooShort": "Value is too short",
        "tooLong": "Value is too long",
        "numberTooSmall": "Value is too small",
        "numberTooLarge": "Value is too large",
        "saveError": "Failed to save the integration",
        "deleteError": "Failed to delete the integration",
        "syncError": "Failed to start synchronization",
        "migrateError": "The configuration could not be migrated",
        "cronInvalid": "Enter a cron expression with five fields",
        "intervalTooShort": "The shortest interval is 1 minute",
        "timezoneRequired": "Time zone is required",
        "modifiedSinceUnavailable": "Changes only needs an inbound direction and a plugin that lists changed records",
        "readBackNeedsClock": "A read-back runs on a schedule, not on events",
        "readBackWithFullSync": "A full inbound sync already reads these fields back; remove the read-back schedule",
        "readBackUnavailable": "Read-back only needs outbound and a plugin that reads this entity back",
        "connectionRequired": "Pick the installation this connector reads",
        "entityLinkAuditFailed": "The decision could not be written to the activity log, so nothing changed. Please try again.",
        "linkDecisionForbidden": "You don't have permission to {{permission}}.",
        "invoiceLinkConflict": "The invoice can't be edited in its current state, or the link changed in the meantime. Return the invoice to editing, or reload and try again.",
        "bridgeManagedByMasterAccount": "Only your accounting office sets up installations on its office bridge.",
        "bridgeAgendaTaken": "This agenda is already used by another client of this office, “{{clientName}}”. On the office's bridges, one agenda serves only one client.",
        "bridgeAgendaTakenUnnamed": "This agenda is already used by another client of this office. On the office's bridges, one agenda serves only one client.",
        "bridgeAgendaIncomplete": "The installation's settings don't show which agenda it opens. Fill in the settings that identify it, such as the company ID (IČO). A plugin that cannot identify its agenda cannot be used on an office bridge.",
        "missingHoldChanged": "The batch has changed in the meantime, load it again.",
        "missingHoldConnectorOff": "The connector is switched off. Switch it on and confirm the batch again.",
        "missingHoldNothingToFinish": "The batch is already fully processed.",
        "missingHoldFailed": "The decision could not be saved. Try again."
      },
      "editor": {
        "title": "Integration",
        "back": "Back to integrations",
        "actionsLabel": "Integration actions",
        "loadError": "Failed to load the integration",
        "enabledLabel": "Enabled",
        "enabledHint": "A disabled integration never syncs. Enabling requires a complete configuration."
      },
      "bridges": {
        "title": "Bridges",
        "description": "A Tappeer Bridge is a small agent on a machine inside your network. It reaches business systems the cloud cannot, and dials out — nothing connects in to it.",
        "empty": "No bridges registered yet.",
        "loading": "Loading bridges...",
        "loadError": "Failed to load bridges",
        "unknownHost": "Host not reported yet",
        "lastSeen": "Last seen {{at}}",
        "neverSeen": "Never connected",
        "status": {
          "online": "Online",
          "offline": "Offline",
          "pending": "Awaiting enrollment",
          "revoked": "Revoked"
        },
        "plugins": {
          "none": "No target systems",
          "detail": "Version {{version}} · {{entities}}"
        },
        "select": {
          "label": "Bridge",
          "placeholder": "Select a bridge",
          "online": "{{name}} (online)",
          "offline": "{{name}} (offline)",
          "unavailable": "{{name}} — no longer available",
          "unknown": "Unknown bridge",
          "noPlugin": "{{name}} — does not host {{externalApp}}",
          "noneHost": "None of your bridges hosts a {{externalApp}} plugin for this entity. Install it on a bridge first.",
          "none": "No enrolled bridges yet. Register one on the Bridges page first."
        },
        "actions": {
          "register": "Register bridge",
          "enrollmentCode": "Enrollment code",
          "revoke": "Revoke",
          "delete": "Delete"
        },
        "wizard": {
          "title": "Register a bridge",
          "back": "Back to bridges",
          "intro": "A bridge is a small agent on a machine inside your network. It reaches business systems the cloud cannot, and dials out — nothing connects in to it.",
          "steps": {
            "name": "Name it",
            "install": "Install the agent",
            "enroll": "Pair the machine",
            "done": "Done"
          },
          "name": {
            "intro": "Give the bridge a name you will recognise later. Everything else — the machine, its operating system, the agent version, the target systems it can reach — the agent reports itself once it is paired.",
            "submit": "Register and continue",
            "registering": "Registering…"
          },
          "install": {
            "intro": "Install the Tappeer Bridge agent on the Windows machine that can reach your business system, using the installer for that machine's architecture. The bridge is available for Windows only.",
            "platforms": {
              "windows": {
                "title": "Run the Windows installer (.msi)",
                "body": "Run the installer and enter the pairing code shown on this step when it asks for it. The installer sets the agent up as a Windows service, starts it and pairs it; administrator rights are needed during installation, and once more if you check or retry the pairing from the console after Finish.",
                "installer": {
                  "archLabel": "Architecture",
                  "arch": {
                    "amd64": "x64",
                    "arm64": "ARM64"
                  },
                  "summary": "Version {{version}} · {{size}}",
                  "download": "Download the installer",
                  "sha256Label": "SHA-256 checksum",
                  "copySha256": "Copy the checksum",
                  "codeLabel": "Pairing code",
                  "copyCode": "Copy the pairing code",
                  "commandLabel": "Or install unattended (PowerShell as administrator)",
                  "copyCommand": "Copy the command",
                  "hint": "Run it in the folder you downloaded the installer to. To run the service under a domain service account, append SERVICEACCOUNT=… SERVICEPASSWORD=….",
                  "gatewayHint": "This environment's gateway is {{endpoint}}; the command above includes it.",
                  "expiresIn": "The pairing code expires in {{remaining}}",
                  "expired": "The pairing code has expired. Issue a new one to install and pair the agent.",
                  "reissue": "Issue a new code",
                  "unavailable": "The installer for this architecture is not available for download yet.",
                  "loadFailed": "The installer could not be loaded. Try again later."
                }
              }
            },
            "afterwards": "Entered the pairing code in the installer, or installed with the unattended command? Then the agent is already paired — continue and this page notices it reporting in. Installed without a pairing code? The agent runs but belongs to nobody yet; the next step pairs it with this account using the one-time code.",
            "continue": "The agent is installed",
            "back": "Back"
          },
          "enroll": {
            "intro": "Run this on the machine where you installed the agent. It spends the code and pairs the machine with “{{name}}”.",
            "codeLabel": "One-time code",
            "waiting": "Waiting for the agent to report in — this page notices by itself.",
            "reissue": "Issue a new code",
            "back": "Back"
          },
          "done": {
            "title": "“{{name}}” is paired and online.",
            "plugins": "Target systems it reports",
            "noPlugins": "None yet. A target system appears here once its plugin is installed on the machine.",
            "next": "Next: add the installation this bridge reaches — the agenda, the accounting unit — on the bridge page, then point a connector at it.",
            "openBridge": "Open the bridge",
            "finish": "Back to bridges",
            "nextOffice": "Next: in each client's account, add the installation on this bridge — the client's agenda — then point the client's connector at it."
          },
          "diagram": {
            "alt": "Tappeer in the cloud, one secure tunnel, and the bridge inside your network reaching the business system.",
            "yourNetwork": "Your network",
            "cloud": "runs in the cloud",
            "tunnel": "Secure tunnel",
            "dialsOut": "opened by the bridge, outwards only",
            "bridge": "Bridge",
            "agent": "small agent on one PC",
            "caption": "The bridge dials out to Tappeer and holds one encrypted tunnel open. Records travel along it both ways; nothing from outside ever connects into your network, and no port is opened.",
            "tappeerZone": "Tappeer server",
            "internet": "Internet",
            "bothWays": "records travel both ways",
            "localLink": "reached locally by the bridge",
            "moreSystems": "other systems…"
          }
        },
        "modals": {
          "register": {
            "title": "Register a bridge",
            "description": "Give it a name you will recognise. Everything else — host, operating system, version, target systems — is reported by the agent once it enrolls.",
            "nameLabel": "Name",
            "nameHint": "For example: Accounting PC, or Warehouse server",
            "nameRequired": "A name is required",
            "submit": "Register",
            "cancel": "Cancel"
          },
          "code": {
            "title": "Enrollment code for {{name}}",
            "shownOnce": "This code is shown once and cannot be retrieved later. If you lose it, issue a new one from the bridge row.",
            "installTitle": "Run this on the machine the bridge is installed on",
            "copyCode": "Copy the code",
            "copyCommand": "Copy the command",
            "copied": "Copied to the clipboard.",
            "expiresIn": "Expires in {{remaining}}",
            "expired": "This code has expired. Issue a new one from the bridge row."
          },
          "revoke": {
            "title": "Revoke this bridge?",
            "message": "The credential of “{{name}}” stops working immediately and its connection is closed.",
            "warning": "A revoked bridge cannot be brought back. The agent has to be enrolled again against a new registration.",
            "confirm": "Revoke",
            "officeWarning": "A revoked bridge cannot be brought back, and the syncs of the clients whose installations run on it stop. The agent has to be enrolled again against a new registration."
          },
          "delete": {
            "title": "Delete this bridge?",
            "message": "“{{name}}” is removed along with its connection history.",
            "confirm": "Delete",
            "installations": "Its installations and their stored credentials are removed with it.",
            "connectors_one": "Its installations and their credentials are removed with it. The connector running through it — {{names}} — is switched off and left without an installation; point it at another bridge to run it again.",
            "connectors_other": "Its installations and their credentials are removed with it. The {{count}} connectors running through it — {{names}} — are switched off and left without an installation; point them at another bridge to run them again.",
            "office": "A bridge that a client's installation still uses cannot be deleted. Remove those installations first."
          }
        },
        "toasts": {
          "revoked": "“{{name}}” has been revoked.",
          "deleted": "“{{name}}” has been deleted."
        },
        "errors": {
          "registerFailed": "Could not register the bridge",
          "codeFailed": "Could not issue an enrollment code",
          "revokeFailed": "Could not revoke the bridge",
          "deleteFailed": "Could not delete the bridge",
          "inUse": "“{{name}}” is still used by client installations: {{clients}}. Remove them before deleting it.",
          "inUseUnlisted": "“{{name}}” is still used by client installations. Remove them before deleting it.",
          "otherAccount": "another account"
        },
        "statusPage": {
          "title": "Bridge",
          "back": "Back to bridges",
          "loadError": "This bridge could not be loaded.",
          "tabs": {
            "overview": "Overview",
            "sessions": "Connection history",
            "activity": "Activity"
          },
          "hostname": "Host name",
          "platform": "Platform",
          "agentVersion": "Agent version",
          "lastSeen": "Last seen",
          "enrolledAt": "Enrolled",
          "plugins": "Target systems",
          "sessions": {
            "title": "Connection history",
            "hint": "Repeated short sessions ending in a timeout point at the network; one long session ending in a shutdown is a deploy.",
            "connectedAt": "Connected",
            "disconnectedAt": "Disconnected",
            "reason": "Reason",
            "gateway": "Gateway",
            "open": "Still connected"
          },
          "actionsLabel": "Bridge actions"
        },
        "health": {
          "online": {
            "title": "Online",
            "heard": "Talking to Tappeer — last heard from {{when}}.",
            "hint": "Talking to Tappeer right now."
          },
          "offline": {
            "title": "Offline",
            "since": "Enrolled, but not heard from since {{when}}. The machine may be off, or the agent stopped.",
            "hint": "Enrolled, but not connected."
          },
          "pending": {
            "title": "Awaiting enrollment",
            "hint": "Registered, but no agent has paired with it yet. Issue an enrollment code and run it on the machine."
          },
          "revoked": {
            "title": "Revoked",
            "hint": "Its credential no longer works. Register a new bridge to pair the machine again."
          },
          "reason": "last session ended: {{reason}}",
          "lastSeenAt": "Last seen {{at}}",
          "agent": "Agent",
          "host": "Host",
          "plugins": "Target systems",
          "noPlugins": "None reported yet"
        },
        "card": {
          "connectors_one": "{{count}} connector runs through it",
          "connectors_other": "{{count}} connectors run through it",
          "noConnectors": "No connector runs through it yet"
        },
        "office": {
          "description": "The bridges of your accounting office. Your clients' installations run on them, and only the office's staff set them up.",
          "clients": {
            "title": "Client installations",
            "hint": "Each agenda on the office's bridges serves one client.",
            "empty": "No client has an installation on this bridge yet.",
            "client": "Client",
            "plugin": "Plugin",
            "installation": "Installation",
            "agenda": "Agenda",
            "otherAccount": "Another account",
            "agendaUnknown": "Not identified",
            "duplicate": "Same agenda twice",
            "duplicateHint": "Another installation of this client on this bridge opens the same agenda."
          }
        },
        "handOver": {
          "action": "Hand over to the office",
          "title": "Hand this bridge over to the office?",
          "message": "“{{name}}” will belong to your accounting office “{{office}}” and keeps its pairing, so the machine needs no new enrollment. The office's staff then manage it under “Office bridges”; the installations of your office's own books stay on it and keep syncing.",
          "warning": "This is one-way: the bridge then belongs to the office and cannot be moved back.",
          "confirm": "Hand over",
          "success": "“{{name}}” now belongs to the office. Manage it under “Office bridges”.",
          "errors": {
            "notAllowed": "This bridge can't be handed over to the office right now.",
            "unavailable": "Office bridges are not available to your accounting office yet.",
            "failed": "Could not hand the bridge over to the office"
          }
        },
        "queue": {
          "title": "Run queue",
          "hint": "The bridge handles one run at a time; the others wait in the queue. Sending changes goes ahead of a sync.",
          "empty": "Nothing is running or waiting on this bridge.",
          "unavailable": "The queue cannot be read right now.",
          "running": "Running",
          "ownRun": "Your run",
          "othersRunning": "Another account's run is running",
          "othersWaiting_one": "+ {{count}} other account's run waiting",
          "othersWaiting_other": "+ {{count}} other accounts' runs waiting",
          "columns": {
            "position": "Position",
            "run": "Run",
            "client": "Client",
            "priority": "Kind",
            "waiting": "Waiting"
          }
        }
      },
      "activity": {
        "title": "Activity",
        "viewDetails": "View details",
        "detailsLabel": "Details",
        "errorLabel": "Error",
        "detailsTruncated": "The payload was larger than the limit and has been cut short.",
        "correlationId": "Correlation ID",
        "loadError": "Activity could not be loaded.",
        "retry": "Try again",
        "loadMore": "Load more",
        "severity": {
          "INFO": "Info",
          "WARN": "Warning",
          "ERROR": "Error"
        },
        "filters": {
          "all": "All",
          "problems": "Errors & warnings"
        },
        "empty": {
          "noActivity": "Nothing has happened yet.",
          "noProblems": "No errors or warnings — everything has run cleanly."
        }
      },
      "syncRuns": {
        "title": "Sync runs",
        "hint": "Open a run to see the activity recorded inside it.",
        "empty": "This integration has not run yet.",
        "loadMore": "Load more",
        "counts": "{{created}} created · {{updated}} updated · {{skipped}} skipped",
        "errorCount": "{{count}} failed",
        "aliasedCount_one": "{{count}} duplicate written",
        "aliasedCount_other": "{{count}} duplicates written",
        "columns": {
          "startedAt": "Started",
          "entity": "Entity",
          "status": "Status",
          "records": "Records",
          "duration": "Duration",
          "activity": "Activity",
          "connector": "Connector"
        },
        "modes": {
          "full": "Full sync",
          "modifiedSince": "Changes only",
          "records": "Selected records",
          "readBack": "Read-back"
        },
        "emptyHint": "Enable a connector and press Sync now — its first run appears here.",
        "attachmentErrorCount": "{{count}} files not moved",
        "fieldWarningCount_one": "{{count}} field not written",
        "fieldWarningCount_other": "{{count}} fields not written",
        "recordErrors": {
          "title_one": "{{count}} record was not synced",
          "title_other": "{{count}} records were not synced",
          "hint": "These records were left out; the run went on with the others.",
          "columns": {
            "businessKey": "Business key",
            "reason": "Reason"
          },
          "capped": "Showing {{shown}} of {{count}}.",
          "codes": {
            "code-too-long": "A code in this record is longer than the target system allows. Shorten it in Tappeer or change the transform rule, then run the sync again."
          },
          "codeTooLong_one": "The code in the field “{{field}}” has {{length}} character; the target system allows at most {{maxLength}}. Shorten it in Tappeer or change the transform rule, then run the sync again.",
          "codeTooLong_other": "The code in the field “{{field}}” has {{length}} characters; the target system allows at most {{maxLength}}. Shorten it in Tappeer or change the transform rule, then run the sync again."
        },
        "fieldWarnings": {
          "title_one": "{{count}} field was not written",
          "title_other": "{{count}} fields were not written",
          "hint": "These fields were left as they are; the rest of each record was synced.",
          "columns": {
            "businessKey": "Business key",
            "field": "Field",
            "reason": "Reason"
          },
          "capped": "Showing {{shown}} of {{count}}.",
          "codes": {
            "text-too-long": "The text was too long for a rule to process. Shorten it or change the rule.",
            "lines-not-replaced": "The target system refused to replace the document's lines (in ABRA Flexi, for example, when it is paired with a payment), so only the document header was written and its lines were left unchanged.",
            "code-not-mapped": "The target system's code matches no value in the connector or connection settings, or matches several. The field was left as it is; adjust the code mapping there.",
            "reference-not-linked": "The document pays an invoice the Invoice connector on the same connection has not linked yet. The document was saved without it; it is added on a later sync once the invoice is linked.",
            "amount-zero": "The document's amount is zero, so no money moved. It was not loaded into Tappeer.",
            "value-not-read": "The value in the target system could not be read unambiguously, so it was left out."
          },
          "unknownCode": "Not written, for a reason this version of Tappeer has no text for ({{code}})."
        },
        "bridgeWait": {
          "label": "Waiting for the bridge",
          "hint": "The bridge handles one run at a time. This run starts when its turn comes.",
          "for": "for {{duration}}",
          "ahead_one": "{{count}} run ahead when queued",
          "ahead_other": "{{count}} runs ahead when queued"
        }
      },
      "readiness": {
        "title": "Sync readiness",
        "hint": "Checks whether a sync through this installation can run. Nothing is synced.",
        "run": "Verify readiness",
        "runAgain": "Verify again",
        "running": "Verifying…",
        "saveFirst": "Save your changes first — the check tests the saved settings.",
        "notSaved": "Readiness can be verified once the installation is saved.",
        "targetStep": "Checking the target system…",
        "detail": "Details:",
        "targetVersion": "Target system version:",
        "stalled": "The check is taking longer than expected. Verify again.",
        "expired": "The result of the last check is no longer available. Verify again.",
        "retry": "Then verify readiness again.",
        "status": {
          "passed": "Passed",
          "failed": "Failed",
          "skipped": "Skipped",
          "running": "In progress"
        },
        "checks": {
          "BRIDGE_ONLINE": "Bridge connection",
          "PLUGIN_VERSION": "Plugin version on the bridge",
          "CONFIG": "Settings",
          "EXECUTABLE": "Starting the target system",
          "LOGIN": "Signing in",
          "AGENDA": "Agenda",
          "DEFINITIONS": "Export and import definitions",
          "EXPORT": "Test export",
          "CARD_IMPORT_KEY": "Master card import key"
        },
        "verdict": {
          "ready": "Ready to sync",
          "notReady": "Not ready to sync",
          "reachable": "The target system answered",
          "notReachable": "The target system did not answer",
          "incomplete": "The check could not be completed",
          "notSupported": "This connector cannot be verified"
        },
        "errors": {
          "notFound": "This installation no longer exists. Reload the page.",
          "forbidden": "You do not have permission to manage integrations.",
          "rateLimited": "Too many checks in a short time. Try again later.",
          "rateLimitedIn_one": "Too many checks in a short time. Try again in {{count}} minute.",
          "rateLimitedIn_other": "Too many checks in a short time. Try again in {{count}} minutes.",
          "unavailable": "The check cannot be started right now. Try again in a moment.",
          "conflict": "Another check of this installation is just starting. Try again in a moment.",
          "failed": "The check could not be started. Try again."
        }
      },
      "failures": {
        "openSettings": "Open settings",
        "help": {
          "sharedIco": "How Money S3 selects the agenda"
        },
        "openGuide": "More in the help",
        "dialogTitle": "Blocking window:",
        "quoteOpen": "“",
        "quoteClose": "”",
        "rawMessage": "Original message:",
        "retrySync": "Then run the sync again.",
        "otherInstance": {
          "sameSession": "The target system is also running in the same user session as the bridge.",
          "otherSession": "The target system is also running on the bridge computer in another user's session."
        },
        "codes": {
          "CONFIG_INVALID": {
            "title": "A connector setting is not valid",
            "remedy": "Correct the settings. {{retry}}"
          },
          "MONEYS3_AGENDA_NOT_FOUND": {
            "title": "Money S3 has no agenda with the configured company ID (IČO)",
            "remedy": "Check the company ID (IČO) in the settings. {{retry}}"
          },
          "MONEYS3_AGENDA_AMBIGUOUS": {
            "title": "Money S3 found more than one matching agenda",
            "remedy": "Check the agenda folder in the settings so that exactly one agenda matches. {{retry}}"
          },
          "MONEYS3_WRONG_AGENDA": {
            "title": "The Money S3 agenda has a different company ID (IČO) than the one configured",
            "remedy": "Check the company ID (IČO) and the agenda in the settings. {{retry}}"
          },
          "MONEYS3_NO_OUTPUT": {
            "title": "Money S3 finished without returning any data",
            "remedy": "Check the Money S3 connection settings. {{retry}} If it keeps failing, contact support."
          },
          "MONEYS3_EXIT_NONZERO": {
            "title": "Money S3 ended with an error",
            "remedy": "Wait a moment. {{retry}} If it keeps failing, contact support."
          },
          "MONEYS3_PROCESS_TIMEOUT": {
            "title": "Money S3 did not finish within the time limit",
            "remedy": "If it keeps happening, raise the time limit in the settings (the “Timeout (ms)” field); it can go about 15 seconds above the default at most. {{retry}}"
          },
          "MONEYS3_ALREADY_RUNNING": {
            "title": "Money S3 is open on the bridge computer",
            "remedy": "Close Money S3 on the bridge computer. {{retry}}"
          },
          "MONEYS3_LOGIN_REQUIRED": {
            "title": "Could not sign in to Money S3",
            "remedy": "The Money S3 password is missing or incorrect. Check the password in the connection settings. {{retry}}"
          },
          "MONEYS3_DIALOG_BLOCKED": {
            "title": "A Money S3 window is waiting for an answer",
            "remedy": "On the bridge computer, open Money S3, deal with the window and close Money S3. {{retry}}"
          },
          "MONEYS3_PROCESS_HUNG": {
            "title": "Money S3 stopped responding",
            "remedy": "If it keeps happening, check on the bridge computer that Money S3 starts and is not waiting for anything. {{retry}}"
          },
          "MONEYS3_PROCESS_SLOW": {
            "title": "Money S3 was still working when the time limit ran out",
            "remedy": "If it keeps happening, raise the time limit in the settings (the “Timeout (ms)” field); it can go about 15 seconds above the default at most. {{retry}}"
          },
          "MONEYS3_TRANSFER_CONFIG_UNWRITABLE": {
            "title": "The Money S3 XML transfer configuration could not be updated",
            "remedy": "On the bridge computer, check that the files in the XMLDE\\Config\\Command folder of the Money S3 data are not read-only and that the bridge may write to them. Or turn off “Manage XML transfer configuration” in the connection settings. {{retry}}"
          },
          "MONEYS3_TRANSFER_CONFIG_MISSING": {
            "title": "The Money S3 XML transfer configuration was not found",
            "remedy": "Check on the bridge computer that the Money S3 data folder contains the XMLDE folder with its standard configuration, or turn off “Manage XML transfer configuration” in the connection settings. {{retry}}"
          },
          "MONEYS3_DATA_FOLDER_UNCONFIRMED": {
            "title": "The Money S3 data folder could not be confirmed",
            "remedy": "On the bridge computer, check that a MonS3.ini next to MonS3.exe names the data folder (DATAROOT) and can be changed by administrators only, or turn off “Manage XML transfer configuration” in the connection settings. If the data folder or a folder above it is a junction or symbolic link, replace it with a real folder: until then no party is written. {{retry}}"
          },
          "BRIDGE_NOT_CONNECTED": {
            "title": "The bridge is not connected",
            "remedy": "Check that the bridge computer is on and connected to the internet. {{retry}}"
          },
          "BRIDGE_BUSY": {
            "title": "The bridge is busy",
            "remedy": "Wait a moment. {{retry}}"
          },
          "BRIDGE_NOT_AVAILABLE": {
            "title": "This account may not use the bridge",
            "remedy": "Point the connector at an installation on a bridge this account may use, or ask your accounting office to allocate the agenda to this account. {{retry}}"
          },
          "BRIDGE_REVOKED": {
            "title": "The bridge was revoked or deleted while the sync was waiting for it",
            "remedy": "Point the connector at an installation on another bridge. {{retry}}"
          }
        },
        "classes": {
          "transient": {
            "title": "The sync failed for a temporary reason",
            "remedy": "Wait a moment. {{retry}} If it keeps failing, contact support."
          },
          "config": {
            "title": "The settings need a correction",
            "remedy": "Check the settings. {{retry}}"
          },
          "auth": {
            "title": "Signing in to the target system failed",
            "remedy": "Check the sign-in details in the settings. {{retry}}"
          },
          "timeout": {
            "title": "The target system did not finish in time",
            "remedy": "Wait a moment. {{retry}} If it keeps happening, contact support."
          },
          "data": {
            "title": "The data could not be processed",
            "remedy": "See the original message and correct the data it names. {{retry}}"
          }
        }
      },
      "attachments": {
        "title": "Attachments",
        "intro": "Files of a record can cross with it. {{externalApp}} has to offer the direction; until it is switched on here, only the data of the record syncs.",
        "summary": {
          "off": "No files cross in either direction",
          "in": "Files are fetched from the other system",
          "out": "Files are sent to the other system",
          "both": "Files cross in both directions"
        },
        "directions": {
          "in": {
            "label": "Fetch files from {{externalApp}}",
            "hint": "A file the external record carries is stored on the Tappeer record as an attachment. It is never treated as the invoice scan and is not read by extraction."
          },
          "out": {
            "label": "Send files to {{externalApp}}",
            "hint": "Files of a Tappeer record are offered to the other system once its data is written. A file it already holds is not sent again."
          }
        },
        "capability": {
          "noRead": "The {{externalApp}} connector does not read files for {{entity}}, so this direction cannot be switched on. It needs a plugin version that offers it.",
          "noWrite": "The {{externalApp}} connector does not write files for {{entity}}, so this direction cannot be switched on. It needs a plugin version that offers it.",
          "notReported": "The bridge has not reported yet that its {{externalApp}} plugin moves files. Records keep syncing; files start moving once it does."
        },
        "roles": {
          "label": "Files that go out",
          "hint": "Only a file with a ticked role is offered to the other system. Incoming files are never filtered by role."
        },
        "transfers": {
          "title": "Attachments",
          "hint": "Every file this connector has queued, moved or refused. A refused file never became eligible and is not retried; a failed one is retried by the next runs.",
          "empty": "No file has been planned for this connector.",
          "emptyHint": "Switch attachments on in Settings — files appear here from the next run.",
          "loadError": "The attachments could not be loaded.",
          "loadMore": "Load more",
          "totalCount": "{{count}} files",
          "columns": {
            "file": "File",
            "direction": "Direction",
            "status": "Status",
            "size": "Size",
            "attempts": "Attempts",
            "reason": "Reason",
            "actions": "Actions"
          },
          "retry": "Retry",
          "retried": "The file is queued again.",
          "repush": "Re-push the record",
          "repushed": "Queued again: {{planned}} files, {{refused}} refused.",
          "actionError": "The action did not go through. Try again.",
          "repushModal": {
            "title": "Send this record's files again?",
            "message": "Tappeer forgets which files this connector has already sent for the record and plans all of them again.",
            "warning": "Use it when the other system lost a file. The other system may end up with a copy it already had.",
            "confirm": "Send again",
            "cancel": "Cancel"
          },
          "reasons": {
            "attachment_too_large": "Over the size limit",
            "attachment_type_not_allowed": "File type not allowed",
            "attachment_role_excluded": "This role is not sent out",
            "attachment_name_invalid": "Invalid file name",
            "attachment_hash_mismatch": "The transferred bytes do not match the file",
            "attachment_rejected": "Refused by the check after the transfer",
            "attachment_not_found": "The other system no longer has the file",
            "attachment_transfer_failed": "The transfer failed"
          }
        },
        "runErrors": {
          "title": "Files that could not be moved ({{count}})",
          "capped": "and {{count}} more"
        }
      },
      "deletion": {
        "title": "Deleted records",
        "summary": {
          "deactivate": "Tappeer deactivates a record deleted at the source",
          "delete": "Tappeer removes a record deleted at the source",
          "info": "Tappeer only marks a record deleted at the source",
          "notReading": "The connector does not read from the source, so it does not watch for deletions"
        },
        "intro": "What Tappeer does when {{externalApp}} deletes a record or stops sending it.",
        "label": "When a record disappears at the source",
        "defaultOption": "{{mode}} (default)",
        "hints": {
          "deactivate": "The record leaves the pickers. Documents that use it stay as they are.",
          "delete": "The record is removed. When something uses it, Tappeer only marks it.",
          "info": "The record stays as it is. It only gets a “Deleted in {{externalApp}}” label."
        },
        "scopeNote": "When you narrow the connector’s scope in the source system, for example with a filter or another accounting unit, records outside the new scope look deleted. When many go missing at once, Tappeer holds them in a batch that you confirm or discard in the monitor. When only a few do, Tappeer handles them according to the chosen mode.",
        "notReading": "Only a connector with the inbound direction watches for deleted records. This one does not have it switched on.",
        "unsupported": "This entity does not support the “{{mode}}” mode. Choose another one.",
        "unsupportedShort": "Unsupported mode"
      },
      "behaviour": {
        "echoSuppression": {
          "title": "Echo suppression",
          "description": "Skips a record that comes back unchanged from the other system, so one edit does not bounce between the two systems forever. It does not merge fields.",
          "offWarning": "Off: every record is written on every run, changed or not. Both systems will keep re-saving each other's records.",
          "pointer": "Which system may write which field is set in Transform → Fields.",
          "goToFieldMap": "Open Fields"
        }
      },
      "mapping": {
        "noMetadata": "The plugin does not describe the {{entityType}} entity, so mapping rules cannot be edited here.",
        "key": {
          "title": "Business key",
          "hint": "How a Tappeer row and a record of the other system are recognised as the same thing.",
          "mode": {
            "default": "Model default",
            "fields": "Fields",
            "expression": "Expression"
          },
          "modelDefault": "Keyed by the model field: {{fields}}",
          "fields": "Key fields",
          "preview": {
            "button": "Preview collisions",
            "error": "The preview could not be computed.",
            "sampled": "{{count}} rows evaluated",
            "unkeyed": "{{count}} rows without a key",
            "collisions": "{{count}} keys are shared by several rows — the rule does not identify a row uniquely.",
            "noCollisions": "Every keyed row has its own key.",
            "truncated": "The preview stopped at its row cap; a larger account may hide more collisions.",
            "columns": {
              "key": "Key",
              "count": "Rows"
            }
          },
          "changeWarning": "Change how the key is built and records that used to match stop matching — you get duplicates instead of updates. Preview collisions before you save."
        },
        "filters": {
          "title": "Filters",
          "hint": "Only rows matching the condition are synced.",
          "out": "Filter outgoing rows",
          "in": "Filter incoming records",
          "serverSide": "server-side",
          "inMemory": "in memory",
          "noDirections": "Choose a sync direction in Settings first — a filter belongs to a direction.",
          "serverSideHint": "Tappeer selects only the matching rows, so the amount of data does not matter.",
          "inMemoryHint": "Every row is read and then filtered, which is slow on large data. Only a plain “is” on a filterable field runs server-side.",
          "inMemoryHintIn": "Every record {{externalApp}} sends is read and then filtered in Tappeer. An incoming filter never runs server-side.",
          "pluginDefault": "Plugin default"
        },
        "derived": {
          "title": "Derived fields",
          "hint": "Compute a field from the record before it is written.",
          "toCanonical": "Incoming — into Tappeer fields",
          "toExternal": "Outgoing — into the other system",
          "target": "Target",
          "targetPlaceholder": "Field name (may be virtual)",
          "add": "Add field",
          "remove": "Remove field",
          "toCanonicalHint": "Applied to each incoming record before it is written into Tappeer.",
          "toExternalHint": "Applied to each outgoing record before it is sent to the other system; the target may be a field only the other system has.",
          "chaining": "Rules run top to bottom, and a later rule can use what an earlier one wrote.",
          "pickTarget": "Choose where the result goes before saving."
        },
        "defaults": {
          "title": "Defaults",
          "hint": "Value used for a Tappeer field the incoming record leaves empty.",
          "add": "Add default",
          "remove": "Remove default",
          "toCanonical": "Incoming — into Tappeer fields",
          "toExternal": "Outgoing — into the other system",
          "toCanonicalHint": "Used when the incoming record leaves the Tappeer field empty.",
          "toExternalHint": "Used when the outgoing record leaves the field empty; the target may be a field only the other system has.",
          "noDirections": "Choose a sync direction in Settings first — a default belongs to a direction."
        },
        "marker": {
          "label": "Stamp the Tappeer id",
          "hint": "The plugin writes the Tappeer id into its marker field, so a record is recognised even after its key changes."
        },
        "valueKind": {
          "label": "Value type",
          "unset": "Not set",
          "string": "Text",
          "number": "Number",
          "boolean": "Yes/No",
          "null": "Empty",
          "json": "JSON"
        },
        "expression": {
          "customPath": "Other path…",
          "add": "Add",
          "remove": "Remove",
          "ops": {
            "field": "Field",
            "const": "Constant",
            "meta": "Record fact",
            "concat": "Join",
            "template": "Template",
            "coalesce": "First non-empty",
            "lookup": "Lookup table",
            "case": "Conditions",
            "arith": "Arithmetic",
            "string": "Text function",
            "splitStreet": "Split street",
            "joinStreet": "Join street",
            "eq": "Equals",
            "ne": "Not equals",
            "gt": "Greater than",
            "gte": "Greater or equal",
            "lt": "Less than",
            "lte": "Less or equal",
            "in": "In list",
            "contains": "Contains",
            "startsWith": "Starts with",
            "endsWith": "Ends with",
            "isNull": "Is empty",
            "notNull": "Is not empty",
            "and": "All of",
            "or": "Any of",
            "not": "Not",
            "resolve": "Look up in the target system",
            "fn": "Plugin function",
            "ref": "Tappeer reference"
          },
          "slots": {
            "op": "Operation",
            "path": "Field path",
            "key": "Key",
            "fn": "Function",
            "left": "Left",
            "right": "Right",
            "value": "Value",
            "list": "List",
            "item": "Item",
            "input": "Input",
            "arg": "Argument",
            "args": "Argument",
            "parts": "Part",
            "when": "Branch",
            "if": "If",
            "then": "Then",
            "else": "Otherwise",
            "separator": "Separator",
            "scale": "Decimals",
            "table": "Table",
            "default": "Default",
            "source": "Lookup source",
            "sourcePath": "Field of the source",
            "wholeRecord": "Whole record",
            "entityType": "Entity",
            "by": "Match by",
            "want": "Return",
            "part": "Street part",
            "streetName": "Street name",
            "buildingNumber": "Building number"
          },
          "meta": {
            "externalId": "External id",
            "externalKey": "External key",
            "insioId": "Tappeer id",
            "runStartedAt": "Run started at",
            "direction": "Direction"
          },
          "arith": {
            "round": "Round"
          },
          "string": {
            "trim": "Trim",
            "upper": "Upper case",
            "lower": "Lower case",
            "stripPrefix": "Strip prefix",
            "addPrefix": "Add prefix",
            "slice": "Slice"
          },
          "streetPart": {
            "streetName": "Street name",
            "buildingNumber": "Building number"
          },
          "lookupKind": {
            "list": "reference list",
            "record": "record"
          },
          "ref": {
            "by": {
              "businessKey": "Business key",
              "externalId": "External id"
            },
            "want": {
              "externalId": "External id",
              "businessKey": "Business key",
              "insioId": "Tappeer id"
            }
          },
          "virtualOption": "{{name}} (virtual)",
          "syncOnly": "sync only",
          "syncOnlyOption": "{{name}} (sync only)",
          "unsupported": "This rule uses an operation that is no longer supported. Replace or remove it."
        },
        "target": {
          "title": "Target mapping",
          "hint": "How {{externalApp}}'s own record becomes Tappeer fields and back. Evaluated by the {{externalApp}} plugin on the bridge.",
          "hintDirect": "How {{externalApp}}'s own record becomes Tappeer fields and back. Evaluated by the {{externalApp}} connector in Tappeer.",
          "runsOn": "Evaluated by the {{externalApp}} plugin on your bridge, over {{externalApp}}'s own record. Raw data never leaves your network.",
          "runsOnDirect": "Evaluated by the {{externalApp}} connector in Tappeer, when it reads and writes records in {{externalApp}}.",
          "model": "{{fields}} fields · {{sources}} lookup sources · {{functions}} functions",
          "in": "Incoming — {{externalApp}} fields → Tappeer fields",
          "inHint": "Each rule reads the {{externalApp}} record and writes one Tappeer field. A name starting with $ is a wire-only field for the rules below.",
          "out": "Outgoing — Tappeer fields → {{externalApp}} fields",
          "outHint": "Each rule reads the Tappeer record, including outgoing derived fields, and writes one {{externalApp}} field.",
          "targetField": "{{externalApp}} field",
          "canonicalField": "Tappeer field",
          "add": "Add mapping",
          "remove": "Remove mapping",
          "reset": "Reset to plugin defaults",
          "status": {
            "default": "Plugin default",
            "changed": "Customised",
            "added": "Added"
          },
          "removedDefaults_one": "{{count}} plugin default rule removed: {{targets}}",
          "removedDefaults_other": "{{count}} plugin default rules removed: {{targets}}",
          "noDirections": "Choose a sync direction in Settings first — a target mapping belongs to a direction.",
          "issues": {
            "unknownTargetPath": "{{path}} is not a field of the {{externalApp}} model the plugin declares.",
            "unknownLookupSource": "Lookup source {{source}} is not declared by the plugin.",
            "unknownTargetFunction": "Function {{name}} is not declared by the plugin.",
            "resolveWithoutDefault": "A lookup has no default, so an unknown key yields an empty value.",
            "unknownCanonicalTarget": "{{field}} is not a Tappeer field of this entity."
          },
          "noChaining": "Every rule reads {{externalApp}}'s record as it arrived — no rule sees another rule's output, so their order does not matter."
        },
        "simple": {
          "advancedRule": "Advanced rule",
          "switchToSimple": "Simple view",
          "switchToAdvanced": "Advanced view",
          "remove": "Remove",
          "addOption": "Add a field",
          "addPart": "Add a part",
          "addRow": "Add a row",
          "addCase": "Add a case",
          "addOtherwise": "Add a fallback",
          "addCondition": "Add a condition",
          "fallbackHint": "Used for any value the table does not list. Without one, an unknown value leaves the field empty.",
          "otherwiseHint": "Used when no case matches. Without one, the field is left empty.",
          "conditionsHint": "Every condition must hold. Plain equals on a filterable field is what the external system can run itself.",
          "operand": {
            "kind": "Kind",
            "field": "Field",
            "value": "Value",
            "meta": "Record fact"
          },
          "meta": {
            "externalId": "External id",
            "externalKey": "External key",
            "insioId": "Tappeer id",
            "runStartedAt": "Sync start time",
            "direction": "Sync direction"
          },
          "operator": {
            "eq": "is",
            "ne": "is not",
            "gt": "is greater than",
            "gte": "is at least",
            "lt": "is less than",
            "lte": "is at most"
          },
          "slots": {
            "shape": "This rule",
            "from": "Take from",
            "options": "Try in order",
            "checks": "Try in order",
            "otherwise": "Otherwise",
            "table": "Translations",
            "tableKey": "External value",
            "fallback": "Anything else",
            "function": "Function",
            "on": "Look at",
            "cases": "Cases",
            "caseWhen": "when",
            "caseThen": "use",
            "parts": "Parts",
            "separator": "Separator",
            "operator": "Comparison",
            "against": "Compare with",
            "conditions": "Conditions"
          },
          "chooseValue": "Choose a value"
        },
        "recipes": {
          "insert": "Insert recipe",
          "hint": "A recipe adds a ready-made rule or filter condition for you to adjust before saving. It is added to what you already have; nothing is replaced.",
          "items": {
            "copyField": {
              "title": "Copy a field",
              "description": "Takes the value straight from one field. Pick the field under “Take from” and choose where it goes."
            },
            "firstFilled": {
              "title": "First filled of several fields",
              "description": "For a value that is sometimes in one field and sometimes in another. List the fields under “Try in order”; the first that is not empty wins, and if all are empty the target field stays empty."
            },
            "fixedValue": {
              "title": "Always the same value",
              "description": "Writes the value you type and overwrites whatever came in. If the value should only fill a field the record leaves empty, add it under “Defaults” instead."
            },
            "translateValues": {
              "title": "Translate values with a lookup table",
              "description": "For two systems that spell the same thing differently. Pick the field, add one row per value and fill in “Anything else” — left blank, a value the table does not list leaves the field empty."
            },
            "flagFromCode": {
              "title": "Yes/no from a code",
              "description": "For a yes/no field the other system only keeps as a code. The result is yes when the field is not the value you type; switch the comparison to “is” for the opposite."
            },
            "chooseByField": {
              "title": "Choose by a field",
              "description": "The value depends on what another field says. Add one case per value and keep “Otherwise”, so a record matching nothing still gets something."
            },
            "joinFields": {
              "title": "Join several fields",
              "description": "Puts several fields into one, with a separator between them (a space to start with)."
            },
            "pluginFunction": {
              "title": "Convert with a plugin function",
              "description": "For a conversion that cannot be written as a rule, such as a country name to its code. Pick one of the functions the plugin offers and the field it reads."
            },
            "filterEquals": {
              "title": "Only records with a given value",
              "description": "Only records where a field is the value you type are synced. A plain “is” on a filterable field is the one condition the other system can run itself."
            },
            "filterExclude": {
              "title": "Leave out records with a given value",
              "description": "Every record is synced except those where a field is the value you type. Filtered in memory."
            },
            "filterFrom": {
              "title": "Only records from a given value on",
              "description": "Only records where a field is at least the value you type — a date or a number — are synced. Filtered in memory, which is slow on a long history."
            },
            "filterAllOf": {
              "title": "Several conditions at once",
              "description": "One row per condition; a record is synced only when every one holds. The filter runs server-side only if every condition is a plain “is” on a filterable field."
            }
          }
        },
        "traps": {
          "readsEarlierRule": "This rule reads {{field}}, which a rule above writes — it sees the new value.",
          "readsLaterRule": "This rule reads {{field}}, which a rule below writes — it still sees the original value.",
          "targetHeldBack": "As set in Fields, {{field}} does not flow in — this rule's result is not written to Tappeer.",
          "targetNotSynced": "As set in Fields, {{field}} is not synced — this rule's result is not written, and a change only in this field is not watched.",
          "filterNotFlow": "A filtered-out record takes no part in the sync, so Tappeer cannot tell whether it was deleted, changed or only filtered. To stop a single field from crossing, set its flow in Fields instead."
        },
        "unavailable": {
          "line": "Not available in this step: {{operations}} — {{reason}}",
          "refNeedsTappeer": "Reads Tappeer's links, which a step evaluated in {{externalApp}} cannot see. Use a step computed in Tappeer.",
          "resolveNeedsTarget": "Runs inside {{externalApp}}. Use a step that reads from or sends to {{externalApp}}.",
          "fnNeedsTarget": "Runs inside {{externalApp}}. Use a step that reads from or sends to {{externalApp}}.",
          "noTargetModel": "This connector delivers Tappeer fields directly; it has nothing to look up or call.",
          "noLookupSources": "The {{externalApp}} plugin declares no lookup sources.",
          "noFunctions": "The {{externalApp}} plugin declares no functions."
        },
        "transformPreview": {
          "direction": "Direction",
          "noDirections": "Choose a sync direction in Settings first — a preview runs in one direction.",
          "source": {
            "label": "Sample record",
            "accountRecord": "Use a record of this account",
            "pasted": "Paste JSON"
          },
          "sampleKind": {
            "label": "The pasted record is",
            "canonical": "A Tappeer record",
            "target": "A {{externalApp}} record"
          },
          "sample": {
            "label": "Record as JSON",
            "hint": "One JSON object, at most {{limit}} KiB. It is sent for this preview only and is not stored.",
            "errors": {
              "empty": "Paste a record first.",
              "invalidJson": "This is not valid JSON.",
              "notObject": "The sample must be one JSON object, not a list or a single value.",
              "tooLarge": "The sample is larger than {{limit}} KiB. Paste a smaller record."
            }
          },
          "run": "Preview",
          "hint": "Uses the transform rules as edited here, including unsaved changes. The field flow and sync directions are the saved ones — save them first to preview a change there. Nothing is saved and no sync runs.",
          "waiting": {
            "title": "Evaluating the preview… {{seconds}} s",
            "hint": "A preview may have to start {{externalApp}} and can take up to two minutes."
          },
          "cancel": "Cancel",
          "error": "The preview could not be computed.",
          "stale": "The rules have changed since this preview. Run it again to see what they do now.",
          "result": {
            "source": {
              "accountRecord": "Previewed on a record of this account.",
              "pasted": "Previewed on the pasted record."
            },
            "direction": "Computed for the direction: {{direction}}"
          },
          "none": {
            "title": "This account has no record to preview yet.",
            "hint": "Paste a record as JSON instead."
          },
          "notices": {
            "approximate": {
              "title": "The input is an approximation.",
              "body": "The {{externalApp}} record could not be read, so the Tappeer record stands in for it. A real sync may give a different result."
            },
            "bridgeInbound": "The {{externalApp}} record stays on your bridge. Only the results of the rules are shown here.",
            "excluded": "A filter excludes this record — a sync would not write it.",
            "noBusinessKey": "The record has no business key, so a sync would skip it.",
            "targetProblem": "{{externalApp}} returned no record — a sync would report the problem below instead of writing it."
          },
          "keys": {
            "business": "Business key",
            "external": "External key"
          },
          "input": "Input record",
          "output": "Result",
          "noOutput": "No record comes out — a sync would write nothing.",
          "stageOutput": "Record after this stage",
          "withheld": {
            "title": "Left unchanged:",
            "reason": "A value was too long for a rule to process, so these fields keep what they had."
          },
          "masked": "Masked",
          "stages": {
            "targetIn": "{{externalApp}} record → Tappeer fields",
            "cloudIn": "Incoming rules in Tappeer",
            "cloudOut": "Outgoing rules in Tappeer",
            "targetOut": "Tappeer fields → {{externalApp}} record"
          },
          "evaluator": {
            "cloud": "Evaluated by Tappeer",
            "bridge": "Evaluated by the bridge",
            "connector": "Evaluated by the connector"
          },
          "skipped": {
            "noTargetSample": "Not evaluated: these rules read a {{externalApp}} record, but the sample is a Tappeer record.",
            "noTargetModel": "Not evaluated: no {{externalApp}} model is declared, so there are no rules here.",
            "noRules": "Not evaluated: there is no rule in this direction."
          },
          "fallback": {
            "title": "Evaluated by Tappeer, not where a sync evaluates these rules.",
            "bridgeNotConnected": "The bridge is not connected.",
            "bridgeBusy": "The bridge is busy with another request. Try again in a moment.",
            "notSupported": "This version of the {{externalApp}} plugin or connector cannot preview rules yet.",
            "timeout": "{{externalApp}} did not answer in time.",
            "targetError": "{{externalApp}} could not evaluate the rules.",
            "noLinkedRecord": "The sample record is not linked to a {{externalApp}} record, so there was none to read."
          },
          "problem": "A sync would report this for the record:",
          "notes": "Notes from the evaluator",
          "slots": {
            "defaultsToCanonical": "Default value, incoming",
            "fieldsToCanonical": "Derived field, incoming",
            "defaultsToExternal": "Default value, outgoing",
            "fieldsToExternal": "Derived field, outgoing",
            "targetIn": "Target mapping, incoming",
            "targetOut": "Target mapping, outgoing",
            "keyOnCreate": "Key of a new record"
          },
          "field": {
            "rule": "Rule {{number}}",
            "edited": "Editing",
            "before": "Before",
            "after": "After",
            "changed": "Changed",
            "unchanged": "Unchanged",
            "diagnostics": "Diagnostics"
          },
          "rule": {
            "title": "In the last preview"
          },
          "maskedHint": "Values that look like secrets are not shown in the preview.",
          "unsavedSettings": "Sync directions or the field flow have unsaved changes. The preview uses the saved ones.",
          "status": {
            "started": "The preview is being evaluated.",
            "finished": "The preview is ready.",
            "failed": "The preview could not be computed."
          }
        }
      },
      "linkDecisionPermissions": {
        "invoice": "edit invoices",
        "party": "manage parties",
        "cost-center": "manage cost centers",
        "job": "manage jobs",
        "org-unit": "manage organizational units",
        "org-unit-member": "manage organizational units and their members",
        "product": "manage products",
        "gl-posting": "manage accounting codes",
        "vat-code": "manage accounting codes",
        "vat-posting": "manage accounting codes",
        "bank-document": "reconcile payments"
      },
      "pendingMatches": {
        "title": "Pending matches",
        "hint": "Incoming records that could be more than one Tappeer row. Pick the row, or reject the match.",
        "empty": "Nothing is waiting for a decision.",
        "loadError": "Pending matches could not be loaded.",
        "loadMore": "Load more",
        "totalCount": "{{count}} pending",
        "externalId": "External id",
        "candidates": "Tappeer row",
        "chooseCandidate": "Choose a row…",
        "openRow": "Open the row",
        "openList": "Open the list",
        "rowMissing": "The row is no longer in Tappeer.",
        "confirm": "Confirm",
        "reject": "Reject",
        "confirmListed": "Confirm listed",
        "rejectAll": "Reject all",
        "confirmed": "The record was linked.",
        "rejected": "The match was rejected.",
        "bulkConfirmed_one": "{{count}} record was linked.",
        "bulkConfirmed_other": "{{count}} records were linked.",
        "bulkRejected_one": "{{count}} match was rejected.",
        "bulkRejected_other": "{{count}} matches were rejected.",
        "bulkPartial": "Linked: {{resolved}}. Could not be linked: {{failed}}.",
        "bulkPartialInvoice": "Linked: {{resolved}}. Could not be linked: {{failed}}. Usually because the invoices can't be edited in their current state; return them to editing, or reload, and confirm again.",
        "permissionRequired": "Confirming a match needs the permission to {{permission}}.",
        "nothingToConfirm": "None of the listed matches has a row picked.",
        "error": "The decision could not be saved.",
        "rejectModal": {
          "title": "Reject match",
          "message": "The record will not be linked to any of the suggested rows. The next sync treats it as new.",
          "confirm": "Reject",
          "cancel": "Cancel"
        },
        "confirmListedModal": {
          "title": "Confirm listed matches",
          "message_one": "The {{count}} listed match will be confirmed, out of {{total}} pending. The record is linked to the row picked in its dropdown; where you picked none, that is the first suggestion.",
          "message_other": "The {{count}} listed matches will be confirmed, out of {{total}} pending. Each record is linked to the row picked in its dropdown; where you picked none, that is the first suggestion.",
          "warning": "The incoming data is written onto the picked rows. A wrongly picked row is overwritten, and that cannot be undone.",
          "confirm": "Confirm listed",
          "cancel": "Cancel"
        },
        "rejectAllModal": {
          "title": "Reject all matches",
          "message_one": "The {{count}} pending match of this connector will be rejected, listed or not.",
          "message_other": "All {{count}} pending matches of this connector will be rejected, including the ones not listed.",
          "warning": "No record is linked. The next sync treats them as new and may create duplicates.",
          "confirm": "Reject all",
          "cancel": "Cancel"
        }
      },
      "entityLinks": {
        "title": "Links",
        "hint": "Every pairing of a target-system record with a Tappeer row this connector has made, closed ones included. An active link can be closed or pointed at another row.",
        "search": "Search by business key, external key or id",
        "status": "State",
        "allStatuses": "All states",
        "empty": "No link matches.",
        "loadError": "Links could not be loaded.",
        "loadMore": "Load more",
        "totalCount_one": "{{count}} link",
        "totalCount_other": "{{count}} links",
        "columns": {
          "businessKey": "Business key",
          "record": "Tappeer row",
          "external": "External record",
          "status": "State",
          "matched": "Matched",
          "lastSynced": "Last synced"
        },
        "rowMissing": "The row is no longer in Tappeer.",
        "missingSince": "Missing at the source since {{date}}",
        "unlink": "Unlink",
        "relink": "Relink",
        "unlinked": "The link was closed.",
        "relinked": "The record was linked to the chosen row.",
        "permissionRequired": "Relinking needs the permission to {{permission}}.",
        "error": "Something went wrong. Please try again.",
        "unlinkModal": {
          "title": "Unlink record",
          "message": "The link between business key {{businessKey}} and external id {{externalId}} will be closed. It stays in the list as history.",
          "warning": "The next sync matches this record again by its business key and alternate keys. If nothing matches, it is treated as new and may be created again as a duplicate; if several rows match, it waits as a pending match.",
          "confirm": "Unlink",
          "cancel": "Cancel"
        },
        "relinkModal": {
          "title": "Relink record",
          "keyLabel": "Business key of the row",
          "lookup": "Look up",
          "noRows": "No other Tappeer row has this key.",
          "pickRow": "Choose a row…",
          "message": "External id {{externalId}}, now linked by business key {{businessKey}}, will be linked to the row you choose instead.",
          "warning": "The next inbound sync writes the target record onto the chosen row; the next outbound sync pushes the chosen row to the target record. The previous pairing is kept as history.",
          "confirm": "Relink",
          "cancel": "Cancel"
        }
      },
      "targetDuplicates": {
        "title": "Duplicates in the target system",
        "hint": "Tappeer rows the target system holds more than once, for example a company filed twice with the same company ID. The sync writes Tappeer's changes to the primary record only. Clean the duplicates up in the target system; until then you can choose which record is primary.",
        "totalCount_one": "{{count}} row with duplicates",
        "totalCount_other": "{{count}} rows with duplicates",
        "loadError": "Duplicates in the target system could not be loaded.",
        "loadMore": "Load more",
        "rowMissing": "The row is no longer in Tappeer.",
        "lastMatchedAt": "Last paired {{date}}",
        "matchedBy": "Shared key:",
        "matchKey": "{{kind}} {{value}}",
        "primary": "Primary",
        "alias": "Duplicate",
        "externalKey": "External key: {{key}}",
        "pairedBy": "Paired by: {{matchedBy}}",
        "matched": "Paired by: {{matchedBy}} · {{date}}",
        "missingSince": "Missing at the source since {{date}}",
        "missingInTarget": "Missing in the target system",
        "permissionRequired": "Setting the primary record needs the permission to {{permission}}.",
        "setPrimary": "Set as primary",
        "primarySet": "{{externalId}} is now the primary record.",
        "setPrimaryModal": {
          "title": "Set as primary",
          "message": "External record {{externalId}} becomes the primary record of {{row}}; {{primaryExternalId}} stays linked as a duplicate.",
          "warning": "From the next sync on, Tappeer's changes are written to {{externalId}} instead of {{primaryExternalId}}. The change is recorded in the connector events.",
          "confirm": "Set as primary",
          "cancel": "Cancel"
        },
        "errors": {
          "notFound": "This record no longer exists. The duplicates were reloaded.",
          "refused": "This record cannot be made primary now. The duplicates were reloaded.",
          "conflict": "The duplicates changed in the meantime. They were reloaded; try again.",
          "generic": "Something went wrong. Please try again."
        }
      },
      "missingRecords": {
        "hold": {
          "sectionTitle": "Held batches",
          "title": "Batch of missing records",
          "status": {
            "pending": "Waiting for your decision",
            "running": {
              "deactivate": "Deactivating",
              "delete": "Removing",
              "info": "Marking"
            }
          },
          "intro": "During a sync, more records than usual went missing from the source system at once, so Tappeer held them. Nothing has happened to them yet. If they really were deleted at the source, confirm it. If they are missing by mistake, for example after a filter change, discard the batch.",
          "facts": {
            "missing": "Missing",
            "missingValue": "{{missing}} of {{total}}",
            "held": "In the batch now",
            "acted": {
              "deactivate": "Deactivated",
              "delete": "Processed",
              "info": "Marked"
            },
            "heldMode": "Mode when held",
            "mode": "Mode",
            "raised": "Held",
            "confirmed": "Confirmed"
          },
          "modeChanged": "The mode was “{{held}}” when the batch was held. Confirming uses the connector’s current setting: “{{current}}”.",
          "connectorOff": {
            "pending": "The connector is switched off. You can confirm the batch once it is on; you can discard it now.",
            "running": {
              "deactivate": "The connector is switched off. Deactivating finishes once it is on.",
              "delete": "The connector is switched off. Removing finishes once it is on.",
              "info": "The connector is switched off. Marking finishes once it is on."
            }
          },
          "discard": "Discard batch",
          "running": {
            "deactivate": "Deactivating… {{acted}} of {{total}} done.",
            "delete": "Removing… {{acted}} of {{total}} done.",
            "info": "Marking… {{acted}} of {{total}} done."
          },
          "reload": "Reload",
          "finish": "Finish",
          "discarded": "The batch is discarded. The next sync looks again at records still missing at the source.",
          "confirmed": "Done. Tappeer is working through the batch.",
          "finishing": "Done. Tappeer is finishing the batch.",
          "loadError": "The held batches could not be loaded."
        },
        "confirm": {
          "deactivate": "Deactivate records",
          "delete": "Remove records",
          "info": "Mark records"
        },
        "confirmModal": {
          "title": "Confirm the held batch",
          "message": {
            "deactivate_one": "Tappeer deactivates {{count}} record missing from the source system. It leaves the pickers; documents that use it stay as they are.",
            "deactivate_other": "Tappeer deactivates {{count}} records missing from the source system. They leave the pickers; documents that use them stay as they are.",
            "delete_one": "Tappeer removes {{count}} record missing from the source system. When something uses it, Tappeer only marks it.",
            "delete_other": "Tappeer removes {{count}} records missing from the source system. A record something uses is only marked.",
            "info_one": "Tappeer only marks {{count}} record as deleted at the source. Nothing changes in Tappeer.",
            "info_other": "Tappeer only marks {{count}} records as deleted at the source. Nothing changes in Tappeer."
          },
          "comesBack": "When a record shows up at the source again, Tappeer brings it back on the next sync.",
          "cancel": "Cancel"
        },
        "list": {
          "title": "Missing at source",
          "hint": "Records the source system stopped sending or reported as deleted, newest first.",
          "totalCount_one": "{{count}} record",
          "totalCount_other": "{{count}} records",
          "columns": {
            "record": "Record",
            "reason": "Why it is missing",
            "state": "What happened",
            "since": "Detected"
          },
          "held": "In a held batch",
          "waiting": "Waiting to be processed",
          "externalKey": "External key: {{key}}",
          "empty": "Nothing is missing at the source.",
          "emptyHint": "When the source system stops sending a record, you will see it here.",
          "loadError": "The missing records could not be loaded.",
          "loadMore": "Load more"
        }
      },
      "connector": {
        "tabs": {
          "settings": "Settings",
          "transform": "Transformations",
          "links": "Links",
          "monitor": "Monitor"
        },
        "selectTab": "Section",
        "saveBar": {
          "label": "Unsaved changes",
          "unsavedIn": "Unsaved changes in: {{tabs}}",
          "discard": "Discard",
          "save": "Save changes",
          "saving": "Saving…",
          "fixErrors": "Some values need attention before the connector can be saved.",
          "dirtyDot": "Unsaved changes"
        },
        "unsaved": {
          "title": "Unsaved changes",
          "message": "This connector has unsaved changes. Adding an installation opens another page — save the changes or discard them first.",
          "messageNoInstallation": "The connector has unsaved changes, but it cannot be saved until it reads an installation. Discard the changes or stay on the page.",
          "cancel": "Stay",
          "discard": "Discard changes",
          "save": "Save and continue",
          "saving": "Saving…"
        },
        "status": {
          "enabled": "Enabled",
          "draft": "Draft",
          "pluginUnavailable": "Plugin unavailable",
          "needsReview": "Needs review",
          "outdated": "Configuration outdated"
        },
        "directions": {
          "in": "Inbound: records changed in {{externalApp}} are written into Tappeer.",
          "readBack": "Read-back only: on its schedule, Tappeer re-reads the status of records it sent to {{externalApp}}, such as posting status. It creates and changes nothing else.",
          "out": "Outbound: records changed in Tappeer are written into {{externalApp}}.",
          "inLabel": "inbound, {{externalApp}} → Tappeer",
          "outLabel": "outbound, Tappeer → {{externalApp}}"
        },
        "setup": {
          "status": {
            "title": "Status",
            "intro": "A connector syncs only while it is enabled. Everything else can be prepared first.",
            "pluginUnavailable": "The plugin this connector uses is not installed on the platform, so the connector cannot be enabled."
          },
          "problems_one": "{{count}} to fix",
          "problems_other": "{{count}} to fix",
          "scheduleCount_one": "{{count}} schedule",
          "scheduleCount_other": "{{count}} schedules",
          "basics": {
            "title": "Basics",
            "intro": "What this connector syncs, and in which direction."
          },
          "schedule": {
            "title": "Schedule",
            "intro": "When this connector runs on its own. Sync now works regardless.",
            "empty": {
              "title": "No schedule yet",
              "description": "Nothing runs periodically until you add a schedule. Sync now still works."
            },
            "add": "Add schedule",
            "remove": "Remove",
            "readBackLast": "Read-back only needs at least one read-back schedule. To stop reading back, set inbound to Off instead.",
            "mode": {
              "label": "What to sync",
              "full": "Full sync",
              "modifiedSince": "Changes only (since last run)",
              "readBack": "Read-back",
              "hint": {
                "noInbound": "Changes only is available for inbound connectors.",
                "unsupported": "{{externalApp}} cannot list records changed since a given time, so only a full sync is available."
              }
            },
            "cadence": {
              "label": "How often",
              "every1m": "Every minute",
              "every15m": "Every 15 minutes",
              "every30m": "Every 30 minutes",
              "hourly": "Hourly",
              "every6h": "Every 6 hours",
              "daily": "Daily at a time",
              "weekly": "Weekly on a day",
              "custom": "Custom (cron)"
            },
            "time": "Time",
            "weekday": "Day",
            "cron": "Cron expression",
            "cronHint": "Five fields: minute hour day month weekday, e.g. 0 2 * * *",
            "timezone": "Time zone",
            "outboundEvents": {
              "label": "Send Tappeer changes to {{externalApp}} immediately",
              "hint": "When on, a record changed in Tappeer is written into {{externalApp}} shortly after it is saved. When off, changes reach {{externalApp}} only with a scheduled Full sync or Sync now."
            },
            "status": {
              "nextRun": "Next run {{when}} ({{at}})",
              "lastRun": "Last run {{when}}",
              "notScheduled": "Not scheduled yet — save to activate.",
              "disabled": "Not scheduled — enable the connector first."
            }
          }
        },
        "advanced": {
          "connection": {
            "title": "Connection settings",
            "required": "Required values first",
            "intro": "How Tappeer reaches {{externalApp}}: addresses, credentials and the plugin's own options.",
            "sharedIntro": "Only the settings that differ per entity. Everything the whole installation shares — the address, the company, the credentials — is set once on the installation itself.",
            "empty": "This plugin needs no connection settings.",
            "readsConnection": "Reads a shared installation.",
            "readsConnectionOnBridge": "Reads a shared installation on bridge {{bridge}}.",
            "editOnConnection": "Edit its shared settings"
          },
          "discovered": {
            "title": "Found on the bridge",
            "intro": "Values the bridge's {{externalApp}} plugin found on its machine. Applying them fills only the fields that are still empty.",
            "applyAll": "Apply all suggestions",
            "nothing": "The bridge has not reported any values for {{externalApp}} yet.",
            "hiddenBy": "Not shown now — it depends on “{{setting}}”.",
            "choice": {
              "label": "{{name}} ({{total}} found)",
              "hint": "Pick one; it fills every setting it belongs to at once.",
              "placeholder": "Select one",
              "source": "Found in {{source}}",
              "use": "Use this",
              "conflicts": "These fields already hold another value. Replace them?",
              "replace": "Replace",
              "keep": "Keep my values",
              "names": {
                "accountingUnit": "Accounting unit"
              }
            },
            "columns": {
              "key": "Setting",
              "value": "Value",
              "source": "Found in"
            }
          },
          "engine": {
            "title": "Engine",
            "intro": "How the sync engine treats records that come back from the other system."
          }
        },
        "transform": {
          "transfer": {
            "label": "Copy, export and import of rules",
            "copy": {
              "button": "Copy rules from another connector",
              "title": "Copy rules from another connector",
              "description": "Takes the rules and the field flow of another {{externalApp}} connector for the same entity. Its connection settings are not copied.",
              "source": "Connector",
              "placeholder": "Choose a connector",
              "usesDefaults": "{{name}} — uses plugin defaults",
              "none": "No other connector uses this plugin for this entity.",
              "loadError": "The connectors could not be loaded."
            },
            "export": {
              "button": "Export rules",
              "hint": "The exported file holds no passwords or connection settings, but it does hold your lookup tables, constants and defaults.",
              "dirty": "Save or discard your changes first — the export holds the saved rules. The file holds no passwords or connection settings, but it does hold your lookup tables, constants and defaults."
            },
            "import": {
              "button": "Import rules",
              "title": "Import rules",
              "description": "Loads the rules and the field flow from a file exported from a {{externalApp}} connector for the same entity.",
              "file": {
                "title": "Choose a .json file",
                "description": "or drop it here",
                "selected": "File:",
                "remove": "Remove file",
                "unreadable": "The file could not be read."
              },
              "paste": {
                "label": "Or paste the exported text"
              },
              "problems": {
                "empty": "There is nothing to import.",
                "invalidJson": "This is not valid JSON.",
                "notObject": "This is not an exported rules file: an object was expected.",
                "tooLarge": "The rules are over the limit of {{limit}} KiB.",
                "tooDeep": "The rules are nested too deep.",
                "wrongKind": "This is not an exported rules file.",
                "wrongFormatVersion": "This file was exported in a format this version of Tappeer cannot read.",
                "differentPlugin": "These rules were exported from a connector of another system, not {{externalApp}}.",
                "differentEntity": "These rules were exported from a connector for another entity."
              },
              "warnings": {
                "pluginVersion": "The file was exported from plugin version {{exported}}; this connector runs version {{current}}. The rules were checked against this connector's version.",
                "pluginVersionUnknown": "The file does not say which plugin version it was exported from; this connector runs version {{current}}. The rules were checked against this connector's version."
              }
            },
            "check": "Check and continue",
            "cancel": "Cancel",
            "refused": "These rules cannot be used on this connector. Nothing was changed.",
            "failed": "The rules could not be checked. Nothing was changed.",
            "confirm": {
              "title": "Replace the rules and the field flow?",
              "message": {
                "connector": "The rules and the field flow you have in the editor now will be replaced by those of connector {{name}}. Nothing is saved until you save the connector.",
                "file": "The rules and the field flow you have in the editor now will be replaced by those from file {{name}}. Nothing is saved until you save the connector.",
                "pasted": "The rules and the field flow you have in the editor now will be replaced by those from the pasted text. Nothing is saved until you save the connector."
              },
              "warnings": "Worth knowing before you replace them:",
              "rekeyed": "The connector's links are re-keyed when you save.",
              "replace": "Replace"
            },
            "replaced": {
              "connector": "Rules and field flow replaced from connector {{name}}.",
              "file": "Rules and field flow replaced from file {{name}}.",
              "pasted": "Rules and field flow replaced from the pasted text."
            },
            "undo": "Undo"
          },
          "fieldMap": {
            "title": "Fields",
            "intro": "Every field of the entity: which way it crosses and what happens to it on the way. Open a field to change its steps. A flow can only restrict where a field is written, never widen it."
          },
          "key": {
            "title": "Business key",
            "intro": "How a Tappeer row and a record in {{externalApp}} are recognised as the same thing."
          },
          "filters": {
            "title": "Filters",
            "intro": "Only rows matching the condition are synced."
          },
          "defaults": {
            "title": "Defaults",
            "intro": "Values used for a field the record leaves empty."
          },
          "marker": {
            "title": "Marker",
            "intro": "Whether the plugin stamps the Tappeer id into its own record, so it is recognised even after its key changes."
          },
          "preview": {
            "title": "Preview",
            "intro": "See what the transform rules do to one record, stage by stage, before you save them."
          }
        },
        "monitor": {
          "activityTitle": "Connector events",
          "activityIntro": "Configuration changes and other connector events, newest first — sync runs are on the other tab."
        },
        "pipeline": {
          "label": "Pipeline"
        },
        "migration": {
          "banner": {
            "outdatedTitle": "This connector's configuration is from plugin schema v{{from}}; the plugin is now v{{to}}.",
            "outdatedBody": "Migrating carries the stored values over to the new schema. Review what changes in Settings first if you prefer.",
            "needsReviewTitle": "The configuration was migrated to plugin schema v{{to}}, but it needs a look before the connector can run.",
            "migrate": "Migrate now",
            "saveFirst": "Save your changes first",
            "review": "Review in Settings",
            "fix": "Fix in Settings"
          },
          "version": {
            "title": "Configuration version",
            "intro": "The plugin's configuration schema is versioned. A connector written against an older version is migrated; anything the migration could not settle is listed here.",
            "connectorVersion": "Connector schema version",
            "pluginVersion": "Plugin schema version",
            "status": "Status",
            "upToDate": "This connector is on the plugin's current schema.",
            "reviewHint": "Saving a valid configuration clears “Needs review”.",
            "diff": {
              "title": "What changed between v{{from}} and v{{to}}",
              "added": "Added keys",
              "removed": "Removed keys",
              "changed": "Changed keys",
              "required": "required",
              "secret": "secret",
              "none": "No key-level differences."
            },
            "report": {
              "previewTitle": "What migrating would do",
              "storedTitle": "Last migration: v{{from}} → v{{to}}, {{at}}",
              "droppedKeys": "Dropped keys",
              "renamedSecrets": "Renamed secrets",
              "clearedSecrets": "Cleared secrets",
              "issues": "Issues",
              "nothing": "Nothing to report — every value carries over as it is."
            },
            "missingRequired": "Required settings without a value",
            "missingRequiredHint": "Fill these in Connection settings above; the connector cannot be enabled without them."
          }
        }
      },
      "fieldMap": {
        "columns": {
          "field": "Field",
          "role": "Role",
          "flow": "Flow",
          "story": "What happens"
        },
        "summary": {
          "fields": "{{count}} fields",
          "allBothWays": "all fields both ways",
          "oneWay": "{{count}} one-way",
          "none": "{{count}} not synced",
          "warnings": "{{count}} warnings",
          "errors": "{{count}} errors"
        },
        "search": "Search fields",
        "show": {
          "label": "Show",
          "all": "All fields",
          "configured": "With a flow set",
          "keys": "Key fields",
          "rules": "With rules",
          "warnings": "With warnings"
        },
        "flow": {
          "label": "Flow of {{field}}",
          "choice": {
            "both": "Both ways",
            "in": "Into Tappeer only",
            "out": "Into {{externalApp}} only",
            "none": "Not synced"
          },
          "locked": {
            "keyField": "A key field always crosses — it is how a record is recognised.",
            "virtual": "This field exists only in {{externalApp}}; there is nothing on the Tappeer side to hold back.",
            "syncOnly": "A sync-only field is read by the rules and never stored, so it has no flow to set."
          },
          "outWrites": "Tappeer writes {{field}} to {{externalApp}}.",
          "outHeld": "Tappeer's {{field}} is not sent to {{externalApp}}.",
          "inWrites": "{{externalApp}} writes {{field}} to Tappeer.",
          "inHeld": "{{externalApp}}'s {{field}} is not written to Tappeer."
        },
        "roles": {
          "businessKey": "Business key",
          "keyRuleInput": "Key rule input",
          "alternateKey": "Alternate key",
          "hashed": "Hashed",
          "filterable": "Filterable"
        },
        "roleHints": {
          "businessKey": "Identifies the record on both sides. Always crosses, whatever the flow.",
          "keyRuleInput": "Read by the business-key rule. Always crosses, whatever the flow.",
          "alternateKey": "Used to find the matching record on first contact when the business key finds nothing.",
          "hashed": "Part of change detection: a change here makes the record look changed.",
          "filterable": "Tappeer can select rows by this field itself when sending, so a plain “is” filter on it is fast."
        },
        "type": {
          "nullable": "optional",
          "unknownRow": "Not a field of this entity",
          "virtualRow": "Only in {{externalApp}}",
          "syncOnlyRow": "For rules only, not stored",
          "unsupportedRule": "Unsupported rule"
        },
        "warnings": {
          "keyFlowsIn": "{{field}} feeds the business key and only {{externalApp}} writes it — a rename there re-keys the record.",
          "toExternalWithoutInverse": "An outgoing rule rewrites {{field}}, which is hashed and also flows in, with no incoming rule. Every round trip would look changed.",
          "unknownFlowKey": "{{field}} has a flow, but the entity has no such field. Set it back to Both ways."
        },
        "notes": {
          "noDirections": "No sync direction is set yet. Choose one in Settings — until then nothing flows."
        },
        "legend": "⇄ both ways · ← into Tappeer · → into {{externalApp}} · ∅ not synced, and left out of change detection · tinted row = the engine objects (red) or wants a look (amber)",
        "empty": {
          "noMetadata": "The plugin does not describe this entity",
          "noMetadataHint": "Without a field list there is nothing to map. Pick another entity in Settings, or update the plugin.",
          "noMatch": "No field matches",
          "noMatchHint": "Try another search, or show all fields.",
          "clearFilters": "Clear filters"
        },
        "shapes": {
          "copy": {
            "field": "Copy {{field}}",
            "value": "Always {{value}}",
            "meta": "Use {{name}}"
          },
          "firstNonEmpty": "First filled of {{options}}",
          "lookupTable": "Translate {{field}} with a lookup table",
          "lookupTableWithFallback": "Translate {{field}} with a lookup table, otherwise {{fallback}}",
          "pluginFunction": "Apply {{name}} to {{field}}",
          "choice": "Choose by {{field}}",
          "choiceWithOtherwise": "Choose by {{field}}, otherwise {{otherwise}}",
          "join": "Join {{parts}}",
          "test": "True when {{left}} {{operator}} {{right}}",
          "advanced": "Advanced rule",
          "meta": {
            "externalId": "the external id",
            "externalKey": "the external key",
            "insioId": "the Tappeer id",
            "runStartedAt": "the sync start time",
            "direction": "the sync direction"
          },
          "value": {
            "empty": "empty",
            "yes": "yes",
            "no": "no"
          },
          "whenSet": "First set of {{options}}, otherwise {{otherwise}}",
          "shapeKind": {
            "copy": "Copy a field or value",
            "choice": "Choose by a field",
            "firstNonEmpty": "First filled of several fields",
            "whenSet": "First set of several fields",
            "lookupTable": "Translate with a lookup table",
            "test": "Yes/no comparison",
            "join": "Join several values",
            "pluginFunction": "Plugin function",
            "allOf": "Conditions that must all hold"
          },
          "allOf": "All of: {{tests}}"
        },
        "story": {
          "none": "—",
          "unplaced": "Rules without a destination",
          "toggle": "Steps of {{field}}",
          "direction": {
            "in": "Into Tappeer",
            "out": "Into {{externalApp}}"
          },
          "edge": {
            "asSent": "as {{externalApp}} sends it",
            "notFilled": "not filled from {{externalApp}}",
            "sentAsIs": "sent as it is",
            "notSent": "not sent to {{externalApp}}"
          },
          "reads": {
            "targetRecord": "Reads: the {{externalApp}} record as it arrived",
            "canonicalAfterAbove": "Reads: the Tappeer record, after the steps above",
            "canonicalAfterEarlier": "Reads: the Tappeer record, after earlier steps",
            "outgoingAfterAbove": "Reads: the outgoing record, after the steps above"
          },
          "layer": {
            "suffix": "· {{layer}}",
            "cloud": "in Tappeer",
            "bridge": "by the {{externalApp}} plugin on your bridge",
            "connector": "by the {{externalApp}} connector"
          },
          "status": {
            "default": "Plugin default",
            "changed": "Customised",
            "added": "Added",
            "removed": "Turned off",
            "own": "Your step"
          },
          "default": "when empty: {{value}}",
          "subField": "{{target}}: {{summary}}",
          "openStep": {
            "in": "Open the incoming step of {{field}}: {{summary}}",
            "out": "Open the outgoing step of {{field}}: {{summary}}"
          },
          "openFeed": "Open the rule for {{target}} that reads {{field}}",
          "alsoFeeds": "also feeds → {{target}}",
          "alsoDecides": "also a condition for → {{target}}",
          "many": {
            "label": "{{summary}}. Show the steps of {{field}}.",
            "targetIn_one": "{{count}} field read from {{externalApp}}",
            "targetIn_other": "{{count}} fields read from {{externalApp}}",
            "targetOut_one": "{{count}} field sent to {{externalApp}}",
            "targetOut_other": "{{count}} fields sent to {{externalApp}}",
            "cloud_one": "{{count}} step in Tappeer",
            "cloud_other": "{{count}} steps in Tappeer",
            "alsoFeeds_one": "{{count}} rule also depends on this field",
            "alsoFeeds_other": "{{count}} rules also depend on this field",
            "turnedOff_one": "{{count}} plugin default turned off",
            "turnedOff_other": "{{count}} plugin defaults turned off"
          },
          "notRun": {
            "in_one": "This connector does not sync into Tappeer. {{count}} rule kept and not run.",
            "in_other": "This connector does not sync into Tappeer. {{count}} rules kept and not run.",
            "out_one": "This connector does not sync into {{externalApp}}. {{count}} rule kept and not run.",
            "out_other": "This connector does not sync into {{externalApp}}. {{count}} rules kept and not run."
          },
          "actions": {
            "edit": "Edit",
            "editFor": "Edit the step {{target}} ({{field}})",
            "turnOff": "Turn off",
            "turnOffFor": "Turn off the step {{target}} ({{field}})",
            "useDefault": "Use default",
            "useDefaultFor": "Use the plugin default for {{target}} ({{field}})",
            "remove": "Remove",
            "removeFor": "Remove the step {{target}} ({{field}})",
            "editDefault": "Edit in Defaults",
            "editDefaultFor": "Edit the default of {{field}} in Defaults",
            "openRule": "Open rule"
          },
          "editor": {
            "label": "Steps of {{field}}",
            "sideIn": "Steps of {{field}} into Tappeer",
            "sideOut": "Steps of {{field}} into {{externalApp}}",
            "step": "{{ordinal}}. {{title}}",
            "kind": {
              "targetIn": "Read from {{externalApp}}",
              "targetOut": "Send to {{externalApp}}",
              "derivedIn": "Compute in Tappeer",
              "derivedOut": "Change before sending",
              "default": "Default when empty"
            },
            "destinationFor": "Destination of the {{field}} step",
            "noSteps": "No steps.",
            "directionOffIn": "This connector does not sync into Tappeer. Rules kept here are not run.",
            "directionOffOut": "This connector does not sync into {{externalApp}}. Rules kept here are not run.",
            "recipeInserted": "Inserted for {{field}}. Fill in its blank values before saving — saved as it is, this step would write an empty value.",
            "destination": "Writes to",
            "destinationPlaceholder": "Field name (may exist only in {{externalApp}})",
            "destinationTaken": "{{name}} — already written",
            "takenIn": "A greyed-out field is already read from {{externalApp}} by another step — edit that step.",
            "takenOut": "A greyed-out field is already sent to {{externalApp}} by another step — edit that step.",
            "issues": {
              "unknownTargetPath": "{{path}} is not a field of {{externalApp}} that the plugin knows."
            },
            "followsPlugin": "After this, the other {{externalApp}} rules of this direction stop following plugin updates."
          },
          "ownList": {
            "in": "The rules that read from {{externalApp}} are now your own list ({{kept}} of {{total}} unchanged). Because a plugin default was changed, turned off or added to, none of them follow plugin updates any more — including the ones you did not touch.",
            "out": "The rules that send to {{externalApp}} are now your own list ({{kept}} of {{total}} unchanged). Because a plugin default was changed, turned off or added to, none of them follow plugin updates any more — including the ones you did not touch.",
            "resetIn": "Use plugin defaults for all incoming rules",
            "resetOut": "Use plugin defaults for all outgoing rules",
            "confirm_one": "This discards {{count}} of your changes in this direction, including rules you added.",
            "confirm_other": "This discards {{count}} of your changes in this direction, including rules you added.",
            "confirmYes": "Discard and use plugin defaults",
            "confirmNo": "Keep my list"
          },
          "add": {
            "trigger": "Add step",
            "triggerFor": "Add a step for {{field}}",
            "entryFor": "{{entry}} ({{field}})",
            "targetIn": "Read from {{externalApp}} fields",
            "derivedIn": "Compute from Tappeer fields",
            "derivedOut": "Change the value before sending",
            "targetOut": "Send to a {{externalApp}} field",
            "reason": {
              "alreadyReadFromTarget": "One step already reads this field from {{externalApp}} — edit that step.",
              "directionOffIn": "This connector does not sync into Tappeer.",
              "directionOffOut": "This connector does not sync into {{externalApp}}.",
              "noTargetModel": "This connector delivers Tappeer fields directly; there is no {{externalApp}} record to read or write here."
            },
            "recipeHint": "A recipe adds a ready-made step for {{field}}. Its blank values still need filling before you save.",
            "recipeHintTargetOut": "A recipe that sends to {{externalApp}} has no destination yet; it is added under “Rules without a destination”.",
            "withoutField": "Add a step without a field"
          },
          "unused": {
            "summary_one": "Not used: {{unused}} of {{count}} {{externalApp}} field",
            "summary_other": "Not used: {{unused}} of {{count}} {{externalApp}} fields",
            "show": "Show",
            "hide": "Hide",
            "toggle": "Unused {{externalApp}} fields"
          },
          "held": {
            "in": "These steps still run; the result is not saved to Tappeer.",
            "out": "Tappeer's value is not sent. A default or a “Change the value before sending” step for this field still sends what it produces; “Send to a {{externalApp}} field” steps read this field as empty.",
            "unwatched": "A change only in this field is not watched."
          }
        }
      },
      "glossary": {
        "entity": {
          "title": "Tappeer entity",
          "text": "What the records are in Tappeer — companies, cost centres, invoices. One lane per entity; every connector in it syncs that entity."
        },
        "connection": {
          "title": "Connection",
          "text": "How Tappeer reaches the external system: directly over the internet, or through a secure tunnel to a bridge on your network."
        },
        "connector": {
          "title": "Connector",
          "text": "One sync of one entity with one external system: its direction, its schedule and the rules that shape each record on the way."
        },
        "externalSystem": {
          "title": "External system",
          "text": "The other system the records come from or go to — an accounting package, an ERP — spoken to by its plugin."
        },
        "businessKey": {
          "title": "Business key",
          "text": "The value that says \"this Tappeer row and that external record are the same thing\" — a company number, a code. Both sides must agree on it."
        },
        "hashedField": {
          "title": "Hashed field",
          "text": "A field included in change detection. When one changes, the record counts as changed and is written; other fields are ignored."
        },
        "echoSuppression": {
          "title": "Echo suppression",
          "text": "After Tappeer writes a record out, the same record comes back in the next run. Echo suppression recognises it as unchanged and skips it."
        },
        "transform": {
          "title": "Transform",
          "text": "The rules applied to a record on its way through: the business key, filters, field steps and defaults."
        },
        "bridge": {
          "title": "Bridge",
          "text": "A small Tappeer agent on a machine inside your network. It reaches systems Tappeer cannot reach, and only ever dials out."
        },
        "direct": {
          "title": "Direct connection",
          "text": "The connector talks to the other system over the internet, with no bridge in between."
        },
        "fieldFlow": {
          "title": "Flow",
          "text": "Which way a field crosses between Tappeer and the other system: both ways, one way, or not at all. Key fields always cross."
        },
        "keyRule": {
          "title": "Key rule",
          "text": "How the business key is computed — a list of fields, or an expression. Changing it re-keys every linked record."
        },
        "alternateKey": {
          "title": "Alternate key",
          "text": "A second way to find the matching record on first contact, used when the business key finds nothing."
        }
      },
      "overview": {
        "intro": "Each lane is one Tappeer entity and the connectors that sync it: where the data lands, how the external system is reached, which connector moves it, and where it comes from. Unfold a card for its details.",
        "lanes": {
          "entity": "Tappeer entity",
          "connection": "Connection",
          "connector": "Connector",
          "system": "External system",
          "entityHint": "Where the records live in Tappeer",
          "connectionHint": "How the system is reached",
          "connectorHint": "What moves the records and shapes them",
          "systemHint": "Where they come from, or go"
        },
        "card": {
          "expand": "Show details",
          "collapse": "Hide details"
        },
        "addConnector": "Add connector",
        "addSystem": "Add system",
        "actionsLabel": "Integration actions",
        "openHelpGuide": "Help",
        "connectorCount_one": "{{count}} connector",
        "connectorCount_other": "{{count}} connectors",
        "noConnector": "No connector yet",
        "addForEntity": "Add a connector for {{entity}}",
        "stages": {
          "system": {
            "plugin": "Plugin v{{version}}"
          },
          "transport": {
            "cloud": "Cloud",
            "direct": "Direct connection",
            "tunnel": "Secure tunnel",
            "openBridge": "Open bridge {{name}}",
            "directHint": "Tappeer reaches {{externalApp}} over the internet.",
            "missing": "No bridge selected",
            "missingHint": "Pick an installation in Settings before enabling the connector.",
            "missingOpen": "Open connector {{name}}",
            "connectionMissing": "No installation selected",
            "connectionMissingHint": "Pick the installation this connector reads in Settings before enabling it.",
            "openConnection": "Open installation {{name}}",
            "unknownHost": "Host not reported yet",
            "agentVersion": "Agent v{{version}}",
            "pluginVersion": "{{externalApp}} plugin v{{version}}",
            "pluginMissing": "{{externalApp}} plugin is not installed on this bridge",
            "lastSeen": "Last seen {{when}}",
            "officeBridge": "Office bridge",
            "queue": {
              "title": "Bridge queue",
              "running": "Running: {{run}}",
              "waiting": "Position {{position}}: {{run}}, waiting {{duration}}"
            }
          },
          "connector": {
            "open": "Open connector {{name}}",
            "rules": {
              "open": "Open the rules of {{name}}",
              "pluginDefault": "plugin defaults",
              "custom": "customised",
              "keyDefault": "Default key",
              "keyFields": "Key from fields",
              "keyExpression": "Key expression",
              "filters_one": "{{count}} filter",
              "filters_other": "{{count}} filters",
              "derived_one": "{{count}} derived field",
              "derived_other": "{{count}} derived fields",
              "defaults_one": "{{count}} default",
              "defaults_other": "{{count}} defaults"
            },
            "disabledHint": "Disabled — nothing syncs until you switch it on."
          }
        },
        "health": {
          "when": "{{when}}",
          "failedCount_one": "{{count}} record failed",
          "failedCount_other": "{{count}} records failed"
        },
        "flow": {
          "summary": "Flow: {{oneWay}} one-way · {{none}} not synced",
          "default": "Flow: all fields both ways"
        },
        "empty": {
          "title": "No sync plugins available",
          "description": "The platform has no sync plugin installed for this account, so there is nothing to connect yet."
        },
        "direction": {
          "in": "Inbound: {{externalApp}} → Tappeer",
          "out": "Outbound: Tappeer → {{externalApp}}",
          "both": "Both ways: {{externalApp}} ⇄ Tappeer",
          "none": "No direction set",
          "legend": "Arrows",
          "legendIn": "inbound",
          "legendOut": "outbound",
          "legendBoth": "both ways"
        }
      },
      "monitor": {
        "filters": {
          "connector": "Connector",
          "status": "Outcome",
          "entity": "Entity",
          "allConnectors": "All connectors",
          "allStatuses": "All outcomes",
          "allEntities": "All entities"
        }
      },
      "connections": {
        "title": "Installations",
        "intro": "The installations your connectors read. Every connector reading one shares these settings, so a URL or a password is entered once.",
        "none": "No installation is configured yet.",
        "noPlugins": "No connector needs shared settings yet.",
        "edit": "Edit",
        "delete": "Remove",
        "migrate": "Migrate",
        "usedBy_one": "Read by {{count}} connector",
        "usedBy_other": "Read by {{count}} connectors",
        "unused": "Read by no connector yet",
        "outdated": "Settings are behind the plugin's current version",
        "needsReview": "Settings need review after the last migration",
        "deleteModal": {
          "title": "Remove {{name}}?",
          "description": "Its stored credentials are deleted with it. Connectors reading it must be pointed elsewhere first.",
          "confirm": "Remove"
        },
        "toast": {
          "saved": "Installation saved",
          "deleted": "Installation removed",
          "migrated": "Settings migrated"
        },
        "errors": {
          "nameRequired": "Name is required",
          "saveFailed": "The installation could not be saved",
          "bridgeRequired": "Bridge is required",
          "loadFailed": "The installations could not be loaded"
        },
        "addFor": "Add {{externalApp}} installation",
        "groups": {
          "required": "Required",
          "requiredHint": "Nothing works until these are filled in.",
          "optional": "Optional",
          "optionalHint": "Worth a look; the plugin manages without them.",
          "advanced": "Advanced",
          "advancedHint": "Timeouts and limits the plugin chose well already. Change them only with a reason.",
          "toFix_one": "{{count}} to fix",
          "toFix_other": "{{count}} to fix"
        },
        "configGroups": {
          "installation": "Installation",
          "login": "Sign-in",
          "company": "Company",
          "database": "Database",
          "locale": "Regional settings",
          "documentTypes": "Document types",
          "payment": "Payment forms",
          "vatCodes": "VAT codes",
          "advanced": "Advanced"
        },
        "introBridge": "The installations this bridge can reach. Every connector reading one shares these settings, so a path or a password is entered once.",
        "noneBridge": "No installation is configured on this bridge yet.",
        "noPluginsBridge": "This bridge has no plugin loaded that needs settings.",
        "direct": "Reached directly",
        "openBridge": "Open bridge {{name}}",
        "needsBridge": "Needs an active bridge with the {{externalApp}} plugin installed.",
        "select": {
          "label": "Installation",
          "placeholder": "Select an installation",
          "hint": "The installation this connector reads. Its address, company and credentials are set on the installation itself.",
          "online": "{{name}} on {{bridge}} (online)",
          "offline": "{{name}} on {{bridge}} (offline)",
          "unavailable": "No longer available",
          "none": "No installation is configured for this connector yet.",
          "noneLink": "Add one on the Installations page.",
          "create": "New installation",
          "setupWizard": "Or open the {{system}} setup wizard.",
          "taken": "{{name}} — already used by connector “{{connector}}”",
          "takenError": "Already used by connector “{{connector}}”.",
          "takenErrorUnnamed": "Already used by another connector for this entity.",
          "allTaken": "Every installation already has a connector for this entity:",
          "allTakenLink": "Add another installation on the Installations page."
        },
        "editor": {
          "title": "Installation",
          "createTitle": "Add {{externalApp}} installation",
          "editTitle": "Edit {{name}}",
          "back": "Back",
          "loadError": "The installation could not be loaded",
          "fixErrors": "Some values need attention before the installation can be saved.",
          "form": {
            "description": "What the bridge needs to reach this {{externalApp}} installation. Every connector reading it shares these settings.",
            "descriptionDirect": "What Tappeer needs to reach this {{externalApp}} installation over the internet. Every connector reading it shares these settings.",
            "nameLabel": "Name",
            "namePlaceholder": "e.g. the agenda or company this opens",
            "nameHint": "How you will recognise it when picking it on a connector.",
            "bridgeLabel": "Bridge",
            "bridgeHint": "The bridge that reaches this installation. It cannot be changed afterwards.",
            "bridgeLockedHint": "Set when the installation was added; it cannot be changed.",
            "bridgePlaceholder": "Select a bridge",
            "empty": "This plugin needs no shared settings.",
            "officeBridgeOption": "{{name}} (Office bridge)"
          },
          "saveBar": {
            "label": "Unsaved changes",
            "unsaved": "This installation has unsaved changes",
            "discard": "Discard",
            "save": "Save changes",
            "saving": "Saving…"
          },
          "inlineSave": {
            "save": "Save and continue",
            "saving": "Saving…"
          },
          "leave": {
            "title": "Unsaved changes",
            "message": "This installation has unsaved changes. If you leave now, they will be lost.",
            "confirm": "Leave without saving"
          },
          "discovery": {
            "reload": "Reload",
            "reloading": "Loading…",
            "reloaded": "The values were loaded.",
            "directTitle": "Found in {{externalApp}}",
            "directIntro": "Values {{externalApp}} offers for the address and login entered here. They are loaded only on request.",
            "nothingFound": "Nothing was found for the values entered.",
            "snapshot": "The bridge runs an older agent that cannot load values on request. These are the values it reported when it started.",
            "storedSecretNotUsed": "With changed settings the stored credentials are not used. Type them again to reload.",
            "removedSecretStillUsed": "A stored value marked for removal is still used for a reload until the installation is saved.",
            "errors": {
              "failed": "The live check failed. Check the address and the login.",
              "busy": "Another reload is running. Try again in a moment.",
              "rateLimited": "Too many reloads in a short time. Try again later.",
              "rateLimitedIn_one": "Too many reloads in a short time. Try again in {{count}} minute.",
              "rateLimitedIn_other": "Too many reloads in a short time. Try again in {{count}} minutes.",
              "invalid": "The entered values are not valid. Correct them and try again.",
              "generic": "The values could not be loaded. Try again.",
              "managedByMasterAccount": "Only your accounting office can load values from its office bridge."
            }
          },
          "mapper": {
            "columns": {
              "tappeer": "In Tappeer",
              "code": "Code in {{externalApp}}",
              "default": "Default"
            },
            "useDefault": "Use the default",
            "notSet": "Not set",
            "default": {
              "automatic": "Automatic: {{value}}",
              "none": "—"
            },
            "status": {
              "none": "Codes from {{externalApp}} are not loaded yet. Load them, or type them in.",
              "failed": "Codes from {{externalApp}} could not be loaded. Type them in, or try again.",
              "stale": "The connection details changed since the codes were loaded. Load them again.",
              "snapshot": "These codes are not live from {{externalApp}}. They are what the bridge reported when it started.",
              "empty": "{{externalApp}} sent no codes. Check the connection details, such as the selected company, and load them again.",
              "noneManual": "Codes from {{externalApp}} are not loaded. Type them in.",
              "failedManual": "Codes from {{externalApp}} could not be loaded. Type them in.",
              "staleManual": "The connection details changed since the codes were loaded. The codes offered may not apply.",
              "emptyManual": "{{externalApp}} sent no codes. Type them in.",
              "pickBridge": "Codes from {{externalApp}} are loaded through a bridge. Pick one first."
            },
            "load": "Load codes from {{externalApp}}",
            "loading": "Loading…",
            "row": {
              "none": "The list is not loaded yet.",
              "failed": "The list could not be loaded.",
              "noList": "{{externalApp}} offers no codes for this row.",
              "unavailable": "The list for this row did not load. Type a code.",
              "missing": "{{externalApp}} has no code {{code}}. Pick another one.",
              "type": "Type a code",
              "pick": "Pick from the list",
              "required": "Required."
            }
          },
          "help": {
            "sharedIco": {
              "title": "Several agendas with the same IČO",
              "why": "Money S3 selects the agenda by its company ID (IČO). When it finds the same IČO in more than one agenda, it quits and transfers nothing — for example with the demo agendas, which all carry one IČO.",
              "whatToSet": "Fill in “Agenda folder suffix”: the part of the name of the agenda’s data folder after “Agenda.” (for the folder “Agenda.spa” it is “spa”). The agenda is then selected by its folder instead of the IČO. Keep “Agenda company ID (IČO)” filled in — every export is still checked against it. If the agenda holds several fiscal years, fill in “Fiscal year” as well; left empty, Money S3 opens the year it used last.",
              "agendaCode": "“Agenda code” does not select the agenda. It is an extra safeguard: when it is set and the opened agenda carries a different code, the transfer is refused.",
              "pickFromList": "The easy way is to pick the agenda from the “Accounting unit” list under “Found on the bridge” — the pick fills in these settings. The list shows the folder and the year only, because the agenda’s name and IČO are not read from disk; type the IČO yourself."
            }
          },
          "readOnly": {
            "title": "Your accounting office manages this installation",
            "body": "It runs on the office bridge, so only the office can change its settings. Your connectors can still read from it."
          },
          "agendaDuplicate": {
            "title": "Another installation opens the same agenda",
            "body": "Another installation of this account on the same bridge opens the same agenda (e.g. the same IČO), so both would write into one agenda and could create duplicate or conflicting records. Unless that is intended, change the agenda settings of one of them, or delete it.",
            "bodyReadOnly": "Another installation of this account on the same bridge opens the same agenda (e.g. the same IČO), so both would write into one agenda and could create duplicate or conflicting records. Unless that is intended, ask your accounting office to change one of them."
          },
          "bridgeUnavailable": {
            "title": "The bridge is no longer available",
            "body": "This account may no longer use the bridge of this installation. You can delete the installation from the target systems list, or contact your accounting office."
          }
        },
        "view": "View",
        "officeBridge": "Office bridge",
        "officeBridgeManaged": "Your accounting office sets up installations on its office bridge.",
        "bridgeUnavailable": "Bridge unavailable",
        "setupWizard": "Open the setup wizard"
      },
      "welcome": {
        "title": "Connect Tappeer to your accounting",
        "incomplete": {
          "title": "Some details could not be loaded",
          "description": "If you have a setup in progress, “Continue setup” may be missing for now. Try reloading the page in a moment."
        },
        "intro": "Tappeer keeps your parties in step with your accounting system and sends your invoices there itself. Then it reads back whether they were posted and paid.",
        "continue": {
          "title": "You have a setup in progress",
          "description": "We'll carry on where you left off.",
          "action": "Continue setup"
        },
        "systems": {
          "title": "Choose your accounting system",
          "setUp": "Set up"
        },
        "manual": {
          "description": "Using another system? You can add a connector manually.",
          "action": "Add a connector manually"
        }
      },
      "systems": {
        "moneyS3": {
          "name": "Money S3",
          "description": "The Money S3 accounting system by Solitea. It connects through Tappeer Bridge on the computer running Money S3.",
          "requirements": "A Windows computer running Money S3 with Tappeer Bridge installed (for a network install, on the server that holds the Money S3 data, or on the terminal server), or your accounting office's bridge.",
          "syncs": "Parties both ways, invoices to Money S3.",
          "readBack": "Posting status, payment and document number."
        },
        "abraFlexi": {
          "name": "ABRA Flexi",
          "description": "The ABRA Flexi cloud accounting system. It connects directly through its API.",
          "requirements": "The ABRA Flexi server address, the company database and a user with API access.",
          "syncs": "Parties both ways, invoices to ABRA Flexi.",
          "readBack": "Posting status, payment and internal document number."
        }
      },
      "setup": {
        "title": "Set up an integration",
        "back": "Back to integrations",
        "intro": "Connect Tappeer to your accounting system. Parties go both ways, invoices go to your accounts and their state comes back.",
        "loadError": "The setup could not be loaded. Reload the page.",
        "continue": "Continue",
        "steps": {
          "system": "System",
          "bridge": "Bridge",
          "connection": "Installation",
          "readiness": "Readiness",
          "codelists": "Codelists",
          "entities": "Parties and invoices",
          "firstSync": "First sync"
        },
        "system": {
          "intro": "Choose the accounting system to connect.",
          "none": "No supported accounting system is available for this account.",
          "notAvailable": "The system “{{plugin}}” is not available. Choose one of the systems below."
        },
        "systemCard": {
          "requirements": "What you need",
          "syncs": "What syncs",
          "readBack": "What is read back",
          "choose": "Choose",
          "chosen": "Chosen"
        },
        "bridge": {
          "intro": "Tappeer reaches {{system}} through Tappeer Bridge, a small agent on a computer in your network that can reach {{system}}.",
          "usableTitle": "Bridges you can use",
          "use": "Use this bridge",
          "chosen": "Chosen",
          "office": "Accounting office",
          "installationsTitle": "Existing installations",
          "installationsHint": "You already have an installation of {{system}}; it has its bridge. Continue with it.",
          "useInstallation": "Continue with this installation",
          "register": "Register a new bridge",
          "registerTitle": "New bridge",
          "cancelRegister": "Cancel",
          "paired": "Bridge “{{name}}” is paired.",
          "blockers": {
            "noBridge": {
              "title": "You have no bridge yet",
              "body": "Register a bridge and install it on the computer that runs {{system}}."
            },
            "pending": {
              "title": "Bridge “{{name}}” is awaiting pairing",
              "body": "Issue a new pairing code and finish installing the agent.",
              "bodyOffice": "Your accounting office has to finish pairing it.",
              "action": "Pair the bridge"
            },
            "offline": {
              "title": "Bridge “{{name}}” is offline",
              "body": "Check that the computer with the bridge is on and connected to the internet. This page refreshes by itself.",
              "help": "How to bring a bridge online"
            },
            "pluginNotReported": {
              "title": "Bridge “{{name}}” does not report {{system}}",
              "body": "The bridge has to report {{system}} with parties and invoices. Check that {{system}} runs on the bridge's computer and that the agent is up to date."
            },
            "officeInstallation": {
              "title": "Your accounting office sets up the installation",
              "body": "The bridge of your accounting office ({{names}}) is used through an installation the office sets up for your account. Ask your office to set it up, or register a bridge of your own."
            }
          }
        },
        "connection": {
          "intro": "The installation tells Tappeer which {{system}} agenda or company database to work with. Every connector of this setup reads from it.",
          "pickHint": "You have several installations of {{system}}. Choose the one to set up.",
          "pick": "Choose",
          "current": "Chosen",
          "notFound": {
            "title": "The installation was not found",
            "body": "It may have been deleted. Choose another one.",
            "action": "Choose another installation"
          },
          "bridgeGone": {
            "title": "An installation has lost its bridge",
            "body": "{{names}} uses a bridge that is no longer available. Set up a new installation instead."
          }
        },
        "readiness": {
          "intro": "Before the first sync, Tappeer checks that a sync can run through this installation.",
          "provenByRun": "A connector of this installation has already synced successfully.",
          "continueAnyway": "Continue anyway",
          "confirm": {
            "title": "Continue without a passed check?",
            "message": "The readiness check did not pass. The first sync may fail until the problem is fixed.",
            "confirm": "Continue anyway",
            "cancel": "Back to the check"
          },
          "continueBlocked": "You can continue once the readiness check has passed."
        },
        "codelists": {
          "intro": "For each Tappeer value, choose the {{system}} code. An empty row uses the default.",
          "backToReadiness": "Back to readiness"
        },
        "entities": {
          "intro": "The installation “{{connection}}” gets two connectors: one for parties, one for invoices. New ones are created switched off; the first sync switches them on.",
          "party": "Parties",
          "invoice": "Invoices",
          "names": {
            "party": "{{system}} – Parties",
            "invoice": "{{system}} – Invoices"
          },
          "badges": {
            "new": "New",
            "existing": "Existing",
            "created": "Created"
          },
          "reused": "The connector “{{name}}” you already have on this installation is used.",
          "createdAs": "Created as “{{name}}”.",
          "openConnector": "Open connector",
          "plan": {
            "inFull": "From {{system}} to Tappeer.",
            "readBack": "Invoice states are read back from {{system}}.",
            "noReadBack": "{{system}} does not send invoice states back; invoices only go out.",
            "outOnChange": "From Tappeer to {{system}}, right after every change.",
            "outScheduled": "From Tappeer to {{system}}, on schedule.",
            "schedule": "{{mode}} {{cadence}}.",
            "modes": {
              "full": "Full sync",
              "modifiedSince": "Changes only",
              "readBack": "Read-back"
            },
            "cadence": {
              "daily": "every day at {{time}} ({{timezone}})",
              "hourly": "every hour",
              "every6h": "every 6 hours",
              "other": "on a custom schedule"
            }
          },
          "create": "Create connectors",
          "createFailed": "The connector could not be created",
          "duplicates": {
            "party": "This installation has more than one connector for parties",
            "invoice": "This installation has more than one connector for invoices",
            "body": "The wizard cannot tell which one to use. Keep one and delete the others."
          },
          "needsMigration": {
            "title": "The connector “{{name}}” needs its settings updated",
            "body": "Nothing syncs until the settings are updated.",
            "action": "Open connector settings"
          },
          "notOutbound": {
            "title": "The connector “{{name}}” sends nothing to {{system}}",
            "body": "The first sync needs the connector to send from Tappeer to {{system}}.",
            "action": "Turn on sending",
            "confirm": {
              "title": "Turn on sending?",
              "message": "The connector “{{name}}” starts sending changes from Tappeer to {{system}}. What it reads from {{system}} stays as it is.",
              "confirm": "Turn on sending",
              "cancel": "Cancel"
            },
            "failed": "Sending could not be turned on"
          }
        },
        "firstSync": {
          "intro": "Tappeer now syncs for the first time: parties first, then invoices. It may take a while. You can close the page and come back later.",
          "enableNote": "The wizard switches the connectors on before it starts.",
          "rows": {
            "partyIn": "Parties from {{system}} to Tappeer",
            "partyOut": "Parties from Tappeer to {{system}}",
            "partyReadBack": "Parties read back from {{system}}",
            "invoiceIn": "Invoices from {{system}} to Tappeer",
            "invoiceOut": "Invoices from Tappeer to {{system}}",
            "invoiceReadBack": "Invoice states read back from {{system}}"
          },
          "pending": "Waiting",
          "waitingForReadBack": "Waiting for the read-back",
          "readBackInMonitor": "The read-back result will show in the monitor.",
          "openMonitor": "Monitor",
          "pendingMatches_one": "{{count}} party waits to be matched",
          "pendingMatches_other": "{{count}} parties wait to be matched",
          "runFailed": "The run ended with an error.",
          "nothingSent": {
            "approved": "No invoice went out yet. That is fine: {{system}} gets approved invoices only.",
            "all": "No invoice went out yet. This account has none so far."
          },
          "expectations": {
            "approved": "Only approved invoices go to {{system}}. If none is approved yet, nothing goes out, and that is fine.",
            "all": "Every invoice of this account goes to {{system}}.",
            "invoices": "Show invoices",
            "readBack": "The first read-back right after the push usually changes nothing. The regular read-back brings the invoice states."
          },
          "start": "Start the first sync",
          "resume": "Continue the sync",
          "running": "The sync is running. Its progress shows here by itself.",
          "waitingForRuns": "The sync has started; its next run is awaited.",
          "openAccountMonitor": "Open the monitor",
          "syncing": "Syncing…",
          "retry": "Try again",
          "failed": {
            "party": "The party sync ended with an error",
            "invoice": "The invoice sync ended with an error"
          },
          "refused": {
            "party": "The party sync could not be started",
            "invoice": "The invoice sync could not be started"
          },
          "enableFailed": "The connector “{{name}}” could not be switched on",
          "openSettings": "Open connector settings",
          "done": {
            "title": "Done. The first sync went through.",
            "body": "From now on, parties and invoices sync by themselves on schedule.",
            "transform": "Rules",
            "finish": "Done"
          },
          "noAnswer": "The start got no answer and no run showed up."
        }
      }
    },
    "documents": {
      "title": "Documents",
      "subtitle": "Manage and organize your documents",
      "searchPlaceholder": "Search supplier, document number…",
      "filters": {
        "allDocuments": "All documents",
        "pendingReview": "To review",
        "sectionAllDocuments": "All documents",
        "sectionPendingReview": "Documents to review",
        "all": "All"
      },
      "empty": "No documents to display",
      "card": {
        "created": "Created",
        "extractionQuality": "Extraction quality",
        "viewDocument": "View document {{filename}}",
        "unknownType": "Unknown document type",
        "uploadedBy": "Uploaded by",
        "completedNew": "Completed · new",
        "processingProgress": "Crunching… {{progress}} %",
        "takingLonger": "Taking longer than usual"
      },
      "overLimit": {
        "badge": "Over plan quota, billed as overage"
      },
      "banner": {
        "processing": "Processing in progress...",
        "fileCount_one": "{{count}} file",
        "fileCount_other": "{{count}} files"
      },
      "error": {
        "loadFailed": "Error loading documents"
      },
      "view": {
        "card": "Cards",
        "table": "Table"
      },
      "sort": {
        "date": "Date",
        "filename": "Filename",
        "type": "Type",
        "status": "Status"
      },
      "table": {
        "filename": "Filename",
        "type": "Type",
        "status": "Status",
        "size": "Size",
        "created": "Created",
        "headers": {
          "id": "ID",
          "name": "Name",
          "type": "Type",
          "size": "Size",
          "uploadedBy": "Uploaded By",
          "date": "Date",
          "actions": "Actions"
        }
      },
      "widgets": {
        "totalDocuments": "Total Documents",
        "pdfs": "PDFs",
        "spreadsheets": "Spreadsheets",
        "documents": "Documents"
      },
      "actions": {
        "uploadDocument": "Upload Document"
      },
      "upload": {
        "button": "Upload Document",
        "title": "Upload Document",
        "selectFile": "Select File",
        "selectedFile": "Selected file",
        "dragDrop": "Drag and drop your file here",
        "clickToSelect": "or click to browse",
        "takePhoto": "Take photo",
        "takeAnotherPhoto": "Take another photo",
        "chooseFromGallery": "Choose from gallery",
        "chooseFile": "Choose file",
        "tooManyFiles_one": "You can choose only {{count}} file at once",
        "tooManyFiles_other": "You can choose at most {{count}} files at once",
        "documentType": "Document Type",
        "autoDetect": "Auto-detect",
        "autoDetectHint": "The system will automatically detect the document type",
        "cancel": "Cancel",
        "clearFiles": "Clear Files",
        "upload": "Upload",
        "uploading": "Uploading...",
        "converting": "Converting...",
        "success": "Document uploaded successfully",
        "duplicate": "This document was already uploaded — opening the existing one",
        "duplicateReason": "Duplicate document – the same file was already uploaded {{date}}",
        "duplicatesSkippedHint": "Duplicate files will be skipped and not uploaded again.",
        "allDuplicates": "All selected files have already been uploaded. Nothing will be uploaded.",
        "processingFailed": "The document was uploaded but could not be processed.",
        "conversionFailed": "The document could not be converted into a readable form.",
        "conversionUnavailable": "The conversion service is unavailable — the file was stored, try again later.",
        "busy": "Too many files are being uploaded right now. Try again in a moment.",
        "tooSlow": "The connection is too slow for this file. Try again on a faster connection.",
        "error": "Failed to upload document",
        "fileTooLarge": "File size exceeds the 100 MB limit",
        "invalidFileType": "Unsupported file type. Allowed: PDF, PNG, JPEG, WebP, HEIC, HEIF, ISDOC (also as XML), DOC, DOCX",
        "isdocInvalid": "The file is not a valid ISDOC document.",
        "limitReached": "Monthly document extraction limit reached. Please upgrade your plan to continue.",
        "selectFiles": "Select Files",
        "filesToUpload": "Files to upload ({{count}})",
        "removeFile": "Remove",
        "uploadAll": "Upload All ({{count}})",
        "dropFilesHere": "Drop files anywhere to upload",
        "dropToAdd": "Drop to add files",
        "pasteHint": "You can also paste files (Ctrl+V / ⌘V)"
      },
      "emailSetup": {
        "button": "Set up email",
        "modal": {
          "title": "Import documents by email",
          "formTitle": "Email mailbox setup",
          "description": "Get a personal email address — just forward invoices and receipts to it. Documents are uploaded and processed automatically, with no manual uploading.",
          "benefits": {
            "forward": "Forward invoices straight from your inbox",
            "auto": "Documents are uploaded and processed automatically",
            "share": "Share the address with suppliers and colleagues"
          },
          "locationHint": "You can find the email setup any time under System settings → Email mailbox.",
          "setupCta": "Set up email",
          "later": "I'll do it later",
          "successTitle": "Your mailbox is ready",
          "createdLabel": "Your address for importing documents",
          "copy": "Copy",
          "usageHint": "Forward invoices and receipts to this address — they'll be uploaded and processed automatically.",
          "editHint": "You can edit the mailbox any time in",
          "editLink": "System settings → Email mailbox",
          "done": "Done"
        }
      },
      "detail": {
        "loading": "Loading document...",
        "retry": "Try again",
        "notFound": {
          "title": "Document not found",
          "message": "The document you're looking for does not exist or has been deleted."
        },
        "error": {
          "title": "Failed to load document"
        },
        "actions": {
          "back": "Back to list",
          "download": "Download",
          "reprocess": "Reprocess",
          "reprocessing": "Reprocessing...",
          "convertToDocument": "Convert to Document",
          "delete": "Delete",
          "approveAll": "Approve All",
          "moreActions": "More actions",
          "comingSoon": "Coming soon",
          "openInvoice": "Open invoice"
        },
        "unknownDocument": "Unknown Document",
        "reprocessError": "Failed to start reprocessing. Please try again later.",
        "reprocessModal": {
          "title": "Reprocess Document",
          "description": "Re-run AI extraction on this document.",
          "documentTypeRequired": "Please select a document type",
          "userPromptLabel": "Additional Instructions",
          "userPromptPlaceholder": "Optional: Add instructions to guide the AI extraction (e.g., 'Focus on delivery address', 'This is a Czech invoice')...",
          "cancel": "Cancel",
          "confirm": "Reprocess"
        },
        "deleteModal": {
          "title": "Delete Document",
          "description": "Are you sure you want to permanently delete this document? This action cannot be undone.",
          "cancel": "Cancel",
          "confirm": "Delete",
          "deleting": "Deleting...",
          "errorTitle": "Could not delete document",
          "errorMessage": "An error occurred while deleting the document. Please try again.",
          "forbiddenTitle": "Permission denied",
          "forbiddenMessage": "You do not have permission to delete this document. Please contact your administrator."
        },
        "backToList": "Back to list",
        "fields": {
          "filename": "Filename",
          "documentType": "Document Type",
          "status": "Status",
          "createdAt": "Created At",
          "placeholder": "No value",
          "confidence": "Confidence"
        },
        "itemsTable": {
          "noItems": "No items",
          "headers": {
            "item": "Item",
            "quantity": "Qty",
            "unitPrice": "Unit Price",
            "total": "Total",
            "vatRate": "VAT %"
          }
        },
        "preview": {
          "controls": {
            "prevPage": "Previous page",
            "nextPage": "Next page",
            "pageCount": "Page {{current}} of {{total}}",
            "zoomIn": "Zoom in",
            "zoomOut": "Zoom out",
            "resetZoom": "Reset zoom"
          },
          "error": {
            "loadFailed": "Failed to load document preview"
          },
          "notPreviewable": "This file type can't be previewed.",
          "download": "Download file",
          "passwordProtected": "This document is password-protected"
        },
        "statusPanel": {
          "processing": {
            "title": "Sniffing through your document!",
            "description": "Give me a moment — I'll dig out all the important bits."
          },
          "extracted": {
            "title": "Extraction complete!",
            "description": "Processing results and creating the document. Just a moment..."
          },
          "invoiceFailed": {
            "title": "Extraction finished, but the document wasn't created",
            "description": "I read the data, but creating the document failed. Use the \"Reprocess\" button above and I'll try again."
          },
          "failed": {
            "title": "Oops, something went wrong!",
            "description": "An error occurred while processing the document. Use the \"Reprocess\" button above and I'll do my best."
          },
          "quotaExceeded": {
            "title": "You've reached your limit",
            "description": "The monthly document extraction limit has been reached. Upgrade your plan to continue."
          },
          "unsupportedDocument": {
            "title": "This document isn't something I can extract",
            "description": "The document doesn't appear to be an invoice or receipt. Please upload only documents you'd like me to process."
          },
          "passwordProtected": {
            "title": "This document is locked",
            "description": "The PDF is password-protected. Enter its password below and I'll unlock it and extract the data."
          }
        },
        "unlock": {
          "passwordLabel": "Document password",
          "passwordPlaceholder": "Enter the document password",
          "submit": "Unlock and extract",
          "errorInvalidPassword": "The password is incorrect. Please try again.",
          "errorAsyncFailed": "Unlocking failed. Check the password and try again.",
          "errorGeneric": "Unlocking failed. Please try again."
        },
        "extractedData": {
          "overallConfidence": "Overall Confidence",
          "noData": "No extraction data available",
          "sections": {
            "documentDetails": "Document Details",
            "supplierInformation": "Supplier Information",
            "customerInformation": "Customer Information",
            "invoiceDetails": "Invoice Details",
            "paymentInformation": "Payment Information",
            "receiptDetails": "Receipt Details",
            "items": "Items",
            "totals": "Totals"
          },
          "fields": {
            "name": "Name",
            "companyId": "Company ID",
            "taxId": "Tax ID",
            "vatId": "VAT ID",
            "address": "Address",
            "email": "Email",
            "phone": "Phone",
            "invoiceNumber": "Invoice Number",
            "invoiceDate": "Invoice Date",
            "dueDate": "Due Date",
            "deliveryDate": "Delivery Date",
            "paymentTerms": "Payment Terms",
            "orderReference": "Order Reference",
            "bankAccount": "Bank Account",
            "bankCode": "Bank Code",
            "bankName": "Bank Name",
            "iban": "IBAN",
            "swift": "SWIFT/BIC",
            "variableSymbol": "Variable Symbol",
            "constantSymbol": "Constant Symbol",
            "specificSymbol": "Specific Symbol",
            "receiptNumber": "Receipt Number",
            "datetime": "Date & Time",
            "paymentMethod": "Payment Method",
            "lineItems": "Line Items",
            "currency": "Currency",
            "subtotal": "Subtotal",
            "vatAmount": "VAT Amount",
            "vatRate": "VAT Rate",
            "total": "Total",
            "amountDue": "Amount Due",
            "amountPaid": "Amount Paid",
            "documentNumber": "Document Number",
            "issueDate": "Issue Date",
            "taxDate": "Tax Date",
            "receiptDatetime": "Receipt Date/Time",
            "relatedDocumentNumber": "Related Document Number",
            "correctionReason": "Correction Reason",
            "netAmount": "Net Amount",
            "totalAmountNoVat": "Total (excl. VAT)",
            "totalVatAmount": "Total VAT",
            "totalAmountInclVat": "Total Amount (incl. VAT)",
            "paidAmount": "Paid Amount",
            "paymentNote": "Payment Note",
            "terminalId": "Terminal ID",
            "cashierId": "Cashier ID",
            "eetFik": "EET FIK",
            "eetBkp": "EET BKP",
            "eetPkp": "EET PKP"
          }
        },
        "processingLogs": {
          "title": "Processing Details",
          "processingDuration": "Processing Duration",
          "tokenUsage": "Token Usage",
          "inputTokens": "Input Tokens",
          "outputTokens": "Output Tokens",
          "totalTokens": "Total Tokens"
        }
      },
      "emptySearch": "Nothing found for “{{query}}”",
      "groups": {
        "attention": "Needs attention",
        "locked": "Awaiting password",
        "processing": "Processing",
        "completed": "Processed",
        "sortedNewest": "Newest first"
      }
    },
    "documentThreads": {
      "title": "Questions",
      "openTag": "Open question",
      "resolve": "Resolve",
      "overviewLink": "All open questions",
      "turn": {
        "masterAccount": {
          "NONE": "Resolved",
          "AWAITING_CLIENT": "Waiting for client",
          "CLIENT_REPLIED": "Client replied"
        },
        "client": {
          "NONE": "Resolved",
          "AWAITING_CLIENT": "Waiting for your reply",
          "CLIENT_REPLIED": "Reply sent"
        }
      },
      "subject": {
        "loading": "Loading document…",
        "unavailable": "Document not available"
      },
      "message": {
        "formerMember": "Former user",
        "side": {
          "DIRECT": "Client",
          "MASTER_ACCOUNT": "Office"
        },
        "note": "Note"
      },
      "messages": {
        "loadEarlier": "Show earlier messages"
      },
      "composer": {
        "openLabel": "Question for the client",
        "replyLabel": "Message",
        "openPlaceholder": "What would you like to ask the client about this document?",
        "masterAccountPlaceholder": "Write to the client…",
        "replyPlaceholder": "Write your reply…",
        "submitOpen": "Send question",
        "submitReply": "Reply",
        "submitQuestion": "Send to client",
        "submitNote": "Send note",
        "tooLong": "The message is too long, at most {{max}} characters.",
        "removeFile": "Remove {{fileName}}",
        "attach": "Attach document",
        "uploadTitle": "Attach document",
        "uploadDescription": "Drop a file here or click to choose one",
        "requiresClientAction": "Wait for the client's reply",
        "requiresClientActionOn": "The question passes to the client for a reply.",
        "requiresClientActionOff": "The client sees the message, but no reply is expected."
      },
      "noClientUser": {
        "title": "A question needs someone to read it",
        "description": "The client has no user in Tappeer yet who could read the question. Invite a user of the client – the question can be sent once they accept the invitation.",
        "askAdmin": "A user of the client can be invited by the client's administrator or the office's administrator.",
        "retry": "Try again",
        "invite": "Invite a user of the client",
        "invited": "Invitation sent. The question can be sent once the user accepts it."
      },
      "new": {
        "hint": "There is no question about this document yet. The client will see it right next to the document.",
        "hintAgain": "Earlier questions are resolved. You can ask the client again."
      },
      "empty": {
        "title": "No questions",
        "description": "The office has no question about this document yet."
      },
      "history": {
        "title": "Resolved questions",
        "resolved": "Resolved {{date}}",
        "resolvedBy": "Resolved {{date}} · {{name}}",
        "loadMore": "Show older questions"
      },
      "errors": {
        "alreadyOpen": "This document already has an open question – showing it now.",
        "resolved": "The question has been resolved in the meantime.",
        "generic": "The action failed. Please try again.",
        "loadThreads": "Questions could not be loaded.",
        "loadMessages": "Messages could not be loaded.",
        "loadOverview": "Open questions could not be loaded.",
        "sameDocument": "This file is the document the question is about. Please attach a different document."
      },
      "toast": {
        "opened": "Question sent to the client",
        "resolved": "Question resolved"
      },
      "overview": {
        "title": "Open questions",
        "button": "Open questions ({{total}})",
        "count": "Open questions: {{total}}",
        "loadMore": "Load more",
        "empty": {
          "title": "No open questions",
          "descriptionMasterAccount": "Ask the client a question from the document detail.",
          "descriptionClient": "When the office asks you something, you will find it here."
        },
        "table": {
          "document": "Document",
          "turn": "Status",
          "lastActivity": "Last activity",
          "asked": "Date asked"
        }
      }
    },
    "invoices": {
      "matching": {
        "findings": {
          "accept": "Accept",
          "reject": "Reject",
          "notePlaceholder": "Why (optional)",
          "answerSaved": "The answer was saved.",
          "settledByPairing": "This finding can be neither accepted nor rejected — only pairing the line by hand settles it."
        },
        "findingExplanation": {
          "UNRESOLVABLE_REFERENCE": "The order this invoice names could not be found.",
          "AMBIGUOUS_ORDER": "More than one order fits what the invoice names, so nothing can be paired until one is chosen.",
          "SUPPLIER_MISMATCH": "The order belongs to a different supplier than the one who sent this invoice.",
          "UNKNOWN_LINE": "No matching line was found on the order.",
          "AMBIGUOUS_PAIRING": "The invoice line fits more than one ordered line equally well.",
          "WEAK_PAIRING": "The line was paired on resemblance (its description, or by elimination), not on a code or an EAN."
        },
        "answerEffect": {
          "UNRESOLVABLE_REFERENCE": {
            "accept": "Accepting records that the order named on the invoice cannot be found; once nothing else on the invoice header is open, every line's pairing is confirmed unless something else holds that line."
          },
          "AMBIGUOUS_ORDER": {
            "accept": "Accepting picks no order; once nothing else on the invoice header is open, every line's pairing is confirmed unless something else holds that line."
          },
          "SUPPLIER_MISMATCH": {
            "accept": "Accepting records that the order's different supplier is acceptable; once nothing else on the invoice header is open, every line's pairing is confirmed unless something else holds that line."
          },
          "UNKNOWN_LINE": {
            "reject": "Rejecting records that nothing on the order matches this line; neither automatic matching nor the AI pairs it again, and it can only be paired by hand."
          },
          "WEAK_PAIRING": {
            "accept": "Accepting confirms the pairing, unless something else still holds the line.",
            "reject": "Rejecting removes the automatic pairing; the line waits to be paired by hand."
          }
        },
        "links": {
          "title": "Pairing",
          "orderedLine": "Ordered line",
          "pairedBy": "Paired how",
          "state": "State",
          "actions": "Actions",
          "receivedLine": "A received line, without an order",
          "byRung": "by {{rung}}",
          "confirmed": "Confirmed",
          "unconfirmed": "Not confirmed",
          "order": "Order {{number}}",
          "confirmedAutomatically": "Confirmed automatically",
          "confirmedBy": "Confirmed by {{name}}"
        },
        "pairing": {
          "unpair": "Unpair",
          "pairLine": "Pair the line by hand",
          "pair": "Pair",
          "pairSuccess": "The line was paired.",
          "orderGroup": "Order {{number}}",
          "otherOrders": "Other orders from this supplier",
          "supplierOrders": "Orders from this supplier",
          "noOtherOrders": "The supplier has no other order to pair with.",
          "noCandidates": "This invoice's supplier has no order to pair with.",
          "loadMore": "Load more",
          "lineNumber": "No.",
          "description": "Description",
          "code": "Code",
          "ordered": "Ordered",
          "invoiced": "Invoiced",
          "unitPrice": "Unit price",
          "proposed": "Proposed",
          "selectLine": "Select line {{number}} of order {{order}}",
          "overInvoiced": "Pairing this line would bill more than was ordered.",
          "nothingOnOrderSuccess": "Saved: the line has no counterpart on the order."
        },
        "errors": {
          "resolveFailed": "The answer could not be saved.",
          "pairingFailed": "The line's pairing could not be saved."
        },
        "lineStatus": {
          "clean": "Settled — nothing open",
          "attention": "The pairing needs an answer",
          "problem": "The line is paired with no ordered line",
          "held": "Left out of automatic matching — waiting to be paired by hand",
          "openLabel": "{{status}} — open the line's pairing"
        },
        "latest": {
          "pairedByHand": "Paired by hand",
          "paired": "Paired",
          "automatically": "Automatically",
          "held": {
            "UNKNOWN_LINE": "Nothing on the order to pair with",
            "WEAK_PAIRING": "Proposed pairing rejected"
          },
          "heldExplanation": "Neither automatic matching nor the AI pairs the line again; it can only be paired by hand."
        },
        "edit": {
          "confirm": "Confirm",
          "cancel": "Cancel",
          "nothingOnOrder": "The line has no counterpart on the order; automatic matching leaves it out.",
          "pairsWith": "The line will be paired with line {{number}} of order {{order}}."
        },
        "lineModal": {
          "title": "Line {{number}}",
          "close": "Close",
          "unconfirmedNote": "This pairing is not confirmed yet. Nothing confirms it while a finding on this line or on the invoice header is open.",
          "notPaired": "The line is not paired with any ordered line yet."
        },
        "actions": {
          "confirmed": "Pairing confirmed"
        }
      },
      "list": {
        "title": "Invoices",
        "error": "Failed to load invoices",
        "retry": "Try again",
        "empty": "No invoices to display",
        "searchPlaceholder": "Search invoices...",
        "tabs": {
          "all": "All",
          "FOR_EDIT": "For Editing",
          "FOR_APPROVAL": "For Approval",
          "FOR_EXPORT": "To Post",
          "FOR_PAYMENT": "To Pay",
          "REJECTED": "Rejected",
          "CANCELLED": "Cancelled",
          "COMPLETED": "Completed",
          "ARCHIVED": "Archived"
        },
        "view": {
          "card": "Cards",
          "table": "Table"
        },
        "headers": {
          "invoiceNumber": "Invoice Number",
          "internalNumber": "Internal Number",
          "supplier": "Supplier",
          "documentType": "Document Type",
          "totalAmount": "Total Amount (incl. VAT)",
          "invoiceDate": "Invoice Date",
          "dueDate": "Due Date",
          "actions": "Actions"
        },
        "sort": {
          "created": "Created",
          "date": "Issue date",
          "amount": "Amount (incl. VAT)",
          "vendor": "Vendor",
          "number": "Number"
        },
        "batchExport": {
          "button": "Export",
          "selectHint": "Select invoices to export",
          "selectedCount": "Selected {{count}}",
          "selectionCapped_one": "Selected the first {{limit}} of {{count}} invoice",
          "selectionCapped_other": "Selected the first {{limit}} of {{count}} invoices",
          "selectAll": "Select all",
          "deselectAll": "Deselect all",
          "exportAs": "Export as",
          "exporting": "Exporting…",
          "cancel": "Cancel",
          "error": {
            "partialValidation_one": "{{count}} invoice could not be exported — the rest were downloaded",
            "partialValidation_other": "{{count}} invoices could not be exported — the rest were downloaded",
            "allSkipped": "Nothing to download — all invoices failed validation.",
            "failed": "Export failed. Please try again.",
            "selectAllFailed": "Could not select all invoices. Please try again.",
            "noData": "No data returned from server.",
            "notExportable": "Some invoices can no longer be exported. Refresh the page and try again.",
            "sessionExpired": "Your session has expired. Please sign in again.",
            "invoiceLabel": "Invoice {{number}}",
            "invoiceUnknown": "Unknown invoice",
            "pdfUnreadable": "The PDF files of the selected invoices cannot be read (they may be encrypted or damaged). Export them as ISDOC XML instead."
          },
          "issue": {
            "pdfMissing": "The invoice has no PDF attached, so it cannot be exported as PDF.",
            "notValidated": "The invoice has not passed validation and its warnings were not accepted, so it cannot be exported."
          }
        },
        "batchAction": {
          "progress": "Processed {{processed}} of {{total}}",
          "error": {
            "interrupted_one": "Done {{done}} of {{count}} invoice, the rest could not be processed. Please try again.",
            "interrupted_other": "Done {{done}} of {{count}} invoices, the rest could not be processed. Please try again."
          }
        },
        "batchArchive": {
          "button": "Move to archive",
          "archiving": "Moving to archive…",
          "confirmTitle": "Move documents to the archive",
          "confirmMessage_one": "Do you really want to move {{count}} document to the archive?",
          "confirmMessage_other": "Do you really want to move {{count}} documents to the archive?",
          "confirmButton": "Move to archive",
          "cancel": "Cancel",
          "successMessage_one": "{{count}} document was moved to the archive.",
          "successMessage_other": "{{count}} documents were moved to the archive.",
          "error": {
            "failed": "Moving to the archive failed. Please try again.",
            "partialValidation_one": "{{count}} document cannot be moved to the archive.",
            "partialValidation_other": "{{count}} documents cannot be moved to the archive.",
            "allSkipped": "No document was moved to the archive.",
            "invoiceLabel": "Invoice {{number}}",
            "invoiceUnknown": "Unknown invoice"
          }
        },
        "batchMoveToExport": {
          "button": "Move to export",
          "moving": "Moving…",
          "confirmTitle": "Move to export",
          "confirmMessage_one": "Are you sure you want to move {{count}} selected invoice to export? Invoices with validation errors will be skipped.",
          "confirmMessage_other": "Are you sure you want to move {{count}} selected invoices to export? Invoices with validation errors will be skipped.",
          "confirmButton": "Move",
          "cancel": "Cancel",
          "successMessage_one": "{{count}} invoice moved to export.",
          "successMessage_other": "{{count}} invoices moved to export.",
          "error": {
            "failed": "Move failed. Please try again.",
            "partialValidation_one": "{{count}} invoice was skipped due to validation errors.",
            "partialValidation_other": "{{count}} invoices were skipped due to validation errors.",
            "allSkipped": "No invoices were moved — all have validation errors.",
            "invoiceLabel": "Invoice {{number}}",
            "invoiceUnknown": "Unknown invoice"
          }
        }
      },
      "card": {
        "invoiceNumber": "Invoice Number",
        "internalNumber": "Internal Number",
        "download": "Download",
        "downloadAria": "Download Invoice",
        "unknown": "Unknown",
        "supplier": "Supplier",
        "totalAmount": "Total Amount (incl. VAT)",
        "invoiceDate": "Issued",
        "dueDate": "Due Date"
      },
      "detail": {
        "loading": "Loading invoice...",
        "retry": "Try again",
        "invoiceLines": "Invoice items",
        "matching": "Order matching",
        "contract": "Contract",
        "AI_ANALYSIS": "AI validation",
        "supplierInfo": "Supplier Information",
        "customerInfo": "Customer Information",
        "addressInfo": "Address Information",
        "dataFields": "Data Fields",
        "invoiceTotals": "Invoice Totals",
        "vatSummary": "VAT Summary",
        "bankingDetails": "Banking Details",
        "duplicateInvoiceNumber": "Duplicate Invoice Number",
        "duplicateVariableSymbol": "Duplicate Variable Symbol",
        "error": {
          "title": "Failed to load invoice"
        },
        "notFound": {
          "title": "Invoice not found",
          "message": "The invoice you're looking for does not exist or has been deleted."
        },
        "actions": {
          "delete": "Delete",
          "back": "Back to overview",
          "changeStatus": "Change Status",
          "qrPayment": "QR Payment",
          "export": "Export",
          "moreActions": "More actions",
          "editBankingDetails": "Edit banking details",
          "editVatSummary": "Edit VAT summary",
          "editVatTotals": "Edit totals",
          "editLines": "Edit invoice lines",
          "editScan": "Edit by scan",
          "editForm": "Edit in form",
          "acceptWarnings": "Accept Warnings",
          "complete": "Finish editing",
          "submitForApproval": "Submit for approval",
          "submitForApprovalSuccess": "The invoice was handed over for approval.",
          "submitForApprovalError": "The invoice could not be handed over for approval.",
          "submitForApprovalNotValidated": "The invoice cannot be handed over for approval until it passes validation.",
          "submitForApprovalBlockedByErrors": "The document has validation errors. It can be handed over for approval once they are resolved.",
          "submitForApprovalBlockedByValidation": "The document is being checked. It can be handed over for approval once the check finishes.",
          "archive": "Move to archive",
          "unarchive": "Restore from archive",
          "completeInvoice": "Complete",
          "cancel": "Cancel invoice",
          "cancelSuccess": "The invoice was cancelled.",
          "cancelError": "The invoice could not be cancelled.",
          "returnToEditing": "Return to editing",
          "selectForExport": "Select for export",
          "select": "Select invoice",
          "archiveHint": "Hides the document from the regular lists. It stays read-only and you can restore it any time.",
          "completeInvoiceHint": "Marks the document as done. It stays in the lists until it is moved to the archive."
        },
        "header": {
          "invoice": "INVOICE",
          "invoiceNumber": "Document number",
          "internalNumber": "Internal number",
          "invoiceType": "Type",
          "vatMode": "VAT mode",
          "vatExemptionNote": "VAT regime clause",
          "orderReference": "Order reference",
          "orderReferencePlaceholder": "Type or search an order",
          "orderReferenceCustom": "Use this number",
          "orderReferenceClear": "No order number",
          "contract": "Contract",
          "isVatDocument": "VAT document",
          "originalDocumentReference": "Original document",
          "userNote": "Note",
          "currency": "Currency",
          "changeCurrency": "Change currency"
        },
        "accountingCodes": {
          "glPosting": "Posting template",
          "vatCode": "VAT classification",
          "connectorDefault": "Default from the connector settings",
          "lineDefault": "From the header, otherwise the connector default",
          "lineCaption": "VAT classification: {{code}}",
          "lineCaptionNotInCodeList": "VAT classification: {{code}}, not in the code list",
          "notInCodeList": "Not in the code list"
        },
        "lineCoding": {
          "costCenterCaption": "Cost centre: {{value}}",
          "jobCaption": "Job: {{value}}"
        },
        "changeCurrency": {
          "select": {
            "title": "Change invoice currency",
            "description": "Pick the new currency for this invoice. You'll be asked to confirm before the change is applied.",
            "label": "Currency",
            "continueLabel": "Continue",
            "cancelLabel": "Cancel"
          },
          "confirm": {
            "title": "Confirm currency change",
            "message": "Change the invoice currency from {{from}} to {{to}}?",
            "warning": "All amounts on the invoice will keep their numeric values — they won't be converted to the new currency.",
            "confirmLabel": "Change currency",
            "cancelLabel": "Back"
          }
        },
        "sections": {
          "documentInfo": "Document information",
          "supplier": "Supplier",
          "customer": "Customer",
          "description": "Document description",
          "noDescription": "No description",
          "lineItems": "Invoice items",
          "lineItems_receipt": "Receipt items",
          "vatMode": "VAT mode",
          "invoiceInformation": "Invoice information",
          "invoiceInformation_receipt": "Receipt information",
          "supplierDetails": "Supplier Details",
          "dates": "Dates",
          "paymentDetails": "Payment details",
          "vatRecap": "VAT summary",
          "invoiceTotals": "Payment summary",
          "invoiceTotals_receipt": "Receipt summary",
          "bankingDetails": "Banking Details",
          "amounts": "Amounts",
          "paymentSymbols": "Payment Symbols",
          "auditInformation": "Audit Information"
        },
        "lineItemsLabels": {
          "code": "CODE",
          "name": "ITEM NAME",
          "quantity": "QUANTITY",
          "unit": "UNIT",
          "pricePerUnit": "PRICE/UNIT",
          "pricePerUnitMJ": "PRICE (UNIT)",
          "pricePerUnitMJVatIncl": "PRICE (UNIT) INCL. VAT",
          "pricePerUnitNoVat": "EXCL. VAT",
          "totalAmountNoVat": "NET BASE",
          "totalNoVat": "TOTAL EXCL. VAT",
          "discount": "DISCOUNT",
          "discountPercent": "DISCOUNT %",
          "vatRate": "VAT %",
          "vatAmount": "VAT",
          "totalWithVat": "TOTAL WITH VAT",
          "recyclingFee": "RECYCLING FEE",
          "noItems": "Invoice has no items",
          "placeholder": "—"
        },
        "validationSummary": {
          "affectedItems_one": "{{count}} item",
          "affectedItems_other": "{{count}} items",
          "errors_one": "{{count}} error",
          "errors_other": "{{count}} errors",
          "warnings_one": "{{count}} warning",
          "warnings_other": "{{count}} warnings"
        },
        "companyLabels": {
          "name": "Name/company",
          "companyId": "Company ID",
          "taxId": "Tax ID",
          "vatId": "VAT ID",
          "address": "Address",
          "email": "Email",
          "phone": "Phone",
          "notAvailable": "Not available",
          "mismatchSupplier": "This company is not marked as a supplier",
          "mismatchCustomer": "This company is not marked as a customer",
          "createPartnerSuccess": "Company created and linked",
          "createPartnerError": "Failed to create company",
          "editPartner": "Edit company",
          "editPartnerSuccess": "Company updated",
          "editPartnerError": "Failed to update company"
        },
        "fillFromRegistry": {
          "button": "Fill from registry",
          "change": "Change from registry",
          "titleSupplier": "Select supplier from registry",
          "titleCustomer": "Select customer from registry",
          "selectPlaceholder": "Search for a party...",
          "apply": "Apply",
          "cancel": "Cancel",
          "back": "Back",
          "overwrite": "Overwrite",
          "confirmTitle": "Overwrite existing data?",
          "confirmMessage": "Selecting \"{{name}}\" will overwrite the current supplier/customer fields. Do you want to continue?",
          "linkedTo": "Linked to: {{name}}",
          "addNew": "Add as new company",
          "addNewSupplier": "Add new supplier",
          "addNewCustomer": "Add new customer",
          "disconnect": "Disconnect company",
          "createSuccess": "Company created and linked",
          "createError": "Failed to create company",
          "linkError": "Company created but could not be linked",
          "disconnectConfirmTitle": "Disconnect company?",
          "disconnectConfirmMessage": "The link to the company will be removed. The entered data will be kept.",
          "disconnectConfirm": "Disconnect"
        },
        "delivery": {
          "sameAsCustomer": "Delivery details same as billing",
          "address": "Delivery address"
        },
        "paymentLabels": {
          "paymentMethod": "PAYMENT METHOD",
          "paymentStatus": "PAYMENT STATUS",
          "paymentNote": "PAYMENT NOTE",
          "paidAmount": "PAID AMOUNT",
          "paidDate": "PAYMENT DATE",
          "postingStatus": "POSTING STATUS",
          "postedOn": "POSTING DATE",
          "accountNumber": "ACCOUNT NUMBER",
          "bankName": "BANK NAME",
          "iban": "IBAN",
          "swift": "SWIFT / BIC",
          "bankCode": "BANK CODE",
          "varSymbol": "VARIABLE SYMBOL",
          "constSymbol": "CONSTANT SYMBOL",
          "specSymbol": "SPECIFIC SYMBOL"
        },
        "vatLabels": {
          "rate": "Rate",
          "base": "Base",
          "vat": "VAT",
          "withVat": "With VAT",
          "total": "Total",
          "totalWithoutVat": "Total without VAT",
          "totalVat": "Total VAT",
          "rounding": "Rounding",
          "totalToPay": "Total to pay",
          "notAvailable": "VAT summary not available",
          "rateMismatch": "Rates {{rates}} do not match the allowed rates for this country and tax date.",
          "rateNotAllowed": "This rate is not valid for the given country and tax date"
        },
        "paymentMethod": {
          "bankTransfer": "Bank Transfer",
          "cash": "Cash",
          "card": "Card"
        },
        "dateLabels": {
          "issueDate": "Issue date",
          "dueDate": "Due date",
          "taxDate": "Tax date",
          "receiptDate": "Receipt date"
        },
        "sidebar": {
          "relatedDocuments": "Related documents",
          "changeHistory": "Change history",
          "noRelatedDocuments": "No related documents yet",
          "noHistory": "No history yet",
          "openRelatedDocument": "Open related document: {{title}}",
          "previewAttachmentError": "Failed to load preview",
          "validationNote": "Validation note",
          "addRelatedDocument": "Link a document",
          "removeRelatedDocument": "Remove link",
          "removeRelatedDocumentConfirm": "Remove link",
          "removeSuccess": "Link removed",
          "removeError": "Failed to remove link"
        },
        "emailPreview": {
          "title": "Source email",
          "from": "From",
          "to": "To",
          "subject": "Subject",
          "date": "Date",
          "close": "Close",
          "download": "Download"
        },
        "linkModal": {
          "title": "Link to another invoice",
          "description": "Search for an invoice to link. The relationship type is detected automatically.",
          "searchPlaceholder": "Search by number, supplier, description…",
          "noResults": "No invoices found",
          "loadMore": "Load more ({{count}} remaining)",
          "loading": "Loading…",
          "selectInvoice": "Link invoice {{number}}",
          "linkButton": "Link",
          "linking": "Linking…",
          "cancel": "Cancel",
          "successToast": "Invoice linked successfully",
          "errorToast": "Failed to link invoice. Please try again."
        },
        "relationTypes": {
          "CREDIT_NOTE_FOR_INVOICE": "Credit Note",
          "DEBIT_NOTE_FOR_INVOICE": "Debit Note",
          "CREDIT_NOTE_FOR_ADVANCE": "Credit Note for Advance",
          "ADVANCE_FOR_FINAL": "Advance Payment",
          "PROFORMA_FOR_ADVANCE": "Proforma Invoice",
          "STORNO": "Cancellation",
          "REPLACEMENT": "Replacement",
          "RELATED": "Related Document"
        },
        "relationDescriptions": {
          "source": {
            "CREDIT_NOTE_FOR_INVOICE": "Correction of original invoice",
            "DEBIT_NOTE_FOR_INVOICE": "Additional charge for invoice",
            "CREDIT_NOTE_FOR_ADVANCE": "Correction of advance",
            "ADVANCE_FOR_FINAL": "Advance for this invoice",
            "PROFORMA_FOR_ADVANCE": "Proforma invoice for advance payment",
            "STORNO": "Cancels original document",
            "RELATED": "Linked document",
            "default": "Source document"
          },
          "target": {
            "CREDIT_NOTE_FOR_INVOICE": "Corrected by credit note",
            "DEBIT_NOTE_FOR_INVOICE": "Charged by debit note",
            "CREDIT_NOTE_FOR_ADVANCE": "Corrected by credit note",
            "ADVANCE_FOR_FINAL": "Applied advance payment",
            "PROFORMA_FOR_ADVANCE": "Advance based on proforma invoice",
            "STORNO": "Cancelled",
            "RELATED": "Linked document",
            "default": "Target document"
          }
        },
        "historyLabels": {
          "created": "Created",
          "createdDescription": "Invoice created in the system.",
          "eventTypes": {
            "CREATED": "Created",
            "UPDATED": "Updated",
            "LINE_ITEMS_UPDATED": "Line items updated",
            "APPROVAL_STATUS_CHANGED": "Status Changed",
            "VALIDATION_STATUS_CHANGED": "Validation Changed",
            "PAYMENT_STATUS_CHANGED": "Payment Status Changed",
            "ARCHIVED": "Archived",
            "UNARCHIVED": "Unarchived",
            "ATTACHMENT_ADDED": "Attachment added",
            "ATTACHMENT_REMOVED": "Attachment removed",
            "AUTOFILL_DISCARDED": "Completion not applied",
            "MATCH_FINDING_ANSWERED": "Match finding review",
            "MATCH_AI_REVIEW": "AI matching review",
            "DELETED": "Deleted",
            "UNKNOWN": "Changed"
          },
          "fieldLabels": {
            "totalAmountInclVat": "Total Amount",
            "totalAmountNoVat": "Total (excl. VAT)",
            "totalVatAmount": "Total VAT",
            "accountingAmountNoVat": "Accounting Amount (excl. VAT)",
            "status": "Document status",
            "validationStatus": "Validation Status",
            "paymentStatus": "Payment Status",
            "invoiceNumber": "Invoice Number",
            "dueDate": "Due Date",
            "invoiceDate": "Issue Date",
            "description": "Description",
            "userNote": "Note",
            "currencyCode": "Currency",
            "quantity": "Quantity",
            "unitPrice": "Unit Price",
            "unitPriceNoVat": "Unit Price (excl. VAT)",
            "vatRate": "VAT Rate",
            "vatAmount": "VAT Amount",
            "vatMode": "VAT Mode",
            "totalAmountLine": "Total",
            "ean": "EAN",
            "classification": "Classification",
            "taxDate": "Tax Date",
            "paidDate": "Payment Date",
            "paidAmount": "Paid Amount",
            "postingStatus": "Posting Status",
            "postedOn": "Posting Date",
            "internalNumber": "Internal Number",
            "category": "Category",
            "accountingAmount": "Accounting Amount",
            "documentType": "Document Type",
            "invoicePurpose": "Invoice Purpose",
            "paymentMethod": "Payment Method",
            "customerCompanyId": "Customer Company ID",
            "customerTaxId": "Customer Tax ID",
            "customerVatId": "Customer VAT ID",
            "supplierCompanyId": "Supplier Company ID",
            "supplierTaxId": "Supplier Tax ID",
            "supplierVatId": "Supplier VAT ID",
            "accountingExchangeRate": "Accounting Exchange Rate",
            "accountingTotalVatAmount": "Accounting Total VAT",
            "accountingCurrencyCode": "Accounting Currency",
            "isVatDocument": "Tax Document",
            "orderReference": "Order Number",
            "originalDocumentReference": "Original Document Reference",
            "roundingAmount": "Rounding",
            "supplierName": "Supplier Name",
            "supplierParty": "Supplier in the directory",
            "supplierEmail": "Supplier Email",
            "supplierPhone": "Supplier Phone",
            "supplierAddress": "Supplier Address",
            "customerName": "Customer Name",
            "customerParty": "Customer in the directory",
            "customerEmail": "Customer Email",
            "customerPhone": "Customer Phone",
            "customerAddress": "Customer Address",
            "bankingDetails": "Banking Details",
            "vatSummary": "VAT Recapitulation",
            "contractId": "Contract",
            "contractLinkSource": "Contract link"
          },
          "lineChanges": {
            "added": "+ {{count}} added",
            "removed": "- {{count}} removed",
            "modified": "~ {{count}} modified",
            "lineNumber": "Line {{number}}",
            "fieldChanged": "{{from}} → {{to}}",
            "fieldSet": "→ {{to}}",
            "fieldCleared": "cleared"
          },
          "vatChanges": {
            "added": "+ {{count}} added",
            "removed": "- {{count}} removed",
            "modified": "~ {{count}} modified"
          },
          "modal": {
            "viewDetails": "View line changes",
            "viewVatDetails": "View VAT changes",
            "viewMatchReview": "Show results",
            "matchReview": {
              "title": "Matching review results",
              "line": "Line",
              "finding": "Finding",
              "answer": "Result",
              "outcome": "Outcome",
              "confidence": "Confidence",
              "reasoning": "Reasoning",
              "confidenceValue": "{{value}}%"
            },
            "lineChanges": "Line item changes",
            "addedLines": "Added",
            "removedLines": "Removed",
            "modifiedLines": "Modified",
            "field": "Field",
            "from": "Before",
            "to": "After",
            "noDetails": "No line changes recorded.",
            "close": "Close"
          },
          "systemChange": "System",
          "valueChanged": "changed",
          "loadError": "Failed to load history",
          "cancelled": "Cancelled",
          "approvers": "Approvers: {{value}}",
          "roleTarget": "Everybody holding the {{role}} role",
          "permissionTarget": "Everybody with the permission to approve",
          "approverDecision": "Approval decision: {{value}}",
          "matchFindingAnswered": "Line {{line}} · {{finding}}: {{resolution}}",
          "matchFindingAnsweredHeader": "{{finding}}: {{resolution}}",
          "approverDecisionValue": {
            "APPROVED": "Approved",
            "REJECTED": "Rejected"
          }
        },
        "qrPayment": {
          "title": "QR Code for Payment",
          "subtitle": "Scan the QR code in your banking app for quick payment",
          "mobileSubtitle": "Share, copy or save the QR code.",
          "loading": "Loading QR code...",
          "remainingAmount": "Remaining to pay",
          "variableSymbol": "VS",
          "constantSymbol": "KS",
          "specificSymbol": "SS",
          "message": "Message for the payee",
          "account": "Account",
          "iban": "IBAN",
          "qrCodeAlt": "Payment QR code for invoice",
          "unavailable": "QR code is not available. The document has no valid bank account, or nothing is left to pay.",
          "shareButton": "Share QR Code",
          "copyButton": "Copy Payment Details",
          "downloadButton": "Download QR",
          "shareTitle": "Payment QR Code",
          "copied": "Payment details copied to clipboard",
          "copyFailed": "Failed to copy payment details",
          "shareFailed": "Failed to share QR code"
        },
        "changeStatus": {
          "title": "Change Invoice Status",
          "subtitle": "Select a new status for invoice {{invoiceNumber}}",
          "selectStatus": "Select status...",
          "cancel": "Cancel",
          "change": "Change Status"
        },
        "exportModal": {
          "title": "Export Invoice",
          "subtitle": "Select a format to export invoice {{invoiceNumber}}",
          "exporting": "Exporting...",
          "cancel": "Cancel",
          "formats": {
            "xml": {
              "title": "ISDOC",
              "description": "Standalone ISDOC file — the Czech e-invoicing standard"
            },
            "pdf": {
              "title": "PDF with ISDOC",
              "description": "Invoice PDF with the ISDOC file embedded",
              "noPdf": "No PDF file attached to this invoice"
            }
          },
          "error": {
            "validationTitle": "Invoice cannot be exported",
            "networkTitle": "Export failed",
            "moreIssues": "…and {{count}} more issue(s)",
            "failed": "Export failed. Please try again.",
            "noData": "No data returned from the server",
            "notExportable": "The invoice can no longer be exported. Refresh the page and try again.",
            "sessionExpired": "Your session has expired. Please sign in again.",
            "pdfUnreadable": "The invoice's PDF file cannot be read (it may be encrypted or damaged), so it cannot be exported as PDF. Export it as ISDOC XML instead."
          },
          "issue": {
            "pdfMissing": "The invoice has no PDF attached, so it cannot be exported as PDF.",
            "notValidated": "The invoice has not passed validation and its warnings were not accepted, so it cannot be exported."
          }
        },
        "bankingDetailsModal": {
          "title": "Edit Banking Details",
          "description": "Update the banking information for this invoice",
          "cancel": "Cancel",
          "save": "Save",
          "saving": "Saving...",
          "errors": {
            "atLeastOneField": "Fill in at least one field",
            "invalidIban": "Invalid IBAN format",
            "saveError": "Failed to save banking details. Please try again."
          },
          "warnings": {
            "invalidDataTitle": "Warning: Invalid data format",
            "invalidDataBody": "Check the highlighted fields. Data can still be saved but may be incorrect.",
            "invalidSwift": "Invalid SWIFT/BIC format (e.g. GIBACZPX or GIBACZPXXXX)",
            "invalidBankCode": "Bank code should be a 4-digit number (e.g. 0800)",
            "invalidIban": "Invalid IBAN format (e.g. CZ6508000000192000145399)"
          }
        },
        "vatSummaryModal": {
          "title": "VAT Summary",
          "description": "Edit VAT rates and total amounts",
          "cancel": "Cancel",
          "save": "Save changes",
          "saving": "Saving...",
          "errors": {
            "saveError": "Failed to save VAT summary. Please try again."
          },
          "vatRatesTitle": "VAT breakdown by rate",
          "noVatRates": "No VAT rates available for this invoice",
          "totalsTitle": "Total amounts",
          "totalWithoutVat": "Total without VAT",
          "totalVatFromRecap": "Total VAT (from breakdown)",
          "totalToPay": "Total to pay",
          "vatRateLabel": "VAT Rate",
          "baseLabel": "Base ({{currency}})",
          "vatLabel": "VAT ({{currency}})",
          "totalInclVatLabel": "Incl. VAT ({{currency}})",
          "warnings": {
            "vatCalcTitle": "Warning: Incorrect VAT calculation",
            "vatCalcBody": "Some VAT rows do not match the calculation.",
            "expectedVat": "Expected: {{expected}} {{currency}}",
            "expectedTotal": "Expected: {{expected}} {{currency}}"
          }
        },
        "editLinesModal": {
          "title": "Edit invoice line items",
          "description": "Edit the highlighted fields. Values are not recalculated automatically – a warning will appear if amounts don't add up.",
          "cancel": "Cancel",
          "save": "Save changes",
          "saving": "Saving...",
          "noLines": "No items",
          "colName": "Name",
          "colQuantity": "Quantity",
          "colPricePerUnit": "Price/unit",
          "colPricePerUnitInclVat": "Price/unit (incl. VAT)",
          "colTotalAmountNoVat": "Net base",
          "colVatRate": "VAT Rate",
          "colVatTotal": "Total VAT",
          "colTotal": "Total",
          "colActions": "Actions",
          "noName": "No name",
          "addLine": "Add line",
          "deleteLine": "Delete line",
          "tooltipExpected": "Expected value",
          "hintExpected": "Expected:",
          "summaryBase": "Base excl. VAT",
          "summaryVat": "Total VAT",
          "summaryTotal": "TOTAL",
          "itemCount_one": "{{count}} item",
          "itemCount_other": "{{count}} items",
          "errors": {
            "saveError": "Failed to save invoice lines. Please try again."
          },
          "warnings": {
            "vatCalcTitle": "Warning: Incorrect VAT calculation",
            "vatCalcBody": "Some line items have an incorrect VAT amount.",
            "expectedVat": "Expected: {{expected}} {{currency}}",
            "expectedTotal": "Expected: {{expected}} {{currency}}"
          }
        },
        "lineItems": {
          "title": "Line Items",
          "columns": {
            "lineNumber": "#",
            "description": "Description",
            "quantity": "Quantity",
            "unitPrice": "Unit Price",
            "unit": "Unit",
            "totalAmount": "Total (incl. VAT)",
            "totalAmountNoVat": "Total (excl. VAT)",
            "vatRate": "VAT Rate (%)",
            "vatAmount": "VAT Amount"
          },
          "empty": "No line items",
          "total": "Total (all line items)",
          "verification": {
            "match": "Matches invoice total amount",
            "discrepancy": "Discrepancy with invoice total"
          },
          "actions": {
            "delete": "Delete line"
          },
          "add": "Add line",
          "placeholder": {
            "description": "Item description",
            "unit": "pcs"
          }
        },
        "fields": {
          "placeholder": "Empty",
          "selectSupplier": "Select supplier...",
          "selectCustomer": "Select customer...",
          "selectDocumentType": "Select document type...",
          "selectStatus": "Select status...",
          "invoiceNumber": "Invoice Number",
          "internalNumber": "Internal Number",
          "documentType": "Document Type",
          "invoicePurpose": "Invoice Purpose",
          "invoiceDirection": "Invoice Direction",
          "paymentStatus": "Payment Status",
          "description": "Description",
          "supplierName": "Supplier Name",
          "supplierCode": "Supplier Code",
          "email": "Email",
          "phone": "Phone",
          "companyId": "Company ID",
          "ico": "Company ID",
          "taxId": "Tax ID",
          "vatId": "VAT ID",
          "invoiceDate": "Invoice Date",
          "dueDate": "Due Date",
          "taxDate": "Tax Date",
          "paidDate": "Paid Date",
          "deliveryDate": "Delivery Date",
          "paymentTerms": "Payment Terms",
          "orderReference": "Order Reference",
          "currency": "Currency",
          "totalAmountInclVat": "Total Amount (incl. VAT)",
          "totalAmountNoVat": "Total Amount (excl. VAT)",
          "paidAmount": "Paid Amount",
          "bankAccount": "Bank Account",
          "bankCode": "Bank Code",
          "bankName": "Bank Name",
          "iban": "IBAN",
          "swift": "SWIFT/BIC",
          "varSymb": "Variable Symbol",
          "constSymb": "Constant Symbol",
          "specSymb": "Specific Symbol",
          "createdAt": "Created At",
          "createdBy": "by {{firstName}} {{lastName}} ({{email}})",
          "updatedAt": "Last Modified At",
          "updatedBy": "by {{firstName}} {{lastName}} ({{email}})",
          "name": "Name",
          "quantity": "Quantity",
          "unit": "Unit",
          "unitPrice": "Unit Price",
          "totalPrice": "Total Price",
          "vatRate": "VAT Rate",
          "vatAmount": "VAT Amount",
          "streetName": "Street Name",
          "buildingNumber": "Building Number",
          "city": "City",
          "postalCode": "Postal Code",
          "countryCode": "Country Code",
          "address": "Address",
          "confidence": "Confidence"
        },
        "deleteDialog": {
          "title": "Delete Invoice",
          "description": "Are you sure you want to delete this invoice?",
          "confirmMessage": "This action will permanently delete<br /> the invoice <strong>{{number}}</strong>.<br />This cannot be undone.",
          "cancel": "Cancel",
          "confirm": "Delete",
          "deleting": "Deleting...",
          "error": "Failed to delete invoice. Please try again."
        },
        "acceptWarningsDialog": {
          "title": "Accept Warnings",
          "confirmMessage": "This invoice has <strong>{{count}}</strong> warning(s). By confirming, validation messages will be hidden and the invoice can be exported and approved. Warnings will reappear if you make further changes.",
          "cancel": "Cancel",
          "confirm": "Accept Warnings",
          "accepting": "Accepting...",
          "notePlaceholder": "Optional note — why are you accepting these warnings?",
          "error": "Failed to accept warnings. Please try again.",
          "acceptError": "Failed to accept warnings. Please try again.",
          "approveError": "Warnings accepted, but approval failed. Please try again."
        },
        "archiveDialog": {
          "title": "Move the invoice to the archive?",
          "confirmMessage": "Do you really want to move invoice <strong>{{number}}</strong> to the archive?",
          "impactReadOnly": "The invoice will be locked and can no longer be edited.",
          "impactHidden": "It disappears from active lists and stops counting toward status totals.",
          "impactReversible": "You can restore it from the archive to its previous state at any time.",
          "cancel": "Cancel",
          "confirm": "Move to archive",
          "archiving": "Moving to archive…",
          "error": "The invoice could not be moved to the archive. Please try again."
        },
        "unarchiveDialog": {
          "title": "Restore invoice from archive?",
          "confirmMessage": "Are you sure you want to restore invoice <strong>{{number}}</strong> from the archive?",
          "impactRestored": "The invoice returns to the active lists and status totals.",
          "impactEditable": "Its previous state is restored — it can be edited or exported again.",
          "cancel": "Cancel",
          "confirm": "Restore from archive",
          "unarchiving": "Restoring...",
          "error": "Failed to restore invoice from archive. Please try again."
        },
        "completeDialog": {
          "title": "Complete the invoice?",
          "confirm": "Complete",
          "cancel": "Cancel",
          "success": "The invoice is completed.",
          "error": "The invoice could not be completed."
        },
        "returnToEditingDialog": {
          "title": "Return invoice to editing?",
          "confirmMessage": "Are you sure you want to return invoice <strong>{{number}}</strong> to editing?",
          "impactEditable": "The document is unlocked and can be edited again.",
          "impactRemovedFromExport": "Any approval under way is withdrawn and the document returns to the drafts.",
          "cancel": "Cancel",
          "confirm": "Return to editing",
          "reverting": "Returning...",
          "error": "Failed to return invoice to editing. Please try again."
        },
        "autoApprovedDialog": {
          "titleApproved": "Document was approved automatically",
          "messageApproved": "Document <strong>{{number}}</strong> was approved automatically during editing and is now locked.",
          "expiredMessageApproved": "Document <strong>{{number}}</strong> was approved automatically and is now locked for editing.",
          "hintApproved": "Returning it to editing unlocks it again. OK keeps the approval, closes any open editor and discards unsaved changes.",
          "titleSubmitted": "Document was handed over for approval",
          "messageSubmitted": "Document <strong>{{number}}</strong> was handed over for approval once its check finished, and is now locked.",
          "expiredMessageSubmitted": "Document <strong>{{number}}</strong> was handed over for approval and is now locked for editing.",
          "hintSubmitted": "Returning it to editing withdraws the approval and unlocks it again. OK leaves it in approval, closes any open editor and discards unsaved changes.",
          "ok": "OK",
          "okCountdown": "OK ({{seconds}} s)",
          "returnToEditing": "Return to editing",
          "reverting": "Returning...",
          "error": "Failed to return the invoice to editing. Please try again."
        },
        "validation": {
          "required": "{{field}} is required",
          "positive": "{{field}} must be greater than 0",
          "nonNegative": "{{field}} must be non-negative",
          "saveError": "Failed to save changes",
          "deleteError": "Failed to delete item",
          "updateStatusError": "Failed to update status"
        },
        "toast": {
          "updateSuccess": "Changes saved",
          "updateError": "Failed to save changes",
          "fieldUpdated": "{{field}} updated",
          "fieldUpdateError": "Failed to update {{field}}"
        },
        "validationBanner": {
          "title": "Invoice contains issues",
          "expand": "Expand",
          "collapse": "Collapse",
          "dismiss": "Dismiss this warning",
          "scrollTo": "Jump to field",
          "stored": "stored",
          "calculated": "calculated",
          "severity": {
            "error": "Errors",
            "warning": "Warnings"
          },
          "fieldLabels": {
            "invoiceNumber": "Invoice Number",
            "invoiceDate": "Issue Date",
            "dueDate": "Due Date",
            "taxDate": "Tax Date",
            "currencyCode": "Currency",
            "paymentMethod": "Payment Method",
            "documentType": "Document Type",
            "description": "Description",
            "totalAmountInclVat": "Total Amount",
            "totalAmountNoVat": "Total (excl. VAT)",
            "vatAmount": "VAT Amount",
            "vatSummary": "VAT Summary",
            "supplier": "Supplier",
            "supplierName": "Supplier Name",
            "supplierAddress": {
              "streetName": "Street (supplier)",
              "buildingNumber": "Building Number (supplier)",
              "city": "City (supplier)",
              "postalCode": "Postal Code (supplier)",
              "countryCode": "Country Code (supplier)"
            },
            "supplierAddressLabel": "Supplier Address",
            "supplierCompanyId": "Supplier Company ID",
            "supplierVatId": "Supplier VAT ID",
            "supplierTaxId": "Supplier Tax ID",
            "customer": "Customer",
            "customerName": "Customer Name",
            "customerCompanyId": "Customer Company ID",
            "customerVatId": "Customer VAT ID",
            "customerTaxId": "Customer Tax ID",
            "customerAddress": {
              "streetName": "Street (customer)",
              "buildingNumber": "Building Number (customer)",
              "city": "City (customer)",
              "postalCode": "Postal Code (customer)",
              "countryCode": "Country Code (customer)"
            },
            "customerAddressLabel": "Customer Address",
            "deliveryAddress": "Delivery Address",
            "bankingDetails": {
              "iban": "IBAN",
              "swift": "BIC/SWIFT",
              "bankAccount": "Bank Account",
              "bankCode": "Bank Code",
              "varSymb": "Variable Symbol"
            },
            "bankingDetailsLabel": "Banking Details",
            "invoiceLines": "Line Items",
            "relationships": "Related Documents",
            "contractId": "Contract",
            "originalDocumentReference": "Original Document",
            "vatMode": "VAT Mode",
            "accountingAmount": "Accounting Amount",
            "accountingAmountNoVat": "Accounting Amount (excl. VAT)",
            "accountingExchangeRate": "Accounting Exchange Rate",
            "quantity": "Quantity",
            "unitPrice": "Unit Price",
            "unitPriceNoVat": "Unit Price (excl. VAT)",
            "vatRate": "VAT Rate",
            "netAmount": "Net Amount",
            "totalAmountLine": "Line Total",
            "description_line": "Description"
          }
        },
        "preview": {
          "noDocument": "No source document available"
        },
        "scanEditor": {
          "saved": "Field saved",
          "saveFailed": "Failed to save field",
          "unsupportedField": "This field cannot be edited from the scan editor yet"
        },
        "documentEditor": {
          "resizeHandle": "Resize panels",
          "confidenceTooltip": {
            "title": "Extraction accuracy",
            "low": "< {{medium}}%",
            "medium": "{{medium}}–{{high}}%",
            "high": "> {{high}}%"
          },
          "back": {
            "extractions": "Back to extractions",
            "invoice": "Back to document"
          },
          "emptyState": "No fields match the current filters",
          "allOk": "All done! Not a single field acting up.",
          "saveChanges": "Save changes",
          "saving": "Saving…",
          "unsavedChanges": {
            "title": "Unsaved changes",
            "message": "You have unsaved changes. If you leave now, they will be lost.",
            "confirm": "Leave without saving",
            "cancel": "Stay"
          },
          "filters": {
            "problemFields": "Show problem fields",
            "showAll": "Show all fields"
          }
        }
      }
    },
    "receipts": {
      "detail": {
        "typeLabel": "Type",
        "status": {
          "paid": "Paid",
          "pending": "Pending",
          "overdue": "Overdue",
          "draft": "Draft"
        },
        "additionalDetails": {
          "isVatDocument": "VAT document",
          "vatMode": "VAT mode",
          "currency": "Currency",
          "internalNumber": "Internal number",
          "orderReference": "Order reference",
          "taxDate": "Tax date",
          "dueDate": "Due date",
          "description": "Description",
          "userNote": "Note"
        },
        "accountingConversion": {
          "title": "Accounting conversion",
          "rate": "Rate",
          "withoutVat": "Without VAT",
          "vat": "VAT",
          "total": "Total"
        }
      }
    },
    "notificationEvents": {
      "expand": "Adjust by document type",
      "collapse": "Hide document types",
      "kindSwitchLabel": "{{event}} – {{kind}}",
      "events": {
        "APPROVAL_REQUESTED": {
          "title": "Document awaiting approval",
          "hint": "The approver receives an email as soon as a document awaits their approval."
        },
        "APPROVAL_REMINDER": {
          "title": "Approver reminder digest",
          "hint": "The approver receives a digest email listing every document still awaiting their approval."
        },
        "DOCUMENT_REJECTED": {
          "title": "Own document rejected",
          "hint": "The document's owner receives an email once the document is rejected."
        },
        "DOCUMENT_APPROVED": {
          "title": "Own document approved",
          "hint": "The document's owner receives an email once the document is approved."
        }
      }
    },
    "profile": {
      "title": "My account",
      "roles": {
        "title": "Roles in the organization",
        "description": "The assigned roles set what is possible in the organization. An administrator changes them."
      },
      "loading": "Loading profile...",
      "retry": "Try again",
      "error": {
        "title": "Failed to load profile",
        "updateFailed": "Failed to update profile. Please try again.",
        "passwordChangeFailed": "Failed to change password. Please check your current password.",
        "allFieldsRequired": "All password fields are required.",
        "passwordMismatch": "New password and confirmation do not match.",
        "passwordTooShort": "Password must be at least 8 characters long.",
        "passwordRequiresUppercase": "Password must contain at least one uppercase letter.",
        "passwordRequiresLowercase": "Password must contain at least one lowercase letter.",
        "passwordRequiresNumber": "Password must contain at least one number.",
        "passwordRequiresSpecial": "Password must contain at least one special character.",
        "currentPasswordIncorrect": "Current password is incorrect.",
        "passwordTooWeak": "Password is too weak. It must contain uppercase, lowercase, number, and special character.",
        "emailAlreadyInUse": "This email is already in use by another account.",
        "noPasswordSet": "No password set. Use password reset to set a password.",
        "passwordMustBeDifferent": "New password must be different from current password."
      },
      "success": {
        "profileUpdated": "Profile updated successfully.",
        "passwordChanged": "Password changed successfully.",
        "notificationSaved": "Notification setting saved."
      },
      "notFound": {
        "title": "Profile not found",
        "message": "Unable to load information about your profile."
      },
      "fields": {
        "firstName": "First name",
        "lastName": "Last name",
        "fullName": "Full name",
        "email": "Email",
        "emailVerifiedAt": "Email verified at",
        "role": "Role",
        "status": "Status",
        "memberSince": "Member since",
        "verified": "Verified",
        "notVerified": "Not verified",
        "yes": "Yes",
        "no": "No",
        "notAvailable": "N/A",
        "active": "Active",
        "inactive": "Inactive",
        "personalInformation": "Personal information"
      },
      "userStats": {
        "approvedRequests": "Approved requests",
        "processedDocs": "Processed documents",
        "averageResponseTime": "Average response time",
        "aiUsage": "AI assistance usage"
      },
      "billing": {
        "title": "Subscription",
        "description": "Manage your plan and payment method."
      },
      "personalInfo": {
        "title": "Personal Information",
        "description": "Manage your personal data and contact information"
      },
      "notificationsInfo": {
        "title": "Email notifications",
        "description": "Emails about document approvals. Each event can be switched off entirely or for some document kinds only.",
        "reminderInterval": {
          "label": "How often to send reminders",
          "every_one": "Every",
          "every_other": "Every",
          "days_one": "day",
          "days_other": "days",
          "invalid": "The interval must be a whole number from 1 to 365."
        }
      },
      "tappeerEmails": {
        "title": "E-mails from Tappeer",
        "creditUsage": {
          "title": "Credit usage alerts",
          "description": "When the organization uses 80% and 100% of its credits."
        },
        "creditRenewal": {
          "title": "Credit renewal",
          "description": "At the start of each period with new credits."
        },
        "marketing": {
          "title": "Tips and news",
          "description": "How to get more out of Tappeer, a monthly summary and news.",
          "success": {
            "granted": "You'll get tips and news.",
            "withdrawn": "You won't get tips and news any more."
          }
        },
        "essential": {
          "title": "Sign-in, invitations, approvals and payments",
          "description": "Tappeer can't be used without them, so they can't be turned off."
        }
      },
      "securityInfo": {
        "title": "Account Security",
        "description": "Manage your password and security settings",
        "currentPassword": "Current password",
        "currentPasswordPlaceholder": "Enter your current password",
        "newPassword": "New password",
        "newPasswordPlaceholder": "Enter your new password",
        "confirmPassword": "Confirm password",
        "confirmPasswordPlaceholder": "Confirm your new password",
        "changePasswordButton": "Change password",
        "changingPassword": "Changing..."
      },
      "account": {
        "title": "Account information",
        "fields": {
          "name": "Organization name",
          "status": "Account status",
          "createdAt": "Account created",
          "accountId": "Account ID"
        }
      }
    },
    "billing": {
      "success": {
        "title": "Payment successful!",
        "description": "Your new plan is now active. You now have access to all features.",
        "invoiceNotice": "An invoice will arrive in your email shortly. You can also find it in the Invoices tab.",
        "viewSubscription": "View subscription",
        "processingTitle": "Confirming your payment…",
        "processingDescription": "This usually takes just a moment.",
        "pendingTitle": "Payment is being processed",
        "pendingDescription": "Your payment was received and your plan will be activated within a few moments. You can check your subscription now."
      },
      "cancel": {
        "title": "Payment cancelled",
        "description": "The payment was cancelled. Your current plan remains unchanged.",
        "tryAgain": "Try again",
        "backToAccount": "Go to my account"
      }
    },
    "systemSettings": {
      "documentOutput": {
        "identitySource": "Company identification comes from the company profile.",
        "sections": {
          "PURCHASE_ORDER": {
            "title": "Purchase order",
            "description": "Texts and terms printed on purchase orders."
          }
        },
        "locales": {
          "cs": "Czech",
          "en": "English"
        },
        "terms": {
          "label": "Terms and conditions",
          "hint": "Printed after the order lines; longer text continues on the next page.",
          "placeholder": "For example: 1. Introductory provisions. These general terms of purchase govern the relationship between the buyer and the supplier…"
        },
        "footerNote": {
          "label": "Footer note",
          "hint": "Printed in the footer of every page, after the company identification.",
          "placeholder": "For example: This document was issued electronically. See www.example.com/privacy for how we process personal data."
        },
        "printsOther": {
          "cs": "The PDF will print the Czech text",
          "en": "The PDF will print the English text"
        },
        "tooLong": {
          "cs": "The Czech text is too long: it can have at most {{max}} characters.",
          "en": "The English text is too long: it can have at most {{max}} characters."
        },
        "save": "Save",
        "saving": "Saving…",
        "saveSuccess": "Settings saved.",
        "saveError": "Could not save the settings.",
        "loadError": "Could not load the generated document settings."
      },
      "comingSoon": "Coming soon",
      "automation": {
        "lifecycle": {
          "description": "A document goes through these steps. Pick a step to set up its automation.",
          "invoice": "Invoice",
          "requisition": "Requisition",
          "purchaseOrder": "Purchase order",
          "enabled": "Enabled",
          "enabledWithoutAi": "Enabled (without AI)",
          "aiAndUser": "AI + user",
          "userOnly": "User approves",
          "skipped": "Skipped",
          "disabled": "Disabled",
          "manual": "Manual",
          "alwaysOn": "Always on",
          "byIntegration": "Per integration",
          "integrationSettings": "Integration settings",
          "backToOverview": "Back to the automation overview",
          "readOnly": "You can view the automation settings. Only someone who manages the rules can change them.",
          "steps": {
            "invoiceInput": "Document input",
            "requisitionInput": "Requisition creation",
            "purchaseOrderInput": "Purchase order creation",
            "purchaseOrder": {
              "validation": {
                "title": "Validation",
                "short": "Validation",
                "description": "Checks the completeness and correctness of the purchase order"
              },
              "approval": {
                "title": "Automatic approval",
                "short": "Approval",
                "description": "AI approves the order or hands it to an approver"
              },
              "closure": {
                "title": "Completion",
                "short": "Completion",
                "description": "When the order completes automatically"
              }
            },
            "requisition": {
              "validation": {
                "title": "Validation",
                "short": "Validation",
                "description": "Checks the completeness and correctness of the requisition"
              },
              "approval": {
                "title": "Automatic approval",
                "short": "Approval",
                "description": "AI evaluates the requisition against the approval policy"
              },
              "ordering": {
                "title": "Purchase order creation",
                "short": "Order",
                "description": "An approved requisition becomes a draft purchase order"
              },
              "closure": {
                "title": "Completion",
                "short": "Completion",
                "description": "When the requisition completes automatically"
              }
            },
            "extraction": {
              "title": "Extraction",
              "short": "Extraction",
              "description": "AI data extraction from the document"
            },
            "autofill": {
              "title": "Missing field calculation",
              "short": "Field autofill",
              "description": "Fills fields derivable from the other values",
              "note": "Missing field calculation has no settings of its own yet."
            },
            "matching": {
              "title": "Line matching",
              "short": "Matching",
              "description": "Pairs invoice lines with purchase order lines"
            },
            "validation": {
              "title": "Validation",
              "short": "Validation",
              "description": "Checks the completeness and correctness of the data"
            },
            "approval": {
              "title": "Automatic approval",
              "short": "Approval",
              "description": "AI evaluates the invoice against the approval policy"
            },
            "export": {
              "title": "Export",
              "short": "Export",
              "description": "Hand-off to the accounting system",
              "note": "Export follows the connected accounting system. Set it up in Integrations."
            },
            "closure": {
              "title": "Completion",
              "short": "Completion",
              "description": "When the invoice completes"
            }
          }
        },
        "validation": {
          "title": "Invoice validation",
          "description": "Validation runs automatically after every invoice change and its result determines the document status.",
          "loadError": "Failed to load the validation settings.",
          "standard": {
            "title": "Standard validation",
            "badge": "always on",
            "description": "Completeness and correctness of the data per the validation rules — legal essentials, required fields, identifier formats, amount calculations, duplicates",
            "linkedSupplier": {
              "title": "Require a supplier from the company directory",
              "description": "A received invoice cannot be sent for approval until its supplier is linked to a company in the directory."
            }
          },
          "paymentSecurity": {
            "title": "Payment security checks",
            "description": "Check of the supplier's solvency and payment details",
            "unreliablePayer": {
              "title": "Flag an unreliable VAT payer",
              "description": "Raises a warning when the supplier is an unreliable VAT payer"
            },
            "bankAccount": {
              "title": "Supplier bank account check",
              "label": "Check mode",
              "options": {
                "USED_OR_PUBLISHED": {
                  "label": "Account was used, or is published",
                  "description": "Raises a warning when the account is on no approved invoice from the supplier and not among the published accounts"
                },
                "PUBLISHED_ONLY": {
                  "label": "The account must be published",
                  "description": "Raises a warning when the account is not among the supplier's published accounts"
                },
                "USED_ONLY": {
                  "label": "Account is on an approved invoice from this supplier",
                  "description": "Raises a warning when the account is on no approved invoice from this supplier"
                },
                "VERIFIED_ONLY": {
                  "label": "Account is verified by two signatures",
                  "description": "Raises a warning when the account on the invoice is not among the supplier's accounts verified by two signatures"
                }
              },
              "foreignNotice": "Published accounts can be looked up only for suppliers from Czechia and Slovakia. For all other suppliers, only the use of the same account on an already approved invoice is verified."
            }
          },
          "ai": {
            "title": "AI validation",
            "description": "The AI assesses the factual soundness of the invoice against the brief below and adds its findings to the validation result. Write the brief as clear bullet points.",
            "prompt": {
              "label": "AI validation brief"
            }
          },
          "save": "Save",
          "saving": "Saving…",
          "saveSuccess": "The AI validation brief has been saved.",
          "saveError": "Failed to save the settings.",
          "resetConfirm": {
            "title": "Restore the default brief?",
            "message": "The current AI validation brief will be overwritten by the default one. This cannot be undone.",
            "confirm": "Restore the default brief",
            "cancel": "Cancel"
          },
          "reset": "Restore the default brief",
          "resetting": "Restoring…",
          "resetSuccess": "The default brief was restored.",
          "resetError": "Failed to restore the default brief.",
          "preview": {
            "title": "Try it on an invoice",
            "description": "Run the AI validation as a dry-run — you will see the findings it would add to the validation result. The invoice is not changed.",
            "resultTitle": "Dry-run result",
            "close": "Close the result",
            "unsavedChanges": "Save the settings before trying them on an invoice.",
            "running": "Evaluating…",
            "error": "The evaluation could not be completed. Please try again.",
            "noFindings": "No findings",
            "findingsCount": "Findings: {{count}}",
            "confidence": "Confidence: {{value}} %",
            "severityError": "Error",
            "severityWarning": "Warning"
          }
        },
        "extraction": {
          "title": "Document data extraction",
          "description": "The first processing step. The AI reads the document and extracts its data.",
          "loadError": "Failed to load the extraction settings.",
          "saveError": "Failed to save the extraction settings.",
          "autoExtract": {
            "label": "Automatic extraction",
            "description": "Enabled: every incoming document is extracted as soon as it is uploaded or arrives by email. Manual: the document waits on its detail page until you start the extraction — it draws no credits until then.",
            "on": "Enabled",
            "off": "Manual"
          }
        },
        "autofill": {
          "title": "Missing invoice field calculation",
          "description": "Runs after a document is extracted. Fields that are missing on the scan or were not extracted, and can be derived with certainty from the other values, are filled in automatically. Filled values never overwrite extracted data and are traceable in the invoice history.",
          "loadError": "Failed to load the autofill settings.",
          "lineAmounts": {
            "label": "Line item amounts",
            "description": "Fills the missing line item totals — Total excl. VAT, Total incl. VAT and VAT amount — when they can be derived from the other values on the line (e.g. quantity and unit price)."
          },
          "enabled": {
            "on": "Enabled",
            "off": "Disabled"
          },
          "accountingTotals": {
            "label": "Total amounts in the accounting currency",
            "description": "Calculates the invoice total amounts in the organization's accounting currency using the selected exchange rate."
          },
          "rateSource": {
            "label": "Exchange rate for the conversion",
            "options": {
              "INVOICE_ONLY": {
                "label": "Only the rate stated on the invoice",
                "description": "The conversion runs only when the invoice states an exchange rate. Without a rate the amounts are not filled."
              },
              "INVOICE_THEN_EXTERNAL": {
                "label": "Invoice rate, otherwise CNB/ECB",
                "description": "The rate stated on the invoice takes priority. When missing, the official CNB (for CZK) or ECB rate for the tax date — or the issue date — is used."
              },
              "EXTERNAL_ALWAYS": {
                "label": "Always the current CNB/ECB rate",
                "description": "The official CNB (for CZK) or ECB rate for the tax date — or the issue date — is always used. A rate stated on the invoice is overwritten by the calculation."
              }
            }
          },
          "saveError": "Failed to save the settings."
        },
        "invoiceClosure": {
          "title": "Invoice completion",
          "description": "The invoice is completed once every enabled condition holds. With no condition enabled it can only be completed by hand.",
          "loadError": "Failed to load the settings.",
          "saveError": "Failed to save the settings.",
          "approval": {
            "label": "The invoice must be approved"
          },
          "payment": {
            "label": "The invoice must be paid"
          },
          "posting": {
            "label": "The invoice must be posted",
            "noAccountingSystem": "An accounting system must be connected to learn whether an invoice was posted."
          },
          "archiving": {
            "title": "Archiving after completion",
            "description": "A completed invoice is archived after the number of days you set: it leaves the regular lists and overviews, is read-only and can be unarchived. Once archived, its completion state no longer changes automatically.",
            "days": {
              "label": "Days after completion",
              "hint": "With 0, the invoice is archived as soon as it is completed.",
              "invalid": "The number of days must be a whole number from 0 to {{max}}.",
              "unit": "days"
            }
          },
          "summary": {
            "approved": "Approved",
            "paid": "paid",
            "paidOnly": "Paid",
            "manual": "Manual only",
            "posted": "posted",
            "postedOnly": "Posted"
          }
        },
        "requisitionApproval": {
          "title": "Requisition approval",
          "loadError": "Failed to load the approval settings.",
          "enabled": {
            "on": "Enabled",
            "off": "Disabled"
          },
          "orgStructureWarning": {
            "title": "The organisation structure is incomplete",
            "message": "Approval needs a configured organisation structure. Without a unit assignment a user's superiors cannot be determined.",
            "usersLabel": "Approvers without an assigned position:"
          },
          "prompt": {
            "label": "Approval policy"
          },
          "save": "Save",
          "saving": "Saving…",
          "saveSuccess": "The approval policy has been saved.",
          "saveError": "Failed to save the settings.",
          "resetConfirm": {
            "title": "Restore the default policy?",
            "message": "The approval policy and the switch return to their defaults. The approver chain is kept.",
            "confirm": "Restore the default policy",
            "cancel": "Cancel"
          },
          "reset": "Restore the default policy",
          "resetting": "Restoring…",
          "resetSuccess": "Default policy restored.",
          "resetError": "Failed to restore the default policy.",
          "preview": {
            "title": "Try it on a requisition",
            "description": "A trial evaluation against the approval policy, without the confidence bar; the requisition status does not change.",
            "resultTitle": "Dry-run result",
            "close": "Close the result",
            "unsavedChanges": "Save the settings before trying them on a requisition.",
            "running": "Evaluating…",
            "error": "The evaluation could not be completed. Please try again.",
            "confidence": "Decision confidence: {{value}} %",
            "wouldSet": "An automated run would move the requisition to \"{{status}}\".",
            "proposedApprover": "Proposed approver: {{name}}",
            "unknownApprover": "unknown user",
            "noSuitableCandidate": "The policy named no approver; the chosen approver chain decides."
          },
          "fallback": {
            "strategyLabel": "Chain",
            "userLabel": "User",
            "orgUnitLabel": "Unit",
            "roleLabel": "Role",
            "userPlaceholder": "Select a user",
            "orgUnitPlaceholder": "Select a unit",
            "orgStructureLink": "Org structure settings",
            "rolePlaceholder": "Select a role",
            "missingChoice": {
              "USER": "The chosen chain requires a user.",
              "ORG_UNIT": "The chosen chain requires a unit.",
              "ROLE": "The chosen chain requires a role."
            },
            "issue": {
              "USER_CANNOT_APPROVE": "The chosen user has no permission to approve documents",
              "UNIT_HAS_NO_APPROVER": "Nobody in the chosen unit has the permission to approve documents",
              "ROLE_HAS_NO_APPROVER": "Nobody holding the chosen role has the permission to approve documents",
              "body": "The settings cannot be stored. The permission to approve is granted by a user’s role.",
              "usersLink": "User settings"
            },
            "strategies": {
              "MANUAL_APPROVER_SELECTION": "No approver is named automatically. A user picks one on the document.",
              "ANYONE_WITH_PERMISSION": "The document goes to everybody who may approve it; one approval from any of them is enough.",
              "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the requester’s unit and the heads of its parent units.",
              "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to the chosen user.",
              "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the chosen unit and the heads of its parent units.",
              "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody in the chosen unit; one approval is enough.",
              "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the unit stated on the document and the heads of its parent units. When the document names no unit, this step is skipped.",
              "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody holding the chosen role; one approval is enough.",
              "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to the approver suggested on it; the “Suggested approver” field is mandatory on the document under this chain."
            }
          },
          "flow": {
            "master": "Approve requisitions",
            "aiStep": "The AI reviews the requisition against the policy",
            "branchNotMet": "does not meet it → the AI picks the approver if the policy says who gets the requisition; otherwise step 2 follows",
            "chainLeadAi": "If the AI neither approves the requisition nor hands it to anyone, it goes to",
            "chainLeadUser": "The requisition goes to",
            "recipientNone": "the requisition is left without an approver",
            "end": "An approved requisition moves on to ordering",
            "selfApproval": {
              "label": "Whoever submitted the requisition for approval cannot approve it",
              "hint": "Applies to every step above. The user who submitted the requisition never becomes its approver, even when the AI or the procedure names them or they are the fallback user."
            }
          }
        },
        "purchaseOrderApproval": {
          "title": "Purchase order approval",
          "loadError": "Failed to load the approval settings.",
          "enabled": {
            "on": "Enabled",
            "off": "Disabled"
          },
          "orgStructureWarning": {
            "title": "The organisation structure is incomplete",
            "message": "Approval needs a configured organisation structure. Without a unit assignment a user's superiors cannot be determined.",
            "usersLabel": "Approvers without an assigned position:"
          },
          "prompt": {
            "label": "Approval policy"
          },
          "save": "Save",
          "saving": "Saving…",
          "saveSuccess": "The approval policy has been saved.",
          "saveError": "Failed to save the settings.",
          "resetConfirm": {
            "title": "Restore the default policy?",
            "message": "The approval policy and the switch return to their defaults. The approver chain is kept.",
            "confirm": "Restore the default policy",
            "cancel": "Cancel"
          },
          "reset": "Restore the default policy",
          "resetting": "Restoring…",
          "resetSuccess": "The default policy was restored.",
          "resetError": "Failed to restore the default policy.",
          "preview": {
            "title": "Try on a purchase order",
            "description": "A trial evaluation against the approval policy, without the confidence bar; the purchase order status does not change.",
            "resultTitle": "Dry-run result",
            "close": "Close the result",
            "unsavedChanges": "Save the settings before trying them.",
            "running": "Evaluating…",
            "error": "The evaluation could not be completed. Please try again.",
            "confidence": "Decision confidence: {{value}} %",
            "wouldSet": "An automatic run would move the purchase order to \"{{status}}\".",
            "proposedApprover": "Proposed approver: {{name}}",
            "unknownApprover": "unknown user",
            "noSuitableCandidate": "The policy named no approver; the chosen approver chain decides."
          },
          "fallback": {
            "strategyLabel": "Chain",
            "userLabel": "User",
            "orgUnitLabel": "Unit",
            "roleLabel": "Role",
            "userPlaceholder": "Select a user",
            "orgUnitPlaceholder": "Select a unit",
            "orgStructureLink": "Org structure settings",
            "rolePlaceholder": "Select a role",
            "missingChoice": {
              "USER": "The chosen chain requires a user.",
              "ORG_UNIT": "The chosen chain requires a unit.",
              "ROLE": "The chosen chain requires a role."
            },
            "issue": {
              "USER_CANNOT_APPROVE": "The chosen user has no permission to approve documents",
              "UNIT_HAS_NO_APPROVER": "Nobody in the chosen unit has the permission to approve documents",
              "ROLE_HAS_NO_APPROVER": "Nobody holding the chosen role has the permission to approve documents",
              "body": "The settings cannot be stored. The permission to approve is granted by a user’s role.",
              "usersLink": "User settings"
            },
            "strategies": {
              "MANUAL_APPROVER_SELECTION": "No approver is named automatically. A user picks one on the document.",
              "ANYONE_WITH_PERMISSION": "The document goes to everybody who may approve it; one approval from any of them is enough.",
              "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the requester’s unit and the heads of its parent units.",
              "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to the chosen user.",
              "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the chosen unit and the heads of its parent units.",
              "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody in the chosen unit; one approval is enough.",
              "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the unit stated on the document and the heads of its parent units. When the document names no unit, this step is skipped.",
              "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody holding the chosen role; one approval is enough.",
              "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to the approver suggested on it; the “Suggested approver” field is mandatory on the document under this chain."
            }
          },
          "flow": {
            "master": "Approve purchase orders",
            "aiStep": "The AI reviews the purchase order against the policy",
            "branchNotMet": "does not meet it → the AI picks the approver if the policy says who gets the purchase order; otherwise step 2 follows",
            "chainLeadAi": "If the AI neither approves the purchase order nor hands it to anyone, it goes to",
            "chainLeadUser": "The purchase order goes to",
            "recipientNone": "the purchase order is left without an approver",
            "end": "An approved purchase order moves on to completion",
            "selfApproval": {
              "label": "Whoever submitted the purchase order for approval cannot approve it",
              "hint": "Applies to every step above. The user who submitted the purchase order never becomes its approver, even when the AI or the procedure names them or they are the fallback user."
            }
          }
        },
        "purchaseOrderValidation": {
          "title": "Purchase order validation",
          "description": "Validation runs after every change of the purchase order. Only an order without errors can be submitted; warnings must be accepted by a person.",
          "standard": {
            "title": "Standard validation",
            "badge": "always active",
            "description": "Completeness and correctness of the data by the validation rules. It has no settings of its own."
          }
        },
        "purchaseOrderPicker": {
          "searchPlaceholder": "Search purchase orders by number, title or supplier…",
          "noResults": "No purchase orders found."
        },
        "requisitionValidation": {
          "title": "Requisition validation",
          "description": "Validation runs automatically after every change of the requisition. Only a requisition without errors and warnings can be submitted for approval.",
          "standard": {
            "title": "Standard validation",
            "badge": "always active",
            "description": "Completeness and correctness of the data by the validation rules — requisition number, at least one line, line description and quantity. It has no settings of its own."
          }
        },
        "requisitionPicker": {
          "searchPlaceholder": "Search requisitions by number, title or supplier…",
          "noResults": "No requisitions found."
        },
        "purchaseOrderClosure": {
          "title": "Purchase order completion",
          "description": "The order is completed once it meets every condition that is switched on. Completion is not a status of its own — the order keeps its status and is marked completed as well. A manually completed order is never reopened by the automation.",
          "loadError": "Failed to load the settings.",
          "saveError": "Failed to save the settings.",
          "baseStatus": {
            "APPROVED": "The order must be approved",
            "DISPATCHED": "The order must be sent to the supplier"
          },
          "delivery": {
            "label": "The order must be delivered",
            "description": "Every line is delivered. Services are not delivered; they count as delivered once invoiced."
          },
          "invoicing": {
            "label": "The order must be invoiced",
            "description": "Every line is invoiced."
          },
          "archiving": {
            "title": "Archiving after completion",
            "description": "A completed document is archived after the number of days you set: it leaves the regular lists and overviews, is read-only and can be unarchived. Once archived, its completion state no longer changes automatically.",
            "days": {
              "label": "Days after completion",
              "hint": "With 0, the document is archived as soon as it is completed.",
              "invalid": "The number of days must be a whole number from 0 to {{max}}.",
              "unit": "days"
            }
          },
          "summary": {
            "APPROVED": "Approved",
            "DISPATCHED": "Sent",
            "delivered": "delivered",
            "invoiced": "invoiced"
          }
        },
        "requisitionClosure": {
          "title": "Requisition completion",
          "description": "The requisition is completed once it meets every condition that is switched on. Completion is not a status of its own — the requisition keeps its status and is marked completed as well. A manually completed requisition is never reopened by the automation.",
          "loadError": "Failed to load the settings.",
          "saveError": "Failed to save the settings.",
          "baseStatus": {
            "APPROVED": "The requisition must be approved",
            "ORDERED": "The requisition must be ordered"
          },
          "delivery": {
            "label": "The requisition must be delivered",
            "description": "Every ordered line is delivered. Services are not delivered; they count as delivered once invoiced."
          },
          "invoicing": {
            "label": "The requisition must be invoiced",
            "description": "Every ordered line is invoiced."
          },
          "archiving": {
            "title": "Archiving after completion",
            "description": "A completed document is archived after the number of days you set: it leaves the regular lists and overviews, is read-only and can be unarchived. Once archived, its completion state no longer changes automatically.",
            "days": {
              "label": "Days after completion",
              "hint": "With 0, the document is archived as soon as it is completed.",
              "invalid": "The number of days must be a whole number from 0 to {{max}}.",
              "unit": "days"
            }
          },
          "summary": {
            "APPROVED": "Approved",
            "ORDERED": "Ordered",
            "delivered": "delivered",
            "invoiced": "invoiced"
          }
        },
        "requisitionOrdering": {
          "title": "Purchase order from a requisition",
          "description": "Once a requisition is approved a draft purchase order is raised. The supplier is carried over from the requisition when it suggests one; otherwise the buyer names it on the order.",
          "loadError": "Failed to load the settings.",
          "autoOrder": {
            "label": "Raise purchase orders from approved requisitions automatically",
            "description": "The order stays a draft; the buyer sends it."
          },
          "saveError": "Failed to save the settings."
        },
        "matching": {
          "title": "Line matching",
          "description": "Invoice lines are matched to purchase order lines automatically by code, EAN or description whenever the invoice is saved and after a goods receipt. An unambiguous match is confirmed on its own; a disputed one awaits a decision.",
          "ai": {
            "title": "AI matching",
            "description": "Completing the matching with AI"
          },
          "loadError": "Failed to load the automation settings.",
          "enabled": {
            "on": "Enabled",
            "off": "Disabled"
          },
          "tools": {
            "title": "What the AI can access",
            "description": "During the review the AI loads this data on its own:"
          },
          "saveError": "Failed to save the settings."
        },
        "title": "Invoice approval",
        "loadError": "Failed to load the automation settings.",
        "enabled": {
          "on": "Enabled",
          "off": "Disabled"
        },
        "prompt": {
          "label": "Approval policy",
          "description": "The rules the AI applies. Write them as clear bullet points — e.g. amount limits or supplier requirements."
        },
        "save": "Save",
        "saving": "Saving…",
        "saveSuccess": "The approval policy has been saved.",
        "saveError": "Failed to save the settings.",
        "resetConfirm": {
          "title": "Restore default settings?",
          "message": "The current approval policy and the switch state will be overwritten by the defaults. This cannot be undone.",
          "confirm": "Restore the defaults",
          "cancel": "Cancel"
        },
        "reset": "Restore the default policy",
        "resetting": "Restoring…",
        "resetSuccess": "Default settings restored.",
        "resetError": "Failed to restore the default settings.",
        "help": {
          "title": "Help",
          "open": "Help",
          "decisionTitle": "How the automation decides",
          "toolsTitle": "What the AI can access ({{count}})",
          "toolsDescription": "During the evaluation the AI loads this data on its own:",
          "writingRulesTitle": "What the policy has to contain",
          "writingInstructionsTitle": "What the task has to contain",
          "examplesTitle": "Examples",
          "demonstrates": "What it shows:",
          "loadError": "Failed to load the help.",
          "close": "Close"
        },
        "invoicePicker": {
          "searchPlaceholder": "Search invoices by number or supplier…",
          "noResults": "No invoices found."
        },
        "preview": {
          "title": "Try it on an invoice",
          "description": "Run a dry-run evaluation — see how the AI would decide. The invoice status does not change.",
          "resultTitle": "Dry-run result",
          "close": "Close the result",
          "unsavedChanges": "Save the settings before trying them on an invoice.",
          "running": "Evaluating…",
          "error": "The evaluation could not be completed. Please try again.",
          "confidence": "Decision confidence: {{value}} %",
          "wouldSet": "An automated run would move the invoice to \"{{status}}\".",
          "proposedApprover": "{{name}} would be chosen as the approver.",
          "unknownApprover": "an unknown user",
          "anyApprover": "Everybody who may approve would be asked.",
          "noSuitableCandidate": "The approver would be determined by the procedure set below."
        },
        "fallback": {
          "strategyLabel": "Procedure",
          "userLabel": "User",
          "userPlaceholder": "Select a user",
          "orgUnitLabel": "Org unit",
          "orgUnitPlaceholder": "Select an org unit",
          "orgStructureLink": "Org structure settings",
          "roleLabel": "Role",
          "rolePlaceholder": "Select a role",
          "issue": {
            "USER_CANNOT_APPROVE": "The chosen user has no permission to approve documents",
            "UNIT_HAS_NO_APPROVER": "Nobody in the chosen unit has the permission to approve documents",
            "ROLE_HAS_NO_APPROVER": "Nobody holding the chosen role has the permission to approve documents",
            "body": "The settings cannot be stored. The permission to approve is granted by a user’s role.",
            "usersLink": "User settings"
          },
          "missingChoice": {
            "USER": "The chosen chain requires a user.",
            "ORG_UNIT": "The chosen chain requires a unit.",
            "ROLE": "The chosen chain requires a role."
          },
          "strategies": {
            "MANUAL_APPROVER_SELECTION": "No approver is named automatically. A user picks one on the document.",
            "ANYONE_WITH_PERMISSION": "The document goes to everybody who may approve it; one approval from any of them is enough.",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the requester’s unit and the heads of its parent units.",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to the chosen user.",
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "The approver is sought among the head of the chosen unit and the heads of its parent units.",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody in the chosen unit; one approval is enough.",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "The document is handed to everybody holding the chosen role; one approval is enough."
          }
        },
        "flow": {
          "master": "Approve invoices",
          "aiStep": "The AI reviews the invoice against the policy",
          "branchNotMet": "does not meet it → the AI picks the approver if the policy says who gets the invoice; otherwise step 2 follows",
          "chainLeadAi": "If the AI neither approves the invoice nor hands it to anyone, it goes to",
          "chainLeadUser": "The invoice goes to",
          "recipientNone": "the invoice is left without an approver",
          "end": "An approved invoice moves on to export",
          "selfApproval": {
            "label": "Whoever submitted the invoice for approval cannot approve it",
            "hint": "Applies to every step above. The user who submitted the invoice never becomes its approver, even when the AI or the procedure names them or they are the fallback user."
          }
        },
        "approvalFlow": {
          "edit": "Edit",
          "show": "Show",
          "candidatesLoadError": "Failed to load who may approve. The approval chain cannot be changed right now. Try reloading the page.",
          "skipped": "Approval is skipped. A submitted document is approved at once and moves on to the next <link>step</link>.",
          "branchMet": "meets the policy → <b>approved</b>",
          "fallbackLead": {
            "USER": "If no approver is found there either, it goes to",
            "OWNER_PICKS": "If no approver is found there either,",
            "NONE": "If no approver is found there either,"
          },
          "recipientChip": {
            "USER": "the user {{name}}",
            "OWNER_PICKS": "the creator picks the approver"
          },
          "recipient": {
            "label": "Who gets the document",
            "userDescription": "Fallback user",
            "OWNER_PICKS": "The creator picks the approver",
            "NONE": "No approver",
            "fixedDescription": "No fallback user"
          },
          "strategyChip": {
            "MANUAL_APPROVER_SELECTION": "the approver the creator picks",
            "ANYONE_WITH_PERMISSION": "every user who may approve",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "the head of the requester’s position",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION_invoice": "the head of the creator’s position",
            "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "the head of the position on the document",
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "the head of the position {{orgUnit}}",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "the members of the position {{orgUnit}}",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "the users with the role {{role}}",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "the user {{user}}",
            "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "the approver suggested on the document"
          },
          "strategyChipUnpicked": {
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "the head of the chosen position",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "the members of the chosen position",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "the users with the chosen role",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "the chosen user"
          }
        }
      },
      "payments": {
        "hero": {
          "myPlan": "My plan",
          "myPlanLimit": "{{count}} documents/month",
          "myPlanCredits_one": "{{credits}} credit/month",
          "myPlanCredits_other": "{{credits}} credits/month",
          "billing": "Billing",
          "billingMonthly": "{{amount}} {{currency}} billed monthly",
          "billingFree": "Free forever",
          "credits": "Documents extracted",
          "creditsUsage": "{{used}} / {{limit}} documents used ({{pct}} %)",
          "creditsUnlimited": "Unlimited",
          "overageProgress": "+ {{used}} / {{capacity}} overage",
          "overageAriaLabel": "Overage usage",
          "overageCost": "Charge {{cost}} {{currency}}"
        },
        "quotaSection": "Documents Extracted",
        "quota": {
          "label": "Documents extracted this billing cycle",
          "resetsOn": "Resets on {{date}}",
          "progressAriaLabel": "Extraction quota: {{label}}",
          "limitReached": "⚠ Monthly limit reached",
          "overageNotification": {
            "title": "Monthly limit exceeded",
            "message": "You have exceeded your monthly limit. You will be billed for {{count}} extra documents this month.",
            "messageWithRemaining": "You have exceeded your monthly limit. You will be billed for {{count}} extra documents. {{remaining}} more can still be processed before the cap."
          },
          "excessCount": "Extractions over limit: {{count}}",
          "currentPlan": "Current plan: {{name}} ({{amount}} {{currency}} / month)"
        },
        "allPlans": {
          "title": "Available Plans",
          "description": "Choose a plan that fits your needs.",
          "monthly": "Monthly",
          "yearly": "Yearly"
        },
        "planCard": {
          "currentPlan": "Current plan",
          "documentsPerMonth": "documents/month",
          "creditsPerMonth_one": "credit/month",
          "creditsPerMonth_other": "credits/month",
          "overageAllowed": "Overage allowed",
          "perMonth": "/month",
          "perYear": "/year",
          "selectPlan": "Select plan",
          "upgrading": "Processing…",
          "noPriceForInterval": "Not available for this billing interval",
          "cancelSubscription": "Cancel subscription",
          "upgrade": "Upgrade",
          "scheduleDowngrade": "Schedule change",
          "cancelScheduledChange": "Cancel scheduled change",
          "unavailable": "Not available"
        },
        "cancelSubscription": {
          "heroButton": "Cancel subscription",
          "processing": "Processing…",
          "scheduled": {
            "title": "Subscription will be cancelled",
            "description": "Your subscription ends on {{date}}. You will then move to the free plan.",
            "resume": "Resume subscription"
          },
          "modal": {
            "title": "Cancel subscription?",
            "bodyWithDate": "Your subscription will end on {{date}}. Until then everything stays the same. After that you will move to the free plan ({{freeLimit}} documents/month).",
            "bodyWithoutDate": "After the period ends you will move to the free plan ({{freeLimit}} documents/month).",
            "bodyWithDateCredits_one": "Your subscription will end on {{date}}. Until then everything stays the same. After that you will move to the free plan ({{credits}} credit/month).",
            "bodyWithDateCredits_other": "Your subscription will end on {{date}}. Until then everything stays the same. After that you will move to the free plan ({{credits}} credits/month).",
            "bodyWithoutDateCredits_one": "After the period ends you will move to the free plan ({{credits}} credit/month).",
            "bodyWithoutDateCredits_other": "After the period ends you will move to the free plan ({{credits}} credits/month).",
            "confirm": "Cancel subscription",
            "dismiss": "Keep subscription"
          }
        },
        "changePlan": {
          "processing": "Processing…",
          "dismiss": "Cancel",
          "upgrade": {
            "title": "Switch to plan \"{{plan}}\"?",
            "body": "New limits apply immediately. The price difference will appear on your next invoice.",
            "confirm": "Upgrade"
          },
          "downgrade": {
            "title": "Switch to plan \"{{plan}}\"?",
            "bodyWithDate": "Plan \"{{plan}}\" will activate on {{date}} (end of the current period). Until then you stay on your current plan.",
            "bodyWithoutDate": "Plan \"{{plan}}\" will activate at the end of the current period. Until then you stay on your current plan.",
            "confirm": "Schedule change"
          }
        },
        "scheduledPlanChange": {
          "title": "Plan change scheduled to \"{{plan}}\"",
          "description": "The new plan will activate on {{date}}.",
          "cancel": "Cancel change"
        },
        "portal": {
          "title": "Payment details",
          "description": "Update card, billing address or VAT ID in the Stripe Customer Portal.",
          "openButton": "Manage payment details",
          "opening": "Opening portal…",
          "error": "Could not open the portal. Please try again.",
          "unavailable": "Subscription management is temporarily unavailable. Please try again later."
        },
        "managedByMasterAccount": {
          "title": "Billing is managed by an office",
          "description": "Billing and payments for this account are managed by the office {{masterAccountName}}.",
          "quotaAvailable": "Documents can be uploaded for extraction.",
          "quotaExhausted": "The office {{masterAccountName}} has used up its extraction quota — please contact the office before uploading more documents.",
          "ownBooksQuotaExhausted": "The office {{masterAccountName}} has used up its extraction quota. Raise the office’s plan on the board under Plan & billing."
        },
        "pageDescription": "Manage your current plan, monitor document extraction usage, and configure overage settings.",
        "pageDescriptionCredits": "Manage your current plan, track your credit usage and buy more credits when you run out."
      },
      "invoices": {
        "loadOlder": "Load older",
        "loadOlderError": "Could not load older invoices. Please try again.",
        "loading": "Loading…",
        "empty": {
          "title": "Nothing here yet",
          "description": "As soon as an invoice is issued, it will appear here and in your email."
        },
        "table": {
          "number": "Number",
          "date": "Date",
          "status": "Status",
          "period": "Period",
          "plan": "Plan",
          "amount": "Amount",
          "pdf": "PDF",
          "download": "Download PDF"
        },
        "status": {
          "open": "Open",
          "paid": "Paid",
          "void": "Void",
          "uncollectible": "Uncollectible"
        }
      },
      "apiKeys": {
        "list": "Your API Keys",
        "fields": {
          "name": "Name",
          "description": "Description",
          "prefix": "Prefix",
          "key": "Key",
          "createdAt": "Created",
          "lastUsedAt": "Last Used",
          "expiresAt": "Expires",
          "rateLimit": "Limit",
          "status": "Status",
          "actions": "Actions",
          "roles": "Roles"
        },
        "placeholders": {
          "name": "e.g., Production API",
          "description": "Optional description of the key's purpose",
          "rateLimitHint": "Requests per minute (Default: 1000)"
        },
        "table": {
          "loading": "Loading API keys...",
          "error": "Error loading API keys",
          "empty": "You haven't created any API keys yet",
          "never": "Never"
        },
        "actions": {
          "generateNewKey": "Generate New Key",
          "viewApiDocs": "API documentation",
          "copyPrefix": "Copy prefix",
          "revoke": "Revoke key",
          "confirmRevoke": "Confirm revoke",
          "cancel": "Cancel",
          "editRoles": "Edit roles"
        },
        "status": {
          "active": "Active",
          "revoked": "Revoked",
          "generating": "Generating..."
        },
        "errors": {
          "nameRequired": "Name is required",
          "rateLimitInvalid": "Limit must be a positive number",
          "createError": "Error creating API key",
          "revokeError": "Error revoking API key",
          "loadError": "Error loading API keys",
          "updateRolesError": "Error updating API key roles"
        },
        "success": {
          "generated": "API Key Generated",
          "generateSuccess": "API key generated successfully",
          "revokeSuccess": "API key revoked successfully",
          "rolesUpdated": "API key roles updated"
        },
        "display": {
          "warningTitle": "Important",
          "warningMessage": "This key will only be shown once. Copy it now and store it securely. If you lose it, you'll need to generate a new one.",
          "yourKey": "Your Key",
          "copyKey": "Copy Key",
          "copied": "Copied",
          "close": "Close"
        },
        "editRoles": {
          "title": "Edit API key roles",
          "description": "Choose the roles of the key {{name}}. Roles decide what the key may do.",
          "save": "Save",
          "saving": "Saving...",
          "legacyRolesNote": "Saving removes roles that cannot be assigned to API keys: {{roles}}."
        }
      },
      "users": {
        "fields": {
          "email": "Email",
          "firstName": "First Name",
          "lastName": "Last Name",
          "displayName": "Full Name",
          "role": "Role",
          "status": "Status",
          "createdAt": "Created",
          "invitedAt": "Invited",
          "invitedBy": "Invited By",
          "expiresAt": "Expires",
          "actions": "Actions"
        },
        "placeholders": {
          "email": "e.g. john@company.com",
          "firstName": "e.g. John",
          "lastName": "e.g. Smith",
          "selectRole": "Select role"
        },
        "filter": {
          "searchPlaceholder": "Search by name or email...",
          "allRoles": "All roles",
          "allStatuses": "All statuses",
          "roleLabel": "Role",
          "statusLabel": "Status"
        },
        "table": {
          "loading": "Loading users...",
          "error": "Error loading users",
          "empty": "No users have been added yet",
          "you": "(you)",
          "systemUser": "System"
        },
        "orgUnit": {
          "label": "Position in the org structure (optional)",
          "choose": "Choose position",
          "change": "Change",
          "remove": "Remove",
          "pickerTitle": "Position in the org structure",
          "confirm": "Choose",
          "asManager": "Make them head of this position",
          "replacesHead": "Replaces the current head, {{name}}, once they accept the invitation.",
          "asManagerTag": "as head"
        },
        "actions": {
          "inviteUser": "Invite user",
          "edit": "Edit",
          "deactivate": "Deactivate",
          "reactivate": "Reactivate",
          "delete": "Delete",
          "resendInvitation": "Resend invitation",
          "cancelInvitation": "Cancel invitation",
          "cancel": "Cancel",
          "save": "Save"
        },
        "status": {
          "inviting": "Sending...",
          "updating": "Saving...",
          "deleting": "Deleting...",
          "pending": "Pending invitation"
        },
        "modals": {
          "invite": {
            "title": "Invite user",
            "description": "Enter the email and role of the new user. An invitation will be sent."
          },
          "edit": {
            "title": "Edit user",
            "description": "Change the name or role of the user.",
            "sharedIdentityNotice": "This user changes their own name and preferences in their profile, because they are also a member of another account or an accounting office."
          },
          "confirmDeactivate": {
            "title": "Deactivate user?",
            "message": "Are you sure you want to deactivate {{name}}? They won't be able to log in until reactivated.",
            "confirm": "Deactivate"
          },
          "confirmReactivate": {
            "title": "Reactivate user?",
            "message": "Are you sure you want to reactivate {{name}}? They will be able to log in again.",
            "confirm": "Reactivate"
          },
          "confirmDelete": {
            "title": "Delete user?",
            "message": "Are you sure you want to permanently delete {{name}}? This action cannot be undone.",
            "confirm": "Delete"
          },
          "confirmCancelInvitation": {
            "title": "Cancel invitation?",
            "message": "Are you sure you want to cancel the invitation for {{email}}?",
            "confirm": "Cancel invitation"
          }
        },
        "errors": {
          "loadError": "Failed to load users",
          "emailRequired": "Email is required",
          "emailInvalid": "Invalid email format",
          "roleRequired": "Role is required",
          "firstNameRequired": "First name is required",
          "lastNameRequired": "Last name is required",
          "inviteError": "Error sending invitation",
          "updateError": "Error updating user",
          "deactivateError": "Error deactivating user",
          "reactivateError": "Error reactivating user",
          "deleteError": "Error deleting user",
          "resendError": "Error resending invitation",
          "cancelError": "Error cancelling invitation",
          "cannotModifySelf": "You cannot change your own role or delete yourself",
          "lastAdmin": "At least one active administrator must remain in the organization."
        },
        "success": {
          "inviteSuccess": "Invitation sent successfully",
          "updateSuccess": "User updated successfully",
          "deactivateSuccess": "User deactivated successfully",
          "reactivateSuccess": "User reactivated successfully",
          "deleteSuccess": "User deleted successfully",
          "resendSuccess": "Invitation resent successfully",
          "cancelSuccess": "Invitation cancelled successfully"
        },
        "orgPositions": {
          "title": "Positions in the organizational structure",
          "empty": "The user is not in any position."
        }
      },
      "webhooks": {
        "fields": {
          "url": "URL Address",
          "authTitle": "Authentication Header",
          "headerName": "Header Name",
          "headerValue": "Header Value"
        },
        "placeholders": {
          "url": "https://example.com/webhook",
          "headerName": "e.g. X-Api-Key, Authorization",
          "headerValue": "Insert header value"
        },
        "hints": {
          "url": "HTTPS endpoint to which POST requests with a JSON payload will be sent.",
          "authToken": "The authentication header is securely stored and hidden after saving the form.",
          "activationLocked": "Save a valid URL address first to enable the webhook."
        },
        "status": {
          "label": "Webhook Status",
          "active": "Webhook is enabled and the system will send notifications to it",
          "inactive": "Webhook is disabled and the system will not send notifications to it"
        },
        "statusBadge": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "actions": {
          "save": "Save Configuration",
          "saving": "Saving...",
          "activate": "Activate",
          "activating": "Activating...",
          "togglingActive": "Changing status...",
          "deactivate": "Deactivate",
          "deactivating": "Deactivating...",
          "delete": "Delete",
          "deleting": "Deleting...",
          "deleteHeader": "Delete Auth Header",
          "clearUrl": "Clear URL",
          "testConnection": "Test Connection"
        },
        "modal": {
          "deleteConfirm": "Are you sure you want to delete the webhook configuration?",
          "deleteWarning": "This action cannot be undone.",
          "activateTitle": "Activate Webhook",
          "activateDescription": "The webhook will be activated and start sending event notifications to the configured endpoint.",
          "deactivateTitle": "Deactivate Webhook",
          "deactivateDescription": "The webhook will be deactivated and stop sending event notifications.",
          "confirm": "Confirm",
          "cancel": "Cancel"
        },
        "errors": {
          "urlRequired": "URL address is required",
          "urlRequiredForActivation": "Enter a valid URL address to activate the webhook",
          "urlInvalid": "Enter a valid URL address",
          "urlInvalidFormat": "Invalid URL format",
          "urlMissingProtocol": "URL must contain http:// or https:// protocol",
          "urlMissingHostname": "URL must contain a valid hostname",
          "urlNotAllowed": "This URL points to a private or internal address and cannot be used",
          "urlCredentials": "URL must not contain a user name or password. Enter credentials under “Authentication Header”",
          "headerValueTooLong": "The header value may have at most 500 characters",
          "headerValueInvalid": "The header value may contain only letters without accents, digits, spaces and common symbols, without line breaks",
          "saveError": "Failed to save webhook configuration",
          "deleteError": "Failed to delete webhook configuration",
          "loadError": "Failed to load webhook configuration"
        },
        "success": {
          "saveSuccess": "Webhook configuration was successfully saved",
          "deleteSuccess": "Webhook configuration was successfully deleted"
        }
      },
      "organization": {
        "loading": "Loading organization...",
        "error": "Failed to load organization data",
        "accountSection": {
          "title": "Account Management",
          "description": "Manage your organization account details and linked company"
        },
        "partySection": {
          "title": "Assigned Company",
          "description": "1:1 company record linked to this account"
        },
        "localizationSection": {
          "title": "Localization"
        },
        "fields": {
          "name": "Organization Name",
          "partyName": "Company Name",
          "companyId": "Company ID",
          "taxId": "Tax ID",
          "vatId": "VAT ID",
          "vatIdHint": "The number the subject is registered for VAT under. Identical to the Tax ID (DIČ) for most Czech companies.",
          "registryEntry": "Commercial register entry",
          "registryEntryHint": "Printed on issued documents. For example: Company registered in the Commercial Register kept by the Municipal Court in Prague, Section C, Insert 123456",
          "phone": "Phone",
          "email": "Email",
          "street": "Street",
          "buildingNumber": "No.",
          "city": "City",
          "postalCode": "ZIP",
          "accountingCurrencyCode": "Accounting Currency",
          "accountingCurrencyCodeHint": "Currency invoices are converted to (e.g. CZK)",
          "reportingCurrencyCode": "Reporting Currency",
          "reportingCurrencyCodeHint": "Currency for reports and exports. If left empty, the accounting currency is used.",
          "country": "Country Code",
          "language": "Language",
          "timezone": "Time Zone",
          "noParty": "No company assigned"
        },
        "localeOptions": {
          "CS": "Čeština",
          "EN": "English"
        },
        "actions": {
          "save": "Save Changes",
          "saving": "Saving...",
          "delete": "Delete Account",
          "cancel": "Cancel"
        },
        "feedback": {
          "saveSuccess": "Changes saved successfully",
          "saveError": "Failed to save changes",
          "deleteNotSupported": "Account deletion is not yet supported. Please contact support.",
          "noPartyToUpdate": "No company is assigned to this account, so its details cannot be edited. Please contact support."
        },
        "errors": {
          "nameRequired": "Organization name is required",
          "nameTooLong": "Name must be at most {{max}} characters",
          "partyNameTooLong": "Company name must be at most {{max}} characters",
          "icoTooLong": "Company ID must be at most {{max}} characters",
          "dicTooLong": "VAT ID must be at most {{max}} characters",
          "localeTooLong": "Currency code must be at most {{max}} characters",
          "registryEntryTooLong": "The register entry can have at most {{max}} characters",
          "accountNameTaken": "This organization name is already taken",
          "accountingCurrencyRequired": "Accounting currency is required"
        },
        "deleteAccount": {
          "title": "Delete this account",
          "hint": "The account and all its data are permanently deleted after a 30-day grace period.",
          "button": "Delete account",
          "confirmTitle": "Delete account?",
          "confirmMessage": "The account will be scheduled for deletion and everyone will be logged out.",
          "confirmWarning": "After 30 days the account and all its data are permanently erased. During that time you can restore it by logging back in.",
          "confirmButton": "Delete account",
          "cancelButton": "Cancel",
          "requestError": "The account could not be scheduled for deletion. Please try again later.",
          "needsDirectAdmin": "Only this organization's own administrator can request its deletion."
        },
        "masterAccountSection": {
          "title": "Office",
          "description": "As an office you can manage your clients' documents from one account.",
          "declareError": "Declaring the account an office failed",
          "action": "Declare an office",
          "declareDialog": {
            "title": "Declare the organisation an office?",
            "intro": "What happens:",
            "ownBooks": "This organisation becomes “My office accounting”. It keeps all its documents, e-mail address and integrations.",
            "masterAccountBoard": "A new office board is created, where you manage your clients. You become its office administrator.",
            "subscription": "The subscription moves to the office board.",
            "peopleTitle": "Who will work in the office?",
            "peopleHint": "Choose where each person belongs. A company employee stays in “My office accounting” only. An office member moves to the board as an office accountant.",
            "classificationLabel": "Classification: {{name}}",
            "masterAccountMemberWarningTitle": "Office members lose their current roles",
            "masterAccountMemberWarningBody": "In “My office accounting” they keep only the accountant role and lose any other, such as approver. Approvals waiting for them may need to be reassigned.",
            "peopleLoading": "Loading the organisation's people…",
            "peopleError": "The organisation's people could not be loaded. Close the dialog and try again.",
            "confirm": "Declare an office",
            "cancel": "Cancel"
          }
        },
        "leaveMasterAccount": {
          "title": "Office",
          "description": "This account is managed by the office {{masterAccountName}}.",
          "button": "Leave the office",
          "confirmTitle": "Leave the office?",
          "confirmMessage": "The account will stop being managed by {{masterAccountName}}. It will be assigned the default plan and start paying for itself. Its documents remain unchanged.",
          "confirmWarning": "This action cannot be undone.",
          "confirmButton": "Leave the office",
          "cancelButton": "Cancel",
          "success": "The account is no longer managed by an office",
          "error": "Leaving the office failed",
          "errorDetachNameTaken": "You cannot leave the office: another organization already uses the same name. Rename your organization in the settings first."
        },
        "hints": {
          "registryInfo": {
            "CZ": "Enter your company registration number (IČO) and we will load the name, registered address and VAT number from the ARES business register.",
            "SK": "Enter your company registration number (IČO) and we will load the name and registered address from the RPO business register. The register does not publish VAT numbers, so fill in your Tax ID (DIČ) and VAT ID yourself."
          }
        },
        "registry": {
          "CZ": {
            "label": "Load details by IČO or DIČ",
            "placeholder": "Enter IČO or DIČ"
          },
          "SK": {
            "label": "Load details by IČO",
            "placeholder": "Enter IČO"
          }
        },
        "masterAccountErrors": {
          "classificationInvalid": "The organisation's people changed in the meantime. Check how they are classified and confirm again.",
          "alreadyAMasterAccount": "This organisation is already an office.",
          "masterAccountDoesNotNest": "An organisation managed by an office cannot become an office itself.",
          "declareConflict": "The organisation's people changed in the meantime. Check how they are classified and try again.",
          "forbidden": "Only an active administrator of the organisation, signed in as themselves, can declare it an office.",
          "ownBooksIdentityReadOnly": "The office's details are edited on the office board."
        },
        "ownBooksIdentityNote": "The office's details are edited on the office board.",
        "logo": {
          "label": "Logo",
          "hint": "PNG or JPG, up to {{max}} MB. Printed on purchase orders.",
          "alt": "Organization logo",
          "none": "No logo uploaded.",
          "upload": "Upload logo",
          "replace": "Replace",
          "remove": "Remove",
          "cancel": "Cancel",
          "removeTitle": "Remove the logo?",
          "removeMessage": "Purchase orders will print without a logo.",
          "uploaded": "Logo uploaded.",
          "removed": "Logo removed.",
          "errors": {
            "wrongType": "The logo must be a PNG or JPG image.",
            "refused": "The logo must be a PNG or JPG image, at most {{px}} × {{px}} px.",
            "tooLarge": "The logo can be at most {{max}} MB.",
            "limitReached": "The organization already has a logo. To change it, choose “Replace”.",
            "busy": "The logo can't be uploaded right now. Please try again in a moment.",
            "tooSlow": "The connection is too slow to upload the logo. Please try again.",
            "uploadFailed": "The logo could not be uploaded. Please try again.",
            "removeFailed": "The logo could not be removed. Please try again."
          }
        }
      },
      "accountRelations": {
        "origin": {
          "CREATED": "Founded by the office",
          "TRANSFERRED": "Transferred to the office",
          "CONVERTED": "Converted when the office was set up"
        },
        "createModal": {
          "title": "New client",
          "subtitle": "Founds a new, empty client account under your office.",
          "icoLabel": "Load details by IČO",
          "icoPlaceholder": "Enter IČO",
          "nameLabel": "Client name",
          "namePlaceholder": "Enter client name",
          "cancel": "Cancel",
          "submit": "Create client",
          "creating": "Creating…",
          "success": "Client created",
          "error": {
            "generic": "Failed to create client",
            "limitReached": "The office has reached its plan's client limit. Contact support to raise the limit.",
            "notActive": "The office account must be active to manage clients.",
            "nameTaken": "A client with this name already exists in the office.",
            "rateLimit": "Too many attempts to create a client in a short time. Please try again shortly.",
            "notAMasterAccountAccountant": "The client was not created: one of the selected accountants is no longer an active accountant of the office. The list of accountants is updated — check the selection and try again."
          },
          "registryNotFound": "No company with this IČO was found in the register.",
          "registryUnavailable": "The register lookup failed. Please try again.",
          "accountants": {
            "label": "Accountants",
            "placeholder": "Select accountants (optional)",
            "hint": "The selected accountants get access to the client as soon as it is created.",
            "noAccountants": "The office has no accountants yet. You can assign them later.",
            "loadError": "The accountants could not be loaded. You can assign them later."
          }
        },
        "disconnectModal": {
          "title": "Disconnect client?",
          "message": "{{name}} will be disconnected from the office and will no longer be managed by this account.",
          "confirm": "Disconnect client",
          "cancel": "Cancel",
          "success": "Client disconnected",
          "error": {
            "generic": "Failed to disconnect the client",
            "detachNameTaken": "The organization cannot be disconnected: another organization already uses the same name. Rename it first.",
            "noOwnUsers": "The client cannot be disconnected because it has no active user of its own. You can delete a client the office founded; otherwise please contact support."
          }
        },
        "deleteModal": {
          "title": "Delete client?",
          "message": "{{name}} has no user of its own, so it cannot be disconnected. It will be scheduled for deletion and permanently deleted with all its data after a 30-day grace period. The office loses access to it immediately; until the period ends, only support can restore it.",
          "confirm": "Delete client",
          "cancel": "Cancel",
          "success": "Client scheduled for deletion",
          "error": {
            "generic": "Failed to delete the client",
            "hasOwnUsers": "The client has a user of its own by now. Please disconnect it instead of deleting it.",
            "needsSupport": "The office did not found this client, so it cannot delete it. Please contact support."
          }
        }
      },
      "mailbox": {
        "loading": "Loading mailbox settings…",
        "error": "Failed to load mailbox settings",
        "preview": "Preview:",
        "sections": {
          "currentMailbox": "Current Mailbox",
          "createMailbox": "Create Mailbox"
        },
        "fields": {
          "status": "Status",
          "emailAddress": "Email Address",
          "prefix": "Address Prefix",
          "prefixHint": "Lowercase letters, numbers and hyphens. At least 3 characters. A random suffix is added so the address cannot be guessed.",
          "entityType": "Invoice receiving address"
        },
        "placeholders": {
          "prefix": "e.g. invoices-acme"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "actions": {
          "create": "Create Mailbox",
          "creating": "Creating…",
          "activate": "Activate",
          "deactivate": "Deactivate",
          "delete": "Delete Mailbox",
          "copy": "Copy address to clipboard"
        },
        "deleteConfirm": {
          "message": "Are you sure? This action cannot be undone.",
          "confirm": "Yes, delete",
          "cancel": "Cancel"
        },
        "validation": {
          "required": "Prefix is required",
          "tooShort": "Prefix must be at least 3 characters",
          "tooLong": "Prefix cannot exceed 119 characters",
          "invalidFormat": "Only lowercase letters, numbers, and hyphens allowed. Cannot start or end with a hyphen.",
          "blacklisted": "This prefix is not allowed. Please choose a different one.",
          "alreadyConfigured": "Your account already has a mailbox configured."
        },
        "feedback": {
          "createSuccess": "Mailbox created successfully",
          "createError": "Failed to create mailbox",
          "enableSuccess": "Mailbox activated",
          "disableSuccess": "Mailbox deactivated",
          "toggleError": "Failed to change mailbox status",
          "deleteSuccess": "Mailbox deleted",
          "deleteError": "Failed to delete mailbox",
          "copied": "Email address copied to clipboard"
        },
        "hints": {
          "usage": "Forward invoices from your suppliers to this address. Attached PDF, ISDOC or Word files will be automatically extracted and turned into documents.",
          "createInfo": "Create a dedicated email address for receiving invoices. Your suppliers can send invoices directly to this address for automatic processing."
        },
        "quarantine": {
          "title": "Held emails",
          "description": "These emails claim to come from a domain that did not confirm the sender. Nothing has been processed and no extraction credit was used. Release only the ones you recognise.",
          "loading": "Loading held emails…",
          "error": "Could not load held emails",
          "noSubject": "(no subject)",
          "fields": {
            "sender": "Sender",
            "subject": "Subject",
            "receivedAt": "Received",
            "attachments": "Attachments",
            "actions": "Actions"
          },
          "actions": {
            "release": "Release",
            "discard": "Discard",
            "loadMore": "Load more"
          },
          "feedback": {
            "releaseSuccess": "Email released for processing",
            "releaseError": "Could not release the email",
            "discardSuccess": "Email discarded",
            "discardError": "Could not discard the email"
          }
        },
        "allowlist": {
          "title": "Trusted senders",
          "description": "Email from these senders is never held back, even when their domain does not confirm the sender. Enter a full address or just a domain.",
          "loading": "Loading the list…",
          "empty": "You have no trusted senders yet.",
          "error": "Could not load the sender list",
          "fields": {
            "value": "Address or domain",
            "valueHint": "For example invoices@supplier.com or supplier.com",
            "addedAt": "Added",
            "actions": "Actions"
          },
          "placeholders": {
            "value": "supplier.com"
          },
          "actions": {
            "add": "Add",
            "remove": "Remove",
            "loadMore": "Load more"
          },
          "validation": {
            "required": "Enter an address or a domain",
            "invalidFormat": "Enter a valid email address or domain",
            "duplicate": "This sender is already on the list"
          },
          "feedback": {
            "addSuccess": "Sender added",
            "addError": "Could not add the sender",
            "removeSuccess": "Sender removed",
            "removeError": "Could not remove the sender"
          },
          "forwardingHint": "If you redirect mail (an Exchange or M365 rule, for example), add the supplier or the domain it is forwarded from — the match is on the From header, not on your ingest address."
        }
      },
      "numberSeries": {
        "fields": {
          "documentType": "Agenda",
          "prefix": "Prefix",
          "pattern": "Pattern",
          "padding": "Digits",
          "preview": "Preview",
          "actions": "Actions"
        },
        "table": {
          "loading": "Loading number series...",
          "error": "Number series could not be loaded",
          "empty": "There are no number series yet"
        },
        "actions": {
          "edit": "Edit number series",
          "save": "Save",
          "cancel": "Cancel"
        },
        "modal": {
          "title": "Number series – {{documentType}}",
          "description": "The preview shows the number this series would issue next."
        },
        "placeholders": {
          "title": "Available placeholders",
          "insert": "Insert into the pattern",
          "prefix": "Series prefix, for example PO",
          "year": "Four-digit year, for example 2026",
          "yy": "Two-digit year, for example 26",
          "month": "Two-digit month of issue, for example 09",
          "seq": "Sequence number, zero-padded to the chosen number of digits"
        },
        "issues": {
          "EMPTY": "The pattern cannot be empty.",
          "TOO_LONG": "The pattern is too long, the maximum is {{max}} characters.",
          "UNKNOWN_PLACEHOLDER": "Unknown placeholder {{placeholder}}. Check for a typo.",
          "UNBALANCED_BRACE": "The pattern contains an unmatched curly brace.",
          "MISSING_SEQUENCE": "The pattern has no {seq}, so every document would get the same number.",
          "PREFIX_EMPTY": "The prefix cannot be empty.",
          "PREFIX_TOO_LONG": "The prefix is too long, the maximum is {{prefixMax}} characters.",
          "PADDING_OUT_OF_RANGE": "The number of digits must be a whole number between {{paddingMin}} and {{paddingMax}}.",
          "RENDERED_TOO_LONG": "The generated number would be longer than {{numberMax}} characters and documents could not be created. Shorten the prefix or the pattern."
        },
        "success": {
          "saved": "Number series saved"
        },
        "errors": {
          "saveError": "The number series could not be saved"
        }
      },
      "bankAccounts": {
        "systemCheck": {
          "title": "System check of accounts",
          "label": "The system may give the first signature",
          "description": "The system may give the first signature when the ERP reported the account first or the VAT payer register publishes it. A person always gives the second signature.",
          "noPermission": "Only someone who manages the account settings can change this.",
          "saved": "Saved.",
          "saveError": "The setting could not be saved.",
          "loadError": "The setting could not be loaded."
        },
        "ownAccounts": {
          "title": "Our company's accounts",
          "noCompany": "Fill in the company details on the Organization tab first."
        }
      }
    },
    "shared": {
      "companyRegistry": {
        "action": "Load details",
        "loading": "Loading…",
        "applied": "Details were loaded from the business register and saved.",
        "errors": {
          "invalidFormat": "Enter the company registration number as 8 digits (a Czech DIČ such as CZ12345678 also works).",
          "notFound": "No company with this registration number was found in the business register.",
          "unavailable": "The business register is currently unavailable. Please try again later."
        }
      },
      "lifecycle": {
        "status": {
          "ACTIVE": "Active",
          "DEACTIVATED": "Deactivated",
          "OUT_OF_VALIDITY": "Out of validity"
        },
        "outOfValidity": {
          "from": "Out of validity (valid from {{date}})",
          "to": "Out of validity (valid until {{date}})"
        },
        "filter": {
          "ALL": "All statuses",
          "INACTIVE": "Inactive",
          "label": "Status"
        },
        "fields": {
          "validFrom": "Valid from",
          "validTo": "Valid until"
        },
        "errors": {
          "invertedWindow": "\"Valid until\" must not be earlier than \"Valid from\"."
        },
        "window": {
          "both": "Valid from {{from}} until {{to}}",
          "from": "Valid from {{from}}",
          "to": "Valid until {{to}}"
        }
      },
      "syncProvenance": {
        "badge": {
          "info": "Deleted in {{system}}",
          "deactivate": "Deactivated — deleted in {{system}}",
          "delete": "Removed — deleted in {{system}}"
        },
        "detectedAt": "Detected {{date}}",
        "more": "+{{count}}",
        "filter": "Missing in accounting system",
        "filterHint": "Only records the accounting system deleted or stopped sending."
      },
      "accountRelation": {
        "ownBooks": "My office accounting"
      },
      "rolesGuide": {
        "toggle": "What each role allows",
        "help": "More in help",
        "helpOpensInNewTab": "More in help (opens in a new tab)"
      }
    },
    "partyValidation": {
      "title": "Duplicate check",
      "acknowledge": "Save anyway",
      "saving": "Saving...",
      "close": "Close",
      "cancel": "Cancel",
      "fieldLabels": {
        "companyId": "Company ID",
        "vatId": "VAT ID",
        "taxId": "Tax ID"
      }
    },
    "partners": {
      "addButton": "Add company",
      "loading": "Loading...",
      "empty": "No companies yet. Add your first one.",
      "noResults": "No companies match your search.",
      "toast": {
        "createSuccess": "Company created",
        "updateSuccess": "Company updated",
        "saveError": "Failed to save company",
        "deactivateSuccess": "Company deactivated",
        "deactivateError": "Failed to deactivate company",
        "reactivateSuccess": "Company reactivated",
        "reactivateError": "Failed to reactivate company",
        "deleteSuccess": "Company deleted",
        "deleteError": "Failed to delete company",
        "batchDeactivateSuccess_one": "{{count}} company deactivated",
        "batchDeactivateSuccess_other": "{{count}} companies deactivated",
        "batchDeactivatePartial": "{{count}} deactivated, {{skipped}} skipped. {{reason}}",
        "batchDeactivateError": "Failed to deactivate the selected companies",
        "batchReactivateSuccess_one": "{{count}} company reactivated",
        "batchReactivateSuccess_other": "{{count}} companies reactivated",
        "batchReactivatePartial": "{{count}} reactivated, {{skipped}} skipped. {{reason}}",
        "batchReactivateError": "Failed to reactivate the selected companies",
        "batchDeleteSuccess_one": "{{count}} company deleted",
        "batchDeleteSuccess_other": "{{count}} companies deleted",
        "batchDeletePartial": "{{count}} deleted, {{skipped}} skipped — they are still in use. {{reason}}",
        "batchDeleteError": "Failed to delete the selected companies"
      },
      "search": {
        "placeholder": "Search…"
      },
      "filters": {
        "role": {
          "all": "All roles",
          "supplier": "Suppliers",
          "customer": "Customers"
        }
      },
      "columns": {
        "name": "Name",
        "companyId": "Company ID",
        "role": "Role",
        "status": "Status",
        "actions": "Actions",
        "taxId": "Tax ID",
        "vatId": "VAT ID"
      },
      "role": {
        "supplier": "Supplier",
        "customer": "Customer"
      },
      "actions": {
        "edit": "Edit",
        "deactivate": "Deactivate",
        "reactivate": "Reactivate",
        "delete": "Delete"
      },
      "deactivateModal": {
        "title": "Deactivate company",
        "message": "Do you want to deactivate \"{{name}}\"?",
        "confirm": "Deactivate",
        "cancel": "Cancel"
      },
      "reactivateModal": {
        "title": "Reactivate company",
        "message": "Do you want to reactivate \"{{name}}\"?",
        "confirm": "Reactivate",
        "cancel": "Cancel"
      },
      "selection": {
        "selectAll": "Select all",
        "selectRow": "Select {{name}}",
        "selectedCount_one": "{{count}} selected",
        "selectedCount_other": "{{count}} selected"
      },
      "detail": {
        "title": "Company",
        "createTitle": "New company",
        "back": "Back to companies",
        "actionsLabel": "Company actions",
        "loadError": "This company could not be loaded.",
        "save": "Save",
        "create": "Create",
        "saving": "Saving...",
        "cancel": "Cancel",
        "postalAddress": "Postal address",
        "deliveryAddress": "Delivery address",
        "sameAsRegisteredOffice": "Same as registered office",
        "contactPersons": {
          "title": "Contact persons",
          "erpNotice": "Removing a person is not propagated to the ERP.",
          "add": "Add person",
          "empty": "No contact persons yet.",
          "personN": "Person {{n}}",
          "main": "Main",
          "openWebsite": "Open website",
          "fields": {
            "firstName": "First name",
            "lastName": "Last name",
            "role": "Role",
            "email": "Email",
            "phone": "Phone",
            "mobile": "Mobile",
            "website": "Website"
          },
          "errors": {
            "emailInvalid": "Invalid email format",
            "websiteInvalid": "Enter an http(s) web address, e.g. www.company.com"
          }
        },
        "bankAccounts": {
          "title": "Bank accounts",
          "erpNotice": "Removing an account is not propagated to the ERP.",
          "add": "Add account",
          "empty": "No bank accounts yet.",
          "accountN": "Account {{n}}",
          "main": "Main",
          "warnings": {
            "invalidSwift": "Invalid SWIFT/BIC format (e.g. GIBACZPX or GIBACZPXXXX)",
            "invalidBankCode": "Bank code should be a 4-digit number (e.g. 0800)",
            "invalidIban": "Invalid IBAN format (e.g. CZ6508000000192000145399)"
          }
        },
        "contactPersonsInvalid": "Fix the highlighted contact person fields."
      },
      "deleteModal": {
        "title": "Delete company",
        "message": "Permanently delete \"{{name}}\"? Only a company nothing refers to can be deleted.",
        "confirm": "Delete",
        "cancel": "Cancel"
      },
      "batchDeactivateModal": {
        "title": "Deactivate companies",
        "message_one": "Deactivate {{count}} selected company?",
        "message_other": "Deactivate {{count}} selected companies?",
        "confirm": "Deactivate",
        "cancel": "Cancel"
      },
      "batchReactivateModal": {
        "title": "Reactivate companies",
        "message_one": "Reactivate {{count}} selected company?",
        "message_other": "Reactivate {{count}} selected companies?",
        "confirm": "Reactivate",
        "cancel": "Cancel"
      },
      "batchDeleteModal": {
        "title": "Delete companies",
        "message_one": "Permanently delete {{count}} selected company? Companies that are still in use are skipped.",
        "message_other": "Permanently delete {{count}} selected companies? Companies that are still in use are skipped.",
        "confirm": "Delete",
        "cancel": "Cancel",
        "confirmationPhrase": "DELETE",
        "confirmationLabel": "Type {{phrase}} to delete these {{count}} companies"
      },
      "countLabel_one": "{{count}} company",
      "countLabel_other": "{{count}} companies",
      "countLoadedLabel_one": "{{loaded}}/{{count}} company",
      "countLoadedLabel_other": "{{loaded}}/{{count}} companies"
    },
    "codeLists": {
      "accountingCodes": {
        "managedInErp": "This list is managed in your accounting system and loaded into Tappeer by an integration.",
        "searchPlaceholder": "Search by code or description...",
        "loadMore": "Load more",
        "loadedCount": "{{loaded}} of {{count}} shown",
        "loadMoreError": "More codes could not be loaded. Try again.",
        "debit": "Dr {{account}}",
        "credit": "Cr {{account}}"
      },
      "glPostings": {
        "error": "The posting templates could not be loaded. Try reloading the page.",
        "empty": {
          "title": "No posting templates yet",
          "description": "Posting templates are managed in your accounting system and loaded into Tappeer by an integration. They show up here after the first sync."
        },
        "noResults": "No posting templates match your search",
        "vatPosting": "VAT posting {{code}}"
      },
      "vatCodes": {
        "error": "The VAT classification could not be loaded. Try reloading the page.",
        "empty": {
          "title": "No VAT classification yet",
          "description": "VAT classification is managed in your accounting system and loaded into Tappeer by an integration. It shows up here after the first sync."
        },
        "noResults": "No VAT classification matches your search",
        "directionBoth": "Received and issued documents"
      },
      "vatPostings": {
        "error": "The VAT posting rules could not be loaded. Try reloading the page.",
        "empty": {
          "title": "No VAT posting rules yet",
          "description": "VAT posting rules are managed in your accounting system and loaded into Tappeer by an integration. They show up here after the first sync."
        },
        "noResults": "No VAT posting rules match your search",
        "directionBoth": "Income and expense",
        "standardRate": "Standard rate",
        "reducedRate": "Reduced rate"
      },
      "orgStructure": {
        "error": "Error loading the organizational structure",
        "empty": {
          "title": "No organizational units",
          "description": "The organizational structure can be created by hand or written by the integration platform from customer systems."
        },
        "create": "New unit",
        "searchPlaceholder": "Search units or users...",
        "noSearchResults": "No units match your search",
        "backToTree": "Back to structure",
        "tree": {
          "expand": "Expand",
          "collapse": "Collapse",
          "noManager": "Unit has no manager"
        },
        "detail": {
          "selectPrompt": "Select a unit in the tree",
          "managerRole": "unit manager",
          "noManagerTitle": "Unit has no manager",
          "noManagerHint": "Approvals silently skip this unit and the document travels to the parent unit.",
          "costCenter": "Cost center",
          "parent": "Parent",
          "rootUnit": "Root unit",
          "memberCount": "Members",
          "children": "Subordinates",
          "members": "Members",
          "membersLoading": "Loading members...",
          "noMembers": "The unit has no members",
          "none": "—",
          "edit": "Edit",
          "addChild": "Add subordinate"
        },
        "form": {
          "createTitle": "New unit",
          "editTitle": "Edit unit",
          "create": "Create",
          "save": "Save",
          "cancel": "Cancel",
          "noParent": "No parent (root unit)",
          "noManager": "No manager",
          "addMember": "Add a member…",
          "removeMember": "Remove {{name}} from the unit",
          "noMembers": "The unit has no members yet.",
          "membersLoading": "Loading members…",
          "membersLoadFailed": "The unit's members could not be loaded.",
          "noCostCenter": "No cost center",
          "fields": {
            "code": "Code",
            "name": "Name",
            "parent": "Parent unit",
            "manager": "Manager",
            "members": "Members",
            "costCenter": "Cost center",
            "description": "Description",
            "status": "Status"
          },
          "hints": {
            "code": "Upper-case letters, digits and hyphens, for example OU-PURCHASE.",
            "codeLocked": "The code cannot be changed after creation.",
            "members": "A person can belong to several units; adding them here does not remove them from another unit."
          },
          "success": {
            "created": "Unit created",
            "updated": "Unit saved"
          },
          "errors": {
            "codeTaken": "A unit with this code already exists.",
            "saveFailed": "The unit could not be saved.",
            "managerFailed": "The unit is saved, but its manager could not be set.",
            "membersFailed": "The unit is saved, but some member changes could not be saved."
          }
        },
        "headTag": "Manager"
      },
      "costCenters": {
        "error": "Error loading cost centers",
        "empty": {
          "title": "No cost centers",
          "description": "Cost centers can be created by hand or written by the integration platform from customer systems."
        },
        "create": "New cost center",
        "searchPlaceholder": "Search by code or name...",
        "noResults": "No cost centers match your search",
        "form": {
          "createTitle": "New cost center",
          "editTitle": "Edit cost center",
          "create": "Create",
          "save": "Save",
          "cancel": "Cancel",
          "fields": {
            "code": "Code",
            "name": "Name",
            "description": "Description",
            "status": "Status"
          },
          "hints": {
            "code": "Upper-case letters, digits and hyphens, for example CC-MARKETING.",
            "codeLocked": "The code cannot be changed after creation."
          },
          "success": {
            "created": "Cost center created",
            "updated": "Cost center saved"
          },
          "errors": {
            "codeTaken": "A cost center with this code already exists.",
            "saveFailed": "The cost center could not be saved."
          }
        }
      },
      "jobs": {
        "error": "Error loading jobs",
        "empty": {
          "title": "No jobs",
          "description": "Jobs can be created by hand or written by the integration platform from customer systems."
        },
        "create": "New job",
        "searchPlaceholder": "Search by code or name...",
        "noResults": "No jobs match your search",
        "form": {
          "createTitle": "New job",
          "editTitle": "Edit job",
          "create": "Create",
          "save": "Save",
          "cancel": "Cancel",
          "fields": {
            "code": "Code",
            "name": "Name",
            "type": "Type",
            "status": "Status",
            "description": "Description"
          },
          "hints": {
            "code": "For example JOB-2026-01.",
            "status": "Only an active job can be assigned to documents.",
            "closing": "A closed job cannot be reopened."
          },
          "success": {
            "created": "Job created",
            "updated": "Job saved"
          },
          "errors": {
            "codeTaken": "A job with this code already exists.",
            "saveFailed": "The job could not be saved."
          }
        }
      },
      "filters": {
        "status": {
          "all": "All statuses",
          "label": "Status"
        },
        "sort": {
          "nameAsc": "Name (A-Z)",
          "nameDesc": "Name (Z-A)",
          "idAsc": "ID (ascending)",
          "idDesc": "ID (descending)"
        }
      }
    },
    "onboarding": {
      "title": "Hey! I'm Tappeer",
      "subtitle": "Let me show you what I can do",
      "description": "I've prepared a sample invoice so you can see how I extract all the important data – invoice number, amount, supplier, due date... Give it a try!",
      "trySample": "Feed me a sample invoice",
      "skipLabel": "I know Tappeer, skip",
      "organization": {
        "header": "About your company",
        "subtitle": "Tell me where your company is registered so I can read invoices the way your country expects.",
        "countryLabel": "Country of registration",
        "countryPlaceholder": "Select a country",
        "locationHint": "You can change all of this later under System settings → Organization.",
        "continue": "Continue",
        "skipLookup": "Continue without loading",
        "errors": {
          "countryRequired": "Pick the country your company is registered in.",
          "countrySaveFailed": "The country could not be saved. Please try again."
        },
        "registry": {
          "CZ": {
            "label": "Company registration number (IČO)",
            "placeholder": "Enter IČO or DIČ",
            "hint": "I'll load the name, registered address and VAT number from the ARES business register."
          },
          "SK": {
            "label": "Company registration number (IČO)",
            "placeholder": "Enter IČO",
            "hint": "I'll load the name and registered address from the RPO business register. It does not publish VAT numbers, so add your DIČ later."
          }
        }
      },
      "accountType": {
        "header": "Whose documents will we process?",
        "subtitle": "Tell me whether you process your own company's documents or your clients' documents.",
        "company": {
          "title": "We are a company",
          "description": "We process our own documents."
        },
        "firm": {
          "title": "We are an accounting firm",
          "description": "We manage our clients' documents."
        },
        "firmHint": "Declaring an office turns this organisation into “My office accounting”, creates an office board for managing your clients and moves the subscription there. You can also declare an office later under System settings → Account management.",
        "confirm": {
          "intro": "What happens when you declare an office:",
          "ownBooks": "This organisation becomes “My office accounting”. It keeps all its documents, e-mail address and integrations.",
          "masterAccountBoard": "A new office board is created, where you manage your clients. You become its office administrator.",
          "subscription": "The subscription moves to the office board.",
          "back": "Back",
          "submit": "Yes, declare an office"
        },
        "refused": "Your organisation now has other people, so it cannot be declared an office here. You can declare it under System settings → Account management, where you choose who works in the office."
      },
      "preview": {
        "header": "Sample invoice",
        "subtitle": "I've got this sample invoice for you",
        "proceed": "Extract this invoice"
      },
      "processing": {
        "title": "Sniffing the data...",
        "subtitle": "I'm searching your document for important details",
        "hint": "This usually takes about 1–2 minutes"
      },
      "complete": {
        "title": "Done! I've got it",
        "subtitle": "Loading result...",
        "dataSafety": "Don't worry, your data is safe. More info in the ToS or the FAQ on our website."
      },
      "steps": {
        "welcome": "Tappeer",
        "extraction": "Sniffing...",
        "done": "Done"
      },
      "tooltips": {
        "export": {
          "title": "Export document",
          "text": "Send it to your accounting system — ISDOC or PDF."
        },
        "qrPayment": {
          "title": "Pay with QR code",
          "text": "Scan the QR or open in your banking app."
        },
        "nextDocument": {
          "title": "Extract next document",
          "text": "Go back and extract another document from your inbox."
        }
      }
    },
    "quotaExceeded": {
      "titleExceeded": "Oops – Limit Reached",
      "titleOk": "Plan Settings",
      "headline": "Oops! You've used up your extraction allowance.",
      "headlineOk": "You're doing great!",
      "save": "Save",
      "admin": {
        "description": "Your current plan's monthly limit has been reached. Enable overages to keep going, or upgrade your plan.",
        "descriptionOverage": "Your limit is reached and you have {{count}} overage extractions this cycle.",
        "descriptionHardCap": "You've reached the absolute limit of your plan ({{hardCap}} documents total). Upgrade your plan or wait for the next billing cycle to continue.",
        "descriptionOk": "You have {{count}} documents left this billing cycle. If you need more, you can upgrade to a higher plan below.",
        "descriptionUnlimited": "Your plan has no document limit.",
        "stayOnPlan": "Allow overages",
        "overagesEnabled": "Enabled — each extra document will be charged at {{amount}} {{currency}}.",
        "overagesEnabledNoPrice": "Enabled — extra documents beyond the limit will be charged.",
        "overagesDisabled": "Disabled — extraction will be blocked when you hit the limit.",
        "upgradePlan": "Upgrade plan",
        "upgradePlanDynamic": "Upgrade to {{name}}",
        "upgradePlanHint": "Switch to a higher plan with a larger allowance.",
        "upgradePlanHintDynamic": "{{amount}} {{currency}} / month — {{docs}} documents monthly."
      },
      "member": {
        "description": "Your organisation's monthly extraction limit has been reached. Please contact your administrator."
      },
      "close": "Close"
    },
    "procurement": {
      "title": "Procurement",
      "overview": {
        "placeholder": "Your overview lands here — what needs you, and what of yours is moving.",
        "nothingYet": "Nothing of yours is in the purchasing chain yet.",
        "error": "Your overview could not be loaded.",
        "retry": "Try again",
        "stalled": "Stalled",
        "stalledHint": "Nothing has changed here since {{time}}.",
        "invoiceForOrder": "for order {{number}}",
        "showingSome": "Showing {{shown}} of {{total}}",
        "create": {
          "label": "New document",
          "requisition": "Requisition",
          "purchaseOrder": "Purchase order",
          "contract": "Contract"
        },
        "lists": "All documents",
        "bands": {
          "waitingOnMe": {
            "title": "For approval",
            "hint": "Somebody is waiting on your decision.",
            "empty": "Nobody is waiting on you."
          },
          "cameBackToMe": {
            "title": "Returned for changes",
            "hint": "An approver rejected it. Fix it and submit it again.",
            "empty": "Nothing to fix."
          },
          "inProgress": {
            "title": "In progress",
            "hint": "Drafts you have not sent yet. Finish them and send them for approval.",
            "empty": "You have no unsubmitted drafts."
          },
          "waitingOnOthers": {
            "title": "Waiting on others",
            "hint": "You sent these. Each one shows whose move it is and how long it has taken.",
            "empty": "Nothing of yours is in flight."
          },
          "recentlyFinished": {
            "title": "Recently completed",
            "empty": "Nothing of yours has completed in the last few days."
          }
        },
        "subtitle": "What needs doing, and where something is stuck.",
        "history": "History",
        "kindCount": "{{kind}} ({{count}})",
        "allClear": {
          "title": "Nobody needs anything from you right now",
          "hint": "Nothing to approve or fix.",
          "hintWithDrafts_one": "Nothing to approve or fix. You do have <strong>{{count}} draft</strong> you have not sent yet.",
          "hintWithDrafts_other": "Nothing to approve or fix. You do have <strong>{{count}} drafts</strong> you have not sent yet.",
          "finishDrafts": "Finish drafts"
        },
        "forMe": {
          "title": "Waiting on you",
          "hint": "These documents do not move without you."
        },
        "kinds": {
          "REQUISITION": "Requisition",
          "PURCHASE_ORDER": "Purchase order",
          "GOODS_RECEIPT": "Delivery note",
          "INVOICE": "Invoice",
          "CONTRACT": "Contract"
        },
        "kindLists": {
          "REQUISITION": "Requisitions",
          "PURCHASE_ORDER": "Purchase orders",
          "GOODS_RECEIPT": "Delivery notes",
          "INVOICE": "Invoices",
          "CONTRACT": "Contracts"
        },
        "row": {
          "noSupplier": "no supplier yet",
          "edited": "edited {{time}}",
          "waiting": {
            "minute_one": "waiting {{count}} minute",
            "minute_other": "waiting {{count}} minutes",
            "hour_one": "waiting {{count}} hour",
            "hour_other": "waiting {{count}} hours",
            "day_one": "waiting {{count}} day",
            "day_other": "waiting {{count}} days"
          },
          "continue": "Continue",
          "decide": "Decide",
          "fix": "Fix",
          "changedAt": "Last changed {{time}}"
        },
        "progress": {
          "label": "Step {{step}} of {{total}}: {{name}}",
          "steps": {
            "REQUISITION": "Requisition",
            "ORDER": "Order",
            "DELIVERY": "Delivery",
            "INVOICE": "Invoice",
            "COMPLETION": "Completion"
          }
        },
        "waitingOn": {
          "label": "next move: {{who}}",
          "andOthers": "{{name}} and {{count}} more",
          "named": {
            "AUTOMATION": "{{names}}",
            "APPROVERS": "{{names}}",
            "BUYER": "buyer {{names}}",
            "SUPPLIER": "supplier {{names}}",
            "VIEWER": "you"
          },
          "unnamed": {
            "AUTOMATION": "automatic approval",
            "APPROVERS": "nobody, no approver yet",
            "BUYER": "buyer",
            "SUPPLIER": "supplier",
            "VIEWER": "you"
          }
        },
        "howItWorks": {
          "title": "How a purchase goes",
          "steps": {
            "requisition": {
              "title": "Requisition",
              "hint": "You write what you need and send it for approval."
            },
            "order": {
              "title": "Purchase order",
              "hint": "An approved requisition becomes an order with the supplier."
            },
            "delivery": {
              "title": "Delivery and invoice",
              "hint": "You confirm the delivery, the supplier sends the invoice."
            },
            "paid": {
              "title": "Paid",
              "hint": "Accounting pays the invoice and the purchase closes."
            }
          }
        }
      },
      "requisition": {
        "justification": "Justification",
        "internalNote": "Internal note",
        "neededBy": "Delivery date",
        "estimatedTotal": "Estimate excl. VAT",
        "currency": "Currency",
        "costCenter": "Cost centre",
        "orgUnit": "Org unit",
        "job": "Job",
        "suggestedSupplier": "Preferred supplier",
        "submittedAt": "Submitted",
        "approvedAt": "Approved",
        "lines": "Requested items",
        "title": "Title",
        "documentType": "Requisition",
        "suggestedApprover": "Suggested approver"
      },
      "purchaseOrder": {
        "number": "Order number",
        "numberRequired": "The order number is required.",
        "note": "Note to supplier",
        "internalNote": "Internal note",
        "supplier": "Supplier",
        "expectedDelivery": "Delivery date",
        "totalNoVat": "Total excl. VAT",
        "totalInclVat": "Total incl. VAT",
        "currency": "Currency",
        "costCenter": "Cost centre",
        "orgUnit": "Org unit",
        "job": "Job",
        "paymentTerms": "Payment terms",
        "paymentTermsDays": "{{days}} days from invoice",
        "paymentTermsUnit": "days",
        "paymentTermsInvalid": "Enter a number of days from 0 to {{max}}.",
        "paymentDue_one": "{{count}} day (due {{date}})",
        "paymentDue_other": "{{count}} days (due {{date}})",
        "incoterms": "Incoterms",
        "incotermsPlace": "Incoterms place",
        "deliveryAddress": "Delivery address",
        "dispatchedAt": "Sent to supplier",
        "dispatchedOn": "Sent {{date}}",
        "notDispatched": "Not sent",
        "lines": "Ordered items",
        "withVat": "With VAT",
        "title": "Title",
        "documentType": "Purchase order",
        "suggestedApprover": "Suggested approver",
        "moreDetails": "More details"
      },
      "customer": {
        "title": "Customer"
      },
      "party": {
        "registryParty": "Company from registry",
        "notLinked": "Not linked",
        "name": "Name",
        "companyId": "Company ID",
        "vatId": "VAT ID",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "editParty": "Edit company",
        "editSuccess": "Company updated",
        "editError": "Failed to update company",
        "addSupplier": "Add new supplier",
        "addCustomer": "Add new customer",
        "createSuccess": "Company created and linked to the document",
        "createdNotLinked": "Company created but could not be linked to the document",
        "createError": "Failed to create company",
        "disconnect": "Disconnect company from document",
        "disconnectConfirmTitle": "Disconnect company from document?",
        "disconnectConfirmMessage": "The link to the company will be removed. The entered data will be kept.",
        "disconnectConfirm": "Disconnect",
        "cancel": "Cancel"
      },
      "lines": {
        "number": "No.",
        "description": "Description",
        "productType": "Type",
        "quantity": "Quantity",
        "estimatedUnitPrice": "Est. unit price",
        "estimatedTotal": "Est. total",
        "unitPrice": "Unit price",
        "totalNoVat": "Total excl. VAT",
        "totalInclVat": "Total incl. VAT",
        "empty": "No items yet.",
        "code": "Item code",
        "codeValue": "Item code: {{code}}",
        "coverage": {
          "header": "Ordered",
          "none": "Not ordered",
          "partial": "{{ordered}} of {{requested}}",
          "full": "Fully ordered"
        },
        "delivery": {
          "header": "Delivered",
          "none": "Not delivered",
          "partial": "{{received}} of {{ordered}}",
          "full": "Fully delivered"
        },
        "invoiced": {
          "header": "Invoiced",
          "unconfirmed": "Includes matches nobody has confirmed yet"
        },
        "unit": "Unit",
        "units": {
          "piece": "pcs",
          "hour": "h",
          "day": "day",
          "kilometre": "km",
          "litre": "l",
          "kilogram": "kg",
          "tonne": "t",
          "metre": "m",
          "squareMetre": "m²",
          "cubicMetre": "m³",
          "package": "pkg"
        },
        "vatRate": "VAT rate"
      },
      "goodsReceipt": {
        "title": "Delivery note",
        "lines": "Delivered items",
        "supplier": "Supplier",
        "order": "Against order",
        "unsolicited": "Unsolicited delivery — no order behind it",
        "deliveryNoteNumber": "Supplier's delivery note number",
        "carrier": "Carrier",
        "receivedAt": "Received at",
        "notes": "Note",
        "ordered": "Ordered",
        "alreadyReceived": "Delivered earlier",
        "receivingNow": "This delivery",
        "remainingAfter": "Remaining after this",
        "context": "Ordered {{ordered}} {{unit}} · {{received}} delivered earlier",
        "receiveAll": "All {{quantity}}",
        "overReceipt": "More than ordered",
        "overReceiptSummary": "Some lines record more than was ordered. That is allowed — matching will flag the difference.",
        "notANumber": "Enter a number.",
        "negative": "A quantity cannot be negative.",
        "saveReceiving": "Save delivery",
        "outstandingPanel": "Order balance",
        "orderStrip": "{{number}} · {{quantity}} outstanding",
        "orderStripDelivered": "{{number}} · fully delivered",
        "orderOutstanding": "Order: {{quantity}} outstanding",
        "withoutDeliveryNote": "Without a delivery note",
        "withoutDeliveryNoteHint": "Without a delivery note – the delivery was confirmed on the order."
      },
      "approverSummary": {
        "label": "Approval by:",
        "andOthers": "{{names}} and {{count}} more",
        "awaitingAutomation": "Approvers are being picked automatically",
        "unassigned": "No approver assigned yet",
        "ariaLabel": "{{summary}} – show the approvers",
        "loading": "Loading the approvers…",
        "loadFailed": "The approvers could not be loaded."
      },
      "approval": {
        "title": "Approval",
        "none": "The document is not waiting for approval.",
        "counter": "Approval {{approved}}/{{required}}",
        "hasApproved": "Approved",
        "targets": "Assigned to",
        "unit": "Unit",
        "roleTarget": "Everybody with the {{role}} role",
        "permissionTarget": "Everybody who may approve",
        "members": "Show who may decide",
        "noMembers": "No member holds the permission to approve.",
        "ownerCannotDecide": "Document author",
        "ownerCannotDecideTooltip": "The author of a document is not permitted to decide on its approval.",
        "history": "Earlier rounds",
        "status": {
          "APPROVED": "Approved",
          "REJECTED": "Rejected",
          "CANCELLED": "Cancelled"
        },
        "action": {
          "APPROVED": "approved",
          "REJECTED": "rejected"
        },
        "rejectTitle": "Reject the document",
        "rejectDescription": "{{number}} goes back for editing. The reason is shown with the rejection.",
        "rejectNote": "Reason",
        "rejectNotePlaceholder": "Why the document is rejected",
        "unreachableTitle": "Approval cannot complete",
        "unreachable": "The assignment resolves to no approver. Change the approvers so the document can be approved.",
        "awaitingAutomation": "Finding who will approve the document.",
        "manualSelectionTitle": "Approver selection required",
        "edit": "Change",
        "choose": "Choose",
        "editTitle": "Approvers",
        "editDescription": "Pick the users or units asked to approve {{number}}. For a unit, its current members decide.",
        "users": "Users",
        "orgUnits": "Units",
        "orgUnitsHint": "A unit member without a role that may approve is not counted among the approvers.",
        "formerMember": "Former member",
        "roles": "Roles",
        "anyApprover": "Anybody who may approve",
        "anyApproverHint": "Any {{roles}} may decide.",
        "save": "Save",
        "targetsRequired": "Pick at least one approver.",
        "saveError": "The approvers could not be changed.",
        "decideError": "The decision could not be recorded.",
        "aiDecision": "Show the reasoning behind the automated decision",
        "aiApprovedTitle": "Approved automatically",
        "withdrawnTitle": "Approval withdrawn",
        "withdrawn": "The document was returned for changes and must be approved again before it is processed further.",
        "aiDecisionTitle": "Automated decision: {{decision}}",
        "aiConfidence": "confidence {{value}} %",
        "aiDecisionNone": "The automated approval has not run on this document yet.",
        "aiUnresolvedApprover": "The current settings did not identify an approver. Consider adjusting the approval policy.",
        "aiSettingsLink": "Approval automation settings",
        "unassignableTitle": "No approver could be assigned",
        "unassignable": "Under the current approval settings nobody could be found to approve this document, so it was rejected automatically. An administrator should review the approval settings."
      },
      "people": {
        "title": "People",
        "you": "You",
        "requester": "Raised for",
        "createdBy": "Raised by",
        "suggestedApprover": "Suggested approver",
        "buyer": "Buyer",
        "receivedBy": "Received by"
      },
      "coveringOrders": {
        "title": "Orders",
        "empty": "No order has been raised from it yet.",
        "open": "Open order {{number}}"
      },
      "answeredRequisitions": {
        "title": "Requisitions",
        "empty": "This order does not answer a requisition.",
        "open": "Open requisition {{number}}"
      },
      "history": {
        "title": "Change history",
        "empty": "No changes yet.",
        "system": "System",
        "approvers": "Approvers: {{value}}",
        "viewLineChanges": "View line changes",
        "linkedDocument": "{{kind}} {{number}}",
        "linesAdded": "+ {{count}} added",
        "linesRemoved": "- {{count}} removed",
        "linesModified": "~ {{count}} modified",
        "valueChanged": "changed",
        "valueCleared": "cleared",
        "allLinesOrdered": "Every line ordered",
        "linesNoLongerOrdered": "Some lines no longer ordered",
        "yes": "Yes",
        "no": "No"
      },
      "createOrder": {
        "title": "Create order",
        "description": "From requisition {{number}}. Items, cost split and coding are copied across.",
        "supplier": "Supplier",
        "supplierPlaceholder": "No supplier yet",
        "expectedDelivery": "Delivery date",
        "deliveryAddress": "Delivery address",
        "deliveryAddressHint": "If left empty, the organization's address is used.",
        "lines": "Items to order",
        "linesRequired": "Choose at least one item.",
        "lineRemaining": "{{remaining}} of {{requested}} {{unit}} left",
        "nothingLeft": "Every item on this requisition is already ordered.",
        "submit": "Create order",
        "error": "The order could not be created.",
        "suggestedSupplierNotEffective": "The suggested supplier {{name}} is not in effect today; please choose another."
      },
      "actions": {
        "moreActions": "More actions",
        "cancel": "Cancel",
        "submitForApproval": "Submit for approval",
        "submitSuccess": "Submitted for approval.",
        "submitError": "The document could not be submitted for approval.",
        "submitBlockedByErrors": "The document has validation errors. It can be submitted for approval once they are resolved.",
        "submitBlockedByValidation": "The document is being checked. It can be submitted for approval once the check finishes.",
        "approve": "Approve",
        "approveSuccess": "Approved.",
        "reject": "Reject",
        "rejectSuccess": "Rejected.",
        "dispatch": "Send to supplier",
        "createOrder": "Create order",
        "transitionError": "The status could not be changed.",
        "saveError": "The change could not be saved.",
        "returnToDraft": "Return to editing",
        "returnToDraftSuccess": "Returned to editing.",
        "closeDocument": "Complete document",
        "closeDocumentSuccess": "Completed.",
        "cancelDocument": "Cancel document",
        "cancelDocumentSuccess": "Cancelled.",
        "copyDocument": "Copy",
        "copySuccess": "Created a copy of {{number}}.",
        "copyError": "The document could not be copied.",
        "delete": "Delete",
        "deleteSuccess": "Deleted.",
        "deleteError": "The document could not be deleted.",
        "recordDelivery": "Record delivery",
        "recordDeliveryFor": "Record delivery for {{number}}",
        "recordNextDelivery": "Record next delivery",
        "recordDeliveryError": "The delivery could not be started.",
        "deliveryOptions": "More delivery options",
        "cancelOptions": "More cancel options",
        "confirmDeliveryWithoutReceipt": "Confirm delivery without a delivery note",
        "confirmDeliveryWithoutReceiptSuccess": "Delivery confirmed.",
        "confirmDeliveryWithoutReceiptError": "The delivery could not be confirmed.",
        "allLinesDelivered": "Every line is already fully delivered.",
        "downloadPdf": "Download PDF",
        "downloadPdfError": "Could not download the purchase order PDF.",
        "downloadPdfTooLarge": "The order is too large for a PDF.",
        "downloadPdfBusy": "The PDF cannot be created right now. The download can be retried in a few moments.",
        "confirmDelivery": "Confirm delivery",
        "confirmDeliverySuccess": "Delivery recorded.",
        "orderRaised": "Approved. Purchase order {{number}} was raised — it is in the linked documents below.",
        "archive": "Move to archive",
        "archiveSuccess": "Moved to archive.",
        "archiveError": "The document could not be moved to the archive.",
        "unarchive": "Restore from archive",
        "unarchiveSuccess": "Restored from archive.",
        "unarchiveError": "The document could not be restored from the archive.",
        "closeDocumentHint": "Marks the document as done. It stays in the lists until it is moved to the archive.",
        "archiveHint": "Hides the document from the regular lists. It stays read-only and you can restore it any time."
      },
      "flow": {
        "lineStripLabel": "Purchase flow of line {{number}}",
        "open": "Open {{number}}",
        "of": "{{quantity}} of {{total}}",
        "matched": "Matched {{quantity}}",
        "unconfirmed": "Proposed match, not confirmed yet",
        "headerLinked": "Names the order as a whole; no line is paired yet",
        "unbacked": "{{quantity}} with no delivery behind it",
        "lineCount_one": "{{count}} line",
        "lineCount_other": "{{count}} lines"
      },
      "linked": {
        "orders": "Purchase orders",
        "requisitions": "Requisitions",
        "receipts": "Delivery notes",
        "invoices": "Invoices",
        "siblingReceipts": "Other deliveries",
        "order": "Purchase order",
        "outstanding": "Outstanding on the order",
        "contract": "Contract",
        "empty": "Nothing linked yet.",
        "open": "Open {{number}}"
      },
      "fieldLabels": {
        "lineNumber": "Line {{number}}",
        "number": "Document number",
        "lines": "Line items",
        "title": "Title",
        "orgUnitId": "Org unit",
        "suggestedApproverUserId": "Suggested approver",
        "supplierPartyId": "Supplier",
        "supplierName": "Supplier name",
        "supplierVatId": "Supplier VAT ID",
        "supplierCompanyId": "Supplier company ID",
        "supplierContact": "Supplier contact",
        "description": "Description",
        "quantity": "Quantity",
        "unitPriceNoVat": "Unit price",
        "status": "Status",
        "internalNote": "Internal note",
        "costCenterId": "Cost centre",
        "jobId": "Job",
        "currencyCode": "Currency",
        "accountingCurrencyCode": "Accounting currency",
        "justification": "Justification",
        "requesterId": "Requester",
        "neededBy": "Delivery date",
        "accountingEstimatedAmountNoVat": "Estimate in accounting currency",
        "suggestedSupplierPartyId": "Suggested supplier",
        "suggestedSupplierName": "Suggested supplier name",
        "suggestedSupplierVatId": "Suggested supplier VAT ID",
        "suggestedSupplierCompanyId": "Suggested supplier company ID",
        "suggestedSupplierAddress": "Suggested supplier address",
        "note": "Note to supplier",
        "buyerUserId": "Buyer",
        "requesterUserId": "Requester",
        "expectedDeliveryDate": "Delivery date",
        "paymentTermsDays": "Payment terms (days)",
        "incoterms": "Incoterms",
        "incotermsPlace": "Incoterms place",
        "withVat": "With VAT",
        "deliveryAddress": "Delivery address",
        "notes": "Note",
        "purchaseOrderId": "Purchase order",
        "receivedAt": "Received at",
        "deliveryNoteNumber": "Supplier's delivery note number",
        "carrier": "Carrier",
        "receivedByUserId": "Received by",
        "supplierAddress": "Supplier address",
        "customerPartyId": "Customer",
        "customerName": "Customer name",
        "customerVatId": "Customer VAT ID",
        "customerCompanyId": "Customer company ID",
        "customerAddress": "Customer address",
        "supplierEmail": "Supplier email",
        "supplierPhone": "Supplier phone",
        "customerEmail": "Customer email",
        "customerPhone": "Customer phone",
        "suggestedSupplierEmail": "Suggested supplier email",
        "suggestedSupplierPhone": "Suggested supplier phone",
        "contractId": "Contract"
      },
      "fields": {
        "unset": "Not set",
        "useTyped": "Use as typed"
      },
      "linesEditor": {
        "addLine": "Add item",
        "removeLine": "Remove item {{number}}",
        "copyLine": "Copy item {{number}}",
        "empty": "No items yet. Add the first one.",
        "requiredMissing": "Every item needs a description and a quantity.",
        "submit": "Save items",
        "error": "The items could not be saved.",
        "discard": "Discard changes"
      },
      "lineDetails": {
        "toggle": "Details of item {{number}}"
      },
      "lineCoding": {
        "saveItemsFirst": "Save or discard the item changes first.",
        "createCostCenter": "New cost centre",
        "createJob": "New job"
      },
      "list": {
        "untitled": "Untitled",
        "error": "The list could not be loaded.",
        "retry": "Try again",
        "invoice": {
          "title": "Invoices & receipts"
        },
        "requisition": {
          "title": "Requisitions",
          "searchPlaceholder": "Number, title, justification or supplier",
          "empty": "No requisitions match the filter.",
          "estimatedTotal": "Estimated excl. VAT",
          "tabs": {
            "FOR_EDIT": "For editing",
            "FOR_APPROVAL": "For approval",
            "TO_ORDER": "To order",
            "AWAITING_DELIVERY": "Awaiting delivery",
            "AWAITING_INVOICE": "Awaiting invoice",
            "REJECTED": "Rejected",
            "CANCELLED": "Cancelled",
            "COMPLETED": "Completed",
            "ARCHIVED": "Archived"
          }
        },
        "purchaseOrder": {
          "title": "Purchase orders",
          "searchPlaceholder": "Number, title or supplier",
          "empty": "No purchase orders match the filter.",
          "totalNoVat": "Total excl. VAT",
          "tabs": {
            "FOR_EDIT": "For editing",
            "FOR_APPROVAL": "For approval",
            "TO_SEND": "To send",
            "AWAITING_DELIVERY": "Awaiting delivery",
            "AWAITING_INVOICE": "Awaiting invoice",
            "REJECTED": "Rejected",
            "CANCELLED": "Cancelled",
            "COMPLETED": "Completed",
            "ARCHIVED": "Archived"
          }
        },
        "goodsReceipt": {
          "title": "Delivery notes",
          "searchPlaceholder": "Number, supplier's delivery note, supplier or carrier",
          "empty": "No delivery notes match the filter.",
          "receivedAt": "Received",
          "unsolicited": "No order",
          "tabs": {
            "DRAFT": "For editing",
            "RECEIVED": "Received",
            "CANCELLED": "Cancelled",
            "ARCHIVED": "Archived"
          }
        },
        "contract": {
          "title": "Contracts"
        },
        "sort": {
          "createdAt": "Created",
          "updatedAt": "Updated",
          "number": "Number",
          "title": "Title",
          "neededBy": "Delivery date",
          "expectedDelivery": "Delivery date",
          "receivedAt": "Received",
          "amount": "Amount"
        },
        "dates": {
          "createdAt": "Created",
          "approvedAt": "Approved",
          "sentAt": "Sent",
          "confirmedAt": "Confirmed",
          "delivery": "Delivery"
        }
      },
      "completion": {
        "completed": "Completed",
        "delivery": "Delivery",
        "invoicing": "Invoicing",
        "infoManualBy": "Completed {{date}} · manually by {{name}}",
        "infoManual": "Completed {{date}} · manually",
        "infoAutomatic": "Completed {{date}} · automatically",
        "settingsLink": "Completion settings"
      },
      "archive": {
        "archived": "Archived",
        "info": "Archived {{date}}",
        "explanation": "An archived document is read-only. In the lists it is under the Archived tab."
      },
      "cancellation": {
        "cancelled": "Cancelled",
        "info": "Cancelled {{date}}",
        "infoBy": "Cancelled {{date}} · {{name}}",
        "reason": "Reason: {{reason}}"
      },
      "confirm": {
        "archive": {
          "title": "Move the document to the archive?",
          "message": "Do you really want to move {{number}} to the archive?",
          "warning": "The document disappears from the regular lists and stays read-only. You will find it under the Archived tab and can restore it any time.",
          "confirm": "Move to archive"
        },
        "close": {
          "title": "Complete the document?",
          "message": "Complete {{number}}?",
          "confirm": "Complete"
        },
        "cancel": {
          "title": "Cancel this document?",
          "message": "Are you sure you want to cancel {{number}}?",
          "warning": "A cancelled document can no longer be worked with.",
          "reason": "Reason (optional)",
          "reasonPlaceholder": "Why are you cancelling this document?",
          "reasonTooLong": "The reason can be at most {{max}} characters long.",
          "confirm": "Cancel document",
          "keep": "Keep document"
        },
        "delete": {
          "title": "Delete this document?",
          "message": "Are you sure you want to delete {{number}}?",
          "warning": "It disappears from the lists and cannot be opened again in the app.",
          "confirm": "Delete"
        },
        "deliveryWithoutReceipt": {
          "title": "Confirm delivery without a delivery note",
          "lead": "Tick the delivered lines and adjust the quantities.",
          "columns": {
            "line": "Line",
            "unit": "Unit",
            "remaining": "Remaining",
            "quantity": "Delivered"
          },
          "overMax": "At most {{max}}",
          "positive": "Enter a quantity above zero.",
          "confirm": "Confirm delivery"
        },
        "lineCoding": {
          "costCenter": {
            "title": "Change the cost centre on every item?",
            "message_one": "{{count}} item has its own cost centre or none; the change replaces it.",
            "message_other": "{{count}} items have their own cost centre or none; the change replaces it.",
            "confirm": "Change cost centre"
          },
          "job": {
            "title": "Change the job on every item?",
            "message_one": "{{count}} item has its own job or none; the change replaces it.",
            "message_other": "{{count}} items have their own job or none; the change replaces it.",
            "confirm": "Change job"
          }
        }
      },
      "completionConditions": {
        "lead": "The document does not meet these completion conditions:",
        "settingsInfo": "Completion conditions are set in the automation settings.",
        "orderNotDispatched": "The order is not marked as dispatched",
        "orderNotApproved": "The order is not approved",
        "requisitionNotOrdered": "The requisition is not ordered",
        "requisitionNotApproved": "The requisition is not approved",
        "deliveryIncomplete": "Incomplete delivery",
        "invoicingIncomplete": "Incomplete invoicing",
        "invoiceNotApproved": "The invoice is not approved",
        "invoiceNotPaid": "The invoice is not paid",
        "invoiceNotPosted": "The invoice is not posted",
        "question": "Do you really want to complete the document by hand?"
      },
      "acceptWarnings": {
        "title": "Accept warnings",
        "message_one": "The document has {{count}} warning. Confirming accepts it and submits the document for approval. Any further edit withdraws the acceptance.",
        "message_other": "The document has {{count}} warnings. Confirming accepts them and submits the document for approval. Any further edit withdraws the acceptance.",
        "notePlaceholder": "Note on accepting the warnings (optional)",
        "confirm": "Accept and submit",
        "acceptError": "The warnings could not be accepted."
      },
      "dispatch": {
        "title": "Send purchase order to supplier",
        "description": "Purchase order {{number}} is sent by e-mail with the PDF attached, or only marked as sent.",
        "emailUnavailable": "E-mail sending is not available. The order can only be marked as sent.",
        "buyerMissing": "The order has no buyer with an e-mail address for the supplier's replies. A buyer is required before sending by e-mail; otherwise the order can only be marked as sent.",
        "replyTo": "Supplier replies go to: {{addresses}}",
        "recipients": "Recipients",
        "recipientsHint": "Several addresses are separated by commas or semicolons. The first address receives the e-mail, the others a copy.",
        "recipientsInvalid": "The addresses are not valid or there are more than {{max}}.",
        "subject": "Subject",
        "body": "Message",
        "saveAsTemplate": "Save as template",
        "saveAsTemplateDescription": "Subject and message become available for further orders. The order number, supplier, company and sender are filled in from each order.",
        "templateName": "Template name",
        "templateNameReplaces": "The template with this name will be replaced.",
        "template": "Template",
        "defaultTemplate": "Default",
        "manageTemplates": "Manage templates",
        "deleteTemplate": "Delete template {{name}}",
        "deleteTemplateError": "The template could not be deleted.",
        "cancel": "Cancel",
        "markAsSent": "Mark as sent without e-mail",
        "sendEmail": "Send e-mail",
        "emailSuccess": "The purchase order has been sent to the supplier.",
        "markedSuccess": "The purchase order is marked as sent.",
        "emailError": "The e-mail could not be sent. The purchase order remains Approved.",
        "sentStatusNotUpdated": "The e-mail was sent to the supplier, but the order status could not be changed. No resend is needed; marking the order as sent is enough.",
        "sendInProgress": "The order is being sent right now. It cannot be sent again.",
        "confirmDeleteTitle": "Delete template",
        "confirmDeleteMessage": "Template {{name}} will be removed for the whole organization.",
        "confirmDelete": "Delete",
        "draftError": "The e-mail draft could not be loaded. The purchase order can be marked as sent."
      },
      "contract": {
        "label": "Contract",
        "currencyConfirm": {
          "title": "Link a contract in another currency?",
          "message": "The document currency will change to {{currency}}, as the contract says. Item prices stay as entered, so check them.",
          "confirm": "Link contract",
          "cancel": "Cancel"
        }
      }
    },
    "contracts": {
      "picker": {
        "label": "Contract",
        "placeholder": "Search contracts",
        "clear": "No contract"
      },
      "list": {
        "title": "Contracts",
        "searchPlaceholder": "Search number or title",
        "empty": "No contracts match the filter.",
        "create": "New contract",
        "untitled": "Untitled",
        "term": "{{from}} – {{to}}",
        "termOpenEnded": "From {{from}}, indefinite",
        "validFromLabel": "Valid from",
        "validToLabel": "Valid until",
        "openEnded": "open-ended",
        "endsLabel": "Ends",
        "limitNoVat": "Limit excl. VAT",
        "used": "{{percent}} % used",
        "costCenter": "Cost centre",
        "job": "Job",
        "tabs": {
          "DRAFT": "Drafts",
          "NOT_YET_IN_FORCE": "Not yet in force",
          "IN_FORCE": "In force",
          "TERMINATING": "Notice given",
          "ENDED": "Ended"
        }
      },
      "create": {
        "title": "New contract",
        "submit": "Create contract",
        "cancel": "Cancel",
        "fields": {
          "direction": "Direction",
          "contractType": "Contract type",
          "noContractType": "No type",
          "supplier": "Supplier",
          "customer": "Customer",
          "partyPlaceholder": "Pick a company",
          "title": "Title",
          "counterpartyNumber": "Counterparty's contract number",
          "currency": "Currency",
          "validityFrom": "Validity from",
          "validityTo": "Validity until",
          "validFrom": "Effective from",
          "validTo": "Effective until",
          "openEnded": "Indefinite",
          "limitAmount": "Limit excl. VAT",
          "noticePeriodDays": "Notice period (days)",
          "owner": "Owner",
          "costCenter": "Cost centre",
          "job": "Job",
          "noCostCenter": "No cost centre",
          "noJob": "No job",
          "note": "Note"
        },
        "hints": {
          "counterpartyNumber": "The number the counterparty writes on its invoices.",
          "currency": "The limit and linked documents are in this currency.",
          "limitAmount": "Optional. Applies to the whole contract."
        },
        "errors": {
          "partyRequired": "Pick a company.",
          "currencyRequired": "Pick a currency.",
          "validityToBeforeFrom": "Validity cannot end before it starts.",
          "validFromRequired": "Fill in when the contract takes effect.",
          "validFromTooEarly": "A contract cannot start more than {{years}} years back.",
          "validToRequired": "Fill in until when the contract is in effect, or choose indefinite.",
          "validToBeforeFrom": "The end cannot be before the start.",
          "noticeRange": "Enter a whole number of days from 0 to {{maxDays}}.",
          "limitInvalid": "The limit cannot be negative.",
          "createFailed": "The contract could not be created. Please try again."
        }
      },
      "party": {
        "title": "Contracts",
        "create": "New contract",
        "showAll": "Show all ({{total}})",
        "empty": "No contracts with this company yet.",
        "loadFailed": "The contracts could not be loaded.",
        "retry": "Try again"
      },
      "detail": {
        "documentType": "Contract",
        "deleteConfirm": "Do you really want to delete contract {{number}}?",
        "actions": {
          "activate": "Activate",
          "activateSuccess": "The contract is active.",
          "activateError": "The contract could not be activated.",
          "copy": "Copy",
          "copySuccess": "Created a copy of contract {{number}}.",
          "copyError": "The contract could not be copied.",
          "delete": "Delete",
          "deleteSuccess": "Contract deleted.",
          "deleteError": "The contract could not be deleted.",
          "saveError": "The change could not be saved.",
          "moreActions": "More actions"
        },
        "fields": {
          "title": "Title",
          "note": "Note",
          "direction": "Direction",
          "contractType": "Contract type",
          "noContractType": "No type",
          "supplier": "Supplier",
          "customer": "Customer",
          "counterpartyNumber": "Counterparty's contract number",
          "validityFrom": "Validity from",
          "validityTo": "Validity until",
          "signedOn": "Signed on",
          "validityOrder": "Validity cannot start after it ends.",
          "owner": "Owner",
          "noOwner": "No owner",
          "costCenter": "Cost centre",
          "job": "Job",
          "noCostCenter": "No cost centre",
          "noJob": "No job",
          "currency": "Currency",
          "noticePeriod": "Notice period",
          "limitAmount": "Limit excl. VAT",
          "noLimit": "No limit",
          "limitInvalid": "The limit cannot be negative.",
          "days_one": "{{count}} day",
          "days_other": "{{count}} days",
          "wholeNumber": "Enter a whole number from {{min}} to {{max}}."
        },
        "facts": {
          "effectiveEnd": "Effective until",
          "indefinite": "Indefinite",
          "cancellationDeadline": "Notice deadline",
          "deadlinePassed": "{{date}} (deadline passed)",
          "terminated": "Terminated",
          "created": "Created"
        },
        "terms": {
          "current": "Current term",
          "range": "{{from}} – {{to}}",
          "openEnded": "from {{from}}, indefinite",
          "terminatedEnd": "(ended by notice, originally until {{date}})",
          "terminatedEndOpenEnded": "(ended by notice, originally indefinite)",
          "terminatedBeforeStart": "(terminated before it started)"
        },
        "linked": {
          "more_one": "+{{count}} more",
          "more_other": "+{{count}} more",
          "notCountedOtherCurrency": "Not counted – different currency",
          "amountNoVat": "{{amount}} excl. VAT",
          "loadError": "The linked documents could not be loaded.",
          "retry": "Try again"
        },
        "references": {
          "title": "References",
          "registryNumber": "Contract registry number",
          "archiveNumber": "Physical archive number"
        },
        "deleteDialog": {
          "title": "Delete this contract?",
          "warning": "It disappears from the lists and cannot be opened again in the app."
        },
        "directionChange": {
          "title": "Change the direction",
          "lead": "The current counterparty does not fit this direction. Pick a new one.",
          "submit": "Change direction",
          "cancel": "Cancel",
          "error": "The direction could not be changed. Check the counterparty and try again."
        }
      },
      "history": {
        "fieldLabels": {
          "number": "Number",
          "title": "Title",
          "note": "Note",
          "direction": "Direction",
          "contractType": "Contract type",
          "partyId": "Counterparty",
          "counterpartyNumber": "Counterparty's contract number",
          "validityFrom": "Validity from",
          "validityTo": "Validity until",
          "signedOn": "Signed on",
          "registryNumber": "Contract registry number",
          "archiveNumber": "Physical archive number",
          "ownerUserId": "Owner",
          "noticePeriodDays": "Notice period",
          "autoRenew": "Automatic renewal",
          "renewalTermMonths": "Renewal length",
          "currencyCode": "Currency",
          "costCenterId": "Cost centre",
          "jobId": "Job",
          "status": "Status",
          "endsOn": "Contract end",
          "validFrom": "Effective from",
          "validTo": "Effective until",
          "limitAmount": "Limit excl. VAT"
        },
        "valueChanged": "changed",
        "valueCleared": "cleared",
        "yes": "Yes",
        "no": "No",
        "days_one": "{{count}} day",
        "days_other": "{{count}} days",
        "months_one": "{{count}} month",
        "months_other": "{{count}} months",
        "termRange": "{{from}} – {{to}}",
        "termOpenEnded": "from {{from}}, indefinite",
        "termLimit": "limit {{amount}} excl. VAT",
        "noLimit": "no limit",
        "indefinite": "indefinite",
        "termModified": "Term from {{from}}: {{changes}}"
      },
      "usage": {
        "title": "Usage",
        "ariaLabel": "Limit usage",
        "used": "{{percent}} % used",
        "overLimit": "Over the limit",
        "committed": "Committed",
        "spent": "Spent",
        "remaining": "Remaining",
        "noVat": "Amounts are excl. VAT.",
        "uncounted_one": "{{count}} invoice in another currency is not counted.",
        "uncounted_other": "{{count}} invoices in another currency are not counted."
      },
      "terms": {
        "allTerms": "All terms",
        "edit": "Edit term",
        "delete": "Delete term",
        "editModal": {
          "title": "Edit term",
          "submit": "Save",
          "cancel": "Cancel",
          "validFrom": "Effective from",
          "validTo": "Effective until",
          "openEnded": "Indefinite",
          "hints": {
            "validFromFixed": "The start of a term no longer changes once the contract is active.",
            "validToFixed": "Only the last term can change its end, or a gap would open between terms."
          },
          "errors": {
            "validFromRequired": "Fill in when the term takes effect.",
            "validToRequired": "Fill in until when the term is in effect, or choose indefinite.",
            "validToBeforeFrom": "The end cannot be before the start.",
            "currentEndsBeforeToday": "The current term cannot end before today.",
            "failed": "The term could not be saved. Please try again."
          },
          "saved": "The term is saved."
        },
        "deleteConfirm": {
          "title": "Delete the term?",
          "message": "Do you really want to delete the term {{range}}?",
          "confirm": "Delete",
          "cancel": "Back"
        },
        "deleted": "The term is deleted.",
        "deleteFailed": "The term could not be deleted."
      },
      "renew": {
        "action": "Renew",
        "title": "Renew the contract",
        "startsOn": "The new term starts on {{date}}, the day after the last one ends.",
        "length": "Term length",
        "lengthOptions": {
          "SAME_AS_LAST": "As long as the last term",
          "UNTIL": "Until a chosen day",
          "INDEFINITE": "Indefinite"
        },
        "sameLengthUntil_one": "Until {{date}} ({{count}} month).",
        "sameLengthUntil_other": "Until {{date}} ({{count}} months).",
        "validTo": "Effective until",
        "submit": "Renew",
        "cancel": "Cancel",
        "errors": {
          "validToRequired": "Fill in until when the new term is in effect.",
          "validToBeforeStart": "The end cannot be before the new term starts.",
          "failed": "The contract could not be renewed. Please try again."
        },
        "success": "The contract is renewed."
      },
      "terminate": {
        "action": "Terminate",
        "endedTooltip": "The contract has already ended; there is nothing to terminate.",
        "title": "Terminate the contract",
        "end": "End of the contract",
        "modes": {
          "END_OF_TERM": "At the end of the current term",
          "ON_DATE": "On a chosen day"
        },
        "endOfTerm": "The contract ends on {{date}} and does not renew.",
        "openEnded": "The current term is indefinite; pick the day the contract ends.",
        "endsOn": "Last day in force",
        "laterTerms": "Later terms with nothing counted against them yet are deleted.",
        "submit": "Terminate",
        "cancel": "Back",
        "errors": {
          "endsOnRequired": "Pick the day the contract ends.",
          "endsOnInPast": "The contract cannot end in the past.",
          "failed": "The contract could not be terminated. Please try again.",
          "endsOnAfterTermEnd": "The contract can end on {{date}} at the latest, when the current term ends."
        },
        "success": "The contract is terminated."
      }
    },
    "credits": {
      "banner": {
        "payerTitle": "AI is paused, credits have run out",
        "payerAction": "Top up credits",
        "askAdmin": "Ask your administrator to top up credits.",
        "clientTitle": "AI is paused – contact {{master}}"
      },
      "status": {
        "panelDescription": "The document is stored. Tappeer will extract it once credits are available."
      },
      "billing": {
        "title": "Credits",
        "usage": "{{used}} / {{allotment}} credits",
        "usedPercent": "{{percent}}%",
        "available_one": "{{credits}} credit available",
        "available_other": "{{credits}} credits available",
        "extra": "+{{credits}} extra",
        "renewsOn": "Credits renew on {{date}}",
        "endsOn": "Ends on {{date}}",
        "noPeriod": "No running period",
        "progressAriaLabel": "Credit usage: {{label}}",
        "transactionsLink": "Credit statement",
        "low": "Credits are running low",
        "exhausted": "Credits have run out, AI is paused",
        "buyPack": "Buy a pack",
        "upgrade": "Upgrade plan",
        "openPortal": "Update payment",
        "upgradePaidFirst": "The upgraded plan takes effect once you pay the upgrade invoice.",
        "pendingUpgrade": {
          "title": "The upgrade to {{planName}} is waiting for its invoice to be paid",
          "payInvoice": "Pay the invoice"
        }
      },
      "packs": {
        "title": "Buy a credit pack",
        "description": "The pack's credits are added to your credits once you complete the payment.",
        "credits_one": "{{credits}} credit",
        "credits_other": "{{credits}} credits",
        "price": "{{price}} excl. VAT",
        "buy": "Buy",
        "loadMore": "Load more",
        "empty": "There is no pack for you right now.",
        "loadError": "The packs could not be loaded. Please try again in a moment.",
        "refusal": {
          "MANAGED_CLIENT": "Your office pays for your credits, so only it can buy a pack.",
          "FREE_PLAN": "Credit packs come with paid plans. Upgrade your plan for more credits.",
          "MANUAL_PLAN": "Tappeer sets up your plan. Get in touch with us for more credits.",
          "NOT_CREDITS_PLAN": "Your plan is not billed in credits, so no pack can be bought for it.",
          "SUBSCRIPTION_NOT_ACTIVE": "Your subscription is not active. Update your payment and packs will be available again.",
          "CHANGE_SCHEDULED": "A plan change or cancellation is scheduled. You can buy a pack once you cancel it or it takes effect.",
          "PENDING_DELETION": "The account is scheduled for deletion, so no pack can be bought now."
        },
        "error": {
          "notOffered": "This pack is no longer offered. Please pick another one.",
          "generic": "The payment could not be opened right now. Please try again in a moment."
        }
      },
      "transactions": {
        "title": "Credit statement",
        "backToBilling": "Back to plan",
        "columns": {
          "date": "Date",
          "type": "Type",
          "operation": "Operation",
          "bucket": "Source",
          "amount": "Change",
          "balanceAfter": "Balance",
          "user": "User",
          "client": "Client"
        },
        "entryType": {
          "CHARGE": "Charge",
          "GRANT": "Grant",
          "EXPIRY": "Expiry",
          "ADJUSTMENT": "Adjustment"
        },
        "bucket": {
          "PLAN_PERIOD": "Plan allotment",
          "PACK": "Pack",
          "MANUAL": "Manual grant"
        },
        "operator": "Tappeer",
        "formerClient": "Former or unavailable client",
        "empty": "There are no credit movements yet.",
        "loadMore": "Load more",
        "loadError": "The statement could not be loaded. Please try again in a moment.",
        "noAccess": {
          "title": "Only a billing administrator can see the credit statement",
          "description": "Ask your administrator if you need it."
        }
      },
      "purchase": {
        "success": "Credits will be added within a minute",
        "cancel": "The purchase was cancelled"
      }
    },
    "documentHandler": {
      "banner": "This document is handled by {{name}}"
    },
    "masterAccountIntegrationTemplates": {
      "list": {
        "intro": "A template is a ready installation and its connectors, which you then apply to your clients. Whatever differs per client is filled in at the client.",
        "new": "New template",
        "filter": {
          "label": "System",
          "all": "All systems"
        },
        "columns": {
          "name": "Name",
          "system": "System",
          "connectors": "Connectors",
          "updatedAt": "Updated",
          "actions": "Actions"
        },
        "connectors_one": "{{count}} connector",
        "connectors_other": "{{count}} connectors",
        "noConnectors": "No connectors",
        "needsReview": "Needs review",
        "delete": "Delete template {{name}}",
        "loadError": "The templates could not be loaded. Try reloading the page.",
        "empty": {
          "title": "No templates here yet.",
          "description": "Set up an installation once, then apply it to every client who needs it.",
          "filtered": "There is no template for this system."
        },
        "shown": "Showing {{shown}} of {{total}}",
        "loadMore": "Load more",
        "deleteConfirm": {
          "title": "Delete the template?",
          "message": "The template “{{name}}” goes away. Clients whose integration was already set up from it keep it as it is.",
          "confirm": "Delete template",
          "cancel": "Cancel",
          "done": "The template is deleted.",
          "failed": "The template could not be deleted. Please try again."
        },
        "apply": "Apply template {{name}} to clients",
        "applyShort": "Apply"
      },
      "editor": {
        "newTitle": "New integration template",
        "back": "Integration templates",
        "loadError": "The template could not be loaded. Try reloading the page.",
        "pluginUnavailable": "{{externalApp}} is not in the catalogue right now, so the template cannot be edited.",
        "basics": {
          "title": "System and name",
          "plugin": "System",
          "pluginPlaceholder": "Choose a system",
          "pluginHint": "Once the template is saved, its system cannot change.",
          "pluginLocked": "The system of a saved template cannot change. Create a new template for another system.",
          "noPlugins": "No system in the catalogue can be saved as a template.",
          "pickFirst": "Choose a system to see what the template sets up.",
          "name": "Template name",
          "nameHint": "This is how you find the template in your office."
        },
        "installation": {
          "title": "Installation",
          "description": "Every client gets these {{externalApp}} installation settings. Mark whatever differs per client with “Filled in at the client”: the template does not keep it and you fill it in when applying it.",
          "nameLabel": "Installation name at the client",
          "nameHint": "The installation gets this name at every client."
        },
        "perClient": {
          "toggle": "Filled in at the client",
          "forcedAgenda": "Every client has its own agenda, so it is always filled in at the client.",
          "forcedSecret": "Credentials belong to each client, so they are always filled in at the client.",
          "toggleFor": "Filled in per client: {{setting}}"
        },
        "connectors": {
          "title": "Connectors",
          "intro": "Every client gets these connectors. They are created switched off; you switch them on at the client.",
          "none": "{{externalApp}} offers nothing to sync.",
          "include": "Include in the template",
          "defaultName": "{{externalApp}} – {{entity}}",
          "name": "Connector name",
          "directions": "Sync direction",
          "schedule": "When it runs",
          "settings": "Connector settings",
          "settingsEmpty": "The connector has no settings of its own."
        },
        "rules": {
          "title": "Rules",
          "defaults": "Plugin default rules",
          "imported": "Imported rules",
          "custom": "Custom rules",
          "hint": "Rules are not edited in a template. Import a file exported from a connector, or keep the plugin default rules.",
          "import": "Import rules",
          "useDefaults": "Use plugin default rules",
          "confirm": {
            "file": "This connector’s rules and field flow will be replaced by those from the file {{name}}. Nothing is saved until you save the template.",
            "pasted": "This connector’s rules and field flow will be replaced by those from the pasted text. Nothing is saved until you save the template."
          },
          "replaced": "The rules are replaced. Save the template to keep them."
        },
        "needsReview": {
          "title": "The template needs a review",
          "body": "{{externalApp}} changed its settings. Go through the template and save it again before you apply it to clients."
        },
        "save": {
          "label": "Saving the template",
          "unsaved": "You have unsaved changes.",
          "new": "The new template is not saved yet.",
          "review": "The template needs to be saved again.",
          "discard": "Discard changes",
          "cancel": "Cancel",
          "save": "Save template",
          "saving": "Saving…",
          "created": "The template is saved.",
          "saved": "The template changes are saved.",
          "fixErrors": "Something in the form does not fit. Fix the highlighted fields."
        },
        "errors": {
          "nameRequired": "Enter the template name.",
          "installationNameRequired": "Enter the installation name.",
          "connectorNameRequired": "Enter the connector name.",
          "directionsRequired": "Choose at least one direction.",
          "nameConflict": "Your office already has a template with this name. Choose another name.",
          "perClientKeySet": "Every client has its own value here. Turn on “Filled in at the client”, or empty the field.",
          "perClientKeySetUnplaced": "A value every client has of its own is filled in in the template. Empty it and save the template again.",
          "pluginUnsupported": {
            "title": "This system cannot be saved as a template",
            "body": "{{externalApp}} has no shared installation settings, or keeps credentials on the connector."
          },
          "featureDisabled": {
            "title": "Integration templates are not available right now",
            "body": "They are not switched on for your office right now. Nothing was saved."
          },
          "configInvalid": "The template does not fit the system’s settings. Nothing was saved.",
          "needsReview": "The template has to be reviewed and saved again first.",
          "other": "The template could not be saved. Please try again."
        },
        "fromConnection": {
          "creating": "Saving the template from the client’s installation…",
          "created": "The template is saved. Have a look at it.",
          "failed": "The template could not be saved from the client’s installation."
        }
      },
      "perClientKeys": {
        "title": "What you fill in for each client",
        "intro": "Checked settings are not copied; you fill them in for each client.",
        "none": "The installation has no shared settings."
      },
      "saveAsTemplate": {
        "action": "Save as an office template",
        "copy": "Copy to other clients",
        "title": "Save as an office template",
        "intro": "The template is saved in your office, and you then apply it to other clients. This client’s installation stays as it is.",
        "name": "Template name",
        "nameRequired": "Enter the template name.",
        "defaultName": "{{externalApp}} – {{installation}}",
        "secretsWarning": "The installation’s credentials are copied into the office template.",
        "rulesWarning": "The connectors’ rules may contain this client’s data.",
        "confirm": "Save to the office",
        "cancel": "Cancel",
        "secretsWarningOwnBridge": "This client’s own credentials (from its own Bridge) are copied into the office template."
      },
      "actionErrors": {
        "needsReview": "The template has to be reviewed and saved again first.",
        "inProgress": "Another template is being applied in your office right now. Try again once it finishes.",
        "configInvalid": "The settings do not fit the system.",
        "featureDisabled": "Integration templates are not switched on for your office right now.",
        "notFound": "The template, the installation or the Bridge could not be found. Someone may have deleted it meanwhile.",
        "clientNotAvailable": "You cannot manage integrations at this client right now.",
        "nameConflict": "Your office already has a template with this name. Save it under another name.",
        "pluginUnsupported": "This system cannot be saved as a template.",
        "other": "Something went wrong. Please try again.",
        "retry": "Try again"
      },
      "refusals": {
        "CLIENT_NOT_AVAILABLE": "You cannot manage integrations at this client right now.",
        "BRIDGE_AGENDA_TAKEN": "Another client already uses this agenda on this Bridge.",
        "BRIDGE_AGENDA_INCOMPLETE": "The agenda is not filled in completely. Fill in all its settings.",
        "INTEGRATIONS_SUSPENDED": "The client’s integrations are suspended.",
        "INTEGRATION_TEMPLATE_CLIENT_ALREADY_CONFIGURED": "The client already has a connector of this system. Nothing changed there.",
        "INTEGRATION_TEMPLATE_NAME_CONFLICT": "The client already has an installation with this name. Choose another name.",
        "INTEGRATION_TEMPLATE_CONFIG_INVALID": "The client’s settings do not fit.",
        "other": "The client could not be set up."
      },
      "apply": {
        "title": "Apply template “{{name}}”",
        "titleLoading": "Apply template",
        "back": "Integration templates",
        "loadError": "The template could not be loaded. Try reloading the page.",
        "pluginUnavailable": "{{externalApp}} is not in the catalogue right now, so the template cannot be applied.",
        "copyTitle": "Copy an installation to other clients",
        "copySource": "Copying from “{{client}} · {{installation}}”. No template is saved.",
        "copyUnknownClient": "Client",
        "saveAsTemplate": "Save as an office template",
        "needsReview": {
          "title": "The template needs a review",
          "body": "{{externalApp}} changed its settings. Go through the template and save it again; then you can apply it.",
          "open": "Open the template"
        },
        "steps": {
          "bridge": "Bridge",
          "clients": "Clients",
          "values": "Client details",
          "summary": "Summary"
        },
        "next": "Continue",
        "previous": "Back",
        "bridge": {
          "intro": "Choose the office Bridge the clients reach {{externalApp}} through.",
          "label": "Office Bridge",
          "empty": "No office Bridge serves {{externalApp}} right now.",
          "emptyHint": "Run a Bridge on the computer with {{externalApp}} and wait until it reports in.",
          "openBridges": "Open office Bridges",
          "required": "Choose a Bridge.",
          "loadError": "The office Bridges could not be loaded. Try reloading the page."
        },
        "clients": {
          "intro": "Choose the clients you set the integration up for.",
          "loadError": "The clients could not be loaded. Try reloading the page.",
          "incomplete": "Some clients could not be loaded, so the list is not complete.",
          "empty": "Your office has no other clients yet.",
          "search": "Search clients",
          "selected": "{{selected}} of max. {{max}} chosen",
          "limit": "You can apply to at most {{max}} clients at once. Apply to the rest in another round.",
          "noMatch": "No client matches.",
          "columns": {
            "choose": "Choose",
            "name": "Client"
          },
          "choose": "Choose client {{name}}",
          "required": "Choose at least one client."
        },
        "values": {
          "intro": "Fill in what each client has of its own.",
          "introNone": "The template needs nothing else from the clients. Just check the installation names.",
          "client": "Client",
          "installationName": "Installation name",
          "installationNameRequired": "Enter the installation name.",
          "fieldFor": "{{setting}} – {{client}}"
        },
        "summary": {
          "running": "Setting the clients up. This may take a moment.",
          "created_one": "Each client gets an installation and {{count}} switched-off connector.",
          "created_other": "Each client gets an installation and {{count}} switched-off connectors.",
          "createdCopy": "Each client gets an installation and the same connectors as the source, all switched off.",
          "bridge": "Bridge",
          "clients": "Clients",
          "enableLater": "You switch the connectors on and run the first sync at each client separately.",
          "secretsWarning": "The source installation’s credentials are copied into the chosen clients’ installations.",
          "rulesWarning": "The connectors’ rules may contain the source client’s data.",
          "apply": "Apply to clients",
          "confirm": {
            "title": "Apply to the clients?",
            "message": "Chosen clients: {{clients}}. Each gets an installation and switched-off connectors; nothing else changes there.",
            "cancel": "Cancel"
          },
          "secretsWarningOwnBridge": "The source client’s own credentials (from its own Bridge) are copied into the chosen clients’ installations."
        },
        "results": {
          "title": "Result",
          "appliedCount": "Set up: {{applied}} of {{total}}",
          "refusedCount": "Not set up: {{refused}}",
          "enableHint": "The connectors are switched off. Switch them on and run the first sync at each client.",
          "columns": {
            "client": "Client",
            "status": "Status",
            "detail": "Detail"
          },
          "unknownClient": "Unavailable client",
          "applied": "Set up",
          "refused": "Not set up",
          "open": "Open at the client",
          "openFor": "Open the installation at {{client}}",
          "fieldError": "{{field}}: {{message}}",
          "backToList": "Back to templates",
          "again": "Apply to more clients"
        },
        "errors": {
          "title": "Nothing was applied to the clients.",
          "partialTitle": "The apply did not finish.",
          "partialBody": "Some clients may already be set up. Try again — the server skips the clients already set up."
        }
      }
    },
    "partyBankAccounts": {
      "title": "Bank accounts for payments",
      "description": "Payments go only to a verified account. An account is verified once two different people sign it.",
      "add": "Add account",
      "showAll": "Show inactive, rejected and revoked too",
      "empty": "No bank accounts yet.",
      "loadError": "The bank accounts could not be loaded.",
      "loadMore": "Load more",
      "row": {
        "anyCurrency": "Any currency",
        "default": "Default",
        "inactive": "Inactive",
        "iban": "IBAN {{iban}}",
        "bic": "BIC {{bic}}",
        "actions": "More account actions"
      },
      "actions": {
        "sign": "Sign",
        "edit": "Edit",
        "history": "History",
        "reject": "Reject",
        "revoke": "Revoke",
        "deactivate": "Deactivate"
      },
      "form": {
        "addTitle": "Add a bank account",
        "addDescription": "A new account stays unverified until two people sign it.",
        "editTitle": "Edit the bank account",
        "submitAdd": "Add account",
        "submitEdit": "Save",
        "cancel": "Cancel",
        "required": "Fill this in.",
        "anyCurrency": "Any currency",
        "fields": {
          "scheme": "Account type",
          "iban": "IBAN",
          "accountNumber": "Account number",
          "bankIdentifier": {
            "CZ": "Bank code",
            "SK": "Bank code",
            "GB_SORT_CODE": "Sort code",
            "US_ABA": "Routing number (ABA)",
            "OTHER": "Bank code"
          },
          "countryCode": "Country",
          "bic": "BIC (SWIFT), optional",
          "label": "Label, optional",
          "currencyCode": "Currency",
          "isDefault": "Default account for this currency"
        },
        "hints": {
          "domesticAccountNumber": "With its prefix, e.g. 19-2000145399."
        }
      },
      "errors": {
        "invalid": "This account number does not check out. Have a look at it.",
        "duplicate": "This account is already here.",
        "inactive": "The account was deactivated meanwhile.",
        "stateConflict": "That is not possible in the state the account is in.",
        "signerIsCreator": "You added the account, so someone else must give the second signature.",
        "signerIsFirstSigner": "You gave the first signature, so someone else must give the second.",
        "signerIsLastEditor": "You changed the account last, so someone else must give the second signature.",
        "signerIsStatementUploader": "You uploaded the bank statement behind the system's signature, so someone else must give the second signature.",
        "stateChanged": "The account changed meanwhile. We've loaded its current state.",
        "evidenceStale": "The evidence the system's signature relied on no longer holds, so the second signature can't be given. Reject the account and add it again so it is checked afresh.",
        "personRequired": "A person has to do this, not an API key.",
        "notPrinted": "The invoice does not show one valid account that could be added.",
        "supplierNotLinked": "The invoice has no supplier yet. Pick one first.",
        "other": "That didn't work. Please try again."
      },
      "bankingErrors": {
        "required": "Fill this in.",
        "invalidFormat": "This account number does not check out. Have a look at it.",
        "unknownBankCode": "We don't know this bank code.",
        "prefixMod11Failed": "The account prefix does not check out. Have a look at it.",
        "accountMod11Failed": "The account number does not check out. Have a look at it.",
        "ibanRequired": "Fill in the IBAN.",
        "ibanTooShort": "The IBAN is too short.",
        "ibanInvalidCountryCode": "The IBAN starts with a country code we don't know.",
        "ibanInvalid": "This IBAN does not check out. Have a look at it.",
        "bicRequired": "Fill in the BIC.",
        "bicInvalidLength": "A BIC has 8 or 11 characters.",
        "bicInvalid": "This BIC does not check out (e.g. GIBACZPX).",
        "schemeUnknown": "We don't know this account type.",
        "countryCodeInvalid": "Pick a country.",
        "countryMismatch": "The country does not go with this account type.",
        "schemeRequiredForCountry": "This country has its own account type; pick it (e.g. IBAN).",
        "bankIdentifierRequired": "Fill in the bank code.",
        "bankIdentifierInvalid": "This bank code does not check out.",
        "accountNumberRequired": "Fill in the account number.",
        "accountNumberInvalid": "This account number does not check out.",
        "routingChecksumFailed": "The routing number does not check out. Have a look at it."
      },
      "sign": {
        "firstTitle": "Sign the bank account",
        "firstMessage": "You are giving the first signature. The account is verified once someone else signs it too.",
        "secondTitle": "Second signature",
        "secondMessage": "With your signature the account becomes verified and can be paid to.",
        "confirm": "Sign",
        "cancel": "Back",
        "firstSignature": "First signature",
        "firstSignedBy": "{{name}}, {{date}}",
        "firstSignerGone": "Someone who no longer has access, {{date}}",
        "systemSigned": "The system, after an independent check, {{date}}",
        "evidenceLoadError": "The check's evidence could not be loaded.",
        "evidenceRetry": "Try again",
        "evidenceMissing": "The check's evidence is missing, so the second signature cannot be given now."
      },
      "evidence": {
        "e1": "The ERP reported this account through an ERP connector before Tappeer ever sent it.",
        "e1Named": "The ERP reported this account through the connector {{connector}} before Tappeer ever sent it.",
        "e2": "A bank statement confirmed an earlier payment to this partner into this account.",
        "e3": "The VAT payer register publishes the account.",
        "register": "Register",
        "vatId": "VAT ID",
        "companyId": "Company ID",
        "registerCompanyId": "Company ID in the register",
        "registerName": "Name in the register",
        "checkedOn": "Checked on",
        "registers": {
          "ADIS": "VAT payer register (Czech Financial Administration)",
          "ODFS": "VAT payer register (Slovak Financial Administration)"
        },
        "notGiven": "not given",
        "nameMismatch": "The register gives a different name than the partner has ({{partyName}}). Before you sign, make sure it is the same company."
      },
      "terminal": {
        "rejectTitle": "Reject the bank account",
        "rejectMessage": "A rejected account cannot be used again. If it is needed later, it is added as a new account.",
        "revokeTitle": "Revoke the verification",
        "revokeMessage": "A revoked account cannot be used again. If it is needed later, it is added as a new account.",
        "reason": "Reason, optional",
        "confirmReject": "Reject",
        "confirmRevoke": "Revoke",
        "cancel": "Back"
      },
      "deactivate": {
        "title": "Deactivate the bank account",
        "message": "The account stays in the history, but nothing will be paid to it.",
        "confirm": "Deactivate",
        "cancel": "Back"
      },
      "history": {
        "title": "Account history",
        "empty": "Nothing here yet.",
        "loadError": "The history could not be loaded.",
        "system": "System",
        "unknownActor": "No person recorded",
        "reason": "Reason: {{reason}}",
        "close": "Close",
        "loadMore": "Load more"
      },
      "toast": {
        "created": "The account is added. It now waits for signatures.",
        "updated": "Saved.",
        "signedFirst": "Signed. The second signature comes next.",
        "verified": "Done, the account is verified.",
        "rejected": "The account is rejected.",
        "revoked": "The verification is revoked.",
        "deactivated": "The account is deactivated."
      },
      "invoice": {
        "accept": "Accept as a new account",
        "accepting": "Adding…",
        "accepted": "The account is added to the partner as unverified.",
        "alreadyThere": "The partner already has this account; it is waiting for signatures.",
        "openPartner": "Partner's bank accounts"
      }
    },
    "bankMovements": {
      "title": "Bank movements",
      "searchPlaceholder": "Counterparty, reference or message",
      "totalCount": "Total: {{count}}",
      "loadMore": "Load more",
      "loadError": "Bank movements could not be loaded.",
      "retry": "Try again",
      "noResults": "No bank movement matches the filters.",
      "empty": {
        "title": "There are no bank movements yet.",
        "description": "They come from bank statements and from the ERP."
      },
      "sort": {
        "bookingDate": "Date",
        "amount": "Amount"
      },
      "filters": {
        "title": "Filters",
        "apply": "Show",
        "clear": "Clear filters",
        "source": "Source",
        "channel": "Channel",
        "direction": "Direction",
        "resolution": "Matching",
        "ownBankAccount": "Our account",
        "any": "All",
        "anyAccount": "All accounts",
        "bookingDate": "Booking date",
        "from": "From",
        "to": "To",
        "includeInactive": "Also show documents no longer in the ERP"
      },
      "table": {
        "bookingDate": "Date",
        "amount": "Amount",
        "counterparty": "Counterparty",
        "reference": "Reference",
        "origin": "Source",
        "resolution": "Matching",
        "ownBankAccount": "Our account",
        "open": "Open the bank movement of {{date}}",
        "inactive": "No longer in the ERP"
      },
      "detail": {
        "title": "Bank movement",
        "bookingDate": "Booking date",
        "valueDate": "Value date",
        "counterparty": "Counterparty",
        "counterpartyAccount": "Counterparty account",
        "ownBankAccount": "Our account",
        "source": "Source",
        "channel": "Channel",
        "creditorReference": "Creditor reference",
        "remittanceInfo": "Message for the recipient",
        "endToEndId": "End-to-end ID",
        "bankReference": "Bank reference",
        "returnCode": "Return reason",
        "createdAt": "Loaded into Tappeer",
        "updatedAt": "Last changed",
        "inactive": "This document is no longer in the ERP. It stays here for the record.",
        "close": "Close",
        "erp": {
          "title": "ERP document",
          "documentNumber": "Document number",
          "fiscalYear": "Fiscal year"
        },
        "statement": {
          "title": "Bank statement",
          "number": "Statement number",
          "period": "Period",
          "format": "Format"
        },
        "pairings": {
          "title": "Paired invoices",
          "empty": "The ERP paired this document with no invoice.",
          "invoiceGone": "The invoice is no longer available",
          "invoiceWithoutNumber": "Invoice without a number"
        }
      },
      "documentKind": {
        "BANK": "Bank document",
        "CASH": "Cash document",
        "INTERNAL": "Internal document"
      },
      "invoicePanel": {
        "title": "Payments from bank and cash desk",
        "document": "{{kind}} {{number}}",
        "total": "of {{amount}} in total"
      },
      "tabs": {
        "movements": "Movements",
        "statements": "Statements",
        "queue": "To match"
      },
      "upload": {
        "action": "Upload statement",
        "title": "Upload a bank statement",
        "description": "We'll read the statement's movements and try to match them with payments.",
        "file": "Statement file",
        "dropTitle": "Pick the statement file",
        "dropDescription": "CAMT.053, MT940 or ABO (GPC)",
        "remove": "Remove the file",
        "format": "Format",
        "formatAuto": "Detect automatically",
        "formatHint": "We detect the format ourselves. Pick it only if you want to set it.",
        "submit": "Upload statement",
        "cancel": "Cancel",
        "close": "Close",
        "success": "The statement is uploaded. We'll read it now.",
        "existing": {
          "title": "This file is already uploaded.",
          "state": "Uploaded {{date}} · {{status}}",
          "open": "Show in statements"
        },
        "refusal": {
          "FILE_MISSING": "Pick the statement file.",
          "FILE_NAME_INVALID": "The file name has characters we don't allow, or is too long. Rename it and try again.",
          "FORMAT_INVALID": "We don't know this format. Pick CAMT.053, MT940 or ABO (GPC), or let us detect it.",
          "UPLOADER_INVALID": "Only a person signed in as themselves uploads a statement, not while impersonating.",
          "SUBSCRIPTION_LOCKED": "The office's subscription is paused, so a statement can't be uploaded now.",
          "FORBIDDEN": "You don't have permission to upload statements.",
          "TOO_SLOW": "The file didn't arrive in time. Check your connection and try again.",
          "TOO_LARGE": "The file is too large. A statement can be at most 10 MB.",
          "BUSY": "Too many files are being uploaded right now. Try again in a moment.",
          "FAILED": "The statement couldn't be uploaded. Try again."
        },
        "dropDescriptionWithoutGpc": "CAMT.053 or MT940"
      },
      "imports": {
        "table": {
          "file": "File",
          "uploadedBy": "Uploaded by",
          "status": "State",
          "content": "Content"
        },
        "statementCount_one": "{{count}} statement",
        "statementCount_other": "{{count}} statements",
        "lineCount_one": "{{count}} movement",
        "lineCount_other": "{{count}} movements",
        "content": "{{statements}} · {{lines}}",
        "skipped": "Uploaded before: {{statements}} · {{lines}}",
        "continuityGap": "The statement doesn't continue the previous one: the balances don't match. A statement may be missing.",
        "position": {
          "statement": "Statement {{number}}",
          "line": "line {{line}}",
          "lineColumn": "line {{line}}, column {{column}}",
          "path": "at {{path}}"
        },
        "failure": {
          "FILE_EMPTY": "The file is empty.",
          "FILE_TOO_LARGE": "The file is too large. A statement can be at most 10 MB.",
          "FORMAT_UNKNOWN": "This doesn't look like a statement we can read. Upload a CAMT.053 or MT940 statement.",
          "FORMAT_UNKNOWN_GPC": "It's an ABO (GPC) statement, and reading those isn't switched on yet. Download the statement from your bank as CAMT.053 or MT940.",
          "FORMAT_MISMATCH": "The file is in another format than the one you picked. Upload it again and let us detect the format.",
          "FORMAT_VERSION_UNSUPPORTED": "We can't read this version of the format yet. Try downloading the statement in another version.",
          "ENCODING_UNSUPPORTED": "The file is in an encoding we can't read.",
          "ENCODING_INVALID": "The file holds characters that don't fit its encoding. It may be damaged.",
          "XML_FORBIDDEN": "The file holds XML parts we don't read for security reasons.",
          "XML_MALFORMED": "The file isn't valid XML. It may be damaged or incomplete.",
          "RECORD_INVALID": "The statement holds a record we don't understand.",
          "FIELD_MISSING": "A required field is missing in the statement.",
          "FIELD_INVALID": "A field in the statement can't be read.",
          "LIMIT_EXCEEDED": "The statement is too big for us: too many movements or too long fields.",
          "CURRENCY_MISMATCH": "The statement's currency doesn't fit: it differs from our account's, or the statement mixes currencies.",
          "BALANCE_MISMATCH": "The balances and movements in the statement don't add up.",
          "NO_STATEMENTS": "The file holds no statement.",
          "OWN_ACCOUNT_NOT_REGISTERED": "The statement is of an account that isn't one of ours. Add it in Settings → Bank accounts and upload the statement again.",
          "OWN_ACCOUNT_AMBIGUOUS": "The statement's account matches more than one of our accounts. Fix them in Settings → Bank accounts and upload the statement again.",
          "STATEMENT_OVERLAP": "We already hold a statement of this account for the same period in another format. Upload one account's statements in one format.",
          "PARSE_TIME_BUDGET_EXCEEDED": "Reading the file took too long. Try a smaller statement.",
          "INTERNAL": "Something went wrong on our side. Try uploading the file again."
        },
        "loadError": "The statements couldn't be loaded.",
        "empty": {
          "title": "No statement has been uploaded yet.",
          "description": "Upload a bank statement as CAMT.053 or MT940."
        }
      },
      "queue": {
        "filters": {
          "show": "Show",
          "showWaiting": "Waiting to be matched",
          "showDismissed": "Taken out",
          "returns": "Returns",
          "returnsAll": "All movements",
          "returnsOnly": "Returns only",
          "returnsNone": "Without returns"
        },
        "return": "Return",
        "returnCode": "Return code {{code}}",
        "statement": "Statement {{number}}",
        "noProposal": "We haven't found a payment for this movement.",
        "history": "Earlier proposals ({{number}})",
        "dismissed": "Taken out: {{reason}}",
        "payment": {
          "gone": "The payment is no longer available.",
          "noPayee": "Unknown payee",
          "invoices": "Invoices: {{numbers}}",
          "invoiceWithoutNumber": "no number",
          "run": "Run {{number}}",
          "runExecution": "Run {{number}} · to execute on {{date}}"
        },
        "sum": {
          "total": "Total"
        },
        "duplicate": {
          "title": "Possible double debit",
          "body": "Another movement already confirmed this payment, so the money may have left twice. The proposal can only be rejected, or the movement taken out of matching.",
          "titleOtherAccount": "Possible double debit to another account",
          "bodyOtherAccount": "Another movement already confirmed this payment, and this money also went to another account than the payment's. Check it with the bank. The proposal can only be rejected, or the movement taken out of matching."
        },
        "actions": {
          "accept": "Accept",
          "reject": "Reject",
          "dismiss": "Not ours",
          "reopen": "Back to matching",
          "acceptSum": "Accept all",
          "rejectSum": "Reject all",
          "matchByHand": "Match by hand",
          "createPayment": "Create payment"
        },
        "accept": {
          "title": "Accept the proposal",
          "titleSum": "Accept the sum of payments",
          "summary": "On the statement {{line}} · payment {{payment}}",
          "summarySum": "On the statement {{line}} · payments in total {{total}}",
          "returnWarning": "The payment will be marked as returned by the bank, and its invoices can be paid again.",
          "difference": "Difference",
          "differenceAmount": "Difference amount",
          "differenceHint": "The statement's amount less the payment's, in the payment's currency.",
          "note": "Note",
          "noteReturnHint": "The return is less than the payment. Say why, for example a bank fee.",
          "submit": "Accept",
          "submitSum": "Accept all",
          "cancel": "Cancel",
          "success": "Done. The movement is matched.",
          "differenceMissing": "Enter the difference amount.",
          "differenceInvalid": "The difference can't be zero and has at most four decimal places.",
          "noteRequired": "Say why the return is less.",
          "noteTooLong": "A note can be at most {{max}} characters.",
          "noteReturnUnstatedHint": "The return isn't in the payment's currency. Say how much of the payment came back.",
          "differenceNamedHint": "The statement states no amount in the payment's currency. Enter the difference in the payment's currency: the statement's amount less the payment's, with a minus when less came.",
          "sumInfo": "The movement confirms all these payments at once, with no difference.",
          "partialInfo": "The statement shows {{shortfall}} less than the payment. You accept it as a partial payment: {{paid}} is paid, the rest is cancelled and its invoices can be paid again.",
          "shortfall": "The unpaid rest falls on",
          "shortfallByDueDate": "Invoices by due date",
          "shortfallByDueDateHint": "Invoices due first are paid first; the last ones carry the unpaid rest. Invoices the ERP confirmed and netted credit notes stay paid.",
          "shortfallChosenHint": "This invoice carries the whole unpaid rest; the others stay paid.",
          "shortfallOption": "{{amount}} in the payment",
          "discountLost": "Invoice {{number}} will be paid only in part, so it loses its discount of {{amount}}.",
          "belowConfirmed": "Invoices the ERP confirmed, together with netted credit notes, stay paid: {{stayingPaid}}. The movement pays less, so it can't be accepted as a partial payment.",
          "partialWithoutRun": "The statement shows less than the payment, but the payment isn't from a payment run, so it can't be split as a partial payment. Reject the proposal, or take the movement out of matching.",
          "split": {
            "label": "What the movement pays and what becomes payable again",
            "invoice": "Invoice",
            "due": "Due",
            "inPayment": "In the payment",
            "paid": "Paid",
            "payableAgain": "Payable again",
            "creditNote": "Netted credit note",
            "erpConfirmed": "Confirmed by the ERP"
          }
        },
        "reject": {
          "title": "Reject the proposal",
          "description": "We won't propose this payment for the movement again.",
          "descriptionSum": "You reject every payment of the sum at once. We won't propose any of them for this movement again.",
          "note": "Why isn't it this payment?",
          "noteSum": "Why aren't these the payments?",
          "submit": "Reject",
          "cancel": "Cancel",
          "success": "The proposal is rejected.",
          "noteTooLong": "A note can be at most {{max}} characters."
        },
        "dismiss": {
          "title": "Not ours",
          "description": "The movement belongs to none of our payments, for example wages or a transfer between accounts. Its open proposals go away.",
          "reason": "Reason",
          "submit": "Take out of matching",
          "cancel": "Cancel",
          "success": "The movement is taken out of matching.",
          "reasonTooLong": "A reason can be at most {{max}} characters."
        },
        "reopen": {
          "title": "Put the movement back into matching?",
          "message": "We'll try to match it again. Rejected proposals stay rejected.",
          "submit": "Back to matching",
          "cancel": "Cancel",
          "success": "The movement is back in matching."
        },
        "match": {
          "title": "Match by hand",
          "description": "On the statement {{line}}. Pick the open payment the movement belongs to.",
          "noCounterparty": "The movement names no counterparty account, so we offer only payments of the same amount. They can't take a difference.",
          "candidates": "Open payments",
          "empty": "No open payment fits this movement. We offer only sent payments from the same account and in the same currency that no statement has confirmed yet.",
          "loadError": "The open payments couldn't be loaded.",
          "submit": "Match",
          "cancel": "Cancel",
          "success": "Done. The movement is matched."
        },
        "createPayment": {
          "title": "Create payment",
          "description": "On the statement {{line}}. Pick the supplier and the invoices the movement paid.",
          "party": "Supplier",
          "partyPlaceholder": "Pick a supplier",
          "creditedAccount": "Credited account",
          "unverified": {
            "title": "The money went to an unverified account",
            "noCounterparty": "The movement names no counterparty account, so the payment won't be credited to any of the supplier's verified accounts.",
            "notVerified": "The movement's account isn't among the supplier's verified accounts. The payment is saved with no credited account."
          },
          "invoices": "The supplier's invoices",
          "invoice": "Invoice",
          "due": "Due",
          "outstanding": "Outstanding",
          "amount": "Amount to pay",
          "amountFor": "Amount for invoice {{number}}",
          "invoiceWithoutNumber": "no number",
          "amountInvalid": "Enter an amount above zero, with at most four decimal places.",
          "amountExceedsOutstanding": "That's more than the invoice still owes.",
          "loaded": "Loaded {{loaded}} of {{total}}",
          "empty": "This supplier has no invoice the movement could pay. Only submitted invoices in the movement's currency that still owe something and that no released run holds fit.",
          "loadError": "The supplier's invoices couldn't be loaded.",
          "sum": "Total {{total}} · movement {{line}}",
          "sumMatches": "The total matches the movement.",
          "sumShort": "{{amount}} still to allocate.",
          "sumOver": "That's {{amount}} more than the movement.",
          "tooMany": "One payment can pay at most {{max}} invoices.",
          "submit": "Create payment",
          "cancel": "Cancel",
          "success": "Done. The payment is created and the movement matched.",
          "accountsLoadError": "The supplier's verified accounts couldn't be loaded, so we can't tell which account the payment credits."
        },
        "refusal": {
          "personRequired": "Only a person signed in as themselves decides, not an API key or impersonation.",
          "runAuthor": "You prepared or edited the payment in its run. Someone else has to decide on it.",
          "statementUploader": "You uploaded the statement, or we don't know who did. Only someone we know didn't upload it decides.",
          "blockedRunAuthor": "You built or edited a run whose export can't be withdrawn because of this movement's earlier match. Someone else decides a match that would free it.",
          "counterpartyDiffers": "The money went to another account than the payment's. Such a proposal can only be rejected.",
          "proposalStale": "The proposal is already decided.",
          "duplicate": "Another movement already confirmed this payment, so this may be a double debit. Such a proposal can only be rejected.",
          "lineDuplicate": "A proposal of a possible double debit waits on the movement. Reject it first, or take the movement out of matching.",
          "createPaymentRunAuthor": "You built or edited the run of a payment proposed for this movement. Someone else has to create the payment from it."
        },
        "errors": {
          "proposalStale": "The proposal no longer stands: it changed meanwhile. Look at the movement again.",
          "noteRequired": "Add a note. It is required for a rejection and for a return less than the payment.",
          "differenceRequired": "The amount differs. Say whether it is a bank fee or an FX difference, and how much.",
          "differenceInvalid": "The difference must be exactly the statement's amount less the payment's. A fee is always positive, and an FX difference applies only to a converted payment.",
          "returnExceedsPayment": "The return is more than the payment. This proposal can't be accepted.",
          "notDismissable": "This movement is no longer waiting to be matched. Look at it again.",
          "notReopenable": "This movement isn't taken out, so there's nothing to put back.",
          "dismissReasonRequired": "Say why the movement isn't ours.",
          "paymentNotConfirmable": "This payment can't be confirmed by the movement now: it changed meanwhile.",
          "partialConverted": "A partial payment can be named only for a movement in the payment's currency that wasn't converted.",
          "shortfallAllocationInvalid": "The unpaid rest can be carried only by an invoice of the payment the ERP hasn't confirmed as paid, and only with a partial payment.",
          "shortfallExceedsAllocation": "The invoice you picked pays less than the unpaid rest. Pick another one.",
          "partialBelowConfirmed": "The movement pays less than the invoices the ERP already confirmed as paid.",
          "sumDifferenceInvalid": "A sum of several payments is accepted without any difference: no fee, FX difference or partial payment.",
          "sumAmountDiffers": "The payments of this sum no longer add up to the movement. Look at it again.",
          "notMatchable": "This movement is no longer waiting to be matched, so it can't be matched by hand. Look at it again.",
          "matchNotCandidate": "The movement can't be matched to this payment. Pick a sent payment from the same account, in the same currency, that no statement has confirmed yet.",
          "matchCounterpartyDiffers": "The money went to another account than the payment's. The movement can't be matched to this payment.",
          "matchNamesAnotherPayment": "The movement carries another payment's identification (end-to-end ID or symbols). It can only be matched to that payment.",
          "matchDifferenceNeedsCounterparty": "The movement names no counterparty account, so it can be matched by hand only to a payment of the same amount, with no difference.",
          "queuePaymentLineInvalid": "This movement is no longer waiting to be matched, so no payment can be created from it. Look at it again.",
          "queuePaymentNamesPayment": "The movement carries the identification of one of our payments (end-to-end ID or symbols). Match it to that payment instead.",
          "queuePaymentRestOtherPayee": "The movement is the unpaid rest of one of our payments. It can be paid only to that payment's payee.",
          "queuePaymentAllocationsInvalid": "Pick at least one invoice, each only once, with an amount above zero.",
          "queuePaymentSumDiffers": "The amounts for the invoices must add up to the movement's amount exactly.",
          "queuePaymentInvoiceOtherParty": "One of the invoices is from another supplier than the one paid.",
          "queuePaymentInvoiceCurrencyDiffers": "One of the invoices is in another currency than the movement.",
          "queuePaymentInvoiceArchived": "One of the invoices is archived, so the movement can't pay it.",
          "queuePaymentInvoiceReserved": "One of the invoices is in a released payment run, which pays it.",
          "queuePaymentInvoiceNotRecordable": "One of the invoices can't take a payment.",
          "queuePaymentInvoiceNotSubmitted": "One of the invoices is still a draft or was rejected. Submit it for approval first.",
          "queuePaymentExceedsOutstanding": "The amount for one of the invoices is more than is left to pay on it.",
          "acceptFailed": "The proposal couldn't be accepted.",
          "rejectFailed": "The proposal couldn't be rejected.",
          "dismissFailed": "The movement couldn't be taken out.",
          "reopenFailed": "The movement couldn't be put back into matching.",
          "matchFailed": "The movement couldn't be matched.",
          "createPaymentFailed": "The payment couldn't be created."
        },
        "loadError": "The movements to match couldn't be loaded.",
        "noResults": "No movement matches the filters.",
        "emptyDismissed": "No movement is taken out.",
        "empty": {
          "title": "Nothing to match right now.",
          "description": "Statement movements we couldn't match ourselves show up here."
        }
      }
    },
    "payments": {
      "blocked": "Blocked",
      "invoicePanel": {
        "title": "Payments",
        "paidOf": "Paid {{paid}} of {{total}}",
        "outstanding": "Left to pay {{amount}}",
        "source": {
          "LEDGER": "From payments in Tappeer",
          "ERP": "From the ERP"
        },
        "erpReports": "The ERP reports: {{state}}",
        "mismatch": {
          "title": "Tappeer and the ERP disagree",
          "body": "From payments in Tappeer: {{ledgerStatus}}. The ERP reports: {{erpStatus}}. We overwrote nothing. Check it in the ERP, or record the missing payment."
        },
        "origin": {
          "RUN": "Payment from a payment run",
          "RECORDED": "Recorded payment",
          "MIGRATION": "Carried-over payment",
          "QUEUE": "Payment from a bank movement"
        },
        "payee": "To: {{name}}",
        "discount": "Discount {{amount}}",
        "withholding": "Withholding {{amount}}",
        "migrated": "Carried over from the invoice's earlier state",
        "openMovement": "Open {{document}}",
        "openStatementLine": "{{source}} – open the movement from the statement",
        "revoked": "Revoked",
        "erpWithdrawn": "The ERP document no longer confirms it",
        "awaitingConfirmation": "Waiting for confirmation.",
        "revoke": "Revoke",
        "confirm": "Confirm payment"
      },
      "record": {
        "action": "Record payment",
        "title": "Record payment",
        "description": "Record a payment you made outside Tappeer — in your bank, by card or in cash. It's saved as your confirmation.",
        "amount": "Amount",
        "paidOn": "Payment date",
        "dateRequired": "Choose the payment date.",
        "method": "Payment method",
        "methodRequired": "Choose the payment method.",
        "payee": "Paid to",
        "payeeSupplier": "The supplier",
        "payeeColleague": "A colleague who paid it",
        "colleague": "Who",
        "colleaguePlaceholder": "Choose a colleague",
        "colleagueRequired": "Choose who paid it.",
        "creditAccount": "To the supplier's account",
        "creditAccountHint": "Optional. Only verified accounts are offered.",
        "noCreditAccount": "Not specified",
        "submit": "Record payment",
        "cancel": "Cancel",
        "success": "The payment is recorded."
      },
      "confirm": {
        "title": "Confirm payment",
        "description": "It's saved as your confirmation. When a bank statement or an ERP document arrives, it's added beside it.",
        "paidOn": "Payment date",
        "submit": "Confirm payment",
        "cancel": "Cancel",
        "success": "The payment is confirmed."
      },
      "revoke": {
        "title": "Revoke manual confirmation",
        "description": "The payment stops being confirmed unless a statement or the ERP confirmed it.",
        "statementTitle": "Revoke statement confirmation",
        "statementDescription": "The movement goes back to the movements to match, and the invoice stops being paid unless the ERP or a person confirmed it by hand. A payment recorded by hand or created from the movement is cancelled, and the invoice opens for payment again.",
        "statementAction": "Revoke confirmation",
        "reason": "Reason",
        "reasonTooLong": "The reason can have at most {{max}} characters.",
        "submit": "Revoke",
        "cancel": "Cancel",
        "success": "The confirmation is revoked."
      },
      "refusal": {
        "personRequired": "Only a person signed in as themselves can record, confirm or revoke a payment, not an API key or impersonation.",
        "runAuthor": "You prepared or edited the run. Someone else has to confirm its payment.",
        "alreadyConfirmed": "Someone has already confirmed this payment by hand.",
        "notConfirmable": "This payment can't be confirmed by hand now.",
        "notRevocable": "This confirmation can no longer be revoked.",
        "partialSplit": "The confirmation of a partial payment can't be revoked. It split the payment into the paid part and the unpaid rest.",
        "returnPaidAgain": "The return can't be revoked now: another payment pays the invoice meanwhile.",
        "bankLineEvidenceUsed": "This confirmation can't be revoked. It let the export of a run this movement confirmed earlier be withdrawn. If the confirmation is wrong, contact the account administrator.",
        "invoiceNotRecordable": "A payment can't be recorded on this document.",
        "nothingOutstanding": "Nothing is left to pay on this document.",
        "personRequiredRun": "Only a person signed in as themselves can do this, not an API key or impersonation.",
        "personRequiredApproval": "Only a person signed in as themselves can approve and release a run, not an API key or impersonation.",
        "approveAuthor": "You prepared or edited the run. Someone else has to approve it.",
        "releaseAuthor": "You prepared or edited the run. Someone else has to release it.",
        "releaseApprover": "You approved the run, or unblocked a payment in it after approval. A third person has to release it.",
        "unblockAuthor": "You prepared or edited the run. Someone else has to unblock a payment in it.",
        "unblockReleaser": "You released the run. Someone else has to unblock a payment in it.",
        "noPayment": "The run has no payment to send.",
        "exportNothingToSend": "No payment can go into the file now: each one is blocked, confirmed or cancelled. Unblock a blocked payment, or cancel the run.",
        "confirmationStands": "A statement, the ERP or a person already confirmed a payment. The money went out, so the export can't be withdrawn.",
        "bankLineEvidence": "A movement from the statement showed the money of this run leave. Its confirmation is revoked, but until that movement confirms another payment of any run, the export can't be withdrawn.",
        "paymentConfirmationStands": "A statement or a person already confirmed the payment. The money went out, so it can't be cancelled."
      },
      "qrRefusal": {
        "notApproved": "The document isn't approved yet.",
        "inPaymentRun": "The document is already in a payment run.",
        "erpReportsPaid": "The ERP reports the document as paid.",
        "nothingOutstanding": "Nothing is left to pay on the document.",
        "noBankAccount": "The document has no valid bank account.",
        "qrUnavailable": "A QR payment can't be created for this document."
      },
      "errors": {
        "recordFailed": "The payment couldn't be recorded.",
        "invoiceNotApproved": "A payment can only be recorded on an approved document.",
        "confirmFailed": "The payment couldn't be confirmed.",
        "revokeFailed": "The confirmation couldn't be revoked.",
        "dateInFuture": "A payment can't be in the future.",
        "exceedsOutstanding": "You can't record more than is left to pay.",
        "amountInvalid": "Enter an amount above zero, with at most four decimal places.",
        "payeeInvalid": "A payment to this payee can't be recorded. Choose the document's supplier or a colleague from this account.",
        "creditAccountNotVerified": "This supplier account is no longer verified. Choose another, or leave it out.",
        "reasonRequired": "Say why you're revoking the confirmation.",
        "discountNotFullSettlement": "A discount can be taken only when the whole invoice is paid.",
        "allocationExceedsOutstanding": "Together it can't be more than the amount to pay.",
        "debitAccountInvalid": "You can't pay from this account now. It has to be ours, active and verified.",
        "runNotHomogeneous": "A run is in the currency of the account it pays from. ABO (KPC) is for Czech crowns only.",
        "nothingToPay": "Nothing can be paid under this selection now.",
        "runNotEditable": "The run has moved on in the meantime, and this can't be changed any more.",
        "transferNotPositive": "The payment must stay above zero. The rest of the credit note waits for another run.",
        "creditNoteNotNettable": "This credit note can't be netted now, or that much is not left on it.",
        "releaserNotThird": "You prepared, edited or approved the run. A third person has to release it.",
        "notBlockable": "This payment can't be blocked or unblocked now.",
        "blockReasonRequired": "Write why you are blocking the payment.",
        "runHasConfirmations": "A statement, the ERP or a person already confirmed a payment of the run. The run can't be cancelled now.",
        "withdrawalReasonRequired": "Write why you are withdrawing the export.",
        "notCancellable": "This payment can't be cancelled: it is in the bank file, or it has already ended.",
        "splitCreditNote": "The payment can't be cancelled now: the credit note netted in it would bring the confirmed part to zero.",
        "buildFailed": "The run could not be prepared.",
        "submitFailed": "The run could not be submitted for approval.",
        "approveFailed": "The run could not be approved.",
        "releaseFailed": "The run could not be released.",
        "exportFailed": "The file could not be created.",
        "withdrawFailed": "The export could not be withdrawn.",
        "cancelFailed": "The run could not be cancelled.",
        "blockFailed": "The payment could not be blocked.",
        "unblockFailed": "The payment could not be unblocked.",
        "cancelLeftOutFailed": "The payment could not be cancelled.",
        "removeAllocationFailed": "The invoice could not be dropped from the run.",
        "updateAllocationFailed": "The payment could not be changed.",
        "netCreditNoteFailed": "The credit note could not be netted."
      },
      "title": "Payments",
      "tabs": {
        "payables": "To pay",
        "runs": "Payment runs"
      },
      "notPayable": "Can't be paid – {{clause}}",
      "moreClauses": "+{{n}}",
      "clauseFix": {
        "openInvoice": "Open the invoice",
        "openRun": "Open the run",
        "verifyAccount": "Verify the account",
        "chooseAccount": "Choose the account"
      },
      "prepareRun": "Prepare a run",
      "loadMore": "Load more",
      "retry": "Try again",
      "totalCount": "Total: {{count}}",
      "filters": {
        "title": "Filters",
        "apply": "Show",
        "clear": "Clear filters"
      },
      "payables": {
        "title": "Invoices to pay",
        "searchPlaceholder": "Invoice, supplier or VS",
        "loadError": "The invoices to pay could not be loaded.",
        "empty": {
          "title": "Nothing to pay right now.",
          "description": "Received invoices show up here until they are paid."
        },
        "noResults": "No invoice matches the filters.",
        "sort": {
          "due": "Due date"
        },
        "filters": {
          "payability": "Payable",
          "anyPayability": "All",
          "payable": "Can be paid",
          "notPayable": "Can't be paid",
          "clause": "Reason",
          "anyClause": "All reasons",
          "dueTo": "Due by",
          "currency": "Currency",
          "anyCurrency": "All currencies",
          "supplier": "Supplier",
          "anySupplier": "All suppliers"
        },
        "table": {
          "invoice": "Invoice",
          "due": "Due",
          "toPay": "To pay",
          "supplierAccount": "Supplier account",
          "state": "State",
          "pastDue": "past due",
          "ofTotal": "of {{total}}",
          "reserved": "{{amount}} in run {{number}}",
          "open": "Open invoice {{number}}"
        },
        "state": {
          "payable": "Can be paid",
          "inRun": "In run {{number}}",
          "inProposal": "In proposal {{number}}",
          "withdrawnFile": "A file of run {{number}} was withdrawn. It may already have reached the bank."
        }
      },
      "build": {
        "title": "Prepare a payment run",
        "debitAccount": "Pay from account",
        "debitAccountPlaceholder": "Choose an account",
        "debitAccountRequired": "Choose the account to pay from.",
        "anyCurrency": "any currency",
        "runCurrency": "Run currency: {{currency}}",
        "currency": "Run currency",
        "currencyPlaceholder": "Choose a currency",
        "currencyRequired": "Choose the run's currency.",
        "dueTo": "Due by",
        "dueToHint": "The run takes approved invoices in the account's currency due by this day at the latest.",
        "dueToRequired": "Choose the due date.",
        "margin": "Margin for the bank",
        "marginUnit": "days",
        "marginHint": "Also takes invoices due this many days later, so the bank pays them in time.",
        "marginInvalid": "Enter a whole number of days from 0 to {{max}}.",
        "format": "File format",
        "preview_one": "The run would take {{count}} invoice now.",
        "preview_other": "The run would take {{count}} invoices now.",
        "previewNone": "Nothing can be paid under this selection now.",
        "noAccount": "We have no verified account of our own to pay from.",
        "bankAccountsLink": "Bank accounts",
        "submit": "Prepare the run",
        "cancel": "Cancel",
        "success": "The run is ready."
      },
      "runs": {
        "title": "Payment runs",
        "searchPlaceholder": "Run number",
        "loadError": "The payment runs could not be loaded.",
        "empty": {
          "title": "There is no payment run yet.",
          "description": "Prepare one from the invoices to pay."
        },
        "noResults": "No run matches the filters.",
        "sort": {
          "created": "Created",
          "amount": "Amount"
        },
        "filters": {
          "status": "State",
          "open": "Open",
          "all": "All",
          "debitAccount": "Pay from account",
          "anyAccount": "All accounts"
        },
        "table": {
          "number": "Number",
          "state": "State",
          "debitAccount": "Pay from account",
          "dueTo": "Due by",
          "payments": "Payments",
          "amount": "Amount",
          "preparedBy": "Prepared by",
          "blocked_one": "{{count}} blocked",
          "blocked_other": "{{count}} blocked",
          "open": "Open run {{number}}"
        }
      },
      "paymentCount_one": "{{count}} payment",
      "paymentCount_other": "{{count}} payments",
      "run": {
        "title": "Payment run {{number}}",
        "loadError": "The payment run could not be loaded.",
        "summary": "{{payments}} · {{amount}} · from account {{account}}",
        "blockedSummary": "Blocked: {{payments}} · {{amount}} — they won't go into the file.",
        "withdrawnWarning": {
          "title": "An earlier file of this run was withdrawn",
          "body": "It may already have reached the bank. Before you send a new file, check in your online banking that no payment from the first one went out."
        },
        "steps": {
          "prepared": "Prepared",
          "approved": "Approved",
          "released": "Released",
          "exported": "Exported",
          "confirmed": "Confirmed"
        },
        "actions": {
          "submit": "Submit for approval",
          "approve": "Approve",
          "release": "Release",
          "export": "Create the bank file",
          "download": "Download the file",
          "withdraw": "Withdraw the export",
          "cancel": "Cancel the run",
          "more": "More actions"
        },
        "selection": {
          "title": "Invoice selection",
          "sentence": "The run took the approved invoices in {{currency}} due by {{date}} that could be paid at the time.",
          "sentenceWithMargin": "The run took the approved invoices in {{currency}} due by {{date}} (with a margin of {{margin}}) that could be paid at the time.",
          "marginDays_one": "{{count}} day",
          "marginDays_other": "{{count}} days",
          "dueTo": "Due by",
          "margin": "Margin for the bank",
          "debitAccount": "Pay from account",
          "currency": "Currency",
          "format": "File format",
          "builtBy": "Built by",
          "notPayableLink": "What can't be paid now",
          "notPayableCaption": "As things stand today, not as they stood when the run was built."
        },
        "payments": {
          "title": "Payments",
          "payee": "Payee",
          "account": "Payee account",
          "reference": "Reference",
          "invoices": "Invoices",
          "amount": "Amount",
          "state": "State",
          "actions": "Payment actions",
          "expand": "Show the invoices of the payment to {{payee}}",
          "collapse": "Hide the invoices of the payment to {{payee}}",
          "totalToSend": "Total to send {{amount}}",
          "totalBlocked": "Blocked {{amount}}",
          "empty": {
            "title": "No payment is left in the run.",
            "description": "Cancel it, or prepare a new one."
          },
          "notPayableNow_one": "{{count}} invoice can't be paid now",
          "notPayableNow_other": "{{count}} invoices can't be paid now",
          "dropsAtExport": "It drops out of the run when the file is created.",
          "block": "Block the payment",
          "unblock": "Unblock",
          "net": "Net a credit note",
          "confirm": "Confirm payment",
          "cancelLeftOut": "Cancel the payment",
          "revoke": "Revoke"
        },
        "allocation": {
          "invoice": "Invoice",
          "due": "Due",
          "toPay": "To pay",
          "paid": "Paying",
          "discount": "Discount",
          "withholding": "Withheld",
          "actions": "Invoice actions",
          "creditNote": "Credit note",
          "edit": "Change the amount",
          "remove": "Drop from the run"
        },
        "cancellation": {
          "BLOCKED_AT_RELEASE": "Dropped at release because it was blocked",
          "BLOCKED_AT_EXPORT": "Dropped when the file was created",
          "INVOICE_NOT_PAYABLE": "Dropped when the file was created: {{invoice}} could no longer be paid",
          "AMOUNT_EXCEEDS_OUTSTANDING": "Dropped when the file was created: {{invoice}} owes less than the payment sent",
          "LEFT_OUT_CANCELLED": "Cancelled because it did not go into the bank file",
          "splitOff": "The cancelled part of a payment the ERP did not confirm",
          "RUN_CANCELLED": "Cancelled with the run",
          "CONFIRMATION_REVOKED": "Cancelled when its last confirmation was revoked",
          "PARTIAL_SHORTFALL": "Cancelled as the unpaid rest of a partly paid payment"
        },
        "exports": {
          "title": "Bank files",
          "file": "File",
          "messageId": "Message ID",
          "sha256": "SHA-256",
          "createdBy": "Created by",
          "state": "State",
          "valid": "Valid",
          "withdrawn": "Withdrawn",
          "download": "Download",
          "copySha": "Copy the SHA-256 of {{file}}",
          "copied": "The SHA-256 is copied."
        },
        "people": {
          "title": "Who worked on the run",
          "preparedBy": "Prepared by",
          "editors": "Edited by",
          "approvedBy": "Approved by",
          "releasedBy": "Released by",
          "exportedBy": "Created the file",
          "confirmedBy": "Confirmed by hand",
          "cancelledBy": "Cancelled by",
          "you": "You"
        }
      },
      "submit": {
        "success": "The run is waiting for approval."
      },
      "approve": {
        "title": "Approve run {{number}}?",
        "body": "{{payments}} for {{amount}} from account {{account}}. Blocked payments are not part of the approved amount.",
        "confirm": "Approve",
        "cancel": "Cancel",
        "success": "Approved."
      },
      "release": {
        "title": "Release the run?",
        "info": "Before release we check every invoice and every account again. Released invoices can't then be paid by another run.",
        "blockedInfo": "Blocked payments are not reserved.",
        "confirm": "Release",
        "cancel": "Cancel",
        "close": "Close",
        "success": "The run is released.",
        "failed": {
          "title": "The run can't be released now.",
          "heldByAnotherRun": "Another released run holds one of its invoices now.",
          "hint": "Block the payment, or drop the invoice from the run.",
          "code": {
            "INVOICE_NOT_PAYABLE": "Can't be paid – {{clause}}",
            "EXCEEDS_OUTSTANDING": "The run pays more than the invoice owes now",
            "DISCOUNT_NOT_FULL_SETTLEMENT": "A discount needs the whole invoice settled",
            "CREDIT_NOTE_EXCEEDS_REMAINING": "The run nets more than is left on the credit note",
            "PAYEE_NOT_SUPPLIER": "The invoice's supplier is no longer the payee",
            "CURRENCY_MISMATCH": "The invoice is no longer in the run's currency",
            "CREDIT_ACCOUNT_INVALID": "The payee account is no longer verified"
          },
          "invoiceNotPayable": "The invoice can't be paid now"
        }
      },
      "export": {
        "confirmTitle": "Create the bank file?",
        "blockedBody_one": "{{count}} blocked payment drops out of the run: it won't go into the file and its invoices return to the invoices to pay.",
        "blockedBody_other": "{{count}} blocked payments drop out of the run: they won't go into the file and their invoices return to the invoices to pay.",
        "plainBody": "Every payment waiting to be sent goes into the file.",
        "confirm": "Create the file",
        "cancel": "Cancel",
        "success": "The file is ready to download.",
        "closedOut": "Every payment is already confirmed. The run is closed and no file was needed.",
        "cancelledOut_one": "{{count}} payment dropped out of the run when the file was created. You'll find the reason on it.",
        "cancelledOut_other": "{{count}} payments dropped out of the run when the file was created. You'll find the reason on each.",
        "failed": {
          "title": "The file can't be created now.",
          "hint": "Block the payment, or cancel the run. Fix the payee account at the supplier.",
          "close": "Close",
          "wholeRun": "The whole run",
          "code": {
            "CREDIT_ACCOUNT_INVALID": "The payee account is no longer verified",
            "CREDIT_ACCOUNT_CHANGED": "The payee account changed since the release",
            "CREDIT_ACCOUNT_NOT_DOMESTIC": "ABO (KPC) pays to Czech accounts only",
            "DEBIT_ACCOUNT_NOT_DOMESTIC": "ABO (KPC) is sent from a Czech account only",
            "CURRENCY_NOT_SUPPORTED": "ABO (KPC) pays in Czech crowns only",
            "BANK_FILE_REFUSED": "The bank would not accept the file"
          }
        }
      },
      "withdraw": {
        "title": "Withdraw the export",
        "reason": "Reason",
        "warning": "The file stays stored. The run returns to approval and its invoices to the invoices to pay. If the file is already at the bank, this does not stop the payments — cancel them there.",
        "submit": "Withdraw the export",
        "cancel": "Cancel",
        "success": "The export is withdrawn."
      },
      "reasonTooLong": "The reason can have at most {{max}} characters.",
      "cancelRun": {
        "title": "Cancel run {{number}}?",
        "body": "The invoices return to the invoices to pay.",
        "releasedBody": "The invoices return to the invoices to pay. Their reservations are released.",
        "confirm": "Cancel the run",
        "cancel": "Back",
        "success": "The run is cancelled."
      },
      "block": {
        "title": "Block the payment",
        "reason": "Reason",
        "info": "The payment stays in the run but does not count towards the approved amount. If it is still blocked when the file is created, it drops out of the run and its invoices return to the invoices to pay.",
        "submit": "Block the payment",
        "cancel": "Cancel",
        "success": "The payment is blocked."
      },
      "unblock": {
        "title": "Unblock the payment?",
        "body": "The payment returns to the run.",
        "approvedBody": "The payment returns to the run's approved amount.",
        "confirm": "Unblock",
        "cancel": "Cancel",
        "success": "The payment is back in the run.",
        "failed": {
          "title": "The payment can't be unblocked now.",
          "hint": "The payment stays blocked until this is resolved."
        }
      },
      "cancelLeftOut": {
        "title": "Cancel the payment?",
        "body": "The payment did not go into the bank file, so no bank has it. Its invoices return to the invoices to pay.",
        "splitBody": "The part the ERP already confirmed stays paid. Only the rest is cancelled, and its invoices return to the invoices to pay.",
        "confirm": "Cancel the payment",
        "cancel": "Back",
        "success": "The payment is cancelled."
      },
      "removeAllocation": {
        "title": "Drop invoice {{number}} from the run?",
        "body": "The invoice returns to the invoices to pay.",
        "confirm": "Drop from the run",
        "cancel": "Cancel",
        "success": "The invoice is dropped from the run.",
        "creditNoteTitle": "Drop credit note {{number}} from the payment?",
        "creditNoteBody": "The credit note leaves the payment, which grows by its amount."
      },
      "editAllocation": {
        "title": "Change the payment of invoice {{number}}",
        "outstanding": "To pay {{amount}}",
        "applied": "Pay",
        "discount": "Early payment discount",
        "withholding": "Withheld",
        "withholdingHint": "The part you don't pay the supplier, such as withholding tax.",
        "settlesInFull": "This settles the whole invoice.",
        "remains": "{{amount}} stays to pay.",
        "appliedInvalid": "Enter an amount above zero.",
        "partInvalid": "Enter zero or a positive amount.",
        "submit": "Save",
        "cancel": "Cancel",
        "success": "The payment is changed."
      },
      "netCreditNote": {
        "title": "Net a credit note",
        "description": "Payment to {{payee}} · {{amount}}",
        "creditNote": "Credit note",
        "date": "Date",
        "remaining": "Left",
        "pick": "Choose credit note {{number}}",
        "amount": "Net",
        "amountInvalid": "Enter an amount above zero.",
        "exceedsRemaining": "You can't net more than is left on the credit note.",
        "transferNotPositive": "The payment must stay above zero. The rest of the credit note waits for another run.",
        "none": "The supplier has no credit note to net.",
        "loadError": "The credit notes could not be loaded.",
        "submit": "Net",
        "cancel": "Cancel",
        "success": "The credit note is netted."
      },
      "approvedWarning": "The run is approved. After a change it returns to approval, and someone who neither prepared nor edited it has to approve it."
    },
    "settingsShell": {
      "title": "System settings",
      "searchPlaceholder": "Search settings",
      "noResults": "Nothing found. Try another word.",
      "sectionDenied": "You don't have sufficient permission for the requested section.",
      "tabs": {
        "settings": "System settings",
        "codeLists": "Code lists",
        "automation": "Automation"
      },
      "groups": {
        "company": "Company",
        "people": "People and access",
        "documents": "Documents",
        "codeLists": "Code lists",
        "connections": "Integrations and API",
        "subscription": "Subscription"
      },
      "sections": {
        "overview": {
          "label": "Overview",
          "description": "How Tappeer is set up.",
          "keywords": "home status summary"
        },
        "organization": {
          "label": "Company profile",
          "description": "Your company name, address and accounting currency.",
          "keywords": "organization company id vat tax address name language currency time zone registry phone"
        },
        "bankAccounts": {
          "label": "Bank accounts",
          "description": "The accounts you pay from and get paid to.",
          "keywords": "iban bank account number swift bic verification payments"
        },
        "users": {
          "label": "Users",
          "description": "Who works in Tappeer and what they may do.",
          "keywords": "invite invitation roles admin approver team people access permissions"
        },
        "mailbox": {
          "label": "Document intake",
          "description": "Where to send invoices so Tappeer can sniff them out.",
          "keywords": "e-mail email mail mailbox forwarding inbox address"
        },
        "automation": {
          "label": "Automation"
        },
        "numberSeries": {
          "label": "Number series",
          "description": "How the documents you issue are numbered.",
          "keywords": "numbering prefix series format orders"
        },
        "documentOutput": {
          "label": "Generated documents",
          "description": "How the documents leaving Tappeer look.",
          "keywords": "pdf footer terms print order layout"
        },
        "partners": {
          "label": "Companies",
          "description": "The suppliers and customers you do business with.",
          "keywords": "supplier suppliers vendor customer customers company companies partner partners company id vat contacts directory code list"
        },
        "orgStructure": {
          "label": "Organizational structure",
          "description": "Your company's units and their heads, which approvals follow.",
          "keywords": "unit department head manager hierarchy organization approval code list"
        },
        "costCenters": {
          "label": "Cost centers",
          "description": "The centers you split costs across.",
          "keywords": "cost center centre costs budget code list"
        },
        "jobs": {
          "label": "Jobs",
          "description": "Jobs and projects you assign documents to.",
          "keywords": "job project contract code list"
        },
        "glPostings": {
          "label": "Posting templates",
          "description": "Posting templates from your accounting system for posting documents.",
          "keywords": "posting template ledger account accounting gl code list"
        },
        "vatCodes": {
          "label": "VAT classification",
          "description": "VAT classification from your accounting system.",
          "keywords": "vat tax classification rate code list"
        },
        "vatPostings": {
          "label": "VAT posting rules",
          "description": "How your accounting system posts VAT.",
          "keywords": "vat tax posting rules accounting code list"
        },
        "integrations": {
          "label": "Integrations",
          "description": "Syncing your data with your accounting system or ERP.",
          "keywords": "integrations integration erp accounting pohoda money s3 abra flexi connector connectors sync synchronization import export plugin",
          "children": {
            "connections": {
              "label": "Installations",
              "description": "Where your connectors read their data from. Connectors on one installation share its settings, so a URL or a password is entered once.",
              "keywords": "installation installations target system target systems connection url password login server database"
            },
            "bridges": {
              "label": "Bridges",
              "description": "Computers on your network through which Tappeer reaches systems it cannot see from the internet.",
              "keywords": "bridge bridges agent computer windows network tunnel pairing pairing code local server"
            },
            "monitor": {
              "label": "Monitor",
              "description": "Runs and problems across every connector of this account.",
              "keywords": "monitor monitoring run runs sync synchronization errors error problems history log status"
            }
          }
        },
        "webhooks": {
          "label": "Webhooks",
          "description": "Let your system know when something happens in Tappeer.",
          "keywords": "webhook url events notifications developer"
        },
        "apiKeys": {
          "label": "API keys",
          "description": "Keys for reaching Tappeer from other apps.",
          "keywords": "token api developer key access"
        },
        "subscription": {
          "label": "Plan",
          "description": "What you have prepaid and how much is left.",
          "keywords": "subscription plan pricing credits payment card"
        },
        "billingInvoices": {
          "label": "Tappeer invoices",
          "description": "The invoices Tappeer sends you.",
          "keywords": "invoices billing payments download pdf"
        },
        "accountManagement": {
          "label": "Account management",
          "description": "Actions on the whole account: accounting office and deleting the account.",
          "keywords": "delete remove cancel close office accounting firm declare leave disconnect account"
        }
      },
      "overview": {
        "attention": {
          "title": "Needs attention"
        },
        "status": {
          "organization": {
            "withCompanyId": "{{name}}, company ID {{companyId}}",
            "nameOnly": "{{name}}"
          },
          "bankAccounts": {
            "count_one": "{{value}} account",
            "count_other": "{{value}} accounts",
            "none": "No accounts yet"
          },
          "mailbox": {
            "active": "Send invoices to {{address}}",
            "disabled": "Receiving by e-mail is off",
            "none": "No address for documents yet"
          },
          "webhooks": {
            "none": "No webhook yet",
            "off": "Webhook is off",
            "failing": "The last delivery failed",
            "on": "Webhook is on"
          },
          "subscription": {
            "balance_one": "{{value}} credit left",
            "balance_other": "{{value}} credits left",
            "paidBy": "{{name}} pays the credits"
          }
        }
      },
      "bankAccountsPending": {
        "count_one": "{{value}} account awaits verification",
        "count_other": "{{value}} accounts await verification"
      },
      "integrationHealth": {
        "bridgeOffline": "Bridge is offline",
        "syncStale": "Sync has stopped"
      }
    },
    "listFilters": {
      "search": "Search",
      "addFilter": "Add filter",
      "filterBy": "Filter by",
      "clearAll": "Clear filters",
      "apply": "Apply",
      "back": "Back",
      "remove": "Remove filter {{name}}",
      "sheetTitle": "Filters",
      "noOptions": "Nothing found",
      "from": "From",
      "to": "To",
      "status": {
        "label": "Status",
        "all": "All",
        "panelTitle": "Filter by status",
        "panelHint": "Click the selected status again to clear it and show all."
      },
      "datePresets": {
        "thisMonth": "This month",
        "lastMonth": "Last month",
        "last30Days": "Last 30 days",
        "custom": "Custom"
      },
      "range": {
        "between": "{{from}} – {{to}}",
        "from": "from {{value}}",
        "to": "to {{value}}"
      },
      "amount": {
        "inclVat": "incl. VAT",
        "exclVat": "excl. VAT",
        "accountingCurrency": "Accounting currency",
        "hint": "Without a currency, the amount converted to the accounting currency is compared.",
        "estimateHint": "Without a currency, the estimate in the accounting currency is compared."
      },
      "flag": {
        "show": "Show"
      },
      "orgUnit": {
        "includeDescendants": "Including subordinates",
        "withDescendants": "{{value}} and subordinates"
      },
      "endsWithin": {
        "days": "{{days}} days"
      },
      "payment": {
        "overdue": "Overdue"
      },
      "check": {
        "error": "With errors",
        "warning": "With warnings",
        "success": "No issues"
      },
      "params": {
        "relationship": "Related to me",
        "supplier": "Supplier",
        "suggestedSupplier": "Suggested supplier",
        "party": "Contract party",
        "direction": "Direction",
        "amount": "Amount",
        "issued": "Issue date",
        "due": "Due date",
        "delivery": "Delivery date",
        "received": "Received",
        "created": "Created",
        "documentType": "Document type",
        "payment": "Payment",
        "posting": "Posting",
        "check": "Check",
        "costCenter": "Cost centre",
        "job": "Job",
        "orgUnit": "Org unit",
        "contract": "Contract",
        "endsWithin": "Ends within",
        "cancelled": "Cancelled"
      },
      "saved": {
        "title": "Saved filters",
        "empty": "You have no saved filters here yet.",
        "loadFailed": "Saved filters could not be loaded.",
        "saveCurrent": "Save current filters…",
        "createTitle": "Save filters",
        "save": "Save",
        "name": "Name",
        "includeStatus": "Including status",
        "includeStatusHint": "The filter then also switches the status to “{{status}}”.",
        "cancel": "Cancel",
        "actions": "Actions for filter {{name}}",
        "rename": "Rename",
        "renameTitle": "Rename filter",
        "overwrite": "Save current filters here",
        "delete": "Delete",
        "deleteTitle": "Delete filter?",
        "deleteMessage": "“{{name}}” will be removed from your saved filters.",
        "created": "Filter “{{name}}” saved.",
        "overwritten": "Filter “{{name}}” now holds the current filters.",
        "deleted": "Filter “{{name}}” deleted.",
        "errors": {
          "nameTaken": "You already have a filter with this name.",
          "nameRequired": "Enter a name for the filter.",
          "nameTooLong": "The name can have at most 80 characters.",
          "limitReached": "You can save at most 50 filters for this list. Delete one and try again.",
          "queryTooLong": "That many filters cannot be saved. Try setting fewer.",
          "failed": "The change could not be saved. Try again."
        }
      }
    }
  },
  "modules": {
    "menu": {
      "myAccount": "My Profile",
      "logout": "Log out",
      "profile": "Profile",
      "systemSettings": "System settings",
      "apiKeyClose": "Close"
    }
  },
  "impersonation": {
    "callback": {
      "loading": "Establishing session…",
      "invalidToken": "The link has expired or is invalid."
    },
    "banner": {
      "message": "You are acting as {{name}}",
      "stopButton": "Stop impersonation",
      "stopping": "Stopping…",
      "stopError": "Failed to stop impersonation. Please try again."
    }
  }
}
